export const vi = {
    "name": "Vietnamese",
    "flagCode": "vn",
    "locale": "en-en",
    "project": {
        "name": "QUp New CC"
    },
    "MigrationBanner": {
        "title": "Next-Generation Command Center",
        "subtitle": "Khám phá dashboard mới và hoàn tất migration trước %{deadline}.",
        "tryNow": "Dùng thử ngay",
        "dismiss": "Đóng"
    },

    "Sidebar": {
        "Product_Discovery": "Khám Phá Sản Phẩm",
        "Setting": "Cài đặt",
        "Map": "Bản đồ",
        "Cue": "Quản lý",
        "Invoice": "Hóa đơn",
        "Supplier": "Nhà cung cấp",
        "Vehicle": "Phương tiện",
        "Merchant": "Cửa hàng",
        "ImportBookings": "Nhập dữ liệu đặt xe",
        "ImportDeliveryBookings": "Nhập dữ liệu giao hàng",
        "Trip": "Chuyến",
        "New_booking": "Tạo mới",
        "City": "Thành phố",
        "Chauffeur": "Di chuyển",
        "Delivery": "Giao hàng",
        "Shuttle": "Xe đưa đón",
        "Intercity": "Liên tỉnh",
        "Customer": "Khách hàng",
        "Driver": "Tài xế",
        "REPORTS": "Báo cáo",
        "Corporate": "Doanh nghiệp",
        "mDispatcher": "Đối tác",
        "Reservation": "Lịch",
        "withdrawalRequest": "Yêu cầu rút tiền",
        "Driver_Settlement": "Thanh toán tài xế",
        "Dashboard": "Phân tích",
        "SmartData": "Dữ liệu thông minh",
        "Smart_Data": "Dữ liệu thông minh",
        "Campaign_Builder": "Trình tạo chiến dịch",
        "Company_operator": "Điều hành viên công ty",
        "Queuing_area": "Hàng đợi",
        "Withdrawal_Requests": "Yêu cầu rút tiền",
        "pickUp": "Đón khách",
        "dropOff": "Trả khách",
        "SignUpNotifications": "Đăng ký thông báo",
        "Payout": "Thanh toán",
        "Payout_label": "Thanh toán",
        "Invoice_Setting": "Hóa đơn",
        "payout": {
            "payoutDriver": "Thanh toán cho tài xế",
            "payoutMerchant": "Thanh toán cho thương nhân",
            "payoutSupplier": "Thanh toán cho nhà cung cấp",
            "Pay_To_Driver": "Thanh toán cho tài xế",
            "payoutDriverHistory": "Lịch sử thanh toán tài xế",
            "Pay_To_Merchant": "Thanh toán cho cửa hàng",
            "Payout_History_For_Merchant": "Lịch sử thanh toán cho cửa hàng",
            "Pay_To_Supplier": "Thanh toán cho Nhà cung cấp",
            "payoutSupplierHistory": "Lịch sử Thanh toán Nhà cung cấp",
            "Driver_Payout": "Thanh toán cho tài xế",
            "Supplier_Payout": "Thanh toán nhà cung cấp",
            "Merchant_Payout": "Thanh toán cho thương nhân"
        },
        "number_of_records_to_export": "Số lượng bản ghi cần xuất",
        "export": "Xuất dữ liệu",
        "Airline": "Hãng bay",
        "driverPayout": {
            "Pay_to_driver": "Thanh toán cho tài xế",
            "Payout_history": "Lịch sử thanh toán"
        },
        "Reports": {
            "Driver_Referral_history": "Tài xế giới thiệu khách hàng",
            "Driver_refers_Pax": "Tài xế",
            "Refund": "Hoàn tiền",
            "Driver_refers_Pax_Customers": "Khách hàng",
            "Driver_refers_Pax_Bookings": "Chuyến",
            "Driver_refers_customer_Drivers": "Tài xế giới thiệu KH (Tài xế)",
            "Driver_refers_customer_Customers": "Tài xế giới thiệu KH (Khách hàng)",
            "Driver_refers_customer_Bookings": "Tài xế giới thiệu KH (Đặt xe)",
            "Passenger_refers_Passengers": "Khách hàng giới thiệu",
            "Driver_refers_drivers_Referrer": "Tài xế giới thiệu tài xế (Người giới thiệu)",
            "Deletion_request": "Yêu cầu xóa dữ liệu",
            "Driver_refers_drivers_Referee": "Tài xế giới thiệu tài xế (Người được giới thiệu)",
            "Supplier_Wallet": "Ví Nhà Cung Cấp",
            "Driver_refers_Driver": "Tài xế giới thiệu tài xế",
            "Driver_refers_driver_Referrer": "Người giới thiệu",
            "Driver_refers_driver_Referee": "Người được giới thiệu",
            "Referral_history": "Lịch sử giới thiệu",
            "Booking_details": "Chi tiết chuyến xe",
            "Financial": "Tài chính",
            "Financial_driver": "Tài xế",
            "Financial_fleet": "Hãng",
            "Financial_company": "Công ty",
            "Financial_Driver": "Doanh thu (Tài xế)",
            "Financial_Fleet": "Doanh thu (Đội xe)",
            "Financial_Company": "Doanh thu (Công ty)",
            "Financial_fleet_profit": "Lợi nhuận đội xe",
            "Financial_Company_Tooltip": "Báo cáo thu nhập ròng của tài xế theo từng công ty",
            "Financial_Driver_ToolTip": "Báo cáo thu nhập ròng của từng tài xế",
            "Financial_Fleet_Profit_ToolTip": "Lợi nhuận đội xe",
            "Driver_activity": "Hoạt động của tài xế",
            "Revenue_Summary": "Báo cáo doanh thu",
            "Revenue_fleet": "Hãng",
            "Revenue_driver": "Tài xế",
            "Revenue_monthly": "Hàng tháng",
            "Revenue_Summary_Fleet": "Tổng quan doanh thu (Đội xe)",
            "Revenue_Summary_Driver": "Tổng quan doanh thu (Tài xế)",
            "Revenue_Summary_Monthly": "Tổng quan doanh thu (Theo tháng)",
            "Total_adjustment": "Điều chỉnh tổng hợp",
            "Promotion": "Ưu đãi",
            "Incident_Cancellation": "Sự cố & Hủy chuyến",
            "Booking_logs": "Lịch sử chuyến xe",
            "Rating": "Đánh giá",
            "Thumbs_rating": "Đánh giá",
            "Stars_rating": "Đánh giá",
            "Operator_logs": "Lịch sử điều hành",
            "Daily": "Theo ngày",
            "Daily_Driver": "Tài xế theo ngày",
            "Daily_Car": "Xe theo ngày",
            "Daily_Driver_Car": "Tài xế & Xe theo ngày",
            "mDispatcher": "Đối tác",
            "Corporate": "Lịch trình của công ty",
            "Driver_login_status": "Tài xế đăng nhập",
            "Car_activity": "Hoạt động phương tiện",
            "Partner": "Đối tác",
            "Prepaid_top_up": "Doanh nghiệp trả trước",
            "Affiliation": "Liên kết",
            "Affiliation_penalty_compensation": "Phạt/Bồi thường",
            "Affiliation_payout_history": "Lịch sử thanh toán",
            "Affiliation_bookings": "Chuyến",
            "Booking_summary": "Tóm tắt lịch trình",
            "Cash_Wallet": "Ví tiền mặt",
            "Credit_Wallet": "Ví tín dụng",
            "Driver_wallet": "Ví tài xế",
            "Driver_Deposit": "Tiền cọc tài xế",
            "Driver_cash_wallet": "Ví tiền mặt",
            "Driver_Deposit_old": "Tiền cọc tài xế",
            "Document_expiry": "Thời hạn hồ sơ",
            "Settlement": "Quyết toán",
            "Unapproved_Driver": "Tài xế chưa được phê duyệt",
            "Approved_Driver": "Tài xế đã được phê duyệt",
            "Pay_to_driver": "Thanh toán cho tài xế",
            "Settlement_history": "Lịch sử thanh toán",
            "Withdrawal_History": "Tài xế rút tiền",
            "creditWalletTooltip": "Tài xế cọc tiền vào ví tín dụng",
            "Incomplete_payment": "Thanh toán chưa hoàn tất",
            "Driver_withdrawal": "Tài xế rút tiền",
            "Incident_&_Cancellation": "Sự cố & Hủy chuyến",
            "Passenger_wallet": "Ví khách hàng",
            "Accept_Cancel_rate": "Hiệu suất tài xế",
            "Acceptance/Cancellation_rate": "Hiệu suất tài xế",
            "driverDepositTooltip": "Tài xế cọc tiền vào ví tín dụng",
            "Customer_quest": "Nhiệm vụ",
            "First_will_win": "Đầu tiên sẽ thắng",
            "Largest_will_win": "Dẫn đầu sẽ thắng",
            "redeemed": "Mã số #",
            "Code_#": "Mã số #",
            "Quests": "Nhiệm vụ",
            "Merchant_Report": "Cửa hàng",
            "Merchant_Financial_Report": "Tài chính",
            "Merchant_Cash_Report": "Ví tiền mặt",
            "Merchant_Credit_Report": "Ví tín dụng",
            "Deletion_Request": "Yêu cầu xóa dữ liệu",
            "Driver_Rating": "KH đánh giá tài xế",
            "Passenger_Rating": "Tài xế đánh giá KH",
            "Company_settlement": "Thanh toán công ty",
            "Export": "Lịch sử xuất file",
            "Third_Party_Booking": "Đặt xe bên thứ ba",
            "BookingDotCom": "Booking.com",
            "Third_Party_Booking_Bookingcom": "Đặt xe bên thứ ba (Booking.com)",
            "Third_Party_Booking_HolidayTaxis": "Đặt xe bên thứ ba (HolidayTaxis)",
            "Third_Party_Booking_Karhoo": "Đặt xe bên thứ ba (Karhoo)",
            "Third_Party_Booking_Hoppa": "Đặt xe bên thứ ba (Hoppa)",
            "Third_Party_Booking_Klook": "Đặt chỗ bên thứ ba (Klook)",
            "Third_Party_Booking_TransferZ": "Đặt chỗ bên thứ ba (TransferZ)",
            "supplierWallet": "Ví Nhà Cung Cấp"
        },
        "Settings": {
            "Block_Passenger": "Chặn Hành Khách",
            "Fleet_info": "Thông tin đội xe",
            "Product_Discovery": "Khám Phá Sản Phẩm",
            "Surchage_Policy": "Chính sách phụ phí",
            "RateLegacy": "Giá (Cũ)",
            "Driver": "Lái xe",
            "Merchant": "Thương nhân",
            "Calendar": "Lịch",
            "Socaial": "Socaial",
            "Quest": "Nhiệm vụ",
            "Referral": "Giới thiệu",
            "Addon_Template": "Add-On Template",
            "Social": "Xã hội",
            "Shift": "Ca",
            "Rate_Templates": "Mẫu giá",
            "Supplier_Plan": "Gói hoa hồng",
            "Vehicle_Lead_Time": "Thời gian dẫn xe",
            "Penalty_Policy": "Chính sách phạt",
            "Stripe_connect": "Stripe Connect",
            "stripe_title_connect": "Kích hoạt tài khoản Stripe Connect của bạn để nhận thanh toán tự động.",
            "Payment_info": "Thông tin thanh toán",
            "Permission": "Quyền truy cập",
            "Driver_refer_driver": "Tài xế giới thiệu tài xế",
            "Show_referal_history": "Hiển thị/ẩn lịch sử giới thiệu trên app tài xế",
            "companyTooltip": "Đối tác cung cấp dịch vụ",
            "User": "Người dùng",
            "General": "Cài đặt chung",
            "Regular": "Theo km",
            "Sharing": "Ghép chuyến",
            "Flat": "Cố định",
            "Hourly": "Theo giờ - Theo ngày",
            "Company": "Công ty",
            "Dispatch": "Điều phối",
            "Voice_SMS": "Thoại & Tin nhắn",
            "Rate": "Giá cước",
            "RateNew": "Giá",
            "Car": "Xe",
            "Car_type": "Loại xe",
            "Car_mgmt": "Quản lý xe",
            "Car_Make": "Hãng & Dòng xe",
            "Meeting_Zone": "Khu vực họp",
            "Restricted_Zone": "Khu vực hạn chế",
            "Stripe_Connect": "Stripe Connect",
            "Voice_&_SMS": "Thoại & Tin nhắn",
            "Street-sharing_rate": "Giá ghép chuyến",
            "Partner_type": "Loại đối tác",
            "Shift_template": "Ca làm việc mẫu",
            "Billing_Usage": "Sử dụng thanh toán",
            "Driver_App": "App tài xế",
            "Shift_settings": "Cài đặt ca làm việc",
            "Operation": "Điều hành",
            "Driver_Note": "Ghi chú tài xế",
            "Promotion_code": "Mã khuyến mãi",
            "Point_config": "Điểm thưởng",
            "Code_#": "Mã số #",
            "Voucher_code": "Mã số #",
            "Campaign": "Chiến dịch",
            "Queuing_area": "Hàng đợi",
            "Referral_code": "Mã giới thiệu bạn bè",
            "City": "Thành phố",
            "category": "Danh mục",
            "3rd_party_location": "Vị trí bên thứ ba",
            "Zone": "Khu vực",
            "App_banner": "Banner app",
            "App_banner_pegasus": "Banner app (Pegasus)",
            "Flight_integration": "Tích hợp chuyến bay",
            "SMS_integration": "Tích hợp SMS",
            "Invoice_Setting": "Hóa đơn",
            "Payout_Setting": "Mẫu Thanh Toán",
            "AI_Atlas": "Chatbot Atlas AI",
            "Driver_refers_customer": "Tài xế giới thiệu KH",
            "Pax_refers_Pax": "KH giới thiệu KH",
            "Customer_refers_customer": "KH giới thiệu KH",
            "Dynamic_Surcharge": "Phụ phí động",
            "Dynamic_Fare": "Giá cước động",
            "FlatZone": "Giá cố định",
            "IntercityZone": "Liên tỉnh",
            "Intercity_Zone": "Vùng liên tỉnh",
            "Intercity_Rate": "Giá liên tỉnh",
            "Car_Color": "Màu xe",
            "third_party_integration": "Tích hợp bên thứ ba",
            "bookingCom": "Booking.com",
            "HolidayTaxis": "HolidayTaxis",
            "Karhoo": "Karhoo",
            "Corporate": "Doanh nghiệp",
            "KarhooIntegration": "Tích hợp Karhoo",
            "holidaytaxis": "HolidayTaxis",
            "karhoo": "Karhoo",
            "hoppa": "Hoppa",
            "Hoppa": "Hoppa",
            "HoppaIntegration": "Tích hợp Hoppa",
            "Third_Party_Integration_Hoppa": "Tích hợp bên thứ ba (Hoppa.com)",
            "titleHoppa": "Thông tin API Hoppa",
            "noteHoppa": "Liên hệ với Hoppa để nhận Client Key và Secrect Key.",
            "titleHoppaWebhook": "Cấu hình Webhook",
            "noteHoppaWebhook": "Cung cấp các thông số dưới đây cho Hoppa. Các thông tin này được sử dụng để giao tiếp giữa hai nền tảng. Vui lòng liên hệ nhà cung cấp kỹ thuật nếu có bất kỳ sự cố nào.",
            "klook": "Klook",
            "Klook": "Klook",
            "KlookIntegration": "Tích hợp Klook",
            "Third_Party_Integration_Klook": "Tích hợp bên thứ 3 (Klook.com)",
            "titleKlook": "Thông tin xác thực API Klook",
            "noteKlook": "Giao tiếp với đội ngũ kỹ thuật của Klook để cung cấp cho bạn client và secret key để kết nối với hệ thống của họ.",
            "titleKlookWebhook": "Cấu hình Webhook",
            "noteKlookWebhook": "Cung cấp các tham số bên dưới để Klook cấu hình. Những thông tin xác thực này được sử dụng để giao tiếp giữa hai nền tảng. Nếu có bất kỳ vấn đề nào, vui lòng liên hệ với nhà cung cấp công nghệ của bạn.",
            "transferZ": "TransferZ",
            "TransferZ": "TransferZ",
            "TransferZIntegration": "Chuyển giao tích hợp TransferZ",
            "Third_Party_Integration_TransferZ": "Tích hợp bên thứ ba (TransferZ.com)",
            "titleTransferZ": "Thông tin xác thực API TransferZ",
            "noteTransferZ": "Giao tiếp với đội ngũ kỹ thuật của TransferZ để cung cấp cho bạn khách hàng và khóa bí mật để kết nối với hệ thống của họ.",
            "titleTransferZWebhook": "Cấu hình Webhook",
            "noteTransferZWebhook": "Cung cấp các tham số bên dưới cho TransferZ để cấu hình. Những thông tin xác thực này được sử dụng để giao tiếp giữa hai nền tảng. Đối với bất kỳ vấn đề nào, vui lòng liên hệ với nhà cung cấp công nghệ của bạn.",
            "Third_Party_Integration_Booking": "Tích hợp bên thứ ba (Booking.com)",
            "Third_Party_Integration_HolidayTaxis": "Tích hợp bên thứ ba (HolidayTaxis)",
            "Third_Party_Integration_Karhoo": "Tích hợp bên thứ ba (Karhoo.com)",
            "Third_Party_Integration_Mozio": "Tích hợp bên thứ ba (Mozio.com)",
            "invoiceBranding": "Thương hiệu trên hóa đơn",
            "invoiceLogo": "Logo Hóa Đơn",
            "invoiceColor": "Màu hóa đơn",
            "payoutBranding": "Thương hiệu Thanh toán",
            "titleInvoice": "Tùy chỉnh thông tin tiêu đề và chân trang của công ty.",
            "titlePayout": "Tùy chỉnh thông tin tiêu đề và chân trang công ty của bạn.",
            "titleheader": "Tiêu đề đầu trang",
            "descriptionHeader": "Mô tả đầu trang",
            "placehodelHeader": "Ví dụ: thêm thông tin công ty như email, số điện thoại, địa chỉ, mã số thuế, v.v.",
            "titleFooter": "Tiêu đề chân trang",
            "placehodelFooter": "Ví dụ: thêm thông tin chuyển khoản ngân hàng hoặc chính sách công ty.",
            "descriptionFooter": "Mô tả chân trang",
            "defaultEmailMessage": "Tin nhắn Email Mặc định",
            "placeholderEmailMessage": "Số tiền sẽ được chuyển vào tài khoản của bạn bằng phương thức thanh toán mà bạn ưa thích. Xin vui lòng liên hệ với chúng tôi qua <email> nếu bạn có bất kỳ câu hỏi nào.\n\nCảm ơn bạn đã sử dụng dịch vụ. Chúng tôi mong muốn có sự hợp tác thành công hơn nữa trong tương lai.\n\nTrân trọng,\nĐội ngũ Good Journey\n\nNếu không có phản đối nào được nhận trong vòng bảy ngày, hóa đơn tự lập sẽ được coi là đã được phê duyệt.",
            "titleBookingCom": "Thông tin API Booking.com",
            "noteBookingCom": "Liên hệ với Booking.com để lấy Client Key và Secrect Key",
            "clientKey": "Khóa Khách Hàng",
            "placeHolderClientKey": "Nhập Client key",
            "secretKey": "Nhập Secrect Key",
            "placeHolderSecretKey": "Nhập Client Secrect",
            "titleBookingComWebhook": "Cấu hình Webhook",
            "noteBookingComWebhook": "Cung cấp các thông số dưới đây cho Booking.com. Các thông tin này được sử dụng để giao tiếp giữa hai nền tảng. Vui lòng liên hệ nhà cung cấp kỹ thuật nếu có bất kỳ sự cố nào.",
            "webhook": "URL Webhook",
            "clientId": "Client Key",
            "clientSecret": "Secrect Key",
            "driver_app": "App tài xế",
            "Jobs_tab": "Tab công việc",
            "Email_config": "Cài đặt email",
            "Driver_fields": "Trường tài xế",
            "Driver_document": "Giấy tờ tài xế",
            "Selected": "Đã chọn",
            "API_Management": "Quản lý API",
            "Penalty_Policy_Customer": "Chính sách KH",
            "Penalty_Policy_Supplier": "Chính sách đối tác",
            "Stop_Sales": "Ngừng Bán Hàng",
            "RestrictedZone": "Khu vực hạn chế",
            "MeetingZone": "Khu vực họp",
            "block_passenger": "Chặn Hành Khách",
            "Billing_usage": "Sử dụng thanh toán"
        }
    },
    "welcome": {
        "next": "Next",
        "getStarted": "Get Started",
        "step1": {
            "title": "Product Discovery",
            "description": "Welcome to Good Journey! Access all the products included in your plan, such as the <span class=\"highlight-white\">Driver App, Customer Web Booker</span> and more.",
            "button": "Learn more"
        },
        "step2": {
            "title": "Introducing Fleet Wallet",
            "description": "Once you reach your free allowance, any additional overage will check your fleet wallet to deduct per additional request.",
            "moreInfo": "💡 Maintain a positive balance, check usage and transaction reports here."
        },
        "step3": {
            "title": "Never Miss a Beat",
            "description": "You can setup <span class=\"highlight-white\">Automated Top-up</span> to ensure no service disruption on top of usage.",
            "description2": "This ensures your drivers stay on the road and your data keeps flowing, no matter how busy things get."
        },
        "step4": {
            "title": "Getting Started",
            "description": "We’re thrilled to have you onboard! Check out our <span class=\"highlight-white\">Guides & Tutorials</span> section to master the platform and get the most out of your fleet management tools."
        }
    },
    "productDiscovery": {
        "title": "Khám Phá Sản Phẩm",
        "fleetCode": "Mã Đội Tàu",
        "fleetCodeDescription": "Các tài xế sử dụng ứng dụng tài xế toàn cầu được yêu cầu nhập mã này trước khi đăng nhập.",
        "description": "Khám phá và kích hoạt các công cụ hỗ trợ đội xe của bạn. Truy cập Ứng dụng Tài xế, Ứng dụng Khách hàng, Cổng Đặt chỗ Web và Ứng dụng Đặt chỗ Đối tác — tất cả đều được thiết kế để tối ưu hóa hoạt động, kết nối với hành khách và phát triển doanh nghiệp của bạn.",
        "web": "Mạng",
        "ios": "iOS",
        "android": "Android",
        "guide": "Hướng dẫn",
        "gallery": "Thư viện",
        "downloadLinks": "Liên kết Tải về",
        "customize": "Cài đặt",
        "base": "Cơ sở tri thức",
        "base_description": "Hướng dẫn tất cả trong một của bạn về nền tảng. Khám phá các hướng dẫn từng bước, câu hỏi thường gặp và các phương pháp tốt nhất để thành thạo việc đặt chỗ, điều phối, thanh toán và nhiều hơn nữa.",
        "base_allowed": {
            "platform_guides": "Hướng dẫn nền tảng",
            "step_by_step_tutorials": "Hướng dẫn từng bước",
            "faqs_troubleshooting": "Câu hỏi thường gặp & Khắc phục sự cố",
            "best_practices": "Các Thực Hành Tốt Nhất",
            "product_releases_updates": "Công bố sản phẩm và Cập nhật"
        },
        "driver_app": "Ứng dụng tài xế",
        "driver_app_description": "Trang bị cho các tài xế của bạn một ứng dụng để quản lý công việc, hoàn thành chuyến đi và cập nhật đặt chỗ một cách dễ dàng.",
        "driver_app_allowed": {
            "booking_notifications": "Thông báo Đặt chỗ",
            "trip_management": "Quản lý chuyến đi",
            "navigate_realtime_tracking": "Điều hướng & Theo dõi Thời gian Thực",
            "inapp_communication_support": "Giao tiếp & Hỗ trợ trong Ứng dụng",
            "track_driver_earnings": "Theo dõi thu nhập của tài xế",
            "driver_signup_link": "Liên kết Đăng Ký Tài Xế"
        },
        "passenger_app": "Ứng dụng Hành khách",
        "passenger_app_description": "Đặt và quản lý chuyến đi một cách dễ dàng. Ứng dụng Hành Khách mang đến trải nghiệm cao cấp cho du khách — từ việc đặt chỗ ngay lập tức đến cập nhật theo thời gian thực — đảm bảo sự thoải mái, độ tin cậy và kiểm soát ở mọi bước.",
        "passenger_app_allowed": {
            "seamless_ride_booking": "Đặt Chỗ Đi Xe Liền Mạch",
            "realtime_tracking_notifications": "Theo dõi & Thông báo Thời gian Thực",
            "inapp_communication": "Giao tiếp trong ứng dụng",
            "flexible_payment_receipts": "Thanh toán và biên nhận linh hoạt",
            "ride_history_favorites": "Lịch sử chuyến đi & Yêu thích"
        },
        "web_driver_app": "Ứng dụng Web Lái xe",
        "web_driver_app_description": "Cung cấp cho các nhà thầu phụ và tài xế đối tác một cách dễ dàng để chấp nhận và quản lý công việc mà không cần cài đặt ứng dụng. Ứng dụng Web Tài xế hoạt động trực tiếp trong trình duyệt — hoàn hảo cho các tài xế hoặc đối tác làm việc một lần sử dụng hệ thống của riêng họ, với thông báo được gửi qua email, SMS hoặc cảnh báo trên web.",
        "web_driver_app_allowed": {
            "job_access_via_web_link": "Truy cập công việc qua liên kết web",
            "trip_management": "Quản lý chuyến đi",
            "notifications_email_sms_web": "Thông báo qua Email/SMS/Web",
            "navigation_status_updates": "Điều hướng & Cập nhật trạng thái",
            "simple_lightweight": "Đơn giản & Nhẹ nhàng",
            "signup_link": "Liên kết Đăng ký Tài xế"
        },
        "web_passenger_app": "Ứng dụng Đặt chỗ Trực tuyến",
        "web_passenger_app_description": "Cho phép khách hàng và đối tác của bạn đặt xe trực tiếp từ trang web của bạn. Ứng dụng Đặt xe trên Web được xây dựng cho các chuyến chuyển sân bay, dịch vụ tài xế và đặt chỗ theo yêu cầu — cung cấp cho các OTA, khách sạn và đại lý du lịch một cách đơn giản để kết nối du khách với đội xe của bạn.",
        "web_passenger_app_allowed": {
            "embed_anywhere": "Nhúng ở bất kỳ đâu",
            "create_ride_bookings": "Tạo Đặt Chỗ Đi",
            "seamless_web_experience": "Trải nghiệm Web liền mạch",
            "partner_ready": "Sẵn sàng cho đối tác",
            "customer_friendly_checkout": "Quy trình thanh toán thân thiện với khách hàng"
        },
        "concierge_booker": "Người đặt phòng Concierge",
        "concierge_booker_description": "Một ứng dụng web đơn giản cho các đối tác và nhân viên — từ nhân viên lễ tân khách sạn và nhân viên giữ xe đến nhân viên pha chế và người tiếp đón nhà hàng — để tạo chuyến đi cho khách của họ chỉ với vài cú nhấp chuột. Mỗi người dùng có tài khoản đăng nhập riêng, có thể đặt chỗ thay mặt cho du khách và theo dõi hoa hồng đã kiếm được.",
        "concierge_booker_allowed": {
            "quick_guest_booking": "Đặt phòng khách nhanh chóng",
            "individual_user_login": "Đăng nhập người dùng cá nhân",
            "commission_tracking": "Theo dõi hoa hồng",
            "easy_web_access": "Truy cập Web dễ dàng",
            "partner_friendly_setup": "Cài đặt thân thiện với đối tác"
        },
        "gojo_api": "API Hành Trình Tốt",
        "gojo_api_description": "Xây dựng với sự tự tin. Truy cập cổng thông tin dành cho nhà phát triển của chúng tôi để khám phá tài liệu tham khảo API, hướng dẫn tích hợp và các quy trình mẫu cho đặt chỗ, điều phối, thanh toán và nhiều hơn nữa.",
        "gojo_api_allowed": {
            "comprehensive_api_reference": "Tài liệu tham khảo API toàn diện",
            "integration_guides": "Hướng dẫn tích hợp",
            "sandbox_testing_tools": "Công cụ Sandbox & Kiểm thử"
        },
        "gojo_canvas": "Canvas Hành Trình Tốt",
        "gojo_canvas_description": "Thiết kế và tùy chỉnh trải nghiệm super-app của bạn. Good Journey Canvas mang đến cho bạn quyền kiểm soát sáng tạo hoàn toàn để quản lý menu, biểu mẫu giao hàng, khuyến mãi và bố cục màn hình chính — tất cả từ một giao diện đơn giản.",
        "gojo_canvas_allowed": {
            "menu_management": "Quản lý Menu",
            "custom_delivery_forms": "Biểu mẫu giao hàng tùy chỉnh",
            "super_app_home_builder": "Super-App Xây Dựng Nhà",
            "promotion_advertising": "Khuyến mãi & Quảng cáo",
            "flexible_content_management": "Quản lý Nội dung Linh hoạt"
        },
        "gojo_chatbot": "Chat Bot AI Hành Trình Tốt",
        "gojo_chatbot_description": "Đặt chuyến đi chỉ bằng một cuộc trò chuyện. Trợ lý trò chuyện được hỗ trợ bởi AI giúp khách hàng, đối tác hoặc nhân viên tạo đặt chỗ ngay lập tức — bằng cách gõ yêu cầu, nói tự nhiên, hoặc thậm chí tải lên lịch trình.",
        "gojo_chatbot_allowed": {
            "conversational_booking": "Đặt chỗ qua hội thoại",
            "file_itinerary_uploads": "Tải lên Tệp & Lịch trình",
            "multi_channel_access": "Truy cập Đa Kênh",
            "smart_suggestions": "Gợi ý thông minh",
            "operator_assistance": "Hỗ trợ Điều hành"
        },
        "concierge_booker_web_setting": "Cài đặt - Người đặt phòng Concierge",
        "pax_app_setting": "Cài đặt - Ứng dụng Hành khách",
        "driver_app_setting": "Cài đặt - Ứng dụng Tài xế Toàn cầu",
        "pax_web_setting": "Cài đặt - Ứng dụng Đặt chỗ Trực tuyến",
        "driver_web_setting": "Cài đặt - Ứng dụng Web Driver",
        "save": "Lưu",
        "cancel": "Hủy",
        "themes": "Chủ đề",
        "links": "Liên kết",
        "ios_driver_app": "Ứng dụng Driver iOS",
        "android_driver_app": "Ứng dụng Driver Android",
        "gallery_driver_app": "Ứng dụng Lái xe Gallery",
        "ios_pax_app": "Ứng dụng Hành khách iOS",
        "android_pax_app": "Ứng dụng Hành khách Android",
        "gallery_pax_app": "Ứng dụng Hành khách Gallery",
        "light_mode": "Chế độ sáng",
        "dark_mode": "Chế độ tối",
        "primary_color": "Màu Sắc Chính",
        "secondary_color": "Màu phụ",
        "longName": "PWA Tên Dài",
        "shortName": "Tên ngắn PWA",
        "adsTracking": "Theo dõi quảng cáo",
        "googleId": "Mã ID Tag của Google",
        "metaId": "ID Pixel Meta",
        "customUrl": "Liên kết Web Đặt chỗ",
        "partnerLink": "Liên kết Web Đối tác",
        "webBookingSettings": "Cài đặt Đặt chỗ Trực tuyến",
        "enableBookNow": "Đặt chỗ ngay",
        "enableBookLater": "Đặt chỗ sau",
        "enableGuestCheckout": "Thanh toán khách",
        "icon192": "Biểu tượng ứng dụng PWA (192x192)",
        "icon512": "Biểu tượng ứng dụng PWA (512x512)",
        "icon192Driver": "Biểu tượng ứng dụng PWA (192x192)",
        "icon512Driver": "Biểu tượng ứng dụng PWA (512x512)",
        "pax_app": "Ứng dụng hành khách",
        "default": "Mặc định",
        "customized": "Tùy chỉnh",
        "quoteSettings": "Quote Settings",
        "html": "HTML",
        "about": "Về",
        "email": "Hỗ trợ qua email",
        "enablePhone": "Số điện thoại",
        "phone": "Please provide the text you would like me to translate to Vietnamese.",
        "policy": "Liên kết Chính sách Bảo mật",
        "termOfUse": "Liên kết Điều khoản Sử dụng",
        "site": "Trang web",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "Tệp HTML",
        "Update_fail": "Các lỗi đã xảy ra",
        "Update_success": "Cài đặt đã được cập nhật thành công",
        "driverSignUp": "Liên kết Đăng Ký Tài Xế",
        "customUrlDriver": "Liên kết Ứng dụng Web Lái xe"
    },
    "APIKeySetting": {
        "APIKey": "Khóa API",
        "APIKey_title": "Không chia sẻ API key công khai. Để bảo vệ tài khoản, Good Journey sẽ tự động vô hiệu hóa bất kỳ API key nào bị rò rỉ.",
        "newKeyBtn": "Tạo key mới",
        "updateApplication": "Cập nhật app",
        "RegisterApp": "Đăng ký app mới",
        "RegisterBtn": "Đăng ký app",
        "appDescription": "Mô tả app",
        "webhookUrl": "Điểm cuối Webhook",
        "appName": "Tên app",
        "clientKey": "Khóa Khách Hàng",
        "secretKey": "Khóa bí mật",
        "hostedEndPoint": "Điểm cuối được lưu trữ",
        "maxEndpoints": "Bạn có thể có tối đa 5 endpoints",
        "addEndpoint": "Thêm Endpoint",
        "updateEndpoint": "Cập nhật Endpoint",
        "ManageWebhooks": "Quản lý Webhooks",
        "CreateWebhook": "Tạo Webhooks",
        "subscriptionID": "ID đăng ký",
        "webhookURL": "URL Webhook",
        "signingSecret": "Chữ ký bí mật",
        "eventsToSend": "Sự kiện để gửi",
        "listeningFor": "Nghe Để",
        "assignedDriver": "Tài xế được chỉ định",
        "bookingStatus": "Trạng thái chuyến xe",
        "driverLocation": "Vị trí tài xế",
        "titleSigningSecret": "Secrect key này được cung cấp bởi đối tác. Nếu Secrect Key bị xâm phạm, bạn có thể cập nhật hoặc xóa webhook.",
        "notUsingHTTPS": "URL Webhook không sử dụng HTTPS.",
        "invalidURL": "URL Webhook không hợp lệ.",
        "clientType": "Loại Client",
        "individual": "Cá nhân",
        "corporate": "Doanh nghiệp",
        "signingSecretLength": "Signing Secrect phải có ít nhất 30 ký tự.",
        "bookingCreated": "Chuyến xe được tạo",
        "partner": "Đối tác",
        "fleetManager": "Quản lý đội xe",
        "apiProvider": "Nhà cung cấp API",
        "selectAPITitle": "Chọn API mà bạn muốn tích hợp",
        "isAutoAccept": "Tự động chấp nhận đặt chỗ",
        "isAutoAcceptPA": "Tự động chấp nhận sửa đổi đang chờ",
        "assignedVehicle": "Xe được phân công"
    },
    "messages": {
        "credits": {
            "406": "Không thể thực hiện thao tác",
            "407": "Không thể thực hiện thao tác",
            "416": "Phiếu giảm giá đã sử dụng",
            "417": "Tài khoản của bạn không hoạt động. Vui lòng liên hệ với quản trị viên.",
            "418": "Đã xảy ra lỗi khi thực hiện thanh toán.",
            "419": "Mã ưu đãi không hợp lệ",
            "420": "Mã đã được sử dụng. Vui lòng nhập mã ưu đãi khác.",
            "421": "Số thẻ không hợp lệ.",
            "422": "Ngày hết hạn không hợp lệ.",
            "429": "Mã vùng không hợp lệ.",
            "430": "Mã AVS không trùng khớp",
            "431": "Mã AVS chưa xác thực",
            "432": "CVV không hợp lệ.",
            "433": "CVV không trùng khớp",
            "434": "CVV chưa xác thực",
            "435": "Ngân hàng cấp CVV chưa tham gia hệ thống xác thực",
            "436": "Thẻ bị từ chối",
            "437": "Credit card verification failed. Please check your information and try again.",
            "439": "Không thể xử lý CVV",
            "441": "Không có dữ liệu CVV từ nhà phát hành.",
            "443": "Không có dữ liệu từ ngân hàng phát hành",
            "445": "Hệ thống AVS không thể xử lý",
            "446": "Ngân hàng phát hành không hỗ trợ AVS",
            "447": "Hệ thống của bạn không được hỗ trợ AVS ",
            "448": "Thẻ của bạn đã bị khóa vì xảy ra sự cố thanh toán nhiều lần liên tiếp. Vui lòng thay đổi phương thức thanh toán hoặc thử lại sau",
            "452": "Thẻ bị từ chối. Vui lòng dùng thẻ tín dụng khác cùng khu vực đăng ký với số điện thoại của bạn.",
            "453": "Cổng thanh toán này không được hỗ trợ",
            "454": "Địa chỉ AVS không khớp",
            "455": "Mã vùng và địa chỉ không trùng khớp",
            "458": "Xác thực thất bại",
            "459": "Không hỗ trợ thẻ ngân hàng",
            "461": "Không hỗ trợ loại thẻ này",
            "462": "Tên chủ thẻ không hợp lệ",
            "463": "Mã không đúng. Vui lòng thử lại",
            "464": "Ngân hàng không hỗ trợ tạo và gửi mã xác minh.",
            "470": "Vui lòng nhập địa chỉ email của khách trước khi đặt xe bằng thẻ tín dụng.",
            "474": "Vui lòng nhập tên khách trước khi tạo đặt xe bằng thẻ tín dụng.",
            "475": "Vui lòng nhập số điện thoại",
            "476": "Số tiền không hợp lệ",
            "524": "Tài khoản không đủ tiền để thực hiện giao dịch.",
            "911": "Không thể xác thực phương thức thanh toán. Vui lòng chọn một phương thức khác và thử lại.",
            "2000": "Không được chấp nhận",
            "2001": "Tài khoản không đủ tiền để thực hiện giao dịch.",
            "2002": "Vượt quá số lần giao dịch cho phép",
            "2003": "Vượt quá giới hạn hoạt động của chủ thẻ",
            "2004": "Thẻ hết hạn",
            "2005": "Số thẻ không hợp lệ",
            "2006": "Ngày hết hạn không hợp lệ",
            "2007": "Không tìm thấy tài khoản",
            "2008": "Lỗi độ dài tài khoản thẻ",
            "2009": "Không tồn tại nhà cung cấp này",
            "2010": "Nhà phát hành thẻ từ chối CVV",
            "2011": "Yêu cầu ủy quyền bằng giọng nói. Ngân hàng của chủ thẻ yêu cầu thực hiện cuộc gọi lấy mã ủy quyền để hoàn tất giao dịch này.",
            "2012": "Từ chối - Thẻ có thể đã bị mất",
            "2013": "Từ chối - Thẻ có thể đã bị mất",
            "2014": "Từ chối - Nghi ngờ có gian lận",
            "2015": "Giao dịch không được cho phép",
            "2016": "Giao dịch trùng lặp",
            "2017": "Chủ thẻ đã ngừng thanh toán",
            "2018": "Chủ thẻ đã ngừng thanh toán",
            "2019": "Giao dịch không hợp lệ",
            "2020": "Vi phạm",
            "2021": "Vi phạm bảo mật",
            "2022": "Từ chối - Có sẵn chủ thẻ cập nhật",
            "2023": "Tính năng này không được hỗ trợ",
            "2024": "Loại thẻ không được kích hoạt",
            "2025": "Lỗi thiết lập - Nhà cung cấp",
            "2026": "ID nhà cung cấp không hợp lệ",
            "2027": "Lỗi thiết lập - Số tiền",
            "2028": "Lỗi thiết lập - Phân cấp",
            "2029": "Lỗi thiết lập - Thẻ",
            "2030": "Lỗi thiết lập - Sảnh hoạt động",
            "2031": "Lỗi mã hóa",
            "2032": "Không cho phép phụ thu",
            "2033": "Dữ liệu không nhất quán",
            "2034": "Chưa thực hiện thao tác nào",
            "2035": "Phê duyệt một phần cho số tiền đối với phiên bản của bên thứ III",
            "2036": "Không tìm thấy ủy quyền để hoàn tác",
            "2037": "Đã hoàn tác",
            "2038": "Xử lí thất bại. Ngân hàng của khách hàng không chấp nhận giao dịch, liên hệ với ngân hàng để biết thêm chi tiết.",
            "2039": "Mã ủy quyền không hợp lệ",
            "2040": "Cửa hàng không khả dụng",
            "2041": "Từ chối - Gọi để được hỗ trợ",
            "2042": "ID khách hàng không hợp lệ",
            "2043": "Đã xảy ra lỗi - Vui lòng không thử lại, gọi cho nhà phát hành.",
            "2044": "Từ chối - Gọi cho nhà phát hành",
            "2045": "Số nhà phát hành không hợp lệ",
            "2046": "Ngân hàng của khách hàng không chấp nhận giao dịch, cần liên hệ với ngân hàng để biết thêm chi tiết.",
            "2047": "Gọi nhà phát hành để nhận lại thẻ. Lỗi này được báo cáo bởi chủ thẻ là thẻ đã bị mất hoặc bị đánh cắp. Công ty thẻ đang yêu cầu người nắm giữ thẻ hiện tại gọi theo số ở mặt sau để báo cáo",
            "2048": "Số tiền không hợp lệ",
            "2049": "Số SKU không hợp lệ",
            "2050": "Gói tín dụng không hợp lệ",
            "2051": "Số thẻ tín dụng không khớp với phương thức thanh toán",
            "2052": "Giao dịch cấp độ III không hợp lệ",
            "2053": "Thẻ đã bị mất hoặc bị đánh cắp",
            "2054": "Số tiền hoàn tác không khớp với số tiền đã ủy quyền",
            "2055": "Số giao dịch không hợp lệ",
            "2056": "Số tiền giao dịch vượt quá giới hạn giao dịch",
            "2057": "Nhà phát hành hoặc Chủ thẻ đã giới hạn loại thẻ này",
            "2058": "Người bán chưa kích hoạt bảo mật MasterCard.",
            "2060": "Xác minh địa chỉ và bảo mật thẻ không thành công",
            "2061": "Dữ liệu giao dịch không hợp lệ",
            "2062": "Số tiền thuế không hợp lệ",
            "2064": "Mã tiền tệ không hợp lệ",
            "2078": "Dữ liệu thanh toán an toàn không hợp lệ",
            "2080": "Thông tin người dùng không hợp lệ",
            "3000": "Mạng xử lí không khả dụng - Vui lòng thử lại",
            "4001": "Thanh toán bị từ chối",
            "4006": "Số tiền ghi nhận vượt quá giới hạn cho phép",
            "81703": "Loại thẻ này không được hỗ trợ bởi tài khoản nhà cung cấp.",
            "81706": "Yêu cầu CVV.",
            "81707": "CVV phải từ 3 hoặc 4 chữ số.",
            "81709": "Yêu cầu nhập ngày hết hạn.",
            "81710": "Ngày hết hạn không hợp lệ.",
            "81714": "Yêu cầu nhập số thẻ.",
            "81715": "Số thẻ không hợp lệ.",
            "81716": "Số thẻ tín dụng phải có từ 12–19 chữ số",
            "81717": "Số thẻ tín dụng không phải là số kiểm tra được chấp nhận.",
            "81718": "Số thẻ tín dụng không thể cập nhật vì loại thẻ này không được hỗ trợ.",
            "81723": "Tên chủ thẻ quá dài. Tối đa 175 ký tự.",
            "81809": "Mã bưu chính không được chứa quá 9 chữ cái hoặc chữ số.",
            "81813": "Mã bưu chính chỉ có thể chứa chữ cái, số, dấu cách và dấu gạch nối",
            "91722": "Mã token phương thức thanh toán không hợp lệ.",
            "91723": "Cập nhật token không hợp lệ.",
            "91730": "Không hỗ trợ xác thực trên tài khoản nhà cung cấp này.",
            "91734": "Loại thẻ tín dụng không được tài khoản nhà cung cấp này chấp nhận.",
            "91738": "Phương thức thanh toán được nhập không phải là thẻ tín dụng hợp lệ.",
            "91745": "Tham số không hợp lệ để cập nhật thẻ tín dụng.",
            "91826": "Mã bưu chính không hợp lệ. Mã bưu chính phải gồm 5 hoặc 9 chữ số, có thể phân tách bằng dấu gạch ngang hoặc dấu cách.",
            "-1": "Tài khoản này đã bị vô hiệu hóa. Vui lòng liên hệ với quản trị viên."
        },
        "reBookingMsg": {
            "303": "Thời gian bạn chọn phải trễ hơn thời gian hiện tại",
            "304": "Không tìm thấy chuyến xe này",
            "500": "Thông tin chuyến xe bị thiếu hoặc không hợp lệ. Vui lòng kiểm tra và thử lại"
        },
        "promoMsg": {
            "304": "Mã ưu đãi không hợp lệ",
            "306": "Mã ưu đãi không hợp lệ. Ưu đãi chỉ được áp dụng cho các khu vực khác.",
            "413": "Rất tiếc, mã ưu đãi không khả dụng",
            "414": "Mã ưu đãi không hợp lệ",
            "415": "Mã ưu đãi không hợp lệ",
            "416": "Mã ưu đãi đã được sử dụng.",
            "419": "Rất tiếc, mã ưu đãi không khả dụng",
            "420": "Rất tiếc, bạn đã đạt giới hạn sử dụng ưu đãi",
            "421": "Rất tiếc, mã ưu đãi này đã đạt giới hạn sử dụng",
            "422": "Rất tiếc, tài khoản của bạn không thể sử dụng mã ưu đãi này",
            "423": "Rất tiếc, bạn đã đạt giới hạn ngân sách ưu đãi",
            "424": "Mã ưu đãi không hợp lệ. Ưu đãi chỉ được áp dụng cho khách hàng được giới thiệu.",
            "425": "Mã ưu đãi này đã đạt đến giới hạn sử dụng mỗi ngày.",
            "426": "Mã ưu đãi của bạn đã đạt mức giới hạn sử dụng trong ngày",
            "427": "Hồ sơ KH chưa hoàn tất, không thể áp dụng mã ưu đãi.",
            "428": "Khách hàng đã dùng hết mã ưu đãi tháng này.",
            "430": "Khách hàng đã dùng hết mã ưu đãi năm nay.",
            "431": "Mã ưu đãi không áp dụng cho phương thức thanh toán này.",
            "432": "Cước phí của bạn chưa đủ điều kiện để áp dụng mã ưu đãi.",
            "433": "Không thể áp dụng mã ưu đãi cho thời điểm bạn chọn.",
            "434": "Rất tiếc, bạn đã đạt giới hạn ngân sách ưu đãi",
            "phoneInvalid": "Vui lòng nhập số điện thoại của hành khách trước khi sử dụng mã ưu đãi"
        },
        "updateBookingMsg": {
            "303": "Không thể cập nhật thông tin chuyến xe. Vui lòng thử lại sau!",
            "304": "Không tìm thấy chuyến xe này",
            "pickUpTime": "Thời gian bạn chọn phải trễ hơn thời gian hiện tại",
            "pickup": "Dịch vụ đặt xe không được hỗ trợ trong khu vực này",
            "destination": "Thông tin chuyến xe bị thiếu hoặc không hợp lệ. Vui lòng kiểm tra và thử lại",
            "dispatchType": "Thông tin chuyến xe bị thiếu hoặc không hợp lệ. Vui lòng kiểm tra và thử lại"
        },
        "sessionExpired": {
            "403": "Bạn đã bị đăng xuất vì tài khoản của bạn đang được đăng nhập từ một thiết bị khác hoặc phiên của bạn đã hết hạn"
        },
        "not_found": {
            "404": "Không tìm thấy trang yêu cầu"
        },
        "booking": {
            "303": "Thời gian bạn chọn phải trễ hơn thời gian hiện tại",
            "304": "Đặt xe {0} cập nhật thất bại do vẫn đang xử lý. Vui lòng thử lại sau",
            "305": "Chuyến xe đã bị hủy hoặc hoàn tất bởi Booking.com; vui lòng từ chối để xóa chuyến xe khỏi hàng đợi.",
            "306": "Xe chưa được gán giá. Hãy vào Cài đặt > Xe > Loại xe để thêm giá",
            "307": "Không thể cập nhật chuyến xe. Vui lòng thử lại sau.",
            "407": "Loại giá không hỗ trợ thêm điểm đến",
            "500": "Thông tin chuyến xe bị thiếu hoặc không hợp lệ. Vui lòng kiểm tra và thử lại",
            "upgroup_success": "Chuyến xe đã tách nhóm thành công",
            "Please_Select_driver": "Vui lòng chọn tài xế",
            "assign_driver_vehicle_success": "Tài xế/Xe đã được gán thành công",
            "assign_driver_success": "Tài xế đã được gán thành công",
            "detach_driver_success": "Tài xế đã được gỡ bỏ thành công",
            "detach_vehicle_success": "Xe đã được gỡ bỏ thành công",
            "Group_success": "Chuyến xe đã được nhóm thành công.",
            "change_supplier_success": "Chuyến xe đã thay đổi nhà cung cấp thành công.",
            "change_supplier_partial": "Gán hàng loạt thất bại đối với các chuyến đi sau (Booking IDs) do vẫn đang xử lý: {0}.",
            "detach_driver_partial": "Gán hàng loạt thất bại đối với các chuyến đi sau (Booking IDs) do vẫn đang xử lý: {0}.",
            "assign_driver_partial": "Gán hàng loạt thất bại đối với các chuyến đi sau (Booking IDs) do vẫn đang xử lý: {0}.",
            "update_dispatch": "Cập nhật & Điều phối",
            "remove_booking_false": "Không thể xóa chuyến xe",
            "remove_booking_success": "Đã xóa chuyến xe thành công",
            "GROUP_NOT_FOUND": "Không tìm thấy ID nhóm",
            "NO_SHARING_BOOKINGS": "Chỉ có thể nhóm chuyến nếu chuyến xe của khách hàng cho phép đi chung xe.",
            "DIFFERENT_CAR_TYPES": "Chuyến xe bạn đang nhóm có loại xe khác",
            "LIMIT_EXCEEDED_ON_SEATS_OR_LUGGAGE": "Không thể nhóm chuyến: Vượt quá giới hạn ghế hoặc hành lý.",
            "INVALID_CAR_TYPE": "Không thể chỉ định tài xế, kiểm tra sức chứa ghế & hành lý của phương tiện.",
            "VALIDATION_ERROR": "Lỗi xác nhận",
            "INTERNAL": "Lỗi máy chủ nội bộ",
            "fare_gt_zero": "Cước phí phải lớn hơn 0!",
            "edit_total_fail": "Chỉnh sửa tổng giá trị thất bại!",
            "complete_fail": "Không thể hoàn tất yêu cầu đặt xe!",
            "cancle_fail": "Có lỗi xảy ra khi hủy yêu cầu đặt xe. Vui lòng thử lại!",
            "incident_fail": "Không thể báo cáo sự cố",
            "phone_invalid": "Vui lòng nhập số điện thoại hợp lệ!",
            "add_psg_fail": "Không thể thêm khách hàng mới",
            "REMOVE_RECIPIENT_DELIVERED": "Không thể xóa người nhận đã được giao.",
            "REMOVE_LAST_ACTIVE_RECIPIENT": "Không thể xóa người nhận hoạt động cuối cùng.",
            "ORDER_HAS_BEEN_FINISHED": "Đơn hàng đã hoàn tất.",
            "end_booking_leave": "Thoát khỏi trang này sẽ kết thúc đặt xe của bạn.",
            "update_booking_fail": "Không cập nhật được thông tin chuyến xe.",
            "EXTERNAL_ID_EXISTED": "ID ngoài đã tồn tại trên hệ thống.",
            "area_service_unavailable": "Dịch vụ đặt xe không được hỗ trợ trong khu vực này",
            "pickupSameDestination": "Pick-up address must be different from the destination.",
            "time_invalid": "Thời gian bạn chọn phải trễ hơn thời gian hiện tại",
            "psg_inactivate": "Tài khoản khách hàng này đã bị hủy kích hoạt. Vui lòng liên hệ tổng đài.",
            "data_incorect": "Đã xảy ra lỗi. Vui lòng thử lại sau.",
            "preAuthorize": "Vui lòng kiểm tra tài khoản của bạn, cần số tiền {0} để đảm bảo chuyến xe.",
            "booking_limited": "Rất tiếc, bạn đã đạt giới hạn đặt xe mỗi phút/ngày. Vui lòng thử lại sau.",
            "minimumBookAhead": "Thời gian đặt trước phải cách thời điểm hiện tại ít nhất {0} giờ {1} phút.",
            "exDoDiffDo": "Điểm đến bổ sung phải khác với điểm đến chính.",
            "recurringTimeRange": "Ngày không hợp lệ. Bạn chỉ có thể đặt xe trước tối đa {0} tháng. Vui lòng liên hệ quản trị viên.",
            "recipientsLimit": "Số lượng người nhận tối đa là {0}.",
            "maximumBookAhead": "Thời gian đặt trước không được muộn hơn {0} ngày so với thời điểm hiện tại.",
            "Please_select_or_add_a_card": "Vui lòng chọn hoặc thêm thẻ!",
            "Unable_to_process_by_fare_zero": "Không thể xử lý yêu cầu của bạn, vui lòng thay đổi loại xe hoặc loại dịch vụ rồi thử lại. Nếu cần, liên hệ đội ngũ hỗ trợ.",
            "Can_not_connect_to_server": "Không thể kết nối với máy chủ!",
            "Check_connection_or_contact_system_support": "Vui lòng kiểm tra kết nối của bạn hoặc liên hệ bộ phận hỗ trợ hệ thống để được giúp đỡ!",
            "Create_new_booking_success": "Chuyến xe mới đã được tạo thành công!",
            "Create_new_recurring_booking_success": "Các chuyến xe mới đã được tạo thành công!",
            "Update_booking_success": "Chuyến xe này đã được cập nhật thành công!",
            "addon_exceeded": "{0} đã vượt quá giới hạn.",
            "addon_exceeded_with_params": "Vui lòng nạp tiền vào ví để tiếp tục sử dụng {0}.",
            "Booking_drop_of_success": "Trả khách thành công!",
            "Cancel_booking_success": "Chuyến xe này đã được hủy thành công!",
            "Cancel_booking_fails": "Đặt chỗ này không thể bị hủy!",
            "adjust_fare_booking_success": "Giá cước đã được điều chỉnh thành công!",
            "adjust_fare_booking_fail": "Điều chỉnh giá cước thất bại!",
            "Booking_detail_not_found": "Không tìm thấy thông tin chuyến xe!",
            "Check_promo_error": "Lỗi kiểm tra mã ưu đãi!",
            "Invalid_format": "Định dạng không hợp lệ",
            "Flight_not_found": "Không tìm thấy chuyến bay!",
            "Add_new_credit_error": "Lỗi thêm tín dụng mới!",
            "Socket_server_disconnected": "Máy chủ socket bị ngắt kết nối!",
            "Please_reload_page_or_check_your_connection": "Rất tiếc. Yêu cầu của bạn không thể xử lý. Vui lòng thử lại.",
            "request_timeout": "Rất tiếc. Yêu cầu của bạn đã hết thời gian xử lý. Vui lòng thử lại.",
            "Check_customer_error": "Lỗi kiểm tra khách hàng!",
            "Please_select_car_type": "Vui lòng chọn loại xe",
            "DropOff_country": "Không hỗ trợ trả khách tại điểm đến đã chọn. Vui lòng chọn loại xe khác hoặc thay đổi hành trình.",
            "Different_Country": "Điểm đón và trả khách phải ở hai quốc gia khác nhau.",
            "Please_enter_destination_for_ridesharing_booking": "Vui lòng nhập điểm đến cho chuyến xe đi chung",
            "Extra_detination_must_be_difference_from_destination": "Điểm đến bổ sung phải khác với điểm đến hiện tại",
            "Pickup_address_must_be_different_from_destination": "Pick-up address must be different from destination",
            "Best_price": "Giá tốt nhất",
            "You_may_be_charged_extra_fee_if_your_trip_excceds": "Bạn có thể bị tính phí bổ sung nếu chuyến đi vượt quá",
            "You_may_be_charged_extra_fee_if_your_trip_excceds_with_params": "Bạn có thể bị tính phí bổ sung nếu chuyến đi vượt quá {0} {1}, {2} {3}.",
            "Reject_booking_success": "Chuyến xe này đã bị từ chối thành công!",
            "Reject_fail": "Đã xảy ra lỗi khi từ chối chuyến xe này. Vui lòng thử lại!",
            "Please_select_payment_method": "Vui lòng chọn phương thức thanh toán",
            "Driver_signed_out_or_deactivated": "Tài xế này vừa đăng xuất hoặc đã bị vô hiệu hóa",
            "reservation_booking_overlaps": "Rất tiếc, chuyến xe này bị trùng với một chuyến xe khác mà tài xế đã nhận.",
            "driver_is_not_available": "Rất tiếc, tài xế này hiện không hoạt động.",
            "seats_luggage_limit": "Không thể gán chuyến xe cho tài xế. Số ghế hoặc hành lý vượt quá giới hạn.",
            "full_capacity": "Không thể gán chuyến xe này cho tài xế vì chuyến đã đạt giới hạn tối đa.",
            "marked_failed_ok": "Đơn hàng đã được đánh dấu là thất bại.",
            "warning_markFail_lastRecipient": "Đây là người nhận cuối cùng của đơn hàng. Bạn cần hoàn tất đơn nếu muốn đánh dấu giao đơn hàng này thất bại.",
            "BOOKINGS_LIMIT_EXCEEDED": "Bạn chỉ có thể gán tối đa 5 đơn hàng vào mỗi nhóm",
            "bookingCanceled": "Chuyến xe đã bị hủy hoặc hoàn tất bởi Booking.com; vui lòng từ chối để xóa chuyến xe khỏi hàng đợi.",
            "contact_info_required": "Vui lòng chọn một hồ sơ người dùng hợp lệ hoặc tạo một hồ sơ mới trước khi tiếp tục. Ngoài ra, bạn có thể tạo một đặt chỗ cho khách.",
            "UNSUPPORTED_ZONE": "Khu vực không được hỗ trợ",
            "INVALID_GUEST_PHONE_NUMBER": "Số điện thoại hành khách không hợp lệ",
            "NEGATIVE_FLEET_BALANCE": "Có vẻ như số dư của bạn quá thấp để tạo một đặt chỗ mới. Vui lòng thêm tiền hoặc thanh toán bất kỳ khoản nợ nào để tiếp tục."
        },
        "item_no_found": "Không tìm thấy mục nào",
        "commonMessages": {
            "greater_than_0": "Nhập giá trị lớn hơn 0",
            "Required_field": "Trường này là bắt buộc",
            "bankPhone_is_required": "Số điện thoại không hợp lệ",
            "bankPhone": "Số điện thoại",
            "distance_from_equa_or_smaller": "The distance 'Từ' must be smaller than or equal to the distance 'Đến'",
            "must_be_number": "Vui lòng nhập số hợp lệ",
            "equal_or_greater_than_0": "Vui lòng nhập giá trị bằng hoặc lớn hơn 0.",
            "must_be_integer": "Vui lòng nhập số nguyên",
            "invalid_email_format": "Vui lòng nhập email hợp lệ",
            "greater_or_equa": "Vui lòng nhập giá trị lớn hơn hoặc bằng {0}.",
            "value_must_between": "Vui lòng nhập giá trị trong khoảng từ {0} đến {1}.",
            "large_10x_markup_price": "Giá cước đã chỉnh sửa không được vượt quá 10 lần giá ước tính.",
            "greater_than": "Vui lòng nhập giá trị lớn hơn {0}.",
            "less_than": "Vui lòng nhập giá trị nhỏ hơn {0}.",
            "less_or_equal": "Vui lòng nhập giá trị nhỏ hơn hoặc bằng {0}.",
            "driver_earnings_warning": "Thanh toán ngoại tuyến: Thu nhập của tài xế không được vượt quá giá cước đã thu.",
            "limit_amount": "Vui lòng nhập giá trị nhỏ hơn hoặc bằng số tiền giới hạn",
            "Integer_from_range": "Vui lòng nhập số nguyên từ {0} đến {1}",
            "integer_greater_than_0": "Vui lòng nhập số nguyên lớn hơn 0. (Nhỏ hơn 100 với dấu phân cách phần trăm và số thập phân là 1 ký tự)",
            "Error_message": "Lỗi!",
            "callcenter_newbooking_message": "Yêu cầu đặt xe mới với số điện thoại <span class='bold'>{0}</span>",
            "callcenter_existed_booking_message": "Một chuyến xe đang hoạt động <span class='bold'>#{0}</span> tồn tại với số điện thoại <span class='bold'>{1}</span>",
            "callcenter_close_newbooking_form_warning": "Vui lòng hoàn tất hoặc đóng chuyến xe hiện tại trước khi nhận yêu cầu khách hàng mới",
            "Emergency_SOS_Title": "Khẩn cấp SOS",
            "Please_enter_a_future_date": "Vui lòng nhập một ngày trong tương lai",
            "Card_holder_is_required": "Cần nhập tên chủ thẻ",
            "Card_number_is_required": "Cần nhập số thẻ",
            "Expired_date_is_required": "Cần nhập ngày hết hạn",
            "Credit_code_is_required": "Vui lòng nhập mã tín dụng (xác thực cuối cùng)",
            "Expired_date_is_invalid": "Ngày hết hạn không hợp lệ. Vui lòng nhập theo định dạng mm/yy",
            "cvv_is_required": "Cần nhập CVV",
            "City_is_required": "Cần nhập thành phố",
            "State_is_required": "Cần nhập bang/tỉnh",
            "Address_is_required": "Cần nhập địa chỉ",
            "Zipcode_is_required": "Cần nhập mã bưu chính",
            "Country_is_required": "Cần nhập quốc gia",
            "Over_query_limit": "Google API không thể tải do lỗi tạm thời. Vui lòng thử lại sau",
            "outOfInputQueueOrder": "Số thứ tự đơn hàng không được lớn hơn tổng số tài xế trong hàng đợi.",
            "Same_pickup_destination": "Pick-up address must be different from destionation address.",
            "Max_length": "Độ dài tối đa là {0} ký tự.",
            "choose_at_least_one": "Vui lòng chọn ít nhất một tùy chọn.",
            "choose_at_least_one_intercity_schedule": "Vui lòng thêm lịch trình hoặc cho phép khách hàng chọn thời gian mong muốn.",
            "startDate_greater_than_endDate": "Ngày bắt đầu lớn hơn ngày kết thúc"
        },
        "trip": {
            "cancel_trip_success": "Chuyến đã được hủy thành công!",
            "data_incorect": "Chưa có tài xế nào được chỉ định. Chọn tài xế từ danh sách hoặc chọn Tự động điều phối để gán sau.",
            "INTERNAL": "Lỗi máy chủ nội bộ.",
            "NOT_FOUND": "Không tìm thấy chuyến hoặc trạng thái không hợp lệ.",
            "SAME_DRIVER": "Tài xế được chỉ định phải khác với tài xế hiện tại.",
            "OVERLAP": "Rất tiếc, chuyến này bị trùng với một chuyến khác mà tài xế đã nhận.",
            "CANNOT_ASSIGN": "Tài xế này không hợp lệ (không tìm thấy, không trực tuyến hoặc chưa đăng nhập)."
        },
        "car_mgmt": {
            "Search_car_color": "Tìm màu xe",
            "Searching": "Đang tìm kiếm"
        },
        "driver_note": {
            "Search_driver_note": "Tìm ghi chú tài xế",
            "Searching": "Đang tìm kiếm"
        }
    },
    "errors": {
        "303": "Không tìm thấy người dùng",
        "453": "Cổng thanh toán không hỗ trợ",
        "553": "Rất tiếc! Khách hàng đang trên xe, vui lòng thử lại sau.",
        "1007": "Khoảng thời gian giữa ngày bắt đầu và ngày kết thúc phải dưới 60 ngày!!",
        "3001": "Số điện thoại đã tồn tại",
        "3002": "Invalid Ngày sinh",
        "3003": "Ngày hết hạn không hợp lệ",
        "3004": "Không tìm thấy tài xế",
        "3005": "Thiếu thông tin thanh toán của tài xế (địa chỉ ngân hàng, thành phố, bang/tỉnh, mã bưu chính)",
        "3006": "Missing Tài khoản ngân hàng info (nameOfAccount, typeOfAccount, routingNumber, accountNumber, ssn)",
        "3007": "Không thể chỉnh sửa tài xế này vì họ đang có chuyến",
        "3008": "Tài xế này hiện đang đăng nhập. Vui lòng yêu cầu họ đăng xuất để chỉnh sửa thông tin.",
        "3009": "Tài xế này đã nhận một hoặc nhiều chuyến xe. Vui lòng gán các chuyến xe này cho tài xế khác trước khi cập nhật/thay đổi thông tin tài xế.",
        "3010": "Kết nối điều phối thất bại.",
        "3011": "Tài xế này phải được thiết lập cho hoạt động trước khi kích hoạt.",
        "3012": "Tài xế này phải được thiết lập cho hoạt động trước khi kích hoạt.",
        "3013": "Chỉ có thể xóa những mục không hoạt động.",
        "3014": "Thiếu trường bắt buộc. Vui lòng kiểm tra.",
        "3015": "Năm sinh không hợp lệ. Vui lòng kiểm tra.",
        "3016": "Mã bưu chính không hợp lệ. Vui lòng kiểm tra.",
        "3017": "Tỉnh/khu vực không hợp lệ. Vui lòng kiểm tra.",
        "3018": "Tên tài khoản không hợp lệ. Vui lòng kiểm tra.",
        "3019": "Số định tuyến không hợp lệ. Vui lòng kiểm tra.",
        "3020": "Cần nhập ngày sinh. Vui lòng kiểm tra.",
        "3021": "Số SSN không hợp lệ. Vui lòng kiểm tra.",
        "3022": "Driver's Tài khoản ngân hàng can't receive funds.",
        "3023": "Không thể thao tác với tài xế đang đăng nhập. Vui lòng thử lại sau.",
        "3026": "Tài xế không còn tồn tại.",
        "3027": "The driver's Tài khoản ngân hàng is not set up. Please go to Drivers module to set up his Tài khoản ngân hàng.",
        "3028": "Thanh toán tài xế đã chọn thất bại. Vui lòng thử lại.",
        "3029": "Không thể xóa dữ liệu doanh thu của tài xế. Vui lòng thử lại",
        "3032": "Tên đăng nhập này đã tồn tại trên hệ thống. Vui lòng nhập tên khác.",
        "3033": "Mã BSB không hợp lệ. Số phải có 6 chữ số theo định dạng xxxxxx.",
        "3036": "Cần có Captcha",
        "3037": "Captcha không hợp lệ",
        "3039": "Cần nhập ID nhóm.",
        "3040": "Số điện thoại này đã được sử dụng bởi tài xế %{brandName} (số điện thoại không thể trùng lặp). Vui lòng nhập số khác.",
        "3041": "Tên đăng nhập đã tồn tại.",
        "3044": "Số CMND/CCCD bị trùng lặp.",
        "3045": "Tài xế đã có xe, vui lòng làm mới trang.",
        "3046": "Xe công ty và công ty của tài xế không trùng khớp.",
        "4001": "Biển số xe đã tồn tại trên hệ thống. Vui lòng nhập biển số khác.",
        "4002": "Ngày hết hạn không hợp lệ.",
        "4003": "Xe phải được vô hiệu hóa trước khi xóa.",
        "4004": "Không tìm thấy xe.",
        "4005": "Xe này đang hoạt động.",
        "4006": "Xe đang được sử dụng và không thể bị xóa hoặc vô hiệu hóa.",
        "4007": "Cần nhập biển số xe.",
        "4009": "Xe đang được gán cho chuyến.",
        "4010": "Xe đang được gán cho một tài xế.",
        "5001": "Công ty đã tồn tại.",
        "5004": "Không tìm thấy công ty.",
        "6001": "Mẫu xe đã tồn tại.",
        "6004": "Không tìm thấy mẫu xe.",
        "6005": "Mẫu xe đang được sử dụng.",
        "7001": "Tên hãng xe đã tồn tại trên hệ thống. Vui lòng nhập tên khác.",
        "7004": "Không tìm thấy hãng xe",
        "8001": "Loại xe đã tồn tại",
        "8004": "Không tìm thấy loại xe",
        "9001": "Tuyến cố định đã tồn tại",
        "9004": "Không tìm thấy tuyến cố định",
        "10001": "Khu vực đã tồn tại",
        "10004": "Không tìm thấy khu vực",
        "11001": "Khu vực đã tồn tại",
        "11002": "Khu vực này bị chồng lấn với khu vực khác. Vui lòng vẽ lại.",
        "11003": "Khu vực được vẽ phải là một hình đa giác",
        "11004": "Không tìm thấy khu vực",
        "11005": "Khu vực đang được sử dụng",
        "12001": "Hộp thư đã tồn tại",
        "12002": "Vui lòng thiết lập SMS Twilio.",
        "12004": "Không tìm thấy hộp thư",
        "12005": "Không có người nhận phù hợp với bộ lọc. Vui lòng kiểm tra danh sách và thử lại.",
        "12006": "Không có khách hàng nào trong tệp.",
        "13001": "Mã ưu đãi này đã tồn tại trên hệ thống. Vui lòng nhập mã khác.",
        "13002": "Ngày không hợp lệ",
        "13003": "Riêng tư",
        "13004": "Không tìm thấy mã ưu đãi",
        "13005": "Chỉ dành cho khách hàng mới",
        "13006": "Vượt quá giới hạn số lượng",
        "13007": "Vượt quá giới hạn ngân sách",
        "13008": "Vượt quá giới hạn tổng số lần sử dụng",
        "13011": "Chiến lược khuyến mãi này đã bị vô hiệu hóa hoặc xóa",
        "13012": "Khoảng thời gian không hợp lệ",
        "13013": "Mã ưu đãi không hợp lệ. Chương trình đang áp dụng cho khu vực khác.",
        "13014": "Khu vực bạn đã chọn đã bị vô hiệu hóa.",
        "14004": "Không tìm thấy chuyến xe",
        "15002": "Đội xe của bạn đã bị vô hiệu hóa. Vui lòng liên hệ quản trị viên",
        "15004": "Không tìm thấy đội xe",
        "16001": "Tên giá cố định đã tồn tại. Vui lòng nhập tên khác.",
        "16004": "Không tìm thấy giá cước",
        "17001": "Tên đã tồn tại",
        "17004": "Không tìm thấy giá gói",
        "18001": "Tên đã tồn tại",
        "18002": "Giá cước đang được sử dụng",
        "18004": "Không tìm thấy giá cước",
        "19001": "Tên gói của bạn đã tồn tại trên hệ thống. Vui lòng nhập tên khác.",
        "19002": "Giá cước đang được sử dụng.",
        "19004": "Không tìm thấy giá cước.",
        "20001": "Tên đăng nhập này đã tồn tại trên hệ thống. Vui lòng nhập tên khác.",
        "20002": "Tài khoản của bạn không hoạt động. Vui lòng liên hệ quản trị viên.",
        "20003": "Tên đăng nhập hoặc mật khẩu không chính xác. Vui lòng thử lại.",
        "20004": "Tên đăng nhập chưa được đăng ký.",
        "20005": "Link đã hết hạn",
        "20006": "Mật khẩu hiện tại không khớp. Vui lòng thử lại.",
        "20007": "Người dùng # đã tồn tại",
        "20008": "Email này đã tồn tại. Vui lòng nhập email khác.",
        "20012": "ID đội tàu đã tồn tại",
        "21001": "Tên quyền đã tồn tại. Vui lòng nhập tên khác.",
        "21002": "Không thể vô hiệu hóa vì quyền này đang được gán cho người dùng.",
        "21003": "Vai trò đang hoạt động",
        "21004": "Không tìm thấy vai trò",
        "22001": "Khách hàng đã tồn tại",
        "22004": "Không tìm thấy khách hàng",
        "22005": "Định dạng tệp không hợp lệ",
        "22006": "Số điện thoại đã tồn tại",
        "24001": "Số điện thoại không hợp lệ",
        "25001": "Tên này đã tồn tại. Vui lòng nhập tên khác.",
        "25002": "Khoảng thời gian không hợp lệ",
        "25004": "Không tìm thấy ca làm việc",
        "26001": "Tên này đã tồn tại. Vui lòng nhập tên khác.",
        "26002": "Ca làm việc này đang được sử dụng, vui lòng hủy gán trước khi xóa.",
        "26004": "Không tìm thấy mẫu ca làm việc",
        "27001": "Chiến dịch đã tồn tại",
        "27002": "Chiến dịch đã được kích hoạt",
        "27004": "Không tìm thấy chiến dịch",
        "28001": "Thành phố đã tồn tại",
        "28002": "Thành phố đang được kích hoạt",
        "28003": "Thành phố đang được sử dụng",
        "28004": "Không tìm thấy thành phố",
        "29002": "Số điện thoại đã tồn tại",
        "30001": "Không tìm thấy hàng đợi",
        "30002": "Hàng đợi đang được sử dụng",
        "30003": "Tên hàng đợi đã tồn tại. Vui lòng nhập tên khác.",
        "30004": "Hàng đợi không được chồng nhau",
        "30005": "Tọa độ hàng đợi không hợp lệ",
        "30006": "Pick-up areas are invalid",
        "31001": "ID công ty đã tồn tại trên hệ thống. Vui lòng nhập ID khác.",
        "31002": "Tên đăng nhập này đã tồn tại. Vui lòng nhập tên khác.",
        "31003": "Không tìm thấy công ty",
        "31004": "Không tìm thấy người dùng doanh nghiệp",
        "31005": "Chỉ các công ty không hoạt động mới có thể bị xóa.",
        "31006": "Số điện thoại này đã được sử dụng trong hệ thống người dùng doanh nghiệp. Vui lòng nhập số khác.",
        "31007": "Không tìm thấy khách doanh nghiệp.",
        "31008": "Không tìm thấy thẻ.",
        "31009": "Số điện thoại này đã tồn tại. Vui lòng nhập số khác.",
        "31010": "Doanh nghiệp này đã bị vô hiệu hóa. Vui lòng liên hệ quản trị viên để biết thêm chi tiết.",
        "31011": "Khách doanh nghiệp này không thể được kích hoạt vì tài khoản doanh nghiệp liên kết đã bị vô hiệu hóa.",
        "31013": "Tên doanh nghiệp đã tồn tại.",
        "31014": "Vui lòng gán giá cho ít nhất một loại xe.",
        "31015": "Email/Số điện thoại này đã liên kết với một tài khoản khác.",
        "31016": "Email/Số điện thoại này đã liên kết với một tài khoản doanh nghiệp khác. Vui lòng cập nhật hồ sơ hoặc xóa người dùng khỏi tài khoản hiện tại trước khi gán vào tài khoản mới.",
        "31017": "Email/Số điện thoại đang trống. Vui lòng nhập thông tin hợp lệ.",
        "32001": "Tên dịch vụ đã tồn tại trên hệ thống. Vui lòng nhập tên khác.",
        "32004": "Không tìm thấy dịch vụ.",
        "33002": "Khoảng thời gian không được chồng lấn nhau.",
        "34001": "Mã đã tồn tại.",
        "34013": "Khoảng thời gian không hợp lệ.",
        "36001": "Tên đã tồn tại",
        "39001": "Cần có tài liệu",
        "43001": "Mẫu phạt đã tồn tại",
        "43002": "Không tìm thấy mẫu phạt",
        "44001": "Mẫu giá đã tồn tại",
        "44002": "Không tìm thấy mẫu giá",
        "44003": "Mẫu giá hiện đang được sử dụng cho một doanh nghiệp. Vui lòng hủy gán trước khi xóa.",
        "45001": "Phụ phí đã tồn tại",
        "45002": "Không tìm thấy phụ phí",
        "45003": "Không tìm thấy mục phụ phí",
        "46001": "Tên đã tồn tại",
        "46002": "Không tìm thấy mục",
        "47001": "Ngừng bán hàng đã tồn tại",
        "47002": "Không tìm thấy Dừng Bán hàng",
        "48003": "Vị trí tùy chỉnh không chứa cùng một khu vực",
        "49003": "Trùng lặp doanh nghiệp trong thanh toán",
        "49004": "Imei tồn tại",
        "50001": "Add-on template existed",
        "50002": "Add-on template not found",
        "50003": "Add-on service existed",
        "50004": "Add-on service not found",
        "71001": "Phụ phí động đã tồn tại",
        "71002": "Khu vực này đang chồng lên khu vực khác. Vui lòng vẽ lại.",
        "71003": "Khu phụ phí động được vẽ phải là một hình đa giác.",
        "71004": "Không tìm thấy phụ phí động",
        "72001": "Giá cước động đã tồn tại",
        "72002": "Khu vực này đang chồng lên khu vực khác. Vui lòng vẽ lại.",
        "72003": "Khu phụ phí động được vẽ phải là một hình đa giác.",
        "72004": "Không tìm thấy giá cước động",
        "74001": "Khu vực đã tồn tại",
        "74002": "Khu vực này đang chồng lên khu vực khác. Vui lòng vẽ lại.",
        "74003": "Khu vực được vẽ phải là một hình đa giác",
        "74004": "Không tìm thấy giá cước khu vực",
        "74005": "Không tìm thấy giá cước khu vực",
        "80001": "Banner app đã tồn tại.",
        "80002": "Không tìm thấy banner app.",
        "80003": "Chỉ có thể xóa những mục không hoạt động.",
        "81001": "Tệp tải lên trống.",
        "81002": "Kích thước tệp tải lên quá lớn.",
        "82002": "Đã xảy ra lỗi khi thiết lập FlightAware. Vui lòng thử lại sau.",
        "90001": "Khu vực liên tỉnh đã tồn tại",
        "90002": "Khu vực này đang chồng lên khu vực khác. Vui lòng vẽ lại.",
        "90003": "Khu vực liên tỉnh được vẽ phải là một hình đa giác",
        "90004": "Không tìm thấy khu vực liên tỉnh",
        "90005": "Khu vực liên tỉnh đang được sử dụng",
        "91001": "Giá cước liên tỉnh đã tồn tại",
        "91002": "Giá cước liên tỉnh đang được sử dụng",
        "91003": "Không tìm thấy giá cước liên tỉnh",
        "92001": "Tên tuyến đường đã tồn tại",
        "92002": "Không tìm thấy tuyến đường",
        "92003": "Tuyến đường này đã tồn tại ở một tuyến khác, vui lòng kiểm tra và thử lại.",
        "92004": "Đang có chuyến hoạt động trên tuyến đường này.",
        "93001": "Ghi chú tài xế đã tồn tại trên hệ thống. Vui lòng nhập ghi chú khác.",
        "93002": "Chỉ có thể xóa những ghi chú không hoạt động.",
        "93003": "Ghi chú tài xế đang được sử dụng.",
        "93004": "Không tìm thấy ghi chú tài xế.",
        "94001": "Tên màu xe đã tồn tại. Vui lòng nhập tên khác.",
        "94002": "Không tìm thấy màu xe.",
        "400000": "Số điện thoại không hợp lệ!",
        "400002": "Đã xảy ra lỗi xác thực.",
        "400003": "Quyền bị từ chối.",
        "400005": "Nội dung tệp không hợp lệ.",
        "400008": "Vui lòng nhập tên khu vực",
        "500000": "Lỗi hệ thống nội bộ.",
        "500001": "Vui lòng thiết lập SMS Twilio",
        "500002": "Yêu cầu hết thời gian xử lý. Vui lòng thử lại sau",
        "500004": "Lỗi hệ thống nội bộ",
        "600001": "Không tìm thấy vị trí",
        "600002": "Tọa độ kinh độ và vĩ độ này đã tồn tại. Vui lòng nhập tọa độ khác.",
        "610001": "Danh mục đã tồn tại",
        "610002": "Không tìm thấy danh mục",
        "610003": "Danh mục đã tồn tại tại vị trí của bên liên quan",
        "700001": "Loại đang được sử dụng.",
        "700002": "Không tìm thấy đối tác.",
        "700003": "Tên loại đối tác đã tồn tại. Vui lòng nhập tên khác.",
        "800000": "Quán này đã được gán cho một tài khoản cửa hàng khác. Vui lòng chọn cửa hàng khác.",
        "800001": "Merchant's Tài khoản ngân hàng can't receive funds.",
        "800002": "Merchant's Tài khoản ngân hàng can't receive funds.",
        "limitMessage": {
            "upgrade": "Upgrade",
            "cancel": "Cancel",
            "driver": {
                "title": "Driver limit reached",
                "description": "Your current subscription allows up to %{limitation} drivers. To add more drivers, please upgrade to the higher plan."
            },
            "vehicle": {
                "title": "Vehicle limit reached",
                "description": "Your current subscription allows up to %{limitation} vehicles. To add more vehicles, please upgrade to the higher plan."
            },
            "operator": {
                "title": "Operator limit reached",
                "description": "Your current subscription allows up to %{limitation} operators. To add more operators, please upgrade to the higher plan."
            }
        },
        "31016_2": "Thông báo: Email/Số điện thoại này đã được liên kết với một tài khoản khác. Vui lòng liên hệ quản lý tài khoản để được hỗ trợ.",
        "undefined": "Đã xảy ra lỗi với máy chủ, vui lòng thử lại.",
        "completeBooking": {
            "113": "Không thể xác thực phương thức thanh toán. Vui lòng chọn phương thức khác và thử lại.",
            "450": "Số dư không đủ để thanh toán. Vui lòng chọn phương thức khác.",
            "451": "Số dư không đủ để thanh toán. Vui lòng chọn phương thức khác.",
            "521": "Ví không có đủ tiền."
        },
        "upload_file_fail": "Tệp không hợp lệ, vui lòng kiểm tra và thử lại.",
        "upload_photo_fail": "Tệp không hợp lệ, vui lòng kiểm tra và thử lại.",
        "missing_some_field": "Trường không hợp lệ, vui lòng kiểm tra và thử lại.",
        "validAddress": "Vui lòng chọn địa chỉ hợp lệ."
    },
    "statusDisplay": {
        "supplierAccepted": "Nhà cung cấp đã nhận",
        "pendingAmmendment": "Chờ sửa đổi",
        "supplierAllocated": "Nhà cung cấp được phân bổ",
        "delivery_supplierAccepted": "Nhà cung cấp đã nhận",
        "completedWithoutService": "Hoàn thành không tài xế",
        "confirmed": "Xác nhận đặt trước ",
        "pending": "Đang xử lý",
        "queue": "Điều phối",
        "offered": "Đang điều phối",
        "booked": "Xe đang đến",
        "engaged": "Đang đi",
        "droppedOff": "Kết thúc",
        "inReview": "Cần xem xét",
        "pre": "Đã chấp nhận đơn",
        "recurrent": "Lặp lại",
        "vacant": "Please provide the text you would like me to translate to Vietnamese.",
        "vacantTime": "Please provide the text you would like me to translate to Vietnamese.",
        "arrived": "Xe đã đến",
        "completed": "Hoàn tất",
        "canceled": "Đã hủy",
        "noShow": "Không thấy khách",
        "driverNoShow": "Người lái không xuất hiện",
        "action": "Đang xử lý",
        "incident": "Sự cố",
        "pickupTimeExceeded": "Quá giờ",
        "canceledByCC": "Đã hủy bởi tổng đài",
        "canceledByPassenger": "Đã hủy bởi khách hàng",
        "canceledByDriver": "Đã hủy bởi tài xế",
        "canceledByPartner": "Đã hủy bởi đối tác",
        "canceledBymDispatcher": "Hủy bởi đối tác",
        "canceledByCorporateAdmin": "Đã hủy bởi đại diện doanh nghiệp",
        "canceledByAPI": "Hủy bởi API",
        "canceledByWebBooking": "Hủy bởi đặt xe qua web",
        "canceledByTimeout": "Hủy do quá giờ",
        "accepted": "Đã chấp nhận",
        "rejected": "Đã từ chối",
        "canceledByCorpAd": "Đã hủy bởi đại diện doanh nghiệp",
        "started": "Đã bắt đầu",
        "intransit": "Đang di chuyển",
        "empty": "Trống",
        "notLive": "Một phần - chưa hoạt động",
        "live": "Một phần - đang hoạt động",
        "full": "Đầy đủ",
        "delivering": "Đang giao hàng",
        "delivery_booked": "Tài xế đang đến người gửi",
        "delivery_arrived": "Đã đến và chờ người gửi",
        "shopForYou_booked": "Tài xế đang đến thu tiền",
        "shopForYou_arrived": "Đã đến và chờ thu tiền",
        "collecting": "Tài xế đang lấy hàng hóa",
        "confirmed_delivery": "Xác nhận",
        "food_booked": "Tài xế đang đến cửa hàng",
        "food_collecting": "Đã đến và chờ lấy hàng",
        "mart_collecting": "Đã đến và chờ lấy hàng",
        "otwMerchant": "Tài xế đang đến cửa hàng",
        "arrivedAndWaitingToCollectItem": "Đã đến và chờ lấy hàng",
        "canceledByAirlineAdmin": "Hủy bởi quản trị viên hãng hàng không",
        "partialCompleted": "Hoàn thành một phần",
        "failed": "Thất bại",
        "allocated": "Đã phân bổ"
    },
    "tripTypes": {
        "scheduled": "Chuyến đã lên lịch",
        "requested": "Yêu cầu chuyến",
        "preferred": "Ưu tiên"
    },
    "login": {
        "Username": "Người dùng",
        "Password": "Mật khẩu",
        "Remember_me": "Ghi nhớ",
        "Forgot_your_password": "Quên mật khẩu",
        "Login": "Đăng nhập"
    },
    "invoice": {
        "createBtn": "Tạo hóa đơn",
        "searchPlInvoice": "Tìm kiếm khách hàng, liên hệ, số hóa đơn",
        "searchPl": "Tìm kiếm mã đặt xe, tên khách hàng",
        "createInvoice": "Tạo hóa đơn",
        "invoicePeriod": "Kỳ hóa đơn",
        "invoicePeriodNote": "Bạn có thể chọn khoảng thời gian theo từng tháng",
        "viewEdit": "Xem/Sửa",
        "billingContact": "Liên hệ thanh toán",
        "memo": "Ghi chú",
        "memoMessage": "Để lại tin nhắn cho khách hàng",
        "dueDate": "Ngày đến hạn",
        "updateInvoice": "Cập nhật hóa đơn",
        "chargeCustomer": "Thu phí khách hàng",
        "invoiceNumber": "Số hóa đơn",
        "noItem": "Số lượng mặt hàng",
        "issuedDate": "Ngày phát hành",
        "refId": "Mã tham chiếu",
        "pickupTime": "Pick Up Time",
        "pickup": "Điểm đón",
        "destination": "Điểm trả",
        "customerName": "Tên khách hàng",
        "totalAmount": "Tổng số tiền",
        "amountDue": "Số tiền cần thanh toán",
        "sendInvoice": "Gửi hóa đơn",
        "copyInvoice": "Sao chép hóa đơn",
        "downloadPDF": "Tải xuống PDF",
        "paymentLink": "Link thanh toán",
        "deleteInvoice": "Xóa hóa đơn",
        "onlySave": "Lưu hóa đơn",
        "saveSend": "Lưu & gửi hóa đơn",
        "sendEmail": "Gửi email",
        "addRecipients": "Thêm người nhận",
        "editInvoice": "Chỉnh sửa hóa đơn",
        "check": "Séc",
        "wire": "Chuyển khoản",
        "digitalWallet": "Ví điện tử",
        "cash": "Tiền mặt",
        "completedTime": "Thời gian hoàn thành",
        "Status": "Trạng thái",
        "bookingStatus": "Trạng thái chuyến xe",
        "chargeBtn": "Thu phí {0}",
        "pastDue": "Quá hạn",
        "payCompleted": "Hóa đơn đã thanh toán thành công!",
        "Delete": "Xóa hóa đơn?",
        "Delete_content": "Hóa đơn này sẽ bị xóa vĩnh viễn. Nếu cần, bạn có thể tạo hóa đơn mới cho đơn này.",
        "viewInvoice": "Xem hóa đơn",
        "pending": "Chờ xử lý",
        "paid": "Đã thanh toán",
        "CopyLink": "Sao chép link",
        "partial": "Một phần",
        "corporatePrepaid": "Doanh nghiệp trả trước"
    },
    "cue": {
        "bookingServiceType": "Loại dịch vụ",
        "pointToPoint": "Một chiều",
        "fromAirport": "Từ sân bay",
        "toAirport": "Đến sân bay",
        "hourly": "Theo giờ",
        "roundTrip": "Khứ hồi",
        "jobVisibility": "Hiển thị công việc",
        "jobPubic": "Công khai",
        "jobPrivate": "Riêng tư",
        "jobSetPubic": "Đặt công khai",
        "jobSetPrivate": "Đặt riêng tư",
        "supplierAccepted": "Nhà cung cấp đã nhận",
        "pendingAmmendment": "Đang chờ sửa đổi",
        "supplierAllocated": "Nhà cung cấp được phân bổ",
        "creationTime": "Thời gian tạo",
        "Pax": "Số hành khách",
        "Luggage": "Hành lý",
        "allocated": "Đã phân bổ",
        "completedWithoutService": "Hoàn thành không tài xế",
        "shuttle": "Xe đưa đón",
        "farmIn": "Nhận chuyến",
        "chargeCode": "Mã phí",
        "clientCaseMatter": "Mô tả chuyến",
        "operatorNote": "Ghi chú nội bộ",
        "farmOut": "Chuyến chuyến",
        "roaming": "Chuyển vùng",
        "FlightUpdate": "Cập nhật chuyến bay",
        "networkType": "Loại hình phân phối",
        "InHouse": "Nội bộ",
        "External": "Đối ngoại",
        "carHailing": "Vãng lai",
        "uploadBookings": "Tải lên chuyến xe",
        "moreActions": "Thao tác khác",
        "rideSharing": "Đi chung",
        "Rearrange": "Sắp xếp lại",
        "GroupId": "Mã nhóm",
        "Active": "Đang hoạt động",
        "Finished": "Đã hoàn thành",
        "Home_affiliate": "Trang chủ/ Liên kết",
        "Booking_type": "Loại hình",
        "From": "Từ",
        "balanceWallet": "{0}: còn lại {1}",
        "partialWallet": "Thanh toán một phần bằng ví",
        "To": "Đến",
        "Status": "Trạng thái",
        "Migration_Status": "Trạng thái chuyển đổi",
        "Migrated": "Đã chuyển đổi",
        "Select_Status": "Chọn trạng thái",
        "Operator": "Điều hành viên",
        "Car_types": "Loại xe",
        "Service_class": "Hạng dịch vụ",
        "Booking_from": "Chuyến xe từ",
        "All": "Tất cả",
        "Pending": "Đang xử lý",
        "Dispatching": "Điều phối",
        "Waiting_for_process": "Đang xử lý",
        "Confirmed_reservation": "Xác nhận đặt trước ",
        "Driver_on_the_way": "Xe đang đến",
        "Arrived_and_waiting": "Xe đã đến",
        "Passenger_on_board": "Đang đi",
        "Dropped_off": "Kết thúc",
        "combobox_select": "Chọn...",
        "Search_here": "Tìm tại đây",
        "Bookingid": "# Đặt xe",
        "Pickup_Drop_Off": "Đón/ Trả khách",
        "Pickup_Drop_Off_Crew": "Thời gian đón/trả khách",
        "Pickup_Drop_Off_Local_Time": "Thời gian vận hành",
        "Pickup_Location_Destination": "Điểm đón/ Điểm đến",
        "Passenger": "Khách hàng",
        "Intercity_Route": "Tuyến liên tỉnh",
        "Airport_Pickup": "Đón tại sân bay",
        "Airport_Pickup_Crew": "Sân bay",
        "Flight_Status": "Trạng thái",
        "Payment": "Thanh toán",
        "Vehicle": "Xe",
        "Car_type": "Loại xe",
        "Driver": "Tài xế",
        "Estimated_Fare": "Giá cước ước tính",
        "Notes": "Ghi chú",
        "Note": "Ghi chú",
        "Type": "Loại",
        "Home": "Trang chủ",
        "Affiliate": "Đối tác liên kết",
        "now": "Đi ngay (Di chuyển)",
        "reservation": "Đặt trước (Di chuyển)",
        "recurring": "Định kỳ (Di chuyển)",
        "No_show": "Không thấy khách",
        "Canceled_by_CC": "Đã hủy bởi tổng đài",
        "Canceled_by_passenger": "Đã hủy bởi khách hàng",
        "Canceled_by_partner": "Đã hủy bởi đối tác",
        "Canceled_by_mDispatcher": "Đã hủy bởi đối tác",
        "Canceled_by_Corporate_Admin": "Đã hủy bởi đại diện doanh nghiệp",
        "Canceled_by_API": "Hủy bởi API",
        "canceled_By_Web_Booking": "Hủy bởi đặt xe qua web",
        "canceled_By_Time_Out": "Hủy do quá giờ",
        "Canceled": "Đã hủy",
        "Completed": "Hoàn thành",
        "Incident": "Sự cố",
        "Payment_Method": "Phương pháp thanh toán",
        "No_Phone": "Không có điện thoại",
        "VIP": "VIP",
        "Non_VIP": "Không VIP",
        "Passenger_type": "Loại khách hàng",
        "Error_load_booking": "Không thể tải thông tin chuyến xe, vui lòng thử lại hoặc làm mới trang!",
        "Edit_total_success": "Tổng số tiền đã chỉnh sửa thành công!",
        "Edit_total_fail": "Tổng giá cước phải bằng hoặc lớn hơn {0}",
        "Time_out": "Quá giờ",
        "Ride_Service": "Dịch vụ đi lại",
        "Regulation": "Đi thường",
        "Ride_Sharing": "Đi chung",
        "Unmatching": "Không khớp",
        "Matching": "Khớp",
        "all": "Tất cả",
        "matching": "Khớp",
        "unmatching": "Không khớp",
        "regulation": "Đi thường",
        "Support_service": "Dịch vụ hỗ trợ",
        "SOS": "Khẩn cấp",
        "Non_SOS": "Không khẩn cấp",
        "Corporate": "Doanh nghiệp",
        "Individual": "Cá nhân",
        "On_curb": "Đón bên ngoài",
        "Meet_Greet": "Dịch vụ đón tiếp",
        "Close": "Đóng",
        "auto_refrest_cue": "Tự động làm mới ({0} giây)",
        "Ride_type": "Loại chuyến",
        "Edit_total_note": "Lưu ý: phí tạm tính, phí công nghệ, phí đặt xe, thuế và tiền tip sẽ được cập nhật khi thay đổi tổng số tiền.",
        "Booking": "Yêu cầu đặt xe",
        "Edit_fare": "Chỉnh sửa giá cước",
        "Adjust_price": "Điều chỉnh giá",
        "Total": "Tổng cộng",
        "Reason": "Lý do",
        "Please_enter_reason": "Nhập lý do",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "dmc": "Bảng đặt xe",
        "corp": "Bảng đặt xe (CTM)",
        "Zone": "Khu vực đón",
        "dropOffZone": "Khu vực trả khách",
        "mDispatcher": "Đối tác",
        "streetSharing": "Ghép chuyến",
        "Driver_No_Job_found": "Chờ ghép chuyến...",
        "expandFilter": "Hiển thị bộ lọc",
        "collapseFilter": "Ẩn bộ lọc",
        "clearSelectedItems": "Xóa các mục đã chọn",
        "Accepted": "Đã chấp nhận",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Order_accepted": "Đơn đã được chấp nhận",
        "Confirmed": "Đã xác nhận",
        "spotTime": "Thời gian điểm hẹn",
        "ETA": "Thời gian đến dự kiến",
        "spareTime": "Thời gian dự phòng",
        "expectedTime": "Thời gian đón dự kiến",
        "Driver_on_the_way_to_sender": "Tài xế đang đến người gửi",
        "Driver_on_the_way_to_recipient": "Tài xế đang đến người nhận",
        "Driver_on_the_way_to_collect_cash": "Tài xế đang đến thu tiền",
        "Driver_on_the_way_to_collect_goods": "Tài xế đang đến lấy hàng",
        "Arrived_waiting_for_sender": "Đã đến & chờ người gửi",
        "Arrived_waiting_for_recipient": "Đã đến & chờ người nhận",
        "Arrived_waiting_to_collect_cash": "Đã đến & chờ thu tiền",
        "Arrived_waiting_to_deliver_goods": "Đã đến & chờ giao hàng",
        "Delivered": "Đang giao",
        "delivery": "Giao hàng",
        "Service": "Dịch vụ",
        "intercity": "Liên tỉnh",
        "Transport": "Di chuyển",
        "About_Sender": "Thông tin người gửi",
        "About_Merchant": "Thông tin cửa hàng",
        "About_Recipient": "Thông tin người nhận",
        "photos": "Hình ảnh",
        "listOfItems": "Danh sách hàng hóa",
        "cashOnPickUp": "Thanh toán khi nhận hàng",
        "Package_information": "Thông tin kiện hàng",
        "otwMerchant": "Tài xế đang đến cửa hàng",
        "arrivedAndWaitingToCollectItem": "Đã đến & chờ lấy hàng",
        "Save_Filter": "Lưu bộ lọc",
        "add_favorite_filter": "Thêm bộ lọc",
        "favorite_filter_name": "Tên",
        "list_favorite_filter": "Quản lý bộ lọc",
        "favorite_filter_actions": "Thao tác",
        "clear_all_filters": "Xóa tất cả bộ lọc",
        "Delete_Filter": "Xóa bộ lọc",
        "CONFIRM_DELETE_FILTER_TEMPLATE": "Bạn muốn xóa bộ lọc này?",
        "batchDelivery": "Giao hàng loạt",
        "editFare": {
            "creditTransactionFee": "Phí thẻ tín dụng",
            "preferredAdjustment": "Điều chỉnh ưu tiên",
            "editFareFee": "Chỉnh sửa giá cước & phí",
            "markupPrice": "Giá Markup",
            "quotedPrice": "Giá niêm yết",
            "basicFare": "Cước phí",
            "preferredEarning": "Thu nhập ưu tiên.",
            "difference": "Chênh lệch",
            "rushHourFee": "Phụ phí",
            "serviceFee": "Dịch vụ bổ sung",
            "otherFees": "Các phí khác",
            "subTotal": "Tổng phụ",
            "airportFee": "Phí sân bay",
            "meetDriverFee": "Gặp tài xế",
            "deliveryFee": "Phí giao hàng",
            "tollFee": "Phí cầu đường",
            "parkingFee": "Phí đỗ xe",
            "gasFee": "Phí nhiên liệu",
            "techFee": "Phí công nghệ",
            "tip": "Tiền Tip",
            "bookingFee": "Phí đặt xe",
            "tax": "Thuế",
            "promoAmount": "Mức ưu đãi",
            "etaFare": "Tổng cộng",
            "fleetService": "Dịch vụ đội xe",
            "Note_serviceFee": "(để chỉnh sửa dịch vụ bổ sung, hãy truy cập danh sách ngoài)",
            "startingFee": "Mở cửa",
            "moveFeeInJourney": "Di chuyển",
            "waitFeeInJourney": "Phí chờ (trong hành trình)",
            "total": "Tổng cộng",
            "totalPayout": "Thanh toán",
            "updatedTotal": "Tổng cộng đã cập nhật",
            "updatedPayout": "Thanh toán đã cập nhật",
            "profit": "Lợi nhuận",
            "extraWaitFee": "Phí chờ ban đầu",
            "heavyTraffic": "Kẹt xe",
            totalWithoutPromo: 'Tổng trước ưu đãi',
        },
        "partialCompleted": "Hoàn thành một phần",
        "failed": "Thất bại",
        "Recurring": "Định kỳ #",
        "DragAndDrop": "Kéo và thả để sắp xếp lại cột",
        "bookingCom": "Booking.com",
        "syncingCompleted": "Đồng bộ hoàn tất",
        "groupManifest": "Nhóm chuyến xe",
        "assignSuppliers": "Chỉ định nhà cung cấp",
        "viewActions": "Thao tác khác",
        "holidaytaxis": "HolidayTaxis",
        "karhoo": "Karhoo",
        "klook": "Klook",
        "transferZ": "TransferZ",
        "pickupTime": "Pick-up time",
        "AssignSupplier": "Chỉ định nhà cung cấp",
        "sharedTransfer": "Vận chuyển chung (%{id})",
        "batchDeliveryGroup": "Giao hàng loạt (%{id}).",
        "foundersFund": "Quỹ đồng hành",
        "zeroCommission": "Không hoa hồng",
        "unassignDriver": "Hủy chỉ định tài xế",
        "notUnassignDriver": "Không thể hủy chỉ định, vui lòng thử lại",
        "notAssignDriver": "Không thể chỉ định, vui lòng thử lại",
        "selectDriver": "Chọn tài xế",
        "unassignVehicle": "Bỏ gán xe",
        "unassignAll": "Bỏ gán tất cả",
        "notUnassignAll": "Không thể bỏ gán tất cả, vui lòng thử lại",
        "unassignAllSuccess": "Xe và tài xế đã được tách thành công.",
        "unassign_all_partial": "Bỏ gán hàng loạt thất bại đối với các chuyến đi sau (Booking IDs) do vẫn đang xử lý: {0}.",
        "notUnassignVehicle": "Không thể bỏ gán xe, vui lòng thử lại",
        "notAssignVehicle": "Không thể gán xe, vui lòng thử lại",
        "selectVehicle": "Chọn xe",
        "confirmUnassign": "Bạn có chắc muốn bỏ gán không?",
        "printMeetingBoard": "In ấn Bảng Họp",
        "needReview": "Cần xem xét"
    },
    "trip": {
        "Driver_vehicle": "Xe của tài xế",
        "tripId": "# chuyến",
        "tripTypes": "Loại chuyến",
        "Start_Time": "Thời gian bắt đầu",
        "Seats_Status": "Trạng thái ghế",
        "No_Of_Booking": "No. chuyến xe",
        "Vehicle": "Xe của tài xế",
        "Estimated_Fare": "Cước phí",
        "capacityStatus": "Trạng thái ghế",
        "Trip_Types": "Loại chuyến",
        "scheduled": "Chuyến đã lên lịch",
        "requested": "Yêu cầu chuyến",
        "preferred": "Ưu tiên",
        "All": "Tất cả",
        "Confirmed": "Đã xác nhận",
        "Started": "Đã bắt đầu",
        "In_Transit": "Đang di chuyển",
        "Empty": "Trống",
        "Partial_not_live": "Một phần - chưa hoạt động",
        "Partial_live": "Một phần - đang hoạt động",
        "Full": "Đầy đủ",
        "Error_load_trip": "Không thể tải chuyến đi, vui lòng thử lại hoặc làm mới trang!"
    },
    "tripDetails": {
        "Trip_ID": "Chuyến liên tỉnh",
        "DRIVER_JOB": "Thông tin tài xế",
        "BOOKINGS": "Chuyến xe",
        "updateTrip": "Cập nhật chuyến",
        "cancelTrip": "Hủy chuyến",
        "note_cancel": "Vui lòng chuyển tất cả chuyến xe sang tài xế khác trước khi hủy chuyến này.",
        "TRIP_INFORMATION": "Thông tin chuyến",
        "route": "Lộ trình",
        "startTime": "Thời gian bắt đầu",
        "distance": "Khoảng cách",
        "duration": "Thời lượng",
        "fare": "Cước phí",
        "cartype": "Loại xe liên tỉnh",
        "seatStatus": "Trạng thái ghế",
        "started": "Đã bắt đầu",
        "intransit": "Đang di chuyển",
        "empty": "Trống",
        "notLive": "Một phần - chưa hoạt động",
        "live": "Một phần - đang hoạt động",
        "full": "Đầy đủ",
        "noOfBooking": "No. chuyến xe",
        "luggage": "Hành lý",
        "nameDriver": "Tên",
        "vehicleType": "Xe",
        "assignDriver": "Chỉ định tài xế",
        "pickUpAddress": "Đón khách",
        "destinationAddress": "Trả khách",
        "customerName": "Tên",
        "customerPhone": "Điện thoại",
        "customerNumber": "Ghế",
        "customerLuggageNumber": "Hành lý",
        "additionalService": "Dịch vụ bổ sung",
        "paymentBooking": "Thanh toán",
        "note": "Ghi chú",
        "CONFIRM_UPDATE": "Xác nhận cập nhật",
        "CONFIRM_UPDATE_MESSAGE": "Bạn muốn cập nhật chuyến này?",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Update_info": "Có, cập nhật thông tin"
    },
    "newbooking": {
        "Addon_driver_capability": "This assignment does not fully meet the customer’s service requirements. Missing Requirements ({0})",
        "Search_Vehicle": "Tìm kiếm xe",
        "rideSharing_multi_point": "Chỉ cho phép một điểm đón và một điểm trả khách cho chuyến xe chung.",
        "Pick_up_time": "Thời Gian Đón",
        "Drop_off_time": "Thời gian trả khách",
        "All_Suppliers": "Tất cả nhà cung cấp",
        "Recipient": "Người nhận",
        "All": "Tất cả",
        "New_Booking": "Yêu cầu đặt xe",
        "GoogleMapRoute": "Google Map",
        "BOOKING_INFORMATION": "Thông tin chuyến xe",
        "TIP_PROMO": "Tiền Tip - Ưu đãi",
        "Pick_up": "Điểm đón",
        "instructions": "Hướng dẫn",
        "instructions_placeholder": "Thêm chỉ dẫn tại đây...",
        "Enter_a_location": "Nhập vị trí",
        "Enter_a_location_delivery": "Nhập vị trí",
        "Enter_3rd_party_location": "Nhập địa điểm bên thứ ba",
        "Enter_a_sender": "Nhập người gửi",
        "Enter_a_recipient": "Nhập người nhận",
        "Vehicle_Selection": "Chọn xe",
        "Destination": "Điểm đến",
        "Pickup_time": "Thời Gian Đón",
        "Note": "Ghi chú",
        "note_for_driver": "Nhập ghi chú",
        "affiliate_note": "Ghi chú cho đối tác liên kết",
        "affiliate_note_placeholder": "Nhập ghi chú đối tác cho điều hành viên",
        "operator_note": "Nhập Ghi chú nội bộ",
        "TRAVELER_INFORMATION": "Thông tin hành khách",
        "Traveler_type": "Loại hành khách",
        "Individual": "Cá nhân",
        "Corporation": "Doanh nghiệp",
        "Phone_number": "Số điện thoại",
        "First_name": "Họ",
        "Last_name": "Tên",
        "Email_address": "Địa chỉ email",
        "Corp_id": "Mã doanh nghiệp",
        "Manager_name": "Tên giám đốc",
        "Manager_email": "Email giám đốc",
        "Cost_centre": "Trung tâm chi phí",
        "Department": "Phòng/ ban",
        "Corp_division": "Bộ phận",
        "Tip": "Tiền Tip",
        "Promo_code": "Mã ưu đãi",
        "Apply": "Áp dụng",
        "Promo": "Ưu đãi:",
        "DISPATCH": "Điều phối",
        "Auto_dispatch": "Tự động",
        "Assign_driver": "Chỉ định",
        "FarmOut": "Chuyển chuyến",
        "Driver": "Tài xế",
        "Driver_Supplier": "Nhà cung cấp/Tài xế",
        "PAYMENT_METHOD": "Phương thức thanh toán",
        "OPERATOR_NOTE": "Ghi chú nội bộ",
        "TRIP_ESTIMATE": "Ước tính",
        "Choose_a_stored_card": "Chọn thẻ đã lưu",
        "Choose_a_payment_method": "Chọn phương thức thanh toán",
        "Use_new_card": "Sử dụng thẻ mới",
        "Card_holder": "Chủ thẻ",
        "Card_number": "Số thẻ",
        "Expired_date": "Ngày hết hạn (tháng/năm)",
        "ccv": "Mã CVV",
        "Distance": "Khoảng cách",
        "Duration": "Thời lượng",
        "Fare": "Cước phí",
        "Route": "Lộ trình",
        "Create": "Đặt xe",
        "Cancel": "Hủy",
        "Meet_driver": "Gặp tài xế",
        "Airline": "Hãng bay",
        "Flight": "Mã Chuyến Bay #",
        "FLY_INFO": "Thông tin bay",
        "Ride_Sharing": "Đi chung",
        "Round_trip": "Khứ hồi",
        "Car_type": "Loại xe",
        "Address": "Địa chỉ",
        "City": "Thành phố",
        "State": "Tiểu bang",
        "Zip_code": "Mã Vùng",
        "Remove": "Hủy",
        "Client_case_matter": "Nội dung khách hàng / Mô tả chuyến",
        "Charge_code": "Mã thanh toán / Mã chuyến",
        "CANCEL_BOOKING": "Xác nhận đóng chuyến xe",
        "CANCEL_BOOKING_CONFIRM": "Bạn chắc chắn muốn thoát? Mọi dữ liệu chuyến xe sẽ bị xóa",
        "Search_here": "Tìm tại đây",
        "No_support_location": "Rất tiếc, dịch vụ không có sẵn tại khu vực này",
        "Closest_driver_message": "Tài xế gần nhất cách khoảng {0}",
        "No_cars_available": "Không có xe trong phạm vi điều phối.",
        "processed_by_affiliate": "Yêu cầu đặt xe sẽ được xử lý bởi các đối tác liên kết",
        "FlightExample": "Số hiệu chuyến bay, ví dụ AA1097",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "dispatch_3rd": "Điều phối qua bên thứ ba",
        "Company": "Công ty",
        "Card_required": "Vui lòng chọn hoặc thêm thẻ!",
        "Tip_value": "Không có sẵn",
        "Calendar": "Lịch",
        "Extra_Destination": "Điểm đến bổ sung",
        "Driver_credit_limited_balance_warning": "Số dư của tài xế này nhỏ hơn hoặc bằng mức giới hạn",
        "Meet_Greet_option": "Dịch vụ đón tiếp",
        "On_Curb_option": "Đón bên ngoài",
        "Extra_Services": "Dịch vụ bổ sung",
        "Addl_Services": "Dịch vụ bổ sung",
        "Save": "Lưu",
        "Regular": "Theo km",
        "Please_fill_in_all_the_required_fields": "Vui lòng điền tất cả các trường bắt buộc",
        "Route_names_not_dup": "Các tên tuyến đường không được trùng lặp.",
        "Please_select_weekdays": "Vui lòng chọn các ngày lặp lại cho chuyến xe này",
        "Flat_rate": "Giá cố định",
        "All_company": "Tất cả công ty",
        "Best_price": "Giá tốt nhất",
        "PromoTitle": "Khuyễn mãi",
        "Show_more": "Xem Thêm",
        "Warning_pending_payment": "Khách hàng có khoản thanh toán chưa hoàn tất từ các chuyến xe trước: %{fare}.",
        "Warning_outstanding_balance": "Số dư chưa thanh toán sẽ được tính vào cuối chuyến.",
        "Not_available": "Không sẵn sàng",
        "Warning_assigned_rate": "Vui lòng thiết lập và gán giá cho loại xe đã chọn để tiếp tục.",
        "PaxLuggageNumber": "Số lượng hành khách/hành lý",
        "paxNumber": "Khách hàng",
        "luggageNumber": "Hành lý",
        "Date": "Ngày",
        "Single": "Một lần",
        "Recurring": "Lặp lại",
        "Date_range": "Ngày tùy chỉnh",
        "WeekDays": "Lặp lại vào các ngày",
        "Create_Route": "Tạo lộ trình",
        "Pickup_Point": "Điểm đón",
        "Drag_To_Render": "Kéo và thả để sắp xếp lại thứ tự",
        "DropOff_Point": "Điểm trả khách",
        "Sender": "Người gửi",
        "Recipients": "Người nhận",
        "Sender_Infomation": "Thông tin người gửi",
        "Recipient_Infomation": "Thông tin người nhận",
        "Recipient_Name": "Tên người nhận *",
        "Recipient_Phone": "Số điện thoại *",
        "Room_floor_block": "Phòng, tầng, và khu (tùy chọn)",
        "Details": "Chi tiết",
        "Package_Content": "Nội dung kiện hàng *",
        "Order_ID": "Mã đơn hàng (ví dụ: mã đơn hàng Shopify)",
        "Instructions_for_driver": "Hướng dẫn cho tài xế",
        "Cost_of_Goods": "Thanh toán khi nhận hàng (COD)",
        "Enter_amount": "Nhập số tiền",
        "Additional_Information": "Thông tin bổ sung",
        "Insurance": "Bảo hiểm",
        "Special_Care": "Chăm sóc đặc biệt",
        "Delivery_Fee": "Phí giao hàng",
        "Item_fees": "Phí mặt hàng",
        "Tech_Fee": "Phí công nghệ",
        "Tax": "Thuế",
        "driverNotes": "Ghi chú của tài xế",
        "rejectModal": "Từ chối chuyến xe",
        "rejectModalBody": "Bạn muốn từ chối chuyến xe này?",
        "rejectButton": "Từ chối chuyến xe",
        "acceptModal": "Chấp nhận chuyến xe",
        "acceptModalBody": "Bạn muốn chấp nhận chuyến xe này?",
        "ConfirmedTo": "Đã xác nhận cho ({0})",
        "proceedAction": "Bạn muốn tiếp tục này?",
        "acceptButton": "Chấp nhận chuyến xe",
        "denyModal": "Từ chối chuyến xe",
        "denyModalBody": "Bạn muốn từ chối chuyến xe này?",
        "denyButton": "Từ chối chuyến xe",
        "Accept_booking_success": "Chấp nhận chuyến xe thành công!",
        "Deny_booking_success": "Đã từ chối chuyến xe thành công!",
        "adjustFare": "Điều chỉnh giá cước",
        "totalFare": "Tổng giá cước",
        "Profit": "Lợi nhuận",
        "DriverEarning": "Thu nhập của tài xế",
        "Payout": "Thanh toán",
        "totalPayout": "Tổng thanh toán",
        "DriverPayOut": "Driver Payout",
        "confirmReject": "Xác nhận từ chối",
        "confirmCancelMSG": "Bạn muốn từ chối chuyến xe này? Bạn có thể chịu phạt từ nhà cung cấp.",
        "reasonCancel3rd": "Lý do từ chối",
        "welcome_psg": "Chào đón hành khách",
        "AmountDue": "Số tiền cần thanh toán",
        "Fleet_Company": "Đội xe",
        "Search_driver_hydra": "Chúng tôi sẽ cố gắng tìm tài xế cho bạn sớm nhất.",
        "ExternalID": "ID ngoài",
        "viewRate": "Xem giá",
        "PointToPoint": "Một chiều",
        "Offer_driver": "Đề xuất tài xế",
        "Assign_driver_vehicle": "Chỉ định tài xế / xe",
        "notify_via_email": "Thông báo cho khách hàng qua email",
        "fleetFare": "Giá vé đội tàu",
        "onlySave": "Lưu",
        "saveCharge": "Lưu & Sạc",
        "saveRefund": "Lưu & Hoàn tiền",
        "lateCancelConfirm": "Bạn có chắc chắn muốn hoàn tất đặt chỗ này không?",
        "canceledDriverConfirm": "Bạn có chắc chắn muốn hủy đặt chỗ này cho tài xế không? Một khoản phí phạt sẽ được áp dụng.",
        "canceledDriverNoChargeConfirm": "Bạn có chắc chắn muốn hủy đặt chỗ này cho tài xế không?",
        "canceledCustomerNoChargeConfirm": "Bạn có chắc chắn muốn đánh dấu khách hàng này là",
        "noshowDriverConfirmCharge": "Bạn có chắc chắn muốn đánh dấu tài xế là không xuất hiện không? Một khoản phí phạt có thể được áp dụng.",
        "noshowDriverConfirmNoCharge": "Are you should you want to mark this customer as a no show?",
        "NoShowConfirm": "Chính sách không xuất hiện sẽ được áp dụng.",
        "completeConfirm": "Bạn có chắc chắn muốn hoàn thành mà không có tài xế không?",
        "completeChargeConfirm": "Khách hàng sẽ bị tính phí đầy đủ. Tài xế sẽ không nhận được bất kỳ khoản hoa hồng nào từ đặt chỗ này.",
        "PricingPlan": "Kế hoạch giá",
        "editFerviceFees": "để chỉnh sửa phí dịch vụ, hãy truy cập danh sách bên ngoài",
        "ungroupAll": "Bỏ nhóm tất cả",
        "satisfaction": "sự hài lòng",
        "Reassign": "Chỉ định lại",
        "addNote": "Thêm ghi chú",
        "noteMagicSend": "Subject",
        "items": "Mục",
        "PaidAmount": "Số tiền đã thanh toán",
        "ExternalPartner": "Đối tác bên ngoài",
        "ExternalPartnerNote": "Các đối tác độc lập quản lý tài xế và phương tiện của riêng họ. Các khoản thanh toán được xử lý trực tiếp với nhà cung cấp.",
        "InHousePartner": "Đối tác nội bộ",
        "InHousePartnerNote": "Được quản lý trực tiếp bởi đội xe của bạn. Các khoản thanh toán được thực hiện trực tiếp cho các tài xế.",
        "Role": "Vai trò",
        "Client": "Khách hàng",
        "ApplyCancellation": "Áp dụng chính sách hủy bỏ",
        "unassigned": "chưa được phân công",
        "bookingSelected": "đặt chỗ đã chọn",
        "Update": "Cập nhật",
        "emailInvoice": "Hóa đơn qua Email",
        "Receipt": "Hóa đơn",
        "addItem": "Thêm Mục",
        "newCustomer": "Thêm Khách Hàng Mới",
        "forGuest": "Đặt phòng cho khách",
        "invalid_some_field": "Trường không hợp lệ, vui lòng kiểm tra và thử lại.",
        "ExpandCorp": "Mở rộng Chi tiết Công ty",
        "hideCorp": "Ẩn Chi Tiết Công Ty",
        "searchCusPlaceholder": "Tìm kiếm tên liên hệ, số điện thoại, email",
        "CorporationGuest": "Công ty - Khách",
        "IndividualGuest": "Cá nhân - Khách",
        "passInfo": "Thông tin hành khách",
        "noAdjustmentPickupTime": "Không có điều chỉnh nào đối với thời gian đón",
        "whenFlightArrives": "Khi chuyến bay đến",
        "minAfterArrival": "{0} phút sau khi hạ cánh",
        "pickupInstructions": "Hướng dẫn nhận hàng",
        "selectMeetingPoint": "Chọn Điểm Gặp Gỡ Nhận Hàng",
        "durationTrip": "Thời gian (Giờ)"
    },
    "bookingDetailLogs": {
        "recipient": "Người nhận",
        "updatedInfo": "Thông tin đã cập nhật",
        "updatedField": "Trường đã cập nhật",
        "valueBefore": "Giá trị trước",
        "valueAfter": "Giá trị sau",
        "location": "Địa điểm",
        "etaFare": "Giá cước",
        "dispatchType": "Điều phối",
        "drvInfo": "Tài xế",
        "meetingPoint": "Điểm Gặp Gỡ",
        "vehicleTypeRequest": "Yêu cầu xe",
        "clientCaseMatter": "Mô tả chuyến",
        "chargeCode": "Mã chuyến",
        "driverEarningType": "Loại thu nhập tài xế",
        "editedDriverEarning": "Thu nhập tài xế",
        "reasonEditFare": "Lý do",
        "bookingReference": "ID ngoài",
        "tip": "Mẹo",
        "type": "Loại dịch vụ",
        "promo": "Ưu đãi",
        "dispatch3rd": "Điều phối qua bên thứ ba",
        "rideSharing": "Đi chung",
        "notes": "Ghi chú của tài xế",
        "operatorNote": "Ghi chú nội bộ",
        "welcomeMessage": "Tin nhắn chào mừng",
        "flightNumber": "Số hiệu chuyến bay",
        "fullName": "Họ tên",
        "email": "Email",
        "cardMask": "Mã che số thẻ",
        "paymentType": "Phương thức thanh toán",
        "recipients": "Người nhận",
        "sender": "Người gửi",
        "pickupName": "Tên điểm đón",
        "pickupPhone": "Số điện thoại điểm đón",
        "pickupEmail": "Email điểm đón",
        "supplierEarningType": "Loại thanh toán",
        "editedSupplierEarning": "Giá trị thanh toán",
        "route": "Tên lộ trình",
        "markupDifference": "Chênh lệch giá markup",
        "selectedDates": "Ngày đã chọn",
        "services": "Dịch vụ đội xe",
        "destinationAddress": "Điểm đến",
        "pickupAddress": "Điểm đón",
        "tripType": "Loại chuyến",
        "pickUpTime": "Thời gian đón",
        "paxNumber": "Hành khách",
        "luggageNumber": "Hành lý",
        "vehicle": "Xe",
        "minutesToArrive": "Dự kiến tài xế đến",
        "affiliateNote": "Ghi chú đối tác",
        "packageRateName": "Tên kiện hàng",
        "supplierCompanies": "Công ty",
        "puPoints": "Điểm đón",
        "doPoints": "Điểm đến",
        "promoValue": "Giá trị ưu đãi",
        "packageInfo": "Thông tin kiện hàng",
        "orderId": "ID đơn hàng",
        "cashOnDelivery": "Thanh toán khi nhận hàng",
        "externalId": "ID ngoài",
        "recurring": "Định kỳ",
        "batchDelivery": "Giao hàng loạt",
        "payout": "Thanh toán",
        "locationDetails": "Chi tiết địa điểm",
        "name": "Tên",
        "phone": "Số điện thoại",
        "address": "Địa chỉ",
        "basicFare": "Giá cước cơ bản",
        "airportFee": "Phí sân bay",
        "bookingFee": "Phí đặt xe",
        "creditTransactionFee": "Phí thẻ tín dụng",
        "fleetService": "Dịch vụ",
        "fleetServices": "Dịch vụ",
        "gasFee": "Phí nhiên liệu",
        "meetDriverFee": "Phí gặp tài xế",
        "moveFeeInJourney": "Phí di chuyển",
        "otherFees": "Phí khác",
        "parkingFee": "Phí đỗ xe",
        "promoAmount": "Số tiền ưu đãi",
        "rushHourFee": "Phí giờ cao điểm",
        "serviceFee": "Phí dịch vụ",
        "startingFee": "Giá mở cửa",
        "subTotal": "Tổng phụ",
        "tax": "Thuế",
        "techFee": "Phí công nghệ",
        "tollFee": "Phí cầu đường",
        "waitFeeInJourney": "Phí chờ (trong hành trình)",
        "psgPhone": "Điện thoại hành khách",
        "totalAddonFee": "Addon fee",
        "addonServices": "Addon services"
    },
    "bookingdetail": {
        "RefreshFare": "Làm mới giá",
        "noShowAction": "Hành động không xuất hiện",
        "noShowClose": "Áp dụng Không xuất hiện & Đóng đặt chỗ",
        "noShowNotClose": "Áp dụng Không hiển thị & Hủy gán",
        "cancelAction": "Hủy hành động",
        "cancelClose": "Áp dụng Hủy & Đóng Đặt",
        "cancelNotClose": "Áp dụng Hủy & Gỡ gán",
        "settings": "Cài đặt",
        "updateSuccessJobVisibilitySingle": "Cập nhật khả năng hiển thị thành công",
        "updateSuccessJobVisibilityMulti": "%{number} chuyến xe đã được cập nhật thành công",
        "failApi": "Đã xảy ra lỗi!",
        "settingsTooltip": "Tài xế đã được chỉ định hoặc chuyến đang diễn ra.",
        "shareJobPublicly": "Chia sẻ công việc công khai",
        "groupOder": "Đơn hàng nhóm",
        "ExistingGroup": "Nhóm hiện có",
        "NewGroup": "Nhóm mới",
        "Search_trip": "Tìm kiếm mã chuyến",
        "All": "Tất cả",
        "creditTransactionFee": "Phí thẻ tín dụng",
        "partial_payment": "Thanh toán một phần",
        "Write_off_debt": "Xóa nợ",
        "Booking_detail": "Chuyến xe",
        "Order_detail": "Đơn hàng",
        "Completed_Booking": "Chuyến xe hoàn thành",
        "Late_Cancel_Passenger": "Hủy chuyến muộn bởi hành khách",
        "Late_Cancel_Driver": "Hủy muộn bởi tài xế",
        "No_Show_Passenger": "Hành khách không xuất hiện",
        "No_Show_Driver": "Người lái không xuất hiện",
        "Late_Cancel": "Hủy muộn",
        "Cancel_Driver": "Tài xế hủy",
        "No_Show": "Không thấy khách",
        "Without_driver": "Hoàn thành không tài xế",
        "Complete_driver": "Hoàn thành với tài xế",
        "BOOKING_INFORMATION": "Thông tin chuyến xe",
        "TIP_PROMO": "Tiền thưởng - Ưu đãi",
        "Rearrange_Column": "Sắp xếp lại cột",
        "Pick_up": "Điểm đón",
        "Enter_a_location": "Nhập vị trí",
        "Destination": "Điểm đến",
        "Pickup_time": "Thời Gian Đón",
        "Notes": "Ghi Chú",
        "TRAVELER_INFORMATION": "Thông tin hành khách",
        "Traveler_type": "Loại hành khách",
        "Individual": "Cá nhân",
        "Corporation": "Doanh nghiệp",
        "Phone_number": "Số điện thoại",
        "First_name": "Họ",
        "Last_name": "Tên",
        "Email_address": "Địa chỉ email",
        "Corp_id": "Mã doanh nghiệp",
        "Manager_name": "Tên quản lý",
        "Manager_email": "Email quản lý",
        "Cost_centre": "Trung tâm chi phí",
        "Department": "Phòng/ ban",
        "Corp_division": "Bộ phận",
        "Tip": "Tiền Tip",
        "Promo_code": "Mã khuyến mãi",
        "Apply": "Áp dụng",
        "Promo": "Khuyễn mãi",
        "DISPATCH": "Điều phối",
        "Auto_dispatch": "Điều phối tự động",
        "Assign_driver": "Chỉ định tài xế",
        "Driver": "Tài xế",
        "PAYMENT_METHOD": "Phương thức thanh toán",
        "Payment_methods": "Phương thức thanh toán",
        "pending_payment": "Thanh toán đang chờ xử lý",
        "TRIP_ESTIMATE": "Ước tính chuyến",
        "Choose_a_stored_card": "Chọn thẻ đã lưu",
        "Choose_a_payment_method": "Chọn phương thức thanh toán",
        "OPERATOR_NOTE": "Ghi chú nội bộ",
        "Use_new_card": "Sử dụng thẻ mới",
        "Card_holder": "Chủ thẻ",
        "Card_number": "Số thẻ",
        "Expired_date": "Ngày Hết Hạn(mm/yy)",
        "ccv": "Mã CVV",
        "Distance": "Khoảng cách",
        "Duration": "Thời lượng",
        "Fare": "Cước phí",
        "Route": "Lộ trình",
        "Meet_driver": "Gặp tài xế",
        "Airline": "Hãng bay",
        "Flight": "Số hiệu chuyến bay",
        "FLY_INFO": "Thông tin chuyến bay",
        "Ride_Sharing": "Đi chung",
        "Round_trip": "Khứ hồi",
        "Car_type": "Loại xe",
        "Address": "Địa chỉ",
        "City": "Thành phố",
        "State": "Tiểu bang",
        "Zip_code": "Mã bưu chính",
        "Remove": "Hủy",
        "New_Booking": "Yêu cầu đặt xe",
        "Clone_Booking": "Nhân bản chuyến xe",
        "New_Order": "New Order",
        "ViewTrackLink": "View Track Link",
        "driverLink": "Link tài xế",
        "ClickCopy": "Nhấp để sao chép link",
        "meetingBoard": "Cuộc họp \n Hội đồng",
        "ViewLog": "Xem lịch sử ",
        "Message": "Tin nhắn",
        "Update_Booking": "Cập nhật chuyến xe",
        "Cancel_Booking": "Hủy chuyến",
        "Complete_with_payment": "Hoàn tất với thanh toán",
        "Incident": "Sự cố",
        "CONFIRM_CANCEL": "Xác nhận Hủy",
        "CONFIRM_CANCEL_MESSAGE": "Bạn muốn Hủy chuyến xe này?",
        "CONFIRM_UPDATE": "Xác nhận cập nhật",
        "CONFIRM_UPDATE_MESSAGE": "Bạn muốn cập nhật chuyến xe này?",
        "CONFIRM_RESET_EDIT_FARE_MESSAGE": "Giá cước chỉnh sửa đã được đặt lại, vui lòng kiểm tra trước khi tiếp tục.",
        "Close": "Đóng",
        "Update_info": "Có, cập nhật thông tin",
        "Update_info_dispatch": "Có, cập nhật thông tin & điều phối",
        "Update_info_tooltip": "Nếu bạn muốn chỉ định đặt xe này cho tài xế mới, vui lòng chọn nút \"Có, cập nhật thông tin & điều phối\".",
        "BOOKING": "Chuyến xe",
        "DROPPED_OFF": "Kết thúc",
        "Payment_Type": "Loại thanh toán",
        "Total": "Tổng cộng",
        "Next": "Tiếp tục",
        "Pay_here": "Thanh toán tại đây",
        "Complete_booking": "Hoàn tất chuyến xe",
        "Complete_booking_tooltip": "Vui lòng nhấp vào \"Cập nhật chuyến xe\" để lưu thay đổi trước khi tiếp tục.",
        "Cancel": "Hủy",
        "Back": "Quay lại",
        "Tax": "Thuế",
        "Booking_fees": "Phí đặt xe",
        "Tech_fees": " Phí dịch vụ",
        "Subtotal": "Tổng cước",
        "Other_fees": "Các phí khác",
        "Waiting_fee": "Phí chờ",
        "Toll_fees": "Phí cầu đường",
        "Heavy_traffic": "Kẹt xe",
        "Rush_hour": "Phụ phí",
        "Basic_fare": "Cước phí",
        "Ok": "Được",
        "Input_reason": "Nhập lí do",
        "Client_case_matter": "Nội dung khách hàng / Mô tả chuyến",
        "Charge_code": "Mã thanh toán / Mã chuyến",
        "Enter_3rd_party_location": "Nhập địa điểm bên thứ ba",
        "Company": "Công ty",
        "Check_promo_error": "Lỗi kiểm tra mã ưu đãi!",
        "Add_new_credit_error": "Lỗi thêm tín dụng mới!",
        "Can_not_get_fare_setting": "Không thể lấy cài đặt giá!",
        "Can_not_get_affilate_fare_setting": "Không thể lấy cài đặt giá của đối tác!",
        "Can_not_check_commisson": "Không thể kiểm tra hoa hồng!",
        "No_flight_info": "Không tìm thấy thông tin chuyến bay",
        "Socket_server_disconnected": "Máy chủ socket bị ngắt kết nối!",
        "Please_reload_page_or_check_your_connection": "Rất tiếc. Yêu cầu của bạn không thể xử lý. Vui lòng thử lại.",
        "View_Logs": "Xem lịch sử cập nhật",
        "Bookingid": "# Đặt xe",
        "Calendar": "Lịch",
        "Extra_Destination": "Điểm đến bổ sung",
        "Meet_Greet_option": "Đón/tiễn",
        "On_Curb_option": "Đón bên ngoài",
        "Credit_Card": "Thẻ tín dụng",
        "Charge": "Thu phí",
        "No_charge": "Không thu phí",
        "QR_Code_method_not_allow_error_message": "Vui lòng chọn phương thức thanh toán khác vì mã QR không khả dụng trên bảng điều khiển!",
        "change_payment_method_note": "Nếu muốn thay đổi phương thức thanh toán, vui lòng quay lại trang đặt xe.",
        "Airport_Fee": "Phí sân bay",
        "Addi_service": "Dịch vụ bổ sung",
        "Additional_Services": "Dịch vụ bổ sung",
        "Minimum": "Tối thiểu",
        "Search_here": "Tìm tại đây",
        "No_Driver_Yet": "Chưa chỉ định tài xế",
        "Personal_Card": "Thẻ cá nhân",
        "Reject_booking": "Từ chối chuyến xe",
        "Confirm_reject": "Xác nhận từ chối",
        "Confirm_reject_message": "Bạn muốn từ chối chuyến xe?",
        "Confirm_reject_booking_with_charge": "Bạn sẽ bị tính phí {0}% trên báo giá dựa theo chính sách hủy chuyến. Bạn vẫn muốn từ chối?",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "shortTrip": "Chuyến ngắn",
        "Add_new_card": "Thêm card mới",
        "Require_customer_info": "Vui lòng nhập thông tin khách hàng để tiếp tục.",
        "Require_corp_info": "Vui lòng nhập thông tin công ty để tiếp tục.",
        "Require_corp_customer_info": "Cần thông tin người dùng để tạo thẻ mới.",
        "confirm_force_overlap": "Xác nhận",
        "confirm_force_overlap_message": "Chuyến xe này bị trùng với các chuyến mà tài xế đã nhận. Bạn vẫn muốn chỉ định chuyến xe này cho tài xế?",
        "select": "Chọn",
        "PICKUP_TIME_RANGE": "Dự kiến đón vào lúc {0}",
        "food": "Đồ ăn",
        "mart": "Đi chợ",
        "Order_summary": "Tóm tắt đơn hàng",
        "addOnPrice": "Giá đã điều chỉnh",
        "applicableFee": "Tổng (áp dụng)",
        "itemValue": "Giá trị mặt hàng",
        "promotion_note_paymentMethod": "Đơn hàng này đang được áp dụng mã ưu đãi với phương thức thanh toán hạn chế: %{method}.",
        "promotion_note_minimum_fare": "Đơn hàng này đang được áp dụng mã ưu đãi với mức giá tối thiểu giới hạn: %{fare}.",
        "promotion_note_schedules": "Đơn hàng này đang được áp dụng mã ưu đãi với thời gian đón giới hạn.",
        "edited_fare_note": "Nhật ký điều chỉnh giá cước chỉ mang tính chất tham khảo. Vui lòng truy cập báo cáo để kiểm tra giá cước và phí cuối cùng.",
        "view_good_receipt": "Xem biên nhận hàng hóa",
        "confirmRemoveGroupTransport": "Bạn muốn xóa chuyến xe hiện tại ra khỏi danh sách này?",
        "confirmRemoveGroupDelivery": "Bạn muốn xóa chuyến xe hiện tại ra khỏi nhóm này?",
        "confirmUngroupTransport": "Bạn muốn tách nhóm tất cả chuyến xe ra khỏi danh sách này?",
        "confirmUngroupDelivery": "Bạn muốn tách nhóm tất cả đặt xe ra khỏi nhóm này?",
        "view_delivery_receipt": "Xem ảnh giao hàng",
        "select_time": "Chọn thời gian",
        "InputReason": "Nhập lí do",
        "viewOrder": "Xem đơn hàng",
        "markFailed": "Đánh dấu thất bại",
        "corporateName": "Tên doanh nghiệp",
        "sendMessage": "Gửi tin nhắn",
        "AmountDueBefore": "Tiền nợ (trước)",
        "AmountDueAfter": "Tiền nợ (sau)",
        "chargeCustomer": "Tính phí khách hàng",
        "pending": "Chưa thanh toán",
        "refundPayment": "Hoàn tiền",
        "refundableAmount": "Số tiền có thể hoàn lại",
        "refundReason": "Thêm lý do hoàn tiền",
        "refundBtn": "Hoàn {0}",
        "partial": "Một phần",
        "paid": "Đã thanh toán",
        "ViewPaymentLogs": "View payment logs",
        "pmActivity": "Hoạt động thanh toán",
        "paidStatus": "Trạng thái thanh toán",
        "paymentLog": "Nhật ký thanh toán",
        "extraWaitFee": "Phí chờ ban đầu",
        "extraWaitTime": "Thời gian chờ (ban đầu)",
        "copied": "Đã sao chép",
        "warnningCancelCorporate": "Lưu ý, bạn có thể bị tính phí theo chính sách hủy của chúng tôi.",
        "customerAdjustments": "Điều chỉnh phí (KH)",
        "customerAdjustmentsTooltip": "Điều chỉnh phí (KH)",
        "supplierDriverAdjustments": "Điều chỉnh phí (tài xế, nhà cung cấp)",
        "updateSummary": "Tóm tắt cập nhật",
        "orderDetails": "Chi tiết đơn hàng",
        "saveAndSendEmail": "Lưu & Gửi Hóa Đơn Điện Tử",
        "pastDetacted": "Phát hiện chuyến xe trong quá khứ",
        "pastDetactedContent": "Bạn sắp tạo một chuyến xe trong quá khứ",
        "DriverSupplier": "Nhà cung cấp/Lái xe",
        "supplierCancelCharge": "Cảnh báo: Phí hủy bỏ",
        "supplierCancelNoCharge": "Xác nhận hủy bỏ",
        "supplierCancelChargeBody": "Bạn có chắc chắn muốn hủy đặt chỗ không?",
        "willChargedPenalty": "Bạn sẽ bị tính phí phạt là {0}.",
        "noChargedPenalty": "Đây là một chính sách hủy miễn phí, sẽ không có khoản phí nào bị tính.",
        "errorGetToken": "Không thể lấy token, vui lòng thử lại sau",
        "unlinkFlight": "Ngắt liên kết Chuyến bay",
        "unlinkFlightBody": "Chú ý! Thay đổi thời gian đón sẽ làm mất liên kết thông tin chuyến bay của bạn và xóa số hiệu chuyến bay."
    },
    "map": {
        "AWS_map_hint": "Gợi ý: Nhấn Enter hoặc Esc để hoàn thành việc vẽ.",
        "Apple_map_hint": "Gợi ý: Nhấn và giữ để kéo và thay đổi kích thước đa giác.",
        "Enter_a_location": "Nhập vị trí",
        "All_company": "Tất cả công ty",
        "All_cars": "Tất cả xe",
        "Show_all_cars": "Show Tất cả xe",
        "Hide_all_cars": "Hide Tất cả xe",
        "Vacant": "Sẵn sàng",
        "Dispatching": "Đang điều phối",
        "Driver_on_the_way": "Xe đang đến",
        "Arrived_and_waiting": "Xe đã đến",
        "P_O_B": "Đang đi",
        "Dropped_off": "Kết thúc",
        "Waiting_for_process": "Đang xử lý",
        "Unavailable": "Không sẵn sàng",
        "Total_Drivers": "Tổng số tài xế",
        "Estimate": "Ước tính",
        "Destination": "Điểm đến",
        "Pickup": "Điểm đón",
        "Start_point": "Điểm bắt đầu",
        "Passenger": "Khách hàng",
        "Driver_name": "Tên tài xế",
        "Search_car_here": "tìm xe/tên tài xế",
        "Error_load_booking": "Không thể tải chuyến xe, vui lòng thử lại hoặc làm mới trang!",
        "Show_all": "Hiển thị tất cả",
        "BookCardInfo": "Thông tin thẻ đặt chỗ",
        "drvPhoneNo": "Số điện thoại tài xế",
        "vhcPhoneNo": "Số điện thoại xe",
        "driversLiveMap": "Bản đồ tài xế",
        "heatMap": "Bản đồ nhu cầu",
        "Trip": "Chuyến",
        "traffic": "Giao thông",
        "bicyclingLayers": "Đi xe đạp",
        "layer": "Chi tiết",
        "trafficBicycling": "Giao thông, Đạp xe",
        "All_airline": "Tất cả hãng hàng không"
    },
    "customer": {
        "Customers": "Khách hàng",
        "Points": "Điểm",
        "Migration_Status": "Trạng thái chuyển đổi",
        "ADD_CUSTOMER": "Thêm khách hàng",
        "EDIT_CUSTOMER": "Chỉnh sửa khách hàng",
        "Add": "Thêm",
        "Activate": "Kích hoạt",
        "Deactivate": "Hủy kích hoạt",
        "Delete": "Xóa",
        "Import": "Nhập dữ liệu",
        "Download_template": "Tải mẫu",
        "View_Message": "Tin nhắn",
        "Send_Message": "Gửi tin nhắn",
        "Export_to_excel": "Xuất ra Excel",
        "Filter": "Bộ lọc",
        "Apply": "Áp dụng",
        "Clear": "Xóa",
        "Name": "Tên",
        "Phone_Number": "Số điện thoại",
        "Email": "Email",
        "Vip": "Khách VIP",
        "companies": "Công ty",
        "File": "Tệp tin",
        "Number_successful_imports": "Nhập thành công:",
        "Number_skipped": "Đã bỏ qua:",
        "Number_duplicate_phone_numbers": "Số điện thoại trùng lặp:",
        "Number_wrong_phone_numbers": "Số điện thoại sai:",
        "Corporate_Name": "Doanh nghiệp",
        "Registered_From": "Đăng ký từ",
        "Registration_Date": "Ngày đăng ký",
        "Registration_date_from": "Ngày đăng ký từ",
        "Registration_date_to": "Ngày đăng ký đến",
        "IOS_Last_Login_Version": "Phiên bản iOS mới nhất",
        "Android_Last_Login_Version": "Phiên bản Android mới nhất",
        "Last_Active_Date": "Ngày hoạt động cuối cùng",
        "Verification": "Xác minh",
        "Support_ID": "ID hỗ trợ",
        "Days_Since_Last_Active": "Số ngày kể từ lần hoạt động cuối",
        "Completed_Bookings": "Chuyến xe hoàn thành",
        "Outstanding_amount": "Số tiền chưa thanh toán",
        "Status": "Trạng thái",
        "Actions": "Thao tác",
        "Action": "Thao tác",
        "Inactive": "Dừng hoạt động",
        "Active": "Đang hoạt động",
        "Edit": "Chỉnh sửa",
        "View": "Xem",
        "ALERT_SELECT_ACTIVATE": "Vui lòng chọn khách hàng để kích hoạt.",
        "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn khách hàng để hủy kích hoạt.",
        "ALERT_SELECT_DELETE": "Vui lòng chọn khách hàng để xóa.",
        "CONFIRM_DELETE": "Bạn muốn xóa tài khoản này? Khách hàng có thể đăng ký tài khoản mới với dữ liệu trống sau khi tài khoản bị xóa.",
        "CONFIRM_DELETE_MULTI": "Bạn muốn xóa những khách hàng này? Chỉ khách hàng không hoạt động và không đăng ký qua app mới có thể xóa.",
        "CONFIRM_DEACTIVATE_MULTI": "Bạn muốn hủy kích hoạt các khách hàng này?",
        "CONFIRM_ACTIVATE_MULTI": "Bạn muốn kích hoạt các khách hàng này?",
        "CONFIRM_EXPORT_TO_EXCEL": "Bạn chắc chắc muốn xuất toàn bộ dữ liệu dưới dang file .xlsx?",
        "Add_card_top_up_success": "Thẻ trả trước đã được nạp tiền thành công",
        "Add_card_success": "Thẻ thanh toán đã được thêm thành công",
        "Add_customer_success": "Khách hàng mới đã được tạo thành công",
        "Update_customer_success": "Khách hàng đã được cập nhật thành công",
        "Deleted_customer_success": "Khách hàng đã được xóa thành công",
        "Create_customer_fail": "Tạo khách hàng không thành công",
        "Update_customer_fail": "Cập nhật khách hàng không thành công",
        "ERROR_EXISTED_PHONE": "Số điện thoại này đã tồn tại. Vui lòng nhập số khác",
        "ERROR_INPUT_FIRSTNAME": "Vui lòng điền Họ",
        "ERROR_INPUT_PHONE": "Vui lòng điền số điện thoại",
        "ERROR_INPUT_VALIDPHONE": "Vui lòng nhập số điện thoại hợp lệ",
        "ERROR_INPUT_VALIDEMAIL": "Vui lòng nhập địa chỉ email hợp lệ",
        "CONFIRM_DELETE_CARD": "Bạn có chắc muốn xóa những thẻ này?",
        "First_name": "Họ",
        "Last_name": "Tên",
        "Phone_number": "Số điện thoại",
        "Email_address": "Địa chỉ email",
        "Notes": "Ghi Chú",
        "Account": "Tài khoản",
        "Card_management": "Quản lý thẻ tín dụng",
        "Home": "Trang chủ",
        "Affiliate": "Đối tác liên kết",
        "SHOW_PERSONAL_CARD": "Thẻ cá nhân",
        "ADD_PERSONAL_CARD": "Thêm thẻ cá nhân",
        "SHOW_mDISPATCHER_CARD": "Hiển thị thẻ đối tác",
        "ADD_mDISPATCHER_CARD": "Thêm thẻ đối tác",
        "Personal_card": "Thẻ cá nhân",
        "mDispatcher_card": "Thẻ đối tác",
        "Card_holder": "Chủ thẻ",
        "Card_number": "Số thẻ",
        "Credit_type": "Loại tín dụng",
        "Credit_code": "Mã tín dụng",
        "Sms_verification": "Mã SMS xác minh",
        "Sms_verification_placeholder": "Nhập mã xác minh",
        "Expired_date": "Ngày hết hạn",
        "CVV": "Mã CVV",
        "Address": "Địa chỉ",
        "Country": "Quốc gia",
        "City": "Thành phố",
        "State": "Tiểu bang",
        "Zip_code": "Mã bưu chính",
        "postal_code": "Mã bưu điện",
        "Required_fields": "Mục bắt buộc",
        "Cancel": "Hủy",
        "Save": "Lưu",
        "ERROR_INPUT_CARD_HOLDER": "Vui lòng nhập tên chủ thẻ",
        "ERROR_INPUT_CARD_NUMBER": "Vui lòng nhập số thẻ",
        "ERROR_INPUT_EXPIRED_DATE": "Vui lòng nhập ngày hết hạn",
        "ERROR_VAILD_EXPIRED_DATE": "Ngày hết hạn không đúng",
        "ERROR_INPUT_CVV": "Vui lòng nhập CVV",
        "ERROR_INPUT_ADDRESS": "Vui lòng nhập địa chỉ",
        "ERROR_INPUT_CITY": "Vui lòng chọn thành phố",
        "ERROR_INPUT_ZIPCODE": "Vui lòng nhập mã vùng",
        "ERROR_INPUT_COUNTRY": "Vui lòng chọn quốc gia",
        "Info_edit_error": "Lỗi!",
        "Gender": "Giới tính",
        "Select_Gender": "Chọn",
        "Select_Idtype": "Chọn loại ID",
        "Male": "Trai",
        "Female": "Gái",
        "Other": "Khác",
        "Date_of_birth": "Ngày sinh",
        "Street_address": "Địa chỉ",
        "Select_Zone": "Chọn vùng",
        "ERROR_GET_GATEWAYS": "LỖI !!! Không thể lấy cổng thanh toán",
        "Require_email": "Vui lòng nhập Email trước khi thêm thẻ mới",
        "Require_lastName": "Vui lòng nhập Tên trước khi thêm thẻ mới",
        "Require_phone_number": "Vui lòng nhập số điện thoại của khách trước khi đặt xe bằng thẻ tín dụng",
        "IMPORT_CUSTOMER_SUCCESS": "Nhập khách hàng thành công",
        "No_card": "Không tìm thấy thẻ",
        "No_Support": "Không hỗ trợ thêm thẻ mới ở khu vực này",
        "Card_Management": "Quản lý thẻ tín dụng",
        "Emergency_contacts": "Số liên lạc khẩn cấp",
        "DETAIL_CUSTOMER": "Chi tiết khách hàng",
        "Select_Country": "Chọn quốc gia",
        "Customer_ID": "Mã tài xế",
        "Credit_balance": "Số dư tín dụng",
        "required_email_payment": "Bắt buộc nhập email. Vui lòng cập nhật hồ sơ để tiếp tục",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "WriteOffDebt": "Xóa nợ",
        "selectPayment": "Vui lòng chọn phương thức thanh toán để đóng tất cả đặt xe có khoản thanh toán chưa hoàn tất",
        "writeOffDebtSuccess": "Xóa nợ thành công",
        "writeOffDebtNotes": "Lưu ý: Chỉ xác nhận xóa nợ sau khi tất cả khoản nợ đã được thanh toán đầy đủ.",
        "totalCustomer": "Tổng số khách hàng",
        "Personal_Card": "Thẻ cá nhân",
        "INFO_ADD_BALANCE_SUCCESS": "Số dư hành khách đã được cập nhật thành công",
        "INFO_UPDATE_POINT_SUCCESS": "Điểm hành khách đã được cập nhật thành công",
        "currency": "Đơn vị tiền tệ",
        "balance": "Số dư",
        "changeBalance": "Thay đổi số dư",
        "change": "Thay đổi",
        "WALLET_DEPOSIT": "Ví",
        "AccessDenied": "Bạn không có quyền truy cập vào mô-đun này!",
        "referral_code": "Mã giới thiệu bạn bè",
        "loginMethod": "Phương thức đăng nhập",
        "searchCustomerPlaceholder": "Tìm kiếm tên liên hệ, điện thoại, email, công ty, ID hỗ trợ"
    },
    "importBookings": {
        "no": "Không.",
        "status": "Trạng thái",
        "pickupDate": "Ngày đón",
        "pickup": "Địa điểm đón",
        "dropoff": "Địa điểm trả",
        "passenger": "Khách hàng",
        "phone": "Số điện thoại",
        "seats": "Số ghế",
        "luggages": "Số hành lý",
        "rideSharing": "Đi chung",
        "flightNumber": "Số hiệu chuyến bay",
        "notes": "Ghi Chú",
        "externalId": "Mã ngoài",
        "operatorNote": "Ghi chú nội bộ",
        "clientCaseMatter": "Mô tả chuyến",
        "chargeCode": "Mã chuyến",
        "price": "Giá",
        "payout": "Thanh toán",
        "paymentType": "Thanh toán",
        "vehicleTypeRequest": "Loại xe",
        "importBookings": "Nhập chuyến xe",
        "corporation": "Doanh nghiệp",
        "clickOrDropCsvFile": "Kéo hoặc thả tệp .csv",
        "importingFileForReview": "Đang nhập tệp để kiểm tra...",
        "import": "Nhập dữ liệu",
        "submit": "Gửi",
        "downloadTemplate": "Tải mẫu",
        "learnMore": "Tìm hiểu thêm",
        "total": "Tổng cộng",
        "valid": "Hợp lệ",
        "invalid": "Không hợp lệ",
        "failed": "Không thành công",
        "processing": "Đang xử lý",
        "success": "Thành công",
        "confirm": "Xác nhận",
        "confirmMessage": "Đơn hàng sẽ được tạo. Bạn muốn tiếp tục?",
        "create": "Tạo",
        "cancel": "Hủy",
        "close": "Đóng",
        "leavingConfirmMessage": "Công việc của bạn chưa được lưu! Bạn có muốn thoát không?",
        "resultMessage": "${success} đặt xe đã được tạo thành công, ${failed} bị lỗi.",
        "limitExceededBookings": "Kích thước file import tối đa: 100 đặt xe",
        "delivery": {
            "no": "#",
            "pickupDate": "Ngày đón",
            "senderName": "Tên người gửi",
            "senderPhone": "Số điện thoại người gửi",
            "senderMail": "Email người gửi",
            "senderAddress": "Địa chỉ người gửi",
            "recipients": "Người nhận",
            "senderDistrictOptional": "Quận",
            "senderLocationDetails": "Địa chỉ chi tiết",
            "recipientName": "Tên người nhận",
            "recipientPhone": "Số điện thoại người nhận",
            "recipientAddress": "Địa chỉ người nhận",
            "recipientDistrictOptional": "Quận",
            "recipientLocationDetailsOptional": "Địa chỉ chi tiết",
            "packageContent": "Nội dung kiện hàng",
            "orderNumber": "# đơn hàng",
            "instructions": "Hướng dẫn cho tài xế",
            "cod": "Giá trị mặt hàng thanh toán khi nhận",
            "rideShare": "Đi chung",
            "paymentType": "Loại thanh toán",
            "carType": "Loại xe",
            "recipientLocationDetails": "Địa chỉ chi tiết",
            "operatorNote": "Ghi chú nội bộ",
            "rideSharing": "Giao hàng loạt"
        }
    },
    "merchant": {
        "INFO_ADD_BALANCE_SUCCESS": "Số dư của cửa hàng đã được cập nhật thành công",
        "ADD_MERCHANT_USER": "Thêm tài khoản cửa hàng",
        "EDIT_MERCHANT_USER": "Chỉnh sửa tài khoản cửa hàng",
        "MERCHANT_USER_DETAILS": "Chi tiết tài khoản cửa hàng",
        "CASH_WALLET": "Ví tiền mặt",
        "CREDIT_WALLET": "Ví tín dụng",
        "ADD_MERCHANT": "Thêm cửa hàng",
        "ACCOUNT_INFO": "Thông tin tài khoản",
        "BILLING_ADDRESS": "Thông tin ngân hàng",
        "user": {
            "fullName": "Thông tin người bán",
            "Phone_Number": "Số điện thoại",
            "Email": "Email",
            "storeName": "Cửa hàng",
            "status": "Trạng thái",
            "actions": "Thao tác",
            "First_name": "Họ",
            "Last_name": "Tên",
            "Select_store": "Chọn cửa hàng",
            "accountHolder": "Tên chủ tài khoản",
            "First_M_Last": "Họ, tên đệm, tên",
            "accountNumber": "Số tài khoản",
            "ibanNumber": "Số IBAN",
            "bankName": "Tên ngân hàng",
            "IDtype": "Loại giấy tờ ID",
            "IDnumber": "Số ID / Số CMND quốc gia",
            "routingNumber": "Số định tuyến/ chuyển tiền/ chi nhánh",
            "checkNumber": "Số séc",
            "ssn": "Số An sinh xã hội (SSN)/Số bảo hiểm quốc gia (NI)",
            "sortCode": "Mã số phân loại",
            "transitNumber": "Số chuyển tiền",
            "institutionNumber": "Số tổ chức",
            "birthDay": "Ngày sinh",
            "address": "Địa chỉ",
            "city": "Thành phố",
            "state": "Bang / Tỉnh",
            "postalCode": "Mã bưu chính",
            "beneficiaryIDIC": "Số CCCD/CMND của người thụ hưởng",
            "relationshipOtherName": "Mối quan hệ với người khác?",
            "verificationDocumentFront": "Giấy tờ xác minh (mặt trước)",
            "verificationDocumentBack": "Giấy tờ xác minh (mặt sau)",
            "Verification_document_tooltip": "Các hình thức nhận dạng hợp lệ:\n- Hộ chiếu\n- Giấy phép lái xe\n- Thẻ cư trú\n- Thẻ công dân\n- CCCD/CMND",
            "additionalDocumentFront": "Giấy tờ bổ sung (mặt trước)",
            "additionalDocumentBack": "Giấy tờ bổ sung (mặt sau)",
            "Additional_document_tooltip": "Các hình thức xác minh hợp lệ:\n- Giấy phép lái xe\n- Hóa đơn\n- Thư do chính phủ cấp\n- Sao kê từ tổ chức tài chính\n- Phiếu đăng ký cử tri",
            "please_select": "Vui lòng chọn",
            "commission": "Hoa hồng",
            "ERROR_INPUT_VALIDPHONE": "Vui lòng nhập số điện thoại hợp lệ.",
            "ERROR_EXISTED_PHONE": "Số điện thoại này đã tồn tại. Vui lòng nhập số khác.",
            "Activate": "Kích hoạt",
            "Deactivate": "Hủy kích hoạt",
            "ALERT_SELECT_ACTIVATE": "Vui lòng chọn người dùng để kích hoạt.",
            "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn người dùng để hủy kích hoạt.",
            "CONFIRM_ACTIVATE_MULTI": "Bạn muốn kích hoạt những người dùng này?",
            "CONFIRM_DEACTIVATE_MULTI": "Bạn muốn hủy kích hoạt các người dùng này?",
            "RESET_PASSWORD": "Bạn muốn đặt lại mật khẩu?",
            "CONFIRM_RESET_PASSWORD": "Bạn muốn đặt lại mật khẩu?",
            "REMOVE_BANK_INFO": "Xác nhận xóa thông tin ngân hàng",
            "CONFIRM_REMOVE_BANK_INFO": "Bạn muốn xóa thông tin ngân hàng?",
            "note_account_password_default": "Lưu ý: Đối với tài khoản mới, mật khẩu mặc định là \"12345678",
            "Cash_Balance": "Số dư tiền mặt",
            "Credit_Balance": "Số dư tín dụng"
        },
        "Update_merchant_user_success": "Người dùng đã được cập nhật thành công",
        "Update_merchant_user_fail": "Cập nhật người dùng không thành công",
        "Create_merchant_user_success": "Người dùng mới đã được tạo thành công",
        "Create_merchant_user_fail": "Tạo người dùng không thành công",
        "Update_merchant_user_status_success": "Người dùng đã được cập nhật thành công",
        "Update_merchant_user_status_fail": "Cập nhật người dùng không thành công",
        "Reset_password_merchant_user_success": "Đặt lại mật khẩu thành công",
        "Reset_password_merchant_user_fail": "Đặt lại mật khẩu không thành công",
        "Deleted_merchant_bank_info_success": "Xóa thông tin ngân hàng thành công",
        "Deleted_merchant_bank_info_fail": "Xóa thông tin ngân hàng không thành công"
    },
    "table_header": {
        "Items_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "Search_here": "Tìm tại đây",
        "Shown_Active": "Đang hiển thị %{start} - %{end} trong tổng số %{total}",
        "Active": "%{active} đang hoạt động",
        "OF": "của"
    },
    "driver": {
        "Driver": "Tài xế",
        "Add": "Thêm",
        "addDriver": "Thêm tài xế",
        "Detail": "Chi tiết",
        "detailDriver": "Chi tiết tài xế",
        "addNewVehicle": "Thêm phương tiện",
        "serviceType": "Loại dịch vụ",
        "transport": "Di chuyển",
        "delivery": "Giao hàng",
        "stripeConnect": "Stripe Connect",
        "stripeConnectDes": "Thêm tài khoản Stripe Connect để thanh toán dễ dàng hơn",
        "bankAccount": "Thông tin ngân hàng",
        "bankAccountDes": "Thông tin ngân hàng của tài xế để xử lý thanh toán",
        "supplierComission": "Hoa hồng nhà cung cấp",
        "supplierComissionDes": "Thiết lập hoa hồng nhà cung cấp nhận được cho mỗi chuyến hoàn thành.",
        "fleetCommission": "Hoa hồng đội xe/nhà cung cấp",
        "fleetCommissionDes": "Thiết lập hoa hồng mà đội xe hoặc nhà cung cấp nhận được cho mỗi chuyến hoàn thành. Nếu tài xế thuộc nhà cung cấp, hoa hồng sẽ được khấu trừ từ thu nhập của nhà cung cấp.",
        "operationZones": "Khu vực hoạt động",
        "operationZonesDes": "Khu vực hoạt động nhà cung cấp",
        "notes": "Ghi chú",
        "notesDes": "Ghi chú nội bộ dành cho tài xế",
        "searchNotes": "Thêm ghi chú cho tài xế",
        "marketplace": "Thị trường",
        "marketplaceDes": "Hỗ trợ tài xế chọn công việc theo ý muốn.",
        "otherSettings": "Cài đặt khác",
        "topDriver": "Tài xế TOP",
        "topDriverDes": "Gắn nhãn 'Tài xế TOP' để ưu tiên tài xế giỏi, đảm bảo họ nhận thêm nhiều chuyến xe.",
        "walletTransferBetweenDriver": "Chuyển tiền giữa tài xế",
        "walletTransferBetweenDriverDes": "Cho phép tài xế chuyển tiền trực tiếp vào ví của nhau, giúp nhóm trưởng hoặc người đại diện phân phối tín dụng dễ dàng hơn.",
        "rideSharing": "Đi chung",
        "rideSharingDes": "Cho phép tài xế thực hiện các chuyến đi chung. Liên hệ với quản lý tài khoản để kích hoạt tính năng nâng cao này.",
        "individual_vehicle": "Xe cá nhân",
        "company_vehicle": "Xe công ty",
        "ContactInfo": "Thông tin liên hệ",
        "name": "Tên",
        "expiryDate": "Ngày hết hạn",
        "action": "Hoạt động",
        "editDocument": "Chỉnh sửa tài liệu",
        "documentToUpload": "Tài liệu cần tải lên",
        "addFiles": "Kéo hoặc thả tệp vào khu vực này để tải lên.",
        "fileSize": "Kích thước tệp tối đa 10 MB",
        "fileSizeDes": "Định dạng tệp phải là .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "removeOldFile": "Vui lòng xóa tệp cũ trước khi tải lên tệp mới",
        "maxLengthFiles": "Vui lòng tải lên tối đa 1 tệp",
        "maxSizeFiles": "Vui lòng tải lên tệp có kích thước nhỏ hơn 10MB",
        "typeFiles": "Vui lòng tải lên tệp có định dạng .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "maxAvatarSizeFiles": "Vui lòng tải lên ảnh đại diện có kích thước nhỏ hơn 8MB",
        "IFSCCode": "Mã IFSC",
        "Drivers": "Tài xế",
        "default": "Mặc định",
        "customize": "Tùy chỉnh",
        "Activate": "Kích hoạt",
        "Stripe_connect": "STRIPE CONNECT",
        "status_stripe": "Trạng thái: {0}",
        "stripeConnectStatus": "Stripe Connect",
        "stripeStatus": "Trạng thái tài khoản Stripe",
        "Deactivate": "Hủy kích hoạt",
        "Delete": "Xóa",
        "acceptInDay": "Đã đạt giới hạn số lượng chuyến mà tài xế có thể nhận trong ngày",
        "acceptATime": "Tổng số chuyến mà một tài xế có thể nhận cùng lúc",
        "Commission": "Thiết lập hoa hồng đội xe",
        "Title_Commission": "Thiết lập hoa hồng đội xe cho tất cả tài xế",
        "Confirm_Set_Commission": "Bạn có chắc muốn thiết lập giá trị hoa hồng này cho tất cả tài xế không?",
        "Commission_Successfully": "Hoa hồng tài xế đã được cập nhật thành công",
        "Apply": "Áp dụng",
        "Type": "Loại",
        "Currency": "Đơn vị tiền",
        "View_Message": "Tin nhắn",
        "Send_Message": "Gửi tin nhắn",
        "Driver_Name": "Tên xài xế",
        "Driver_ID": "CMND/CCCD",
        "Phone_Number": "Số điện thoại ",
        "Driver_Type": "Loại tài xế",
        "TOP": "HÀNG ĐẦU",
        "Company": "Công ty",
        "City": "Thành phố",
        "Driver_License_Number": "Số GPLX",
        "License_Plate": "Biển số",
        "Car_Type": "Loại xe",
        "Zone": "Khu vực",
        "Registered_From": "Đăng ký từ",
        "Registration_Date": "Ngày đăng ký",
        "IOS_Last_Login_Version": "Phiên bản đăng nhập cuối (iOS)",
        "Android_Last_Login_Version": "Phiên bản đăng nhập cuối (Android)",
        "Last_Active_Date": "Ngày hoạt động cuối cùng",
        "Days_Since_Last_Active": "Số ngày kể từ lần hoạt động cuối",
        "Completed_bookings": "Chuyến hoàn tất",
        "Status": "Thao tác",
        "Actions": "Thao tác",
        "Action": "Thao tác",
        "Inactive": "Không hoạt động",
        "Active": "Chỉnh sửa",
        "Edit": "Không hoạt động",
        "View": "Xem",
        "ALERT_SELECT_ACTIVATE": "Vui lòng chọn tài xế để kích hoạt.",
        "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn tài xế để hủy kích hoạt.",
        "ALERT_SELECT_DELETE": "Vui lòng chọn tài xế để xóa.",
        "CONFIRM_DELETE": "Bạn muốn xóa tài khoản tài xế này? Sau khi bị xóa, tài xế có thể đăng ký mới, nhưng tất cả dữ liệu trước đó sẽ bị mất vĩnh viễn.",
        "CONFIRM_DEACTIVATE_MULTI": "Bạn muốn hủy kích hoạt tài xế đã chọn? Đồng hồ tính cước của họ cũng sẽ bị vô hiệu hóa. Chỉ có thể hủy kích hoạt những tài xế không có chuyến.",
        "CONFIRM_ACTIVATE_MULTI": "Bạn muốn kích hoạt các tài xế này? Chỉ có thể kích hoạt những tài xế đã có đầy đủ thông tin.",
        "CONFIRM_DELETE_MULTI": "Bạn muốn xóa các tài xế này? Chỉ có thể xóa những tài xế đang ở trạng thái không hoạt động.",
        "CONFIRM_REMOVE_BANKING_INFOR": "Bạn muốn xóa thông tin ngân hàng?",
        "REMOVE_BANKING_INFOR": "Xóa thông tin ngân hàng",
        "ADD_DRIVER": "THÊM TÀI XẾ",
        "Avatar": "Ảnh đại diện",
        "Individual_Driver": "Di chuyển - Xe công ty",
        "Owner_Operator": "Di chuyển - Xe cá nhân",
        "deliveryCompany": "Giao hàng - Xe công ty",
        "deliveryIndividual": "Giao hàng - Xe cá nhân",
        "CONTACT_INFO": "THÔNG TIN LIÊN HỆ",
        "Home_address": "Địa chỉ nhà",
        "Username": "Tên đăng nhập",
        "First_name": "Họ",
        "Last_name": "Tên",
        "Phone_number": "Số điện thoại",
        "Email_address": "Địa chỉ email",
        "Select_city": "Chọn thành phố",
        "State": "Tiểu bang",
        "Zip_code": "Mã bưu chính",
        "Date_of_birth": "Ngày sinh",
        "placeholderDate": "mm/ngày/năm",
        "City_driver_want_to_drive": "Thành phố hoạt động",
        "Driver_license_number": "Số GPLX",
        "Driver_license_state": "Quận/huyện GPLX",
        "Driver_license_expiry": "Ngày hết hạn GPLX",
        "FOR_INSPECTOR": "GIÁM ĐỊNH",
        "Document": "Tài liệu",
        "Document_Id": "ID tài liệu",
        "Link": "Liên kết",
        "Notes": "Ghi chú",
        "UPLOAD_DOCUMENT": "TẢI LÊN TÀI LIỆU",
        "Click_here_to_download": "Nhấp để tải xuống",
        "Click_here_to_view": "Nhấp để xem",
        "EXTENSION_REQUIREMENT": "Định dạng tệp phải là .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "Invalid_file": "Nội dung tệp không hợp lệ",
        "File_size_larger_than_5Mb": "Kích thước tệp phải lớn hơn 5Mb",
        "BANK_ACCOUNT": "THÔNG TIN NGÂN HÀNG",
        "Name_of_bank": "Ngân hàng",
        "Name_of_account": "Tên chủ tài khoản",
        "First_M_Last": "Họ Tên Đệm Tên",
        "RTBnumber": "Số định tuyến/ chuyển tiền/ chi nhánh",
        "bankName": "Tên ngân hàng",
        "Select_a_bank": "Chọn ngân hàng",
        "Account_number": "Số tài khoản",
        "IBAN_number": "Số IBAN",
        "Check_number": "Số séc",
        "Swift_code_number": "Mã số Swift",
        "SSNNI": "SSN/ NI",
        "sortCode": "Mã phân loại",
        "Verification_document": "Giấy tờ xác minh (mặt trước)",
        "Additional_document": "Giấy tờ bổ sung (mặt trước)",
        "Verification_document_back": "Giấy tờ xác minh (mặt sau)",
        "Additional_document_back": "Giấy tờ bổ sung (mặt sau)",
        "others": "Khác",
        "signedW9Form": "Mẫu W-9 đã ký",
        "driverLicense": "Giấy phép lái xe",
        "Verification_document_tooltip": "Các hình thức nhận dạng hợp lệ:\n- Hộ chiếu\n- Giấy phép lái xe\n- Thẻ cư trú\n- Thẻ công dân\n- CCCD/CMND",
        "Additional_document_tootip": "Các hình thức xác minh hợp lệ:\n- Giấy phép lái xe\n- Hóa đơn\n- Thư do chính phủ cấp\n- Sao kê từ tổ chức tài chính\n- Phiếu đăng ký cử tri",
        "isBankAccountOwner": "Đây có phải tài khoản của bạn không?",
        "yes": "Đồng ý",
        "no": "Từ chối",
        "beneficiary_name": "Tên người thụ hưởng",
        "beneficiary_idic": "CMND/CCCD người thụ hưởng",
        "relationship": "Mối quan hệ",
        "select_relationship": "Chọn trạng thái quan hệ",
        "spouse": "Vợ/Chồng",
        "daughterOrSon": "Con gái/Con trai",
        "brotherOrSister": "Anh/Chị/Em ruột",
        "relative": "Họ hàng",
        "friends": "Bạn bè",
        "other": "Khác",
        "relationshipOtherName": "Mối quan hệ với người khác?",
        "OPERATION": "VẬN HÀNH",
        "CAR_INSURANCE": "BẢO HIỂM XE",
        "Policy_number": "Số chính sách",
        "Effective_date": "Ngày hiệu lực",
        "Expired_date": "Ngày hết hạn",
        "Select_company": "Chọn công ty",
        "All_company": "Tất cả công ty",
        "All_Car_Type": "Tất cả loại xe",
        "Car": "Xe",
        "Existing_car": "Xe đang sử dụng",
        "New_car": "Xe mới",
        "License_plate": "Biển số",
        "Select_license_plate": "Chọn Biển số",
        "Select_Car_Type": "Chọn loại xe",
        "vehicleOwner": "Tên chủ sở hữu",
        "Make": "Hãng xe",
        "Select_Car_Make": "Chọn hãng xe",
        "Model": "Dòng xe",
        "Select_Car_Model": "Chọn mẫu xe",
        "Year": "Năm",
        "Select_Year": "Chọn năm",
        "Color": "Màu sắc",
        "Passengers": "Khách hàng",
        "Luggage": "Hành lý",
        "License_expiry": "Ngày hết hạn giấy phép",
        "Shift": "Ca làm việc",
        "Select_Shift_Template": "Chọn mẫu ca làm việc",
        "Fleet_commission": "Hoa hồng đội xe (báo cáo)",
        "Company_commission": "Hoa hồng công ty (báo cáo)",
        "rideHailing": "Vãng lai",
        "intercity": "Liên tỉnh",
        "food": "Đồ ăn",
        "mart": "Đi chợ",
        "streetSharing": "Ghép chuyến",
        "Shuttle": "Xe đưa đón",
        "parcel": "Giao hàng",
        "driverInsurance": "Bảo hiểm tài xế",
        "Percentage": "Phần trăm",
        "Amount": "Số tiền",
        "transaction": "Giao dịch",
        "Terminal_ID": "Mã nhận diện thiết bị",
        "Auth_key": "Mã xác nhận",
        "CREDIT_DEPOSIT": "Ví tín dụng",
        "Credit_Balance": "Số dư tín dụng",
        "Balance": "Số dư",
        "Change_balance": "Thay đổi số dư",
        "Select_balance": "Chọn số dư",
        "Adjust_amount": "Điều chỉnh số tiền",
        "Adjust_value": "Điều chỉnh giá trị",
        "New_balance": "Số dư mới",
        "New_point": "Điểm mới",
        "Enter_reason": "Nhập lí do",
        "ERROR_INPUT_BALANCE": "Vui lòng chọn số dư.",
        "ERROR_INPUT_AMOUNT": "Vui lòng nhập giá trị này.",
        "ERROR_INPUT_REASON": "Vui lòng nhập lý do.",
        "ERROR_INPUT_VALID_AMOUNT": "Vui lòng nhập giá trị lớn hơn hoặc bằng 0.",
        "INFO_ADD_BALANCE_SUCCESS": "Số dư của tài xế đã được cập nhật thành công",
        "INFO_ADD_CASH_BALANCE_SUCCESS": "Số dư tiền mặt của tài xế đã được cập nhật thành công",
        "Force_meter": "Bắt buộc kết nối đồng hồ đo",
        "Force_meter_tooltip": "App tài xế phải được kết nối với đồng hồ đo trước khi vận hành. Áp dụng cho đồng hồ Pulsar & Centrodyne",
        "ERROR_EXISTED_PHONE": "Số điện thoại đã tồn tại. Vui lòng nhập số khác",
        "TOP_driver": "Tài xế nổi bật",
        "Ride_sharing": "Đi chung",
        "Note_password": "Lưu ý: Đối với tài khoản tài xế mới, mật khẩu mặc định là \"12345678",
        "Required_fields": "Mục bắt buộc",
        "Cancel": "Hủy",
        "Save": "Lưu",
        "SaveAndInProgress": "Lưu & Đang xử lý",
        "SaveAndDeactivate": "Lưu & Vô hiệu hóa",
        "ERROR_REQUIRE_": "Vui lòng nhập",
        "ERROR_INPUT_AVATAR": "Vui lòng tải lên ảnh đại diện.",
        "ERROR_INPUT_DRIVER_TYPE": "Vui lòng chọn loại tài xế.",
        "ERROR_INPUT_DOCUMENT": "Vui lòng tải lên",
        "ERROR_INPUT_USERNAME": "Vui lòng nhập tên đăng nhập.",
        "ERROR_INPUT_VALID_USERNAME": "Tên đăng nhập chỉ có thể chứa chữ cái thường và số, độ dài từ 3 đến 20 ký tự",
        "ERROR_INPUT_PHONE": "Vui lòng nhập số điện thoại hợp lệ.",
        "ERROR_INPUT_VALID_EMAIL": "Vui lòng nhập email hợp lệ.",
        "ERROR_INPUT_EMAIL": "Vui lòng nhập email.",
        "ERROR_INPUT_FIRSTNAME": "Vui lòng nhập Họ",
        "ERROR_INPUT_LASTNAME": "Vui lòng nhập Tên",
        "ERROR_INPUT_ADDRESS": "Vui lòng nhập Địa chỉ nhà",
        "ERROR_INPUT_CITY": "Vui lòng nhập Thành phố",
        "ERROR_INPUT_STATE": "Vui lòng nhập Tiểu bang",
        "ERROR_INPUT_ZIPCODE": "Vui lòng nhập Mã bưu chính",
        "ERROR_INPUT_BIRTHDAY": "Vui lòng nhập ngày sinh",
        "ERROR_INPUT_NAME_OF_BANK": "Please input Ngân hàng.",
        "ERROR_INPUT_NAME_OF_ACCOUNT": "Vui lòng nhập tên chủ tài khoản.",
        "ERROR_INPUT_ROUTING_NUMBER": "Vui lòng nhập mã tài khoản quốc tế",
        "ERROR_INPUT_BANK_NAME": "Vui lòng chọn ngân hàng.",
        "ERROR_INPUT_ACCOUNT_NUMBER": "Vui lòng nhập số tài khoản.",
        "ERROR_INPUT_CHECK_NUMBER": "Vui lòng nhập mã kiểm tra",
        "ERROR_INPUT_SSN": "Vui lòng nhập mã SSN",
        "ERROR_INPUT_DocumentId": "Vui lòng nhập mã tài liệu.",
        "ERROR_INPUT_SORTCODE": "Vui lòng nhập sort code.",
        "ERROR_INPUT_COMPANY": "Vui lòng chọn công ty để kích hoạt.",
        "ERROR_INPUT_LICENSE_PLATE": "Vui lòng chọn biển số xe.",
        "ERROR_INPUT_ZONE": "Vui lòng chọn khu vực để kích hoạt.",
        "ERROR_INPUT_SHIFT": "Vui lòng chọn ca làm việc để kích hoạt.",
        "ERROR_ACCOUNT_NUMBER_ONLY_NUMBERS": "Chỉ được chứa số",
        "ERROR_SSN_ONLY_NUMBERS": "Chỉ được chứa số",
        "ERROR_SSN_LENGTH": "SSN phải có ít nhất 4 ký tự",
        "ERROR_COMMISSION_NUMBERS": "Vui lòng nhập số hợp lệ",
        "INFO_DEACTIVAED_SUCCESS": "Ngưng kích hoạt tài xế thành công",
        "INFO_ACTIVAED_SUCCESS": "Kích hoạt tài xế thành công",
        "INFO_DEACTIVAED_SUCCESS_BUT_HARDWARE": "Lỗi. Không thể tắt đồng hồ tính cước kết nối với tài xế này",
        "INFO_MULTIDEACTIVAED_SUCCESS": "Đã ngưng kích hoạt {0} tài xế",
        "INFO_MULTIDEACTIVAED_HARDWARE_SUCCESS": "Đã ngưng kích hoạt {0} tài xế và {1} đồng hồ tính cước ",
        "INFO_MULTIDEACTIVAED_SUCCESS_BUT_HARDWARE": "Đã ngưng kích hoạt {0} tài xế và {1} đồng hồ tính cước. {2} đồng hồ tính cước khác chưa được ngưng kích hoạt vì một số lỗi chưa xác định ",
        "INFO_MULTIACTIVAED_SUCCESS": "Đã kích hoạt {0} tài xế",
        "DRIVER_UPDATE_SUCCESS": "Cập nhật tài xế thành công",
        "DRIVER_CREATE_SUCCESS": "Thông tin tài xế đã được thêm thành công",
        "Expiry_Date": "Ngày hết hạn",
        "Case_number": "Số hồ sơ",
        "Export_to_csv": "Xuất file CSV",
        "CONFIRM_EXPORT_TO_CSV": "Bạn muốn xuất tất cả dữ liệu dưới định dạng .csv?",
        "Ride_sharing_tooltip": "Đi chung xe là tính năng nâng cao, vui lòng liên hệ hỗ trợ để biết thêm thông tin.",
        "In_Review": "Đang kiểm tra",
        "Reset_password_success": "Đặt lại mật khẩu thành công",
        "Topup_note": "(Được phép nạp số dư cho tài xế sau khi kích hoạt tài khoản)",
        "cash_balance": "Số dư tiền mặt",
        "cash_wallet": "Ví tiền mặt",
        "total_balance": "Tổng số dư",
        "total_cash_balance": "Tổng số dư tiền mặt",
        "total_credit_balance": "Tổng số dư tín dụng",
        "banking_status": "Trạng thái ngân hàng",
        "bankingStatus": {
            "verified": "Đã xác minh",
            "not_verified": "Chưa xác minh",
            "inComplete": "Chưa hoàn thành",
            "connected": "Kết nối",
            "disconnected": "Ngắt kết nối"
        },
        "INVALID_FILE_SIZE": "Kích thước tệp phải nhỏ hơn 8Mb.",
        "totalDrivers": "Tổng số tài xế",
        "profileStatus": "Trạng thái hồ sơ",
        "profile_completed": "Hoàn thành",
        "profile_incomplete": "Chưa hoàn thành",
        "profile_inProgress": "Đang xử lý",
        "in_review_completed": "Đang xem xét (hồ sơ hoàn thành)",
        "in_review_incomplete": "Đang xem xét (hồ sơ chưa hoàn thành)",
        "in_review_inProgress": "Đang xem xét (hồ sơ đang xử lý)",
        "CASH_WALLET_DEPOSIT": "Ví tiền mặt",
        "payoutSelect": "Thanh toán (tin nhắn và email sẽ được gửi cho tài xế sau khi thanh toán)",
        "Confirm_update_cash_balance": "Thay đổi số dư tiền mặt",
        "Confirm_update_cash_balance_msg": "Bạn muốn thay đổi số dư của tài xế?",
        "cashBalance": "Số dư tiền mặt",
        "cashBalance_unavailable": "0.00",
        "cashBalance_active": "Đang hoạt động",
        "cashBalance_negative": "Ngừng hoạt động",
        "creditBalance": "Số dư tín dụng",
        "ERROR_INPUT_DOCUMETID": "Vui lòng nhập mã tài liệu.",
        "ERROR_INPUT_EXPIRYDATE": "Vui lòng nhập ngày hết hạn.",
        "driverType": "Loại tài xế",
        "tooltip_in_review_completed": "Gửi tin nhắn đến tài xế ở trạng thái 'Đang xem xét' đã hoàn thành hồ sơ.",
        "tooltip_in_review_incomplete": "Gửi tin nhắn đến tài xế trạng thái 'Đang xem xét' chưa hoàn thành hồ sơ.",
        "tooltip_in_review_inProgress": "Gửi tin nhắn đến tài xế trạng thái 'Đang xem xét' đã hoàn thành hồ sơ nhưng cần xác minh thêm.",
        "tooltip_active": "Gửi tin nhắn đến tài xế 'Đang hoạt động'.",
        "tooltip_inactive": "Gửi tin nhắn đến tài xế kích hoạt lại tài khoản.",
        "active": "Đang hoạt động",
        "inactive": "Ngừng hoạt động",
        "inReviewInProgress": "Đang kiểm tra",
        "Market_place": "Thị trường",
        "Market_place_tooltip": "Hỗ trợ tài xế chọn chuyến đi ngay hoặc đặt trước",
        "selectDriverType": "Chọn loại tài xế",
        "PlsSelectDriverType": "Vui lòng chọn loại tài xế",
        "emergencyContacts": "Liên hệ khẩn cấp",
        "switchVehicle": "Chuyển đổi phương tiện",
        "switchVehicleNote": "Cho phép tài xế chuyển sang bất kỳ phương tiện nào trong cùng công ty.",
        "vehicleModel": "Mẫu xe",
        "licensePlateNumber": "Biển số xe",
        "addVehicle": "Thêm phương tiện",
        "newVehicle": "Xe mới",
        "linkVehicle": "Xe đã liên kết",
        "modal": "Mẫu xe",
        "selectVehicle": "Chọn xe",
        "selectVehicleNote": "Cho phép tài xế chọn hoặc đổi phương tiện cho chuyến xe.",
        "Warning_change_company": "Cảnh báo: Chuyển tài xế sang công ty khác sẽ hủy liên kết tất cả phương tiện liên quan.",
        "searchDriverPlaceholder": "Tìm kiếm tên, điện thoại, email, tên người dùng, biển số",
        "please_select_a_name_of_bank": "Vui lòng chọn tên ngân hàng"
    },
    "corporate": {
        "User_Name": "Người dùng",
        "Edit_Balance": "Chỉnh sửa số dư",
        "Corporates": "Doanh nghiệp",
        "Supplier": "Nhà cung cấp",
        "CarTypes": "Loại xe",
        "Add": "Thêm",
        "Balance": "Số dư",
        "Activate": "Đang hoạt động",
        "Deactivate": "Ngừng hoạt động",
        "Delete": "Xóa",
        "Company_Name": "Tên công ty",
        "Admin_Name": "Tên Admin",
        "Username": "Tên đăng nhập",
        "Phone_Number": "Số điện thoại",
        "importBooking": "Có thể nhập dữ liệu chuyến xe",
        "Email": "Email",
        "Registered_From": "Đăng ký từ",
        "Registration_Date": "Ngày đăng ký",
        "Status": "Trạng thái",
        "Actions": "Thao tác",
        "Action": "Thao tác",
        "Inactive": "Không hoạt động",
        "Active": "Đang hoạt động",
        "In_Review": "Đang kiểm tra",
        "Edit": "Chỉnh sửa",
        "View": "Xem",
        "ADD_CORPORATE_CARD": "Thêm thẻ doanh nghiệp",
        "selectCountry": "Chọn quốc gia",
        "CONFIRM_DELETE_CARD": "Bạn có chắc muốn xóa những thẻ này?",
        "ALERT_SELECT_ACTIVATE": "Chọn doanh nghiệp để kích hoạt",
        "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn doanh nghiệp để hủy kích hoạt.",
        "ALERT_SELECT_DELETE": "Chọn doanh nghiệp để xóa",
        "CONFIRM_DELETE": "Xác nhận xóa những khách hàng doanh nghiệp này?",
        "CONFIRM_DELETE_USER": "Bạn chắc chắn muốn xóa khách hàng doanh nghiệp này?",
        "CONFIRM_DEACTIVATE_MULTI": "Xác nhận xóa ngưng kích hoạt những khách hàng doanh nghiệp này?",
        "CONFIRM_ACTIVATE_MULTI": "Xác nhận kích hoạt những khách hàng doanh nghiệp này?",
        "CONFIRM_DELETE_MULTI": "Bạn muốn xóa những doanh nghiệp này? \n** Chỉ có thể xóa các doanh nghiệp không hoạt động.",
        "ERROR_INPUT_PHONE": "Vui lòng nhập số điện thoại hợp lệ",
        "ERROR_INPUT_VALIDPHONE": "Vui lòng nhập số điện thoại hợp lệ",
        "ERROR_EXISTED_PHONE": "Số điện thoại này đã tồn tại. Vui lòng nhập số khác.",
        "Account": "Tài khoản",
        "Corp_traveler": "Người dùng doanh nghiệp",
        "Payment_methods": "Phương thức thanh toán",
        "Corp_operators": "Nhà điều hành doanh nghiệp",
        "Pricing": "Giá",
        "COMPANY_INFORMATION": "Thông tin công ty",
        "Company_name": "Tên công ty",
        "Company_ID": "ID công ty (dành cho người dùng doanh nghiệp đăng ký)",
        "Company_address": "Địa chỉ công ty",
        "Invoice_email": "Email nhận hóa đơn",
        "Confirmation_email": "Email xác nhận",
        "colorCodeBooking": "Mã màu",
        "ADMIN_ACCOUNT": "Tài khoản Admin",
        "First_name": "Họ",
        "Last_name": "Tên",
        "Commission": "Hoa hồng",
        "commissionBooking": "Áp dụng hoa hồng cho đặt xe từ ứng dụng/PWA",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "Reset_password": "Đặt lại mật khẩu",
        "Employee_Name": "Tên",
        "Created_Date": "\tNgày Tạo",
        "Add_corporate_card": "Thêm thẻ doanh nghiệp",
        "Corp_Users": "Người dùng doanh nghiệp",
        "Pricing_Default": "Mẫu giá doanh nghiệp",
        "Pricing_Discount": "Giảm giá theo phần trăm (chỉ áp dụng cho người dùng doanh nghiệp)",
        "Markup_By_Percent": "Tăng giá theo phần trăm (chỉ áp dụng cho người dùng doanh nghiệp)",
        "Pricing_Discount_new": "Giảm giá theo phần trăm",
        "Markup_By_Percent_new": "Tăng giá theo phần trăm",
        "Pricing_Add_different_rates": "Thêm các mức giá khác nhau",
        "ERROR_INPUT_COMPANYNAME": "Vui lòng nhập tên công ty",
        "ERROR_INPUT_USERNAME": "Vui lòng nhập tên đăng nhập.",
        "ERROR_INPUT_FIRSTNAME": "Vui lòng nhập tên.",
        "ERROR_INPUT_EMAIL": "Vui lòng nhập email.",
        "ERROR_INPUT_VALID_EMAIL": "Vui lòng nhập địa chỉ email hợp lệ.",
        "ERROR_INPUT_VALID_NUMBER": "Vui lòng nhập số hợp lệ",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Vui lòng nhập giá trị trong khoảng {0} đến {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Tài khoản {0} đã được tạo thành công. Vui lòng kiểm tra email {1} để lấy dữ liệu đăng nhập",
        "INFO_UPDATE_CORPORATE_SUCCESS": "Thông tin đã được cập nhật thành công.",
        "INFO_UPDATE_PRICING_SUCCESS": "Giá đã được cập nhật thành công",
        "INFO_RESET_PASSWORD_SUCCESS": "Tài khoản {0} đã được tạo lại. Vui lòng kiểm tra email {1} để lấy dữ liệu đăng nhập",
        "COMFIRM_RESET_PASSWORD": "Bạn có muốn đặt lại mật khẩu?",
        "Traveler_signature": "Chữ kí hành khách",
        "Parcel_Delivery": "Bật giao hàng",
        "Tracking_log": "Lịch sử theo dõi",
        "Rating": "Đánh giá",
        "Email_address": "Địa chỉ email",
        "Assistant_email": "Email trợ lý",
        "Corp_PO": "Đơn đặt hàng công ty",
        "Cost_centre": "Trung tâm chi phí",
        "Corp_division": "Bộ phận",
        "Corp_id": "Mã doanh nghiệp",
        "Department": "Phòng/ ban",
        "Manager_email": "Email quản lý",
        "Manager_name": "Tên của quản lý",
        "Corporate_card": "Thẻ doanh nghiệp",
        "Direct_invoicing": "Thanh toán trả sau",
        "Corporate_Prepaid": "Doanh nghiệp trả trước",
        "Cash": "Tiền mặt",
        "Car_Type_ID": "Mã loại xe",
        "App_Display_Name": "Tên hiển thị trên app",
        "Normal_Fare": "Theo km",
        "Flat_Fare": "Giá cố định",
        "Hourly_Daily_Rate": "Theo giờ/Theo ngày",
        "Delivery_Rate": "Giao hàng",
        "Assign_rate": "Gán giá",
        "Zone": "Khu vực",
        "Rate": "Giá cước",
        "Zone_Rate": "Khu vực - Giá",
        "Please_select_rate": "Vui lòng chọn giá",
        "Paid_by": "Thanh toán bởi",
        "Enter_new_credit_card": "Nhập thẻ tín dụng mới",
        "TOP_UP": "Nạp tiền",
        "Top_up": "Nạp tiền",
        "Topup_amount": "Số tiền nạp",
        "Currency": "Đơn vị tiền tệ",
        "ERROR_INPUT_AMOUNT": "Vui lòng nhập số tiền hợp lệ.",
        "VAT_number": "Số VAT",
        "Gender": "Giới tính",
        "Select_Gender": "Chọn",
        "Male": "Nam",
        "Female": "Nữ",
        "Date_of_birth": "Ngày sinh",
        "Street_address": "Địa chỉ",
        "City": "Thành phố",
        "State": "Tiểu bang",
        "Zip_code": "Mã bưu chính",
        "Country": "Quốc gia",
        "adding_new_card": "Bạn đang thêm thẻ mới để sử dụng dịch vụ trong khu vực %{zoneName}.",
        "No_Support": "Hiện tại không hỗ trợ thêm thẻ mới ở khu vực này.",
        "Job_title": "Chức danh",
        "required_phone_number_payment": "Bắt buộc nhập số điện thoại doanh nghiệp. Vui lòng cập nhật hồ sơ để tiếp tục.",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "AddCardBeforeTopup": "Không tìm thấy thẻ tín dụng. Vui lòng thêm thẻ mới để tiếp tục.",
        "flightNumber": "Số hiệu chuyến bay",
        "Company_Type": "Loại hình công ty",
        "Standard": "Doanh nghiệp tiêu chuẩn",
        "Airline": "Hãng bay",
        "Branding": "Thương hiệu",
        "bgImage": "Hình nền (1600x900)",
        "logoImage": "Hình ảnh logo",
        "aliasTitle": "Tham số Alias (URL)",
        "importChauffeurBooking": "May kakayahang mag-import ng mga booking sa transportasyon",
        "isCorporateVip": "Doanh nghiệp VIP",
        "isCorporateVipToolTip": "Bật cài đặt này để tự động gán trạng thái VIP cho tất cả khách doanh nghiệp khi tạo tài khoản, bạn có thể tắt đối với từng người dùng riêng lẻ.",
        "qrTitle": "Link đặt xe bằng mã QR trên web",
        "qrNote": "Link đặt xe của đối tác đã sẵn sàng! Đặt mã QR tại những nơi thuận tiện để khách hàng dễ dàng quét mã và đặt chuyến!",
        "PricingLegacy": "Giá (cũ)",
        "defaultTemplate": "Mẫu mặc định",
        "Select_Rate_Template": "Chọn mẫu giá"
    },
    "airline": {
        "Airlines": "Hãng bay",
        "Add": "Thêm",
        "Activate": "Đang hoạt động",
        "Deactivate": "Ngưng hoạt động",
        "Delete": "Xóa",
        "Company_Name": "Tên công ty",
        "Admin_Name": "Tên Admin",
        "Username": "Tên đăng nhập",
        "Phone_Number": "Số điện thoại",
        "Email": "Email",
        "Registered_From": "Đăng ký từ",
        "Registration_Date": "Ngày đăng ký",
        "Status": "Trạng thái",
        "Actions": "Thao tác",
        "Action": "Thao tác",
        "Inactive": "Không hoạt động",
        "Active": "Đang hoạt động",
        "In_Review": "Đang kiểm tra",
        "Edit": "Chỉnh sửa",
        "View": "Xem",
        "ADD_CORPORATE_CARD": "Thêm thẻ hãng hàng không",
        "selectCountry": "Chọn quốc gia",
        "CONFIRM_DELETE_CARD": "Bạn có chắc muốn xóa những thẻ này?",
        "ALERT_SELECT_ACTIVATE": "Vui lòng chọn hãng hàng không để kích hoạt",
        "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn hãng hàng không để hủy kích hoạt",
        "ALERT_SELECT_DELETE": "Vui lòng chọn hãng hàng không để xóa",
        "CONFIRM_DELETE": "Bạn muốn xóa hãng hàng không này?",
        "CONFIRM_DELETE_USER": "Bạn muốn xóa người dùng của hãng hàng không này?",
        "CONFIRM_DEACTIVATE_MULTI": "Bạn muốn hủy kích hoạt công ty này?",
        "CONFIRM_ACTIVATE_MULTI": "Bạn muốn kích hoạt công ty này?",
        "CONFIRM_DELETE_MULTI": "Bạn muốn xóa công ty này? \n** Chỉ có thể xóa những công ty không hoạt động.",
        "ERROR_INPUT_PHONE": "Vui lòng nhập số điện thoại hợp lệ.",
        "ERROR_INPUT_VALIDPHONE": "Vui lòng nhập số điện thoại hợp lệ.",
        "ERROR_EXISTED_PHONE": "Số điện thoại này đã tồn tại. Vui lòng nhập số khác.",
        "Airline": "Hãng bay",
        "Crew": "Nhân sự HK",
        "Payment_methods": "Phương thức thanh toán",
        "Airline_operators": "Điều hành viên hãng hàng không",
        "Pricing": "Giá",
        "COMPANY_INFORMATION": "Thông tin công ty",
        "Company_name": "Tên công ty",
        "Company_ID": "ID công ty",
        "Company_address": "Địa chỉ công ty",
        "Invoice_email": "Email nhận hóa đơn",
        "Confirmation_email": "Email xác nhận",
        "colorCodeBooking": "Mã màu",
        "ADMIN_ACCOUNT": "Tài khoản Admin",
        "First_name": "Họ",
        "Last_name": "Tên",
        "Commission": "Hoa hồng",
        "Required_fields": "Mục bắt buộc",
        "Required_fields_crews": "Lưu ý: Đối với tài khoản mới, mật khẩu mặc định là \"12345678\".",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "Reset_password": "Đặt lại mật khẩu",
        "Crew_Name": "Nhân sự HK",
        "Created_Date": "Ngày Tạo",
        "Add_corporate_card": "Thêm thẻ hãng hàng không",
        "Corp_Users": "Điều hành viên",
        "Pricing_Default": "Mặc định",
        "Pricing_Discount": "Giảm giá theo phần trăm",
        "Markup_By_Percent": "Tăng giá theo phần trăm",
        "Pricing_Add_different_rates": "Thêm các mức giá khác nhau",
        "ERROR_INPUT_COMPANYNAME": "Vui lòng nhập tên công ty",
        "ERROR_INPUT_USERNAME": "Vui lòng nhập tên đăng nhập.",
        "ERROR_INPUT_FIRSTNAME": "Vui lòng nhập tên Họ",
        "ERROR_INPUT_EMAIL": "Vui lòng nhập email.",
        "ERROR_INPUT_VALID_EMAIL": "Vui lòng nhập địa chỉ email hợp lệ.",
        "ERROR_INPUT_VALID_NUMBER": "Vui lòng nhập số hợp lệ.",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Vui lòng nhập giá trị từ {0} đến {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Tài khoản {0} đã được tạo thành công.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "Thông tin đã được cập nhật thành công.",
        "INFO_UPDATE_PRICING_SUCCESS": "Giá đã được cập nhật thành công.",
        "INFO_RESET_PASSWORD_SUCCESS": "Tài khoản {0} đã được đặt lại thành công.",
        "COMFIRM_RESET_PASSWORD": "Bạn muốn đặt lại mật khẩu?",
        "Traveler_signature": "Chữ kí hành khách",
        "Tracking_log": "Lịch sử theo dõi",
        "Rating": "Đánh giá",
        "Email_address": "Địa chỉ email",
        "Assistant_email": "Email trợ lý",
        "Corp_PO": "Đơn hàng của công ty",
        "Cost_centre": "Trung tâm chi phí",
        "Corp_division": "Bộ phận",
        "Corp_id": "Mã doanh nghiệp",
        "Department": "Phòng/ ban",
        "Manager_email": "Email quản lý",
        "Manager_name": "Tên quản lý",
        "Corporate_card": "Thẻ hãng hàng không",
        "Direct_invoicing": "Thanh toán trả sau",
        "Corporate_Prepaid": "Thẻ trả trước hãng hàng không",
        "Cash": "Tiền mặt",
        "Car_Type_ID": "Mã loại xe",
        "App_Display_Name": "Tên hiển thị trên app",
        "Normal_Fare": "Theo km",
        "Flat_Fare": "Giá cố định",
        "Hourly_Daily_Rate": "Theo giờ/Theo ngày",
        "Delivery_Rate": "Giao hàng",
        "Assign_rate": "Gán mức giá",
        "Zone": "Khu vực",
        "Rate": "Giá cước",
        "Zone_Rate": "Khu vực - Giá",
        "Please_select_rate": "Vui lòng chọn giá",
        "Paid_by": "Thanh toán bởi",
        "Enter_new_credit_card": "Nhập thẻ tín dụng mới",
        "TOP_UP": "Nạp tiền",
        "Top_up": "Nạp tiền",
        "Topup_amount": "Số tiền nạp",
        "Currency": "Đơn vị tiền tệ",
        "ERROR_INPUT_AMOUNT": "Vui lòng nhập số tiền hợp lệ.",
        "VAT_number": "Số VAT",
        "Gender": "Giới tính",
        "Select_Gender": "Chọn",
        "Male": "Nam",
        "Female": "Nữ",
        "Date_of_birth": "Ngày sinh",
        "Street_address": "Địa chỉ",
        "City": "Thành phố",
        "State": "Tiểu bang",
        "Zip_code": "Mã bưu chính",
        "Country": "Quốc gia",
        "adding_new_card": "Bạn đang thêm thẻ mới để sử dụng dịch vụ trong khu vực %{zoneName}.",
        "No_Support": "Không hỗ trợ thêm thẻ mới ở khu vực này",
        "Job_title": "Chức danh",
        "required_phone_number_payment": "Bắt buộc nhập số điện thoại doanh nghiệp. Vui lòng cập nhật hồ sơ để tiếp tục.",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "AddCardBeforeTopup": "Không tìm thấy thẻ tín dụng. Vui lòng thêm thẻ mới để tiếp tục."
    },
    "message": {
        "Add": "Thêm",
        "Delete": "Xóa",
        "Items_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "Search_here": "Tìm tại đây",
        "Shown_Active": "Hiển thị {0} - {1} trên tổng số {2}",
        "Date": "Ngày",
        "Subject": "Chủ đề",
        "To": "Đến",
        "Type": "Loại",
        "Result": "Kết quả",
        "Actions": "Thao tác",
        "New_message": "Tin nhắn mới",
        "MESSAGE_DETAILS": "Chi tiết tin nhắn",
        "All": "Tất cả",
        "Company": "Công ty",
        "Active": "Đang hoạt động",
        "In_Active": "Không hoạt động",
        "In_Review": "Đang kiểm tra",
        "Send_to": "Gửi tới",
        "All_drivers": "Tất cả tài xế",
        "All_customers": "Tất cả hành khách",
        "All_merchants": "Tất cả cửa hàng",
        "Customized_driver": "Tài xế được điều chỉnh theo yêu cầu",
        "Customized_customer": "Hành khách được điều chỉnh theo yêu cầu",
        "Customized_merchant": "Cửa hàng tùy chỉnh",
        "Receiver_list": "Danh sách người nhận",
        "Content": "Nội dung",
        "Required_fields": "Mục bắt buộc",
        "Search_driver_name_driver_phone_number": "Tìm kiếm tên tài xế, số điện thoại tài xế",
        "Search_category_name": "Tìm kiếm tên danh mục",
        "Search_customer_name_customer_phone_number": "Tìm kiếm tên khách hàng, số điện thoại khách hàng",
        "Search_merchant_name_merchant_phone_number": "Tìm kiếm tên cửa hàng, số điện thoại cửa hàng",
        "Search_car_type": "Tìm kiếm loại xe",
        "Searching": "Đang tìm kiếm...",
        "No_results": "Không có kết quả",
        "Send": "Gửi",
        "Cancel": "Hủy",
        "SMS_failed_Inbox_succeeded": "SMS thất bại, hộp thư đến thành công",
        "Failed": "Thất bại",
        "Succeeded": "Thành công",
        "CONFIRM_DELETE": "Bạn muốn xóa tin nhắn này?",
        "CONFIRM_DELETE_MULTI": "Bạn muốn xóa tin nhắn này?",
        "ALERT_SELECT_DELETE": "Vui lòng chọn tin nhắn để xóa",
        "ERROR_INPUT_RECEIVERLIST": "Vui lòng chọn ít nhất một tài xế để gửi tin nhắn",
        "ERROR_INPUT_CUSTOMER_RECEIVERLIST": "Vui lòng chọn ít nhất một khách hàng để gửi tin nhắn",
        "ERROR_INPUT_SUBJECT": "Vui lòng nhập chủ đề",
        "ERROR_INPUT_CONTENT": "Vui lòng nhập nội dung",
        "ERROR_INPUT_LEAST_ONE_SUBJECT_CONTENT": "Vui lòng thiết lập ít nhất một ngôn ngữ để tiếp tục",
        "ERROR_INPUT_SUBJECT_MULTI_LANGUAGE": "Vui lòng nhập chủ đề cho ngôn ngữ {0}",
        "ERROR_INPUT_CONTENT_MULTI_LANGUAGE": "Vui lòng nhập nội dung cho ngôn ngữ {0}",
        "ERROR_INPUT_URL_MULTI_LANGUAGE": "Vui lòng nhập URL cho ngôn ngữ {0}",
        "ERROR_INPUT_TITLE_MULTI_LANGUAGE": "Vui lòng nhập tiêu đề cho ngôn ngữ {0}",
        "ERROR_INPUT_BODY_MULTI_LANGUAGE": "Vui lòng nhập nội dung chính cho ngôn ngữ {0}",
        "import_fail_success_driver": "%{success} tài xế đã được nhập thành công, %{fail} thất bại.",
        "import_fail_success_passenger": "%{success} khách hàng đã được nhập thành công, %{fail} thất bại.",
        "import_fail_success_merchant": "%{success} cửa hàng đã được nhập thành công, %{fail} thất bại.",
        "CONFIRM_SEND_SUCCESS": "Tin nhắn của bạn đã được gửi. Quá trình này có thể mất vài phút. Vui lòng đợi trong khi hệ thống xử lý yêu cầu của bạn.",
        "Load_message_and_sms_fail": "Đã xảy ra lỗi khi tải thông tin tin nhắn và SMS.",
        "Update_message_and_sms_fail": "Đã xảy ra lỗi khi cập nhật thông tin tin nhắn và SMS.",
        "Update_message_and_sms_success": "Thông tin tin nhắn và SMS đã được cập nhật thành công.",
        "Driver_List": "Danh sách tài xế",
        "Car_Type_List": "Danh sách loại xe",
        "Search_vehicle_type_name": "Tìm kiếm tên loại xe",
        "ALERT_PROCESSING_DELETE": "Yêu cầu của bạn đang được xử lý. Quá trình này có thể mất vài giây.",
        "Customer": "Khách hàng",
        "Driver": "Tài xế",
        "StatusOfCustomer": "Trạng thái khách hàng",
        "StatusOfDriver": "Trạng thái tài xế",
        "StatusOfMerchant": "Trạng thái cửa hàng",
        "SendTo": "Gửi tới",
        "DownloadReceiverList": "Tải Danh sách người nhận",
        "warningInputChangeOver": "Chênh lệch hơn 20% giữa hai lần nhập gần nhất. Vui lòng cân nhắc!",
        "NoteDownloadReveverList": "Sau 1 tháng, danh sách người nhận sẽ bị vô hiệu hóa tải xuống.",
        "Load_voip_fail": "Đã xảy ra lỗi khi tải thông tin VOIP.",
        "Update_voip_success": "Thông tin VOIP đã được cập nhật thành công.",
        "Update_voip_fail": "Đã xảy ra lỗi khi cập nhật thông tin VOIP.",
        "expiryDate": "Gửi đến người dùng mới cho đến khi",
        "expiryDate_placeholder": "Expiry Date (mm/dd/yyyy)",
        "NA": "Không áp dụng",
        "PleaseSelectStatusOfDriver": "Vui lòng chọn trạng thái tài xế",
        "versionApp": "Phiên bản app",
        "platform": "Nền tảng",
        "contentType": "Loại nội dung",
        "url": "Địa chỉ URL",
        "title": "Chức danh",
        "contentId": "ID nội dung",
        "body": "Nội dung chính",
        "image_notification": "Hình ảnh",
        "platformItem": {
            "all": "Tất cả",
            "iOS": "iOS",
            "android": "Android"
        },
        "comparisonVersionApp": {
            "is": "Là",
            "is_not": "Không phải là",
            "is_one_of": "Là một trong số",
            "is_not_one_of": "Không phải là một trong số",
            "greater_or_equal": "Lớn hơn hoặc bằng",
            "less_or_equal": "Nhỏ hơn hoặc bằng"
        },
        "contentTypeItem": {
            "html": "HTML",
            "link": "Liên kết"
        },
        "Please_input": "Trường này là bắt buộc"
    },
    "fleetInfo": {
        "Fleet_name": "Tên đội xe",
        "Phone_number": "Số điện thoại",
        "Email_address": "Địa chỉ email",
        "Country": "Quốc gia",
        "Time_zone": "Múi giờ",
        "Address": "Địa chỉ",
        "Website": "Trang web",
        "Currency": "Đơn vị tiền tệ",
        "Distance_unit": "Đơn vị khoảng cách",
        "Load_fleet_info_fail": "Đã xảy ra lỗi khi tải thông tin đội xe"
    },
    "surchargePolicy": {
        "Surchage_Policy": "Chính sách phụ phí",
        "SurgePolicy": "Chính sách tăng giá",
        "surgeType": "Loại tăng giá",
        "bookingTimeCoverage": "Phạm vi thời gian chuyến xe",
        "Delete_surcharge": "Bạn muốn xóa phụ phí đã chọn?",
        "Delete_surcharge_item": "Bạn muốn xóa mục phụ phí đã chọn?",
        "Delete_surcharge_item_success": "Phụ phí đã được hủy kích hoạt thành công",
        "Delete_surcharge_item_fail": "Đã xảy ra lỗi khi hủy kích hoạt mục phụ phí",
        "linkNewPolicy": "Liên kết chính sách mới",
        "Link": "Liên kết",
        "ViewPolicy": "Xem chính sách",
        "Unlink": "Hủy liên kết",
        "Create_Surcharge_Item_success": "Mục phụ phí đã được tạo thành công",
        "Create_Surcharge_Item_fail": "Đã xảy ra lỗi khi tạo mục phụ phí",
        "Update_Surcharge_Item_success": "Mục phụ phí đã được cập nhật thành công",
        "Update_Surcharge_Item_fail": "Đã xảy ra lỗi khi cập nhật mục phụ phí",
        "single": "Một ngày",
        "yearly": "Hàng năm",
        "weekly": "Ngày trong tuần",
        "Please_select_at_least_one_day": "Vui lòng chọn ít nhất một ngày",
        "Booking_lead_time": "Thời gian đặt chỗ",
        "Start_date_must_be_before_end_date": "The start date must be before the end date"
    },
    "penaltyPolicy": {
        "penaltyPolicy": "Chính sách phạt",
        "Reservation": "Đặt trước",
        "onDemand": "Đi ngay",
        "noShow": "Không xuất hiện",
        "driverNoShow": "Người lái không xuất hiện",
        "freeCancellation": "Hủy miễn phí trong khoảng",
        "fieldExclusions": "Các trường bao gồm",
        "penaltyActive": "Mức thời gian hủy - trước thời gian đón",
        "penaltyType": "Phạt theo",
        "Compensation": "Bồi thường cho nhà cung cấp/tài xế",
        "Create_penalty_success": "Tạo mẫu phạt thành công",
        "Create_penalty_fail": "Đã xảy ra lỗi khi tạo mẫu phạt",
        "Update_penalty_success": "Cập nhật mẫu phạt thành công",
        "Update_penalty_fail": "Đã xảy ra lỗi khi cập nhật mẫu phạt",
        "confirmDelete": "Xác nhận Xóa",
        "confirmDeleteContent": "Bạn muốn xóa chính sách phạt này? Việc xóa chính sách sẽ hủy liên kết với tất cả các mức giá đặt xe.",
        "Delete_success": "Xóa mẫu phạt thành công",
        "Delete_fail": "Đã xảy ra lỗi khi xóa mẫu phạt",
        "payoutPolicy": "Chính sách thanh toán",
        "commission": "Phần trăm phạt của khách hàng",
        "commissionPayout": "Phần trăm thanh toán của nhà cung cấp",
        "fixAmount": "Số tiền",
        "amount": "Số tiền",
        "amount_driver": "Số lượng",
        "percent": "Phần trăm",
        "percent_driver": "Phần trăm dựa trên giá cước",
        "basedOnPayout_driver": "Phần trăm dựa trên Thanh toán",
        "percentPayout": "% thanh toán",
        "percentFare": "% giá cước",
        "penaltyFee": "Phí hủy",
        "commissionType": "Loại bồi thường",
        "commissionFee": "Bồi thường",
        "tax": "Thuế",
        "techFee": "Phí công nghệ",
        "minute": "phút",
        "hour": "giờ",
        "setDefaultSuccess": "Chính sách phạt mặc định đã được thiết lập thành công",
        "setDefaultFail": "Các lỗi xảy ra trong khi thiết lập chính sách hình phạt mặc định"
    },
    "rateTemplates": {
        "Rate_Templates": "Mẫu giá",
        "newRate": "Mẫu giá mới",
        "placeHolderName": "Nhập tên mẫu giá",
        "Assign_Rate": "Gán mức giá",
        "carTypeName": "Tên loại xe",
        "appDisplayName": "Tên hiển thị trên app",
        "assign_rate_success": "Loại xe đã được gán giá thành công",
        "assign_rate_fail": "Đã xảy ra lỗi khi gán giá",
        "confirmDeleteTitle": "Xác nhận Xóa",
        "confirmDelete": "Bạn muốn xóa mẫu này? Việc xóa sẽ hủy liên kết với tất cả các đối tác/doanh nghiệp liên quan.",
        "setDefaultSuccess": "Đã thiết lập thành công mẫu giá mặc định",
        "setDefaultFail": "Đã xảy ra lỗi khi thiết lập mẫu giá mặc định",
        "Delete_rate_template_success": "Xóa mẫu giá thành công",
        "Delete_rate_template_fail": "Đã xảy ra lỗi khi xóa mẫu giá",
        "setDefault": "Đặt làm mặc định",
        "Regular": "Giá theo km",
        "Sharing": "Giá ghép chuyến",
        "Flat": "Giá cố định",
        "Hourly": "Giá theo giờ/ngày",
        "Delete_default": "Nếu bạn cố gắng xóa mẫu mặc định, hệ thống sẽ không cho phép cho đến khi bạn đặt một mức giá mặc định khác."
    },
    "supplierPlan": {
        "Supplier_Plan": "Gói hoa hồng",
        "rateTemplate": "Sơ đồ giá",
        "rateTemplateNote": "Phép tính giá cước dùng để xác định số tiền thanh toán cho tài xế hoặc nhà cung cấp.",
        "percent": "Hoa hồng đội xe",
        "percentNote": "Phần trăm đội xe thu được trên mỗi chuyến.",
        "amount": "Số tiền cố định",
        "amountNote": "Số tiền đội xe trừ trên mỗi chuyến.",
        "supplierPenaltyId": "Chính sách phạt nhà cung cấp",
        "payoutType": "Loại",
        "Select_penalty_policy": "Chọn chính sách phạt",
        "Select_corporate": "Chọn Doanh Nghiệp",
        "Select_supplier_plan": "Chọn gói hoa hồng",
        "Create_supplier_plan_success": "Gói hoa hồng đã được tạo thành công.",
        "Create_supplier_plan_fail": "Đã xảy ra lỗi khi tạo gói hoa hồng.",
        "Update_supplier_plan_success": "Gói hoa hồng đã được cập nhật thành công.",
        "Update_supplier_plan_fail": "Đã xảy ra lỗi khi cập nhật gói hoa hồng.",
        "Payout_Plan": "Gói thanh toán",
        "Payout_Plan_note": "Thiết lập số tiền thanh toán cho nhà cung cấp.",
        "default": "Mặc định",
        "custom": "Gói tùy chỉnh",
        "cannotSetPayout": "Không thể thiết lập gói thanh toán cho tài xế của đối tác bên ngoài."
    },
    "stopSales": {
        "stopSales": "Ngừng Bán",
        "confirm_delete": "Bạn có chắc chắn muốn xóa chính sách này không?",
        "Create_stop_sales_success": "Đã tạo thành công việc dừng bán hàng",
        "Create_stop_sales_fail": "Các lỗi đã xảy ra trong quá trình tạo dừng bán hàng",
        "Update_stop_sales_success": "Đã cập nhật thành công việc dừng bán hàng",
        "Update_stop_sales_fail": "Các lỗi đã xảy ra trong quá trình cập nhật dừng bán hàng",
        "Delete_success": "Đã xóa thành công ngừng bán",
        "Delete_fail": "Các lỗi xảy ra trong quá trình xóa bán hàng dừng.",
        "allVehicle": "Tất cả phương tiện",
        "allZone": "Tất cả Khu vực"
    },
    "generalSetting": {
        "alertNotifications": {
            "title": "Thông báo cảnh báo",
            "emails": "Email",
            "emailsPlaceholder": "Nhập email",
            "slack": "Kênh Slack (Hướng dẫn)",
            "slackPlaceholder": "URL POST Slack",
            "discord": "Kênh Discord (Hướng dẫn)",
            "discordPlaceholder": "Nhập kênh Discord",
            "telegram": "Kênh Telegram (Hướng dẫn)",
            "telegramPlaceholder": "Nhập kênh Telegram."
        },
        "showFare": {
            "title": "Hiển thị giá cho tài xế",
            "totalFare": "Tổng giá cước",
            "estimateGross": "Ước tính tổng thu nhập"
        },
        "carHailing": "Khách vãng lai",
        "regular": "Theo km",
        "cancelTimeout": "Tự động hủy các chuyến xe quá giờ",
        "allowStripePaymentLink": "Cho phép tạo link thanh toán Stripe",
        "flat": "Cố định",
        "techFee": "Phí công nghệ trên mỗi giao dịch",
        "customizeLogo": "Tùy chỉnh logo bảng điều khiển",
        "logo": "Biểu trưng",
        "customerApp": "App khách hàng",
        "hourly": "Theo giờ",
        "shuttle": "Xe đưa đón",
        "parcel": "Giao hàng",
        "freeCancelTime": "Số lần hủy miễn phí mỗi ngày",
        "AM": "SA",
        "PM": "CH",
        "RUSH_HOUR": "Phụ phí",
        "Name": "Tên",
        "Date": "Ngày",
        "Mon": "Thứ Hai",
        "Tue": "Thứ Ba",
        "Wed": "Thứ Tư",
        "Thu": "Thứ Năm",
        "Fri": "Thứ Sáu",
        "Sat": "Thứ Bảy",
        "Sun": "Chủ Nhật",
        "Time_range": "Phụ phí",
        "From": "Từ",
        "To": "Đến",
        "Rush_hour_time_calculation": "Khoảng thời gian",
        "Rush_hour_surcharge": "Tính toán thời gian phụ phí",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "MDISPATCHER_CANCELLATION": "Hành khách/Đối tác hủy chuyến",
        "Book_now": "Đi ngay",
        "MDISPATCHER_CANCELLATION_TOOLTIP": "Hành khách/Đối tác hủy chuyến",
        "Book_now_toolTip": "Phí hủy áp dụng nếu chuyến xe bị hủy trong vòng",
        "Book_later_toolTip": "Phí hủy áp dụng nếu chuyến xe đặt trước bị hủy trước thời gian đón trong vòng",
        "Drv_Book_now_toolTip": "Phí hủy áp dụng nếu chuyến xe bị hủy trong thời gian quy định, tính từ lúc nhận chuyến.",
        "Drv_Book_later_toolTip": "Phí hủy áp dụng nếu chuyến xe trước bị hủy trong thời gian quy định, trước thời gian đón dự kiến.",
        "Free_cancel": "Thời gian hủy miễn phí",
        "Hide_cancel_btn": "Ẩn nút hủy sau số lần",
        "Driver_cancellation": "Tài xế hủy",
        "Time_day": "Số lần mỗi ngày",
        "Duration": "Thời gian hủy miễn phí",
        "Times": "Số lần",
        "Book_later": "Chuyến xe đặt trước",
        "Intercity": "Liên tỉnh",
        "Intercity_tooltip": "Phí hủy áp dụng nếu chuyến xe liên tỉnh bị hủy trong thời gian quy định, trước thời gian đón.",
        "MDISPATCHER_NO_SHOW": "Thời lượng",
        "AIRPORT_FEE": "Phí sân bay",
        "From_airport": "Liên tỉnh",
        "To_airport": "Phí hủy áp dụng nếu chuyến xe liên tỉnh bị hủy trong thời gian quy định, trước thời gian đón.",
        "MEET_DRIVER": "Phí sân bay",
        "On_curb": "Không thấy khách",
        "Meet_Greet": "Dịch vụ đón tiếp",
        "Add": "Từ sân bay",
        "Edit": "Đến sân bay",
        "DELETE_SURCHARGE": "Xóa phụ phí",
        "DELETE_SERVICE": "Xóa dịch vụ",
        "CHANGE_APPLY_SERVICE_FEES": "Thay đổi phí dịch vụ áp dụng",
        "DELETE_CONFIRM": "Bạn muốn xóa mục này?",
        "DELETE_SURCHARGE_CONFIRM": "Bạn muốn xóa phụ phí đã chọn?",
        "DELETE_ADDITIONAL_SERVICES_CONFIRM": "Bạn muốn xóa dịch vụ đã chọn?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_CUSTOM": "Bạn muốn áp dụng phí khác nhau cho từng khu vực?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_ALL": "Bạn muốn áp dụng cùng một mức phí cho tất cả các khu vực?",
        "EDIT_SERVICE_FEES": "Bạn muốn xóa phụ phí đã chọn?",
        "EDIT_SERVICE_FEES_CONFIRM": "Bạn muốn thoát mà không lưu cài đặt cho %{currentZone}?",
        "HEAVY_TRAFFIC": "Bạn muốn áp dụng phí khác nhau cho từng khu vực?",
        "Heavy_traffic_surcharge": "Bạn muốn áp dụng cùng một mức phí cho tất cả các khu vực?",
        "TOLL_FEE": "Chỉnh sửa phí dịch vụ",
        "parkingFee": "Chỉnh sửa phí dịch vụ",
        "gasFee": "Bạn muốn thoát mà không lưu cài đặt cho %{currentZone}?",
        "OTHER_FEES": "Kẹt xe",
        "Can_edit": "Phụ phí kẹt xe",
        "Can_add_note": "Phí cầu đường",
        "Other_fees_amount": "Phí đậu đỗ",
        "TAX": "Phí xăng xe",
        "Tax_surcharge": "Các phí khác",
        "TIP": "Có thể chỉnh sửa",
        "Default_tip": "Tiền tip mặc định",
        "RESERVATION_REMINDER": "Nhắc nhở chuyến xe đặt trước",
        "Driver_app_SMS_alert_before": "App tài xế - SMS & thông báo trước",
        "notifyWhenDriverFailStartTrip": "Thông báo cho điều hành viên nếu tài xế không bắt đầu chuyến trước thời gian đón.",
        "notifyWhenDriverFailStartTripTooltip": "Thông báo sẽ hiển thị trong phần thông báo của nền tảng. Bạn cũng có thể thiết lập thông báo gửi qua email, Slack, Discord hoặc Telegram để cập nhật kịp thời.",
        "Pax_app_alert_before": "App hành khách - thông báo trước",
        "Confirm_driver_info_via_email_before": "Gửi email/SMS xác nhận chuyến xe cho khách hàng trước",
        "Confirm_driver_info_via_email_before_hint": "Hệ thống sẽ gửi xác nhận chuyến xe cho khách hàng theo thời gian được thiết lập, trước thời gian đón.",
        "Show_request_tab_on_driver_app": "Hiển thị tab 'Yêu cầu' trên app tài xế",
        "Show_preferred_tab_on_driver_app": "Hiển thị tab 'Ưa thích' trên app tài xế",
        "Sound_notification": "Âm thanh thông báo",
        "Advance_information": "Thông tin nâng cao cho người dùng doanh nghiệp",
        "Load_general_fail": "Đã xảy ra lỗi khi tải cài đặt chung",
        "Update_general_success": "Cài đặt chung đã được cập nhật thành công",
        "Update_general_fail": "Đã xảy ra lỗi khi cập nhật cài đặt chung",
        "Time_over_lap": "Các khoảng thời gian không được chồng lên nhau",
        "Allow_passenger_to_register_as_corp_traveler": "Cho phép hành khách đăng ký làm người dùng doanh nghiệp",
        "Not_Allow_Make_Booking_Without_Assign_Fare": "Không hiển thị loại xe trên PWA và app nếu không gán giá (v4.6.60 trở lên)",
        "Not_Allow_show_car_type_on_cc": "Không hiển thị loại xe trên CC nếu không gán giá",
        "Disable_Direct_Invoicing_Receipt_Email": "Vô hiệu hóa email biên lai thanh toán trả sau",
        "Additional_services": "Dịch vụ bổ sung",
        "Edit_additional_services": "Chỉnh sửa dịch vụ bổ sung",
        "Service_Fee_By_Currencies": "Phí dịch vụ",
        "Service_type": "Loại dịch vụ",
        "Optional": "Tùy chọn",
        "Compulsory": "Bắt buộc",
        "Vehicle_type": "Loại xe",
        "Adding_additional_service_success": "Dịch vụ mới đã được tạo thành công",
        "Update_additional_service_success": "Dịch vụ đã được cập nhật thành công",
        "Delete_additional_service_success": "Dịch vụ đã được xóa thành công",
        "Adding_additional_service_fail": "Không thể thêm dịch vụ",
        "Update_additional_service_fail": "Không thể cập nhật dịch vụ",
        "Other_settings": "Dịch vụ bổ sung",
        "Operator_assign_error": "Đã xảy ra lỗi khi gán điều hành viên",
        "Create_surcharge_success": "Phụ phí mới đã được tạo thành công",
        "Update_surcharge_success": "Phụ phí đã được cập nhật thành công",
        "Delete_surcharge_success": "Phụ phí đã được xóa thành công",
        "Create_surcharge_fail": "Không thể tạo phụ phí",
        "Update_surcharge_fail": "Không thể cập nhật phụ phí",
        "Delete_surcharge_fail": "Không thể xóa phụ phí",
        "Get_surcharge_detail_fail": "Không thể lấy thông tin chi tiết về phụ phí",
        "Repeat": "Lặp lại",
        "DayOfWeek": "Ngày trong tuần",
        "SingleDay": "Một ngày",
        "Yearly": "Hàng năm",
        "Backup_phone_number": "Số dự phòng",
        "Backup_phone_number_hint": "Chuyển hướng cuộc gọi đến số này khi tài xế và hành khách ở ngoài khu vực hoạt động",
        "Apply_countdown_clock": "Áp dụng đồng hồ đếm ngược",
        "No_show_duration_tooltip": "Thiết lập thời gian hiển thị nút \"Không xuất hiện\" sau khi tài xế nhấn nút \"Đã đến\" trên app tài xế",
        "Limit_radius": "Giới hạn bán kính",
        "Limit_radius_tooltip": "Tài xế có thể báo cáo khách Không xuất hiện trong bán kính này",
        "Limit_radius_arrive_pickup": "Giới hạn bán kính mà tài xế có thể đến & đón khách",
        "Booking_validation": "Xác nhận chuyến",
        "Invalid_period_of_time": "Khoảng thời gian không hợp lệ",
        "hide_Provider_Filter_From_Corporate_Board": "Ẩn bộ lọc nhà cung cấp khỏi bảng điều khiển doanh nghiệp",
        "customer_email_is_optional": "Không bắt buộc nhập email khách hàng trên app hành khách",
        "disable_hourly_rate": "Vô hiệu hóa giá theo giờ khi cả giá theo giờ và giá cố định đều có sẵn.",
        "customer_gender_is_compulsory": "Bắt buộc nhập thông tin giới tính khách hàng trên app hành khách",
        "SHOW_MAP_STATUS": "Hiển thị trạng thái bản đồ",
        "Pay_to": "Thanh toán cho",
        "EMERGENCY_SOS": "Cứu hộ khẩn cấp (S.O.S)",
        "customer_address_is_compulsory": "Bắt buộc nhập địa chỉ khách hàng trên app hành khách",
        "customer_id_is_compulsory": "Bắt buộc nhập số CMND/CCCD trên app hành khách.",
        "allowPassengerToUploadDocument": "Cho phép hành khách tải lên tài liệu số CMND/CCCD.",
        "compulsoryNationalIcDocumentInPaxApp": "Bắt buộc nhập tài liệu CMND/CCCD trên app hành khách.",
        "doNotAllowAddDriverWhenNationalIdDuplicated": "Không cho phép điều hành viên thêm tài xế khi số CMND/CCCD trùng lặp",
        "forceCustomerToUseLiveLocation": "Buộc khách hàng sử dụng vị trí trực tiếp",
        "disableMarketPlace": "Vô hiệu hóa Market Place cho tài xế mới",
        "dontShowSecondStageImmediately": "Ẩn đăng ký tài xế giai đoạn 2",
        "dontAddCarMM": "Không cho phép Tài xế thêm nhãn hiệu/mẫu xe mới",
        "dontEditCapability": "Do not allow Driver to edit Driver Capability",
        "compulsoryCarInsurance": "Bắt buộc nhập thông tin bảo hiểm xe",
        "marketPlace": "Thị Trường",
        "Enable": "Bật",
        "Disable": "Tắt",
        "showTotalFareWithoutPromotionOnDriverApp": "Hiển thị tổng giá cước không bao gồm ưu đãi trên app tài xế",
        "showTotalFareWithoutPromotionOnDriverApp_hint": "- Di chuyển: áp dụng cài đặt này trước khi tài xế thanh toán.\n- Giao hàng & liên tỉnh: áp dụng cài đặt này trước khi tài xế bắt đầu công việc.",
        "hideFareOnPaxAppForAllCorporateBookings": "Ẩn giá trên app hành khách cho tất cả chuyến xe doanh nghiệp",
        "hidePaxNameAvatarOnDispatchScreen": "Ân thông tin khách hàng trên App trước khi chuyến xe bắt đầu",
        "showFullCustomerNameOnDriverApp": "Hiển thị đầy đủ tên khách hàng trên app tài xế",
        "hideDriverLogoutBtn": "Ẩn nút Đăng xuất trên app tài xế",
        "showMeetAndGreetButtonForEveryBooking": "Hiển thị nút \"Đón tiếp\" trên mỗi chuyến xe",
        "showEcontract": "Hiển thị nút E-Contract",
        "isShowConfirmationCode": "Hiển thị mã xác nhận đặt chỗ",
        "showIncidentReportButton": "Nút Hiển thị Sự cố",
        "inReviewStatus": "Trạng thái đang xem xét",
        "inReviewStatusTooltip": "Đánh dấu một đặt chỗ là “Đang xem xét.” Chuyến đi vẫn còn hoạt động cho đến khi nhà điều hành đóng lại.",
        "incidentBtnDrvApp": "Hiển thị nút “Sự cố” trong ứng dụng Tài xế",
        "incidentBtnDrvAppTooltip": "Thêm một nút trên các chuyến đi đang hoạt động để tài xế báo cáo sự cố, mà nhà điều hành có thể xem xét và đóng lại.",
        "fareChangeTolerance": "Độ dung sai thay đổi giá vé",
        "fareChangeToleranceTooltip": "Các thay đổi giá cước trên mức % này yêu cầu sự phê duyệt thủ công từ người điều hành.",
        "groupManifest": "Biểu mẫu Nhóm",
        "JobOrderedBy": "Công việc được đặt hàng bởi",
        "optional": "Tùy chọn",
        "pickupTime": "Thời gian lấy hàng",
        "route": "Đường đi",
        "settings": "Cài đặt",
        "Default_value": "Giá trị mặc định",
        "limitTopupAmount": {
            "valueByCurrencies": "Mức cảnh báo",
            "minimumByCurrencies": "Số tiền nạp tối thiểu",
            "maximumByCurrencies": "Số tiền nạp tối đa",
            "title": "Số tiền nạp tối thiểu và tối đa"
        },
        "driverApp": "App tài xế",
        "passengerApp": "App hành khách",
        "Default_Topup_Values": "Giá trị nạp tiền mặc định",
        "service_fees": "Phí dịch vụ",
        "commission_fleet": "Hoa hồng đội xe mặc định",
        "apply_all": "Giống nhau cho tất cả các khu vực hoạt động",
        "apply_custom_zone": "Khác nhau giữa các khu vực hoạt động",
        "apply": "Áp dụng",
        "tollFeeDriverCanInput": "Giới hạn số tiền tài xế có thể nhập",
        "unlimited": "Không giới hạn",
        "limited": "Có giới hạn",
        "sameFee": "Phí giống nhau",
        "customizedAirportfee": "Tùy chỉnh phí ",
        "noteAirportFeeModal": "Lưu ý: Phí sân bay chỉ áp dụng cho các sân bay có trong danh sách.",
        "intercity_schedule_trip_time_range": "Để đảm bảo thứ tự thời gian chuyến xe, vui lòng đảm bảo khoảng thời gian của chuyến đi ưu tiên/yêu cầu lớn hơn so với chuyến đi theo lịch trình.",
        "airportFee": {
            "tooltipApply": "Phí sân bay mặc định sẽ được áp dụng cho mỗi chuyến đi từ/đến sân bay. Nếu phí sân bay được tùy chỉnh, phí mới sẽ được áp dụng cho địa điểm đó.",
            "titleSearchAiportZone": "Vui lòng tìm kiếm sân bay của bạn và thêm phí.",
            "airport": "Sân bay",
            "currency": "Đơn vị tiền tệ",
            "fromAirportFee": "Phí từ sân bay",
            "toAirportFee": "Phí đến sân bay",
            "action": "Thao tác"
        },
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "tipPaymentMethod": "Phương thức thanh toán cho phép khách hàng tip tài xế sau chuyến đi.",
        "allowPaxUpdateTip": "Cho phép hành khách cập nhập tiền tip trong suốt chuyến xe",
        "tipDefaultValues": "Tip mặc định sau chuyến đi",
        "creadit": "Thẻ tín dụng (Thẻ cá nhân/ Thẻ doanh nghiệp)",
        "wallet": "Ví",
        "tnGeWallet": "Ví TnG",
        "vippseWallet": "Vipps",
        "DurationRegularBooking": "Miến phí phí chờ",
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "DurationRegularBookingToolTip": "Đây là khoảng thời gian chờ miễn phí mà tài xế phải đợi khách hàng và không thể đánh dấu là Khách không xuất hiện cho đến khi hết thời gian.",
        "noShowCountDown": {
            "customizedNoShow": "Tùy chỉnh địa điểm cụ thể (ví dụ: sân bay...)",
            "customizedNoShowTitle": "Áp dụng đếm ngược cho Khách không xuất hiện cho các địa điểm cụ thể (ví dụ: sân bay...)."
        },
        "maxWaitTime": "Thời gian chờ thêm tối đa",
        "maxWaitTimeToolTip": "Đây là thời gian chờ thêm tối đa sẽ được tính phí cho khách hàng. Bạn có thể tùy chỉnh mức phí theo từng phút trong cài đặt giá cước.",
        "maxWaitTimePlaceholder": "Thời gian phí chờ tối đa",
        "HEAT_MAP": "Bản đồ nhiệt",
        "heatMap": {
            "defaultMode": "Chế độ mặc định",
            "radius": "Bán kính",
            "intensity": "Cường độ",
            "opacity": "Độ mờ",
            "requestedBookings": "Yêu cầu đặt xe",
            "activePassengers": "Hành khách đang hoạt động",
            "completedBookings": "Chuyến đã hoàn tất",
            "timeoutBookings": "Chuyến quá giờ",
            "tooltipRadius": "Bán kính ảnh hưởng của mỗi điểm dữ liệu, tính bằng pixel.",
            "tooltipIntensity": "Cường độ tối đa của heat map.",
            "tooltipOpacity": "Độ mờ của heat map, biểu thị bằng số từ 0 đến 1."
        },
        "schedule_trip": "Chuyến theo lịch trình",
        "driver_starts_trip_before_set_time": "Tài xế bắt đầu chuyến trước thời gian đã đặt",
        "request_trip": "Chuyến được yêu cầu",
        "preferred_trip": "Chuyến ưu tiên",
        "time_range": "Khoảng thời gian cho chuyến yêu cầu và chuyến ưu tiên",
        "working_time": "Thời gian làm việc",
        "hour": "Giờ",
        "hours": "Giờ",
        "minutes": "Phút",
        "indicate_pickup_time_in_advance_to_customer": "Thông báo thời gian đón trước cho khách hàng.",
        "customers_can_select_start_time_and_request_intercity_trip": "Khách hàng có thể chọn thời gian bắt đầu và yêu cầu chuyến đi liên tỉnh. Tài xế cũng có thể tạo chuyến đi ưu tiên theo lịch trình của họ. Ví dụ: khoảng thời gian 1 giờ sẽ cho phép khách hàng và tài xế tạo chuyến đi liên tỉnh bắt đầu từ 8:00 sáng - 9:00 sáng, 9:00 sáng - 10:00 sáng, hoặc 10:00 sáng - 11:00 sáng.",
        "this_setting_limits_customers_to_create_request_trip_within_working_hours_only": "Cài đặt này giới hạn khách hàng chỉ có thể tạo chuyến trong giờ làm việc.",
        "face_mask_verify": "Xác minh đeo khẩu trang",
        "faceMask_allZones": "Tất cả khu vực",
        "faceMask_customized": "Tùy chỉnh khu vực",
        "turn_on_verify": "Bật xác minh",
        "force_to_wear_face_mask": "Bắt buộc đeo khẩu trang",
        "time_range_to_verify": "Không xác minh lại trong khoảng thời gian",
        "customizedFaceMaskZone": "Xác minh đeo khẩu trang tùy chỉnh",
        "zoneOperation": "Khu vực hoạt động",
        "FaceMaskCustomized": "Tùy chỉnh",
        "time": "thời gian ",
        "day": "ngày",
        "days": "ngày",
        "allow_driver_to_skip_verification_after": "Cho phép tài xế bỏ qua xác minh sau khoảng thời gian",
        "driver_need_to_verify": "Thời điểm tài xế cần xác minh",
        "open_app": "Mở ứng",
        "start_reservation": "Bắt đầu chuyến đặt trước",
        "choose_at_least_one": "Chọn ít nhất một thao tác để tiếp tục.",
        "face_mask_customized_fail": "Chọn ít nhất một thao tác để tiếp tục ({0}).",
        "vehicleAgeLimit": "Giới hạn tuổi xe",
        "vehicleAgeLimit_years": "năm",
        "founderFund_firstBooking": "Quỹ Nhà sáng lập: chỉ áp dụng cho lần đặt đầu tiên",
        "distance_diversity": "Đa dạng khoảng cách",
        "Add_Surcharge_Distance": "Thêm",
        "from": "Từ",
        "to": "Đến",
        "surchargeValue": "Phụ phí",
        "actions": "Thao tác",
        "please_enter_distance_range_valid": "Khoảng cách %{name} không hợp lệ!",
        "please_enter_distance_to": "Vui lòng nhập khoảng cách \"Đến",
        "please_enter_surchargeValue": "Vui lòng nhập khoảng cách \"Phụ phí\" cho phạm vi khoảng cách %{name}",
        "please_enter_surchargeValue_is_number": "Vui lòng nhập số hợp lệ cho \"Phụ phí\" trong phạm vi khoảng cách %{name}",
        "Update_service_fee_success": "Phí dịch vụ đã được cập nhật thành công",
        "Update_service_fee_fail": "Đã xảy ra lỗi khi cập nhật phí dịch vụ",
        "Update_fleet_commission_success": "Hoa hồng đội xe mặc định đã được cập nhật thành công",
        "Update_fleet_commission_fail": "Đã xảy ra lỗi khi cập nhật hoa hồng đội xe mặc định",
        "RESERVATION_POLICY": "Chính sách đặt chuyến",
        "default_expected_pickup_time": "Thời gian đón mặc định dự kiến",
        "default_expected_pickup_time_hint": "Thời gian tài xế dự kiến có mặt tính từ thời gian đón.",
        "same_original_pickup_time": "Giống với thời gian đón ban đầu",
        "quarter_before": "Trước 15 phút",
        "half_before": "Trước 30 phút",
        "quarter_after": "Sau 15 phút",
        "half_after": "Sau 30 phút",
        "custom": "Tùy chỉnh",
        "min_before": "phút trước",
        "min_after": "phút sau",
        "TransactionFee": "Phí giao dịch",
        "creditCardPercent": "Thẻ tín dụng/trả trước",
        "directBilling": "Thanh toán trực tiếp",
        "externalCard": "Thẻ ngoài",
        "zoneIds": "Địa điểm",
        "vehicles": "Phương tiện",
        "default_expected_pickup_time_airport": "Thời gian đón dự kiến mặc định (Sân bay đến)",
        "expectedPickupTooltip": "Nếu một số chuyến bay được cung cấp, bộ đệm mặc định này sẽ được áp dụng để tự động tính toán thời gian đón. Điều này chỉ áp dụng cho các đặt chỗ được tạo qua bảng điều khiển quản trị."
    },
    "social": {
        "pax_app": "App hành khách",
        "driver_app": "App tài xế",
        "default": "Mặc định",
        "customized": "Tùy chỉnh",
        "html": "HTML",
        "about": "Giới thiệu",
        "email": "Email hỗ trợ",
        "enablePhone": "Số điện thoại",
        "phone": "Please provide the text you would like me to translate to Vietnamese.",
        "policy": "Chính sách bảo mật",
        "termOfUse": "Điều khoản sử dụng",
        "site": "Trang web",
        "logoDriverIOS": "Logo - iOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "Tệp HTML",
        "Update_fail": "Đã xảy ra lỗi khi cập nhật social",
        "Update_success": "Social đã được cập nhật thành công"
    },
    "user": {
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "Search_here": "Tìm tại đây",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Username": "Tên đăng nhập",
        "Name": "Tên",
        "Phone_number": "Số điện thoại",
        "Email": "Email",
        "Permission": "Quyền truy cập",
        "Status": "Trạng thái",
        "Actions": "Thao tác",
        "Active": "Đang hoạt động",
        "Inactive": "Ngưng hoạt động",
        "Edit": "Chỉnh sửa",
        "Deactivate": "Ngừng hoạt động",
        "Delete": "Xóa",
        "Add": "Thêm",
        "ADD_USER": "Thêm người dùng",
        "First_name": "Họ",
        "Last_name": "Tên",
        "AgendId": "Người dùng #",
        "Email_address": "Địa chỉ email",
        "Address": "Địa chỉ",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "EDIT_USER": "Chỉnh sửa người dùng",
        "Yes": "Đồng ý",
        "DELETE_USER": "Xóa người dùng",
        "DETAIL_USER": "Chi tiết người dùng",
        "DELETE_CONFIRM": "Bạn có chắc muốn xóa người dùng đã chọn không",
        "Update_user_fail": "Lỗi xảy ra khi cập nhập người dùng",
        "Update_user_success": "Cập nhật thành công người dùng",
        "Create_user_fail": "Lỗi xảy ra khi tạo người dùng",
        "Create_user_success": "Tài khoản {0} đã được tạo thành công. Vui lòng kiểm tra email {1} để lấy dữ liệu đăng nhập",
        "Load_user_fail": "Lỗi xảy ra khi tải người dùng",
        "Update_user_status_fail": "Lỗi xảy ra khi cập nhập trạng thái người dùng",
        "Delete_user_fail": "Lỗi xảy ra khi xóa người dùng",
        "Delete_user_success": "Xóa người dùng thành công",
        "CONFIRM_RESET_PASSWORD": "Bạn có muốn đặt lại mật khẩu?",
        "RESET_PASSWORD": "Bạn có muốn đặt lại mật khẩu?",
        "Reset_password": "Đặt lại mật khẩu",
        "Select_permission": "Chọn quyền truy cập",
        "Reset_password_success": "Đặt lại mật khẩu thành công"
    },
    "report": {
        "query": {
            "errorMessage": {
                "bookFrom": "Vui lòng chọn chuyến xe từ",
                "paymentMethod": "Vui lòng chọn phương thức thanh toán",
                "bookingType": "Vui lòng chọn loại chuyến",
                "ratingType": "Vui lòng chọn loại đánh giá",
                "stars": "Vui lòng chọn loại đánh giá",
                "type": "Loại",
                "transactionType": "Vui lòng chọn loại giao dịch",
                "serviceType": "Vui lòng chọn loại dịch vụ",
                "rideService": "Vui lòng chọn dịch vụ di chuyển",
                "invalidEmail": "Vui lòng nhập địa chỉ email hợp lệ"
            },
            "search": {
                "driverReferalPax": "Tìm: Tên tài xế, số điện thoại",
                "passengerRefersPassengers": "Tìm: Tên khách hàng, số điện thoại",
                "driverReferalPaxDetail": "Tìm: Tên khách hàng",
                "bookingDetails": "Tìm: Mã đặt xe, người điều phối, số điện thoại khách hàng, tên khách hàng, tên tài xế, CMND# / CCCD#, Biển số, Hàng đợi, ghi chú, chuyến đi, mã hỗ trợ ",
                "financial": "Tìm: Tên tài xế, số điện thoại",
                "completedTime": "Thời gian hoàn thành",
                "collectedTime": "Thời gian thu thập",
                "financialDriver": "Tìm: Mã đặt xe, tên tài xế, CMND# / CCCD#",
                "carActivity": "Tìm: Biển số",
                "affiliation": "Tìm: Mã đặt xe",
                "prepaidTopUp": "Tìm: Tên công ty, Top up ID, Mã giao dịch",
                "operatorLogs": "Tìm: Tên người điều phối, tên đăng nhập, mô tả",
                "corporate": "Tìm kiếm: ID chuyến, tên tài xế, người dùng doanh nghiệp, vụ việc khách hàng, mã phí",
                "bookingLogs": "Tìm: Mã đặt xe, Tên khách hàng, Mã hỗ trợ, Tên tài xế, CMND#/CCCD#",
                "rating": "Tìm: Mã đặt xe, số điện thoại khách hàng, tên khách hàng, biển số xe",
                "mDispatcher": "Tìm: Mã đặt xe, Tên đối tác",
                "totalAdjustment": "Tìm: Mã đặt xe",
                "incidentCancellation": "Tìm: Mã đặt xe, số điện thoại khách hàng, mã hỗ trợ, tên khách hàng",
                "acceptanceCancellationRate": "Tìm: Tên tài xế, số điện thoại",
                "revenueDriver": "Tìm: Tên tài xế",
                "dailyDriver": "Tìm: Tên tài xế, số điện thoại tài xế, CMND#/ CCCD#",
                "dailyCar": "Tìm: Biển số, quyền truy cập",
                "dailyDriverCar": "Tìm: Tên tài xế, số điện thoại tài xế, CMND#/ CCCD#, Biển số",
                "driverLoginStatus": "Tìm: Tên tài xế, số điện thoại tài xế, CMND#/ CCCD#, Biển số",
                "bookingSummary": "Tìm: Tên người điều phối, tên đăng nhập, mã đặt xe",
                "creditWallet": "Tìm: Tên công ty, Tên tài xế, Mã đặt xe, Mã giao dịch, Người điều phối",
                "cashWallet": "Tìm: Tên công ty, Tên tài xế, Mã đặt xe, Mã giao dịch, Số điện thoại",
                "SupplierWallet": "Tìm kiếm: Tên công ty, ID đặt chỗ",
                "settlement": "Tìm: Tên tài xế, CMND#/ CCCD#",
                "driverRating": "Tìm: Mã đặt xe, số điện thoại khách hàng, tên khách hàng, biển số xe, mã hỗ trợ",
                "driverWithdrawal": "Tên tài xế, Số điện thoại, Công ty, Mã giao dịch, Số tham chiếu #",
                "penaltyCompensation": "Tìm: Mã đặt xe, Tên tài xế, Tên khách hàng",
                "incompletePayment": "Tìm: Mã đặt xe, Mã hỗ trợ, Tên khách hàng",
                "passengerWallet": "Tìm: Mã đặt xe, Mã giao dịch, Tên khách hàng",
                "driverDeposit": "Tìm: Tên công ty, Tên tài xế, Mã đặt xe, Người điều hành",
                "refund": "Tìm: Mã đặt xe, Mã chuyến đi, Mã hỗ trợ, Tên khách hàng",
                "driverRefersCustomerBookings": "Tìm: Mã giới thiệu, Mã hỗ trợ",
                "driverHistory": "Tìm: Mã thanh toán",
                "merchantHistory": "Tìm: Mã thanh toán",
                "firstWillWin": "Tìm: tên khách hàng, số điện thoại khách hàng, mã khách hàng",
                "firstWillWinDriver": "Tìm: tên tài xế, số điện thoại tài xế, tên đăng nhập",
                "merchant": "Tìm: cửa hàng",
                "merchantCashTransactionHistory": "Tìm: Mã đặt xe, Mã giao dịch, Tên cửa hàng",
                "merchantCreditTransactionHistory": "Tìm: Mã đặt xe, Mã giao dịch, Tên cửa hàng",
                "deleteAccountRequest": "Tìm: Số điện thoại",
                "affiliationPayoutHistory": "Tìm: Mã thanh toán",
                "thirdPartyBooking": "Tìm kiếm: ID đặt xe, ID ngoài"
            },
            "common": {
                "all": "Tất cả"
            },
            "today": "Hôm nay",
            "sendDownloadLink": "Địa chỉ email người nhận ",
            "generaltingYourExcel": "Xin lưu ý, việc tạo tệp excel của bạn có thể mất một thời gian. Chúng tôi sẽ gửi email cho bạn ngay khi tệp đã sẵn sàng.",
            "messageSuccess": "Tệp đang được xử lý. Bạn sẽ nhận được email khi đã sẵn sàng. Theo dõi tiến trình hoặc tải xuống trực tiếp từ Báo cáo/Lịch sử xuất",
            "thisMonth": "Tháng này",
            "lastMonth": "Tháng trước",
            "past30Days": "30 ngày trước",
            "thisYear": "Năm nay",
            "custom": "Tùy chỉnh",
            "customize": "Tùy chỉnh",
            "thisWeek": "Tuần này",
            "past7Days": "7 ngày trước",
            "weekly": "Hàng tuần",
            "monthly": "Hàng tháng",
            "allTime": "Tất cả thời gian",
            "tomorrow": "Ngày mai",
            "nextWeek": "Tuần tới",
            "lastWeek": "Tuần trước",
            "nextMonth": "Tháng tới",
            "next7Day": "7 Ngày Tới",
            "yesterday": "Ngày hôm qua",
            "fromDate": "Từ ngày",
            "toDate": "Đến ngày",
            "driver": "Tài xế: %{name}",
            "customer": "Khách hàng: %{name}",
            "referralCode": "Mã ưu đãi: %{name}",
            "referer": "Người giới thiệu: %{name}",
            "referee": "Người giới thiệu: %{name}",
            "usedPromoCode": "Ưu đãi: %{name}",
            "voucherCode": "Mã: %{name}",
            "city": "Thành phố",
            "company": "Công ty",
            "company_report": "Công ty: %{name}",
            "companySupplier_report": "Nhà cung cấp/Công ty: %{name}",
            "supplier_report": "Nhà cung cấp: %{name}",
            "corporate_report": "Doanh nghiệp: %{name}",
            "campaign_report": "Chiến dịch: %{name}",
            "operator": "Người điều phối",
            "farmType": "Loại trang trại",
            "carLicensePlate": "Biển số xe ô tô: %{name}",
            "settlementType": "Loại",
            "bookingService": "Loại hình phân phối",
            "payoutOption": "Tùy chọn thanh toán",
            "currency": "Đơn vị tiền tệ",
            "bookingFrom": "Chuyến xe từ",
            "Provider": "Nhà cung cấp",
            "thirdPartyAction": "Thao tác",
            "paymentMethod": "Phương thức thanh toán",
            "paymentStatus": "Trạng thái thanh toán",
            "bookingType": "Loại hình",
            "adjustPrice": "Điều chỉnh giá",
            "intercityRoute": "Tuyến đường liên tỉnh",
            "ratingType": "Loại đánh giá",
            "stars": "Đánh giá",
            "driverRating": "Đánh giá tài xế",
            "vehicleRating": "Đánh giá phương tiện",
            "mDispatcherType": "Loại đối tác",
            "mDispatcher": "Tên đối tác",
            "campaign": "Chiến dịch",
            "promocode": "Mã khuyến mãi",
            "canceledBy": "Bị hủy bởi",
            "timezone": "Múi giờ",
            "month": "Tháng",
            "year": "Năm",
            "view": "Xem",
            "action": "Thao tác",
            "status": "Trạng thái",
            "module": "Mô đun",
            "driverType": "Loại",
            "vehicleType": "Loại xe",
            "serviceType": "Loại dịch vụ",
            "expireDate": "Ngày hết hạn",
            "rideSharing": "Đi chung",
            "rideService": "Dịch vụ di chuyển",
            "transactionType": "Loại giao dịch",
            "completeFromCC": "Hoàn tất từ Trung tâm điều hành",
            "withDrawalTransactionType": "Loại giao dịch",
            "bookingStatus": "Trạng thái chuyến xe",
            "withdrawalStatus": "Trạng thái",
            "originalStatus": "Trạng thái thanh toán ban đầu",
            "currentStatus": "Trạng thái thanh toán hiện tại",
            "tip": "Tiền tip",
            "type": "Loại",
            "userType": "Loại người dùng",
            "eventType": "Loại sự kiện",
            "eventState": "Trạng thái sự kiện",
            "eventName": "Tên sự kiện",
            "merchantType": "Loại cửa hàng",
            "merchantService": "Dịch vụ cửa hàng",
            "storeName": "Cửa hàng",
            "merchant": "Gian hàng",
            "event": "Tên sự kiện: %{name}",
            "store": "Tên cửa hàng: %{name}",
            "selectedMerchant": "Tên gian hàng: %{name}",
            "associatedApps": "App liên quan",
            "settlement": "Thanh toán",
            "rideServiceItem": {
                "all": "Tất cả",
                "regulation": "Đi thường",
                "rideSharing": "Đi chung"
            },
            "actionItem": {
                "all": "Tất cả",
                "login": "Đăng nhập",
                "logout": "Đăng xuất",
                "bookIn": "Sẵn sàng",
                "bookOff": "Không sẵn sàng",
                "deny": "Từ chối",
                "ignore": "Bỏ qua",
                "accept": "Chấp nhận",
                "startTrip": "Xe đang đến",
                "updateBooking": "Cập nhật",
                "arrive": "Đã đến",
                "pickup": "Đón khách",
                "drop": "Trả khách",
                "complete": "Hoàn tất",
                "noShow": "Không thấy khách",
                "driverNoShow": "Người lái không xuất hiện",
                "rqJob": "Điều phối",
                "cancel": "Hủy"
            },
            "loginStatusItem": {
                "all": "Tất cả",
                "online": "Đang đăng nhập",
                "offline": "Không đăng nhập"
            },
            "payoutType": "Loại thanh toán",
            "affiliationPayoutTypeItem": {
                "auto": "Thanh toán tự động",
                "manual": "Thanh toán thủ công"
            },
            "affiliationSettlementItem": {
                "payable": "Có thể thanh toán",
                "receivable": "Có thể nhận thanh toán"
            },
            "affiliationPaymentMethod": {
                "online": "Trực tuyến",
                "directInvoicing": "Thanh toán trực tiếp"
            },
            "payoutPaymentStatusItem": {
                "paid": "Đã thanh toán",
                "pending": "Gián đoạn"
            },
            "farmTypeItem": {
                "all": "Tất cả",
                "farmIn": "Nhận chuyến",
                "farmOut": "Farm out",
                "roaming": "Chuyển vùng",
                "affiliationOwner": "Chủ hãng liên kết",
                "farmInAndAffiliationOwner": "Nhận chuyến và chủ sở hữu liên kết",
                "farmOutAndAffiliationOwner": "Chuyển chuyến và chủ sở hữu liên kết"
            },
            "settlementDriverTypeItem": {
                "all": "Tất cả tài xế",
                "individual": "Xe công ty"
            },
            "shortTrip": {
                "all": "Tất cả",
                "shortTrip": "Chuyến ngắn",
                "nonShortTrip": "Chuyến không ngắn"
            },
            "paymentMethodItem": {
                "B2BTerminal": "B2B Terminal",
                "webBooking": "Đặt trên web",
                "pendingPayment": "Thanh toán bị gián đoạn",
                "all": "Tất cả",
                "cash": "Tiền mặt",
                "cashBySender": "Người gửi trả tiền mặt",
                "cashByRecipient": "Người nhận trả tiền mặt",
                "personalCard": "Thẻ cá nhân",
                "corporateCard": "Thẻ doanh nghiệp",
                "qrCodePayment": "Mã thanh toán QR",
                "directBilling": "Thanh toán trả sau",
                "externalCard": "Thẻ ngoài",
                "mDispatcherCard": "Thẻ đối tác",
                "corporatePrepaid": "Doanh nghiệp trả trước",
                "canceled": "Đã hủy",
                "noShow": "Không thấy khách",
                "driverNoShow": "Người lái không xuất hiện",
                "incident": "Sự cố",
                "fleetCard": "Thẻ ngoài",
                "applePay": "Apple Pay",
                "creditCardExternal": "Thẻ tín dụng",
                "paxWallet": "Ví",
                "tngeWallet": "Ví TnG",
                "vippseWallet": "Vipps",
                "zainCash": "ZainCash",
                "xendit": "Xendit",
                "exAlipay": "Alipay",
                "FIB": "FIB",
                "SantimPay": "SantimPay",
                "gCash": "GCash",
                "completedWithoutService": "Hoàn thành mà không cần tài xế",
                "BankOfGeorgia": "Ngân hàng Georgia",
                "partialCompleted": "Đã hoàn thành một phần",
                "failed": "Không thành công",
                "googlePay": "Google Pay",
                "paymentLink": "Link thanh toán",
                "easyPaisa": "Easy Paisa",
                "jazzCash": "Jazz Cash",
                "samsung_pay": "Samsung Pay",
                "kakao_pay": "Kakao Pay",
                "naver_pay": "Naver Pay",
                "wechat_pay": "WeChat Pay",
                "alipay": "Alipay",
                "paynow": "PayNow",
                "grabpay": "GrabPay",
                "cashapp": "Thanh toán qua Cash App"
            },
            "paymentStatusItem": {
                "all": "Tất cả",
                "fullPayment": "Thanh toán đầy đủ",
                "partialPayment": "Thanh toán một phần",
                "pendingPayment": "Thanh toán bị gián đoạn",
                "partialRefund": "Hoàn tiền một phần",
                "fullRefund": "Hoàn tiền đầy đủ"
            },
            "companySettlementTypeItem": {
                "all": "Tất cả",
                "fleetOweCompany": "Đội xe nợ công ty",
                "companyOweFleet": "Công ty nợ đội xe"
            },
            "bookingStatusItem": {
                "all": "Tất cả",
                "completed": "Hoàn thành",
                "incident": "Sự cố",
                "paxNoShow": "Hành khách không có mặt",
                "driverNoShow": "Tài xế không có mặt",
                "rejected": "Bị từ chối",
                "canceledByTimeOut": "Bị hủy do hết thời gian",
                "canceledByTimeOutRejected": "Bị hủy do hết thời gian (bị từ chối)",
                "canceledByBookingBoard": "Hủy bởi bảng đặt xe",
                "canceledByCustomer": "Bị hủy bởi hành khách",
                "canceledBySupplier": "Hủy bởi nhà cung cấp"
            },
            "bookingFromItem": {
                "all": "Tất cả",
                "paxApp": "App hành khách",
                "mDispatcher": "Đối tác",
                "kiosk": "Kiosk",
                "cc": "Trung tâm điều hành",
                "webBooking": "Đặt trên web",
                "carHailing": "Khách vãng lai",
                "streetSharing": "Ghép chuyến",
                "dashboard": "Bảng đặt xe",
                "corp": "Bảng đặt xe (CTM)",
                "dmc": "Bảng đặt xe (DMC)",
                "Boost_web_link": "Link Boost"
            },
            "thirdPartyActionItem": {
                "all": "Tất cả",
                "searched": "Đã tìm kiếm",
                "allocated": "Đã phân bổ",
                "updated": "Đã cập nhật",
                "cancelled": "Đã hủy"
            },
            "bookingTypeItem": {
                "batchDelivery": "Giao hàng loạt",
                "all": "Tất cả",
                "now": "Đi ngay (Di chuyển)",
                "reservation": "Đặt trước (Di chuyển)",
                "intercity": "Liên tỉnh",
                "delivery": "Giao hàng",
                "shuttle": "Xe đưa đón"
            },
            "adjustPrices": {
                "all": "Tất cả",
                "normalPrice": "Giá thông thường",
                "addonPrice": "Giá bổ sung"
            },
            "bookingServiceItem": {
                "all": "Tất cả",
                "roaming": "Chuyển vùng",
                "homeFleet": "Chuyển chuyến",
                "localBooking": "Nội bộ",
                "farmIn": "Nhận chuyến",
                "farmInAndAffiliationOwner": "Farm in & Chủ hãng liên kết",
                "provideService": "Nhận chuyến"
            },
            "ratingTypeItem": {
                "all": "Tất cả",
                "like": "Thích",
                "dislike": "Không thích"
            },
            "starsItem": {
                "all": "Tất cả",
                "star1": "1 sao",
                "star2": "2 sao",
                "star3": "3 sao",
                "star4": "4 sao",
                "star5": "5 sao"
            },
            "incidentCanceledTypes": {
                "all": "Tất cả",
                "incident": "Sự cố",
                "canceled": "Đã hủy"
            },
            "canceledByItem": {
                "all": "Tất cả",
                "CorpAD": "Admin doanh nghiệp",
                "passenger": "Khách hàng",
                "driver": "Tài xế",
                "merchant": "Cửa hàng",
                "CC": "CC",
                "mDispatcher": "Đối tác",
                "Partner": "Đối tác",
                "webBooking": "Đặt trên web",
                "timeout": "Quá giờ"
            },
            "incidentStatusItem": {
                "RESOLVED": "Đã giải quyết",
                "DISPUTED": "Tranh chấp"
            },
            "bookingSummaryActionItem": {
                "all": "Tất cả",
                "create": "Tạo",
                "update": "Cập nhật",
                "cancel": "Hủy",
                "complete": "Hoàn tất",
                "incident": "Sự cố"
            },
            "transactionTypeItem": {
                "DriverFees": "Driver Fees",
                "bookingAdjustment": "Điều chỉnh chuyến",
                "bankAccount": "Chuyển khoản vào tài khoản ngân hàng",
                "sentToCustomer": "Gửi cho khách hàng",
                "receivedFromDriver": "Nhận từ tài xế",
                "sentToDriver": "Gửi cho tài xế",
                "creditWallet": "Chuyển vào ví tín dụng",
                "netEarning": "Thu nhập ròng",
                "referralEarning": "Thu nhập từ giới thiệu",
                "all": "Tất cả",
                "topUp": "Nạp tiền",
                "editBalance": "Chỉnh sửa số dư",
                "bookingDeduction": "Khấu trừ chuyến",
                "bookingPromo": "Ưu đãi chuyến",
                "topUpGCash": "Nạp tiền qua GCash",
                "cashWallet": "Ví tiền mặt",
                "topUpMOLPay": "Nạp tiền qua Razer Pay",
                "topUpQRIS": "Nạp tiền qua QRIS",
                "topUpZainCash": "Nạp tiền qua ZainCash",
                "topUpXendit": "Nạp tiền qua Xendit",
                "topUpalipayExternal": "Nạp tiền qua Alipay",
                "topUpFIB": "Nạp tiền qua FIB",
                "topUpSantimPay": "Nạp tiền qua SantimPay",
                "topUpTelebirr": "Nạp tiền qua Telebirr",
                "topUpKsher": "Nạp tiền qua Ksher",
                "topUpWallet": "Nạp tiền qua {0}",
                "TnG": "Nạp tiền qua TnG",
                "credit": "Nạp tiền qua thẻ tín dụng",
                "ride": "Chuyến đi",
                "tipAfterCompleted": "Tip sau chuyến",
                "debtWriteOff": "Xóa nợ",
                "refund": "Hoàn tiền",
                "excessOffsetAmount": "Cộng khoản thừa tiền mặt",
                "excessDeductionAmount": "Trừ khoản thừa tiền mặt",
                "cashExcess": "Trừ khoản thừa tiền mặt",
                "gateway": "Nạp tiền từ cổng thanh toán",
                "driverTopUpForPax": "Trừ khoản thừa tiền mặt",
                "updatedBalance": "Số dư đã cập nhật",
                "partialEarning": "Thu nhập",
                "payout": "Thanh toán",
                "payoutManual": "Thanh toán thủ công",
                "payoutDriver": "Thanh toán",
                "itemValue": "Giá trị mặt hàng",
                "redeemVoucher": "Mã đổi thưởng #",
                "topUpReferrer": "Phần thưởng giới thiệu",
                "driverInsurance": "Bảo hiểm tài xế",
                "cancellationPenalty": "Phí hủy",
                "WingBank": "Chuyển vào tài khoản Wingbank",
                "customerDebt": "Nợ khách hàng",
                "googlePay": "Nạp tiền qua Google Pay",
                "applePay": "Nạp tiền qua Apple Pay",
                "samsung_pay": "Nạp tiền bằng Samsung Pay",
                "kakao_pay": "Nạp tiền qua Kakao Pay",
                "naver_pay": "Nạp tiền bằng Naver Pay",
                "wechat_pay": "Nạp tiền bằng WeChat Pay",
                "alipay": "Nạp tiền bằng Alipay",
                "paynow": "Nạp tiền qua PayNow",
                "grabpay": "Nạp tiền bằng GrabPay",
                "cashapp": "Nạp tiền qua Cash App Pay",
                "merchantCommission": "Hoa hồng cửa hàng",
                "eWallet": "Chuyển vào ví điện tử bên ngoài",
                "reversed": "Hoàn trả khoản rút tiền",
                "driverNoShow": "Người lái không xuất hiện",
                "noShowPenalty": "Người lái không xuất hiện",
                "bookingEarning": "Lợi nhuận ròng"
            },
            "moduleItem": {
                "all": "Tất cả",
                "bookings": "Chuyến xe",
                "customers": "Khách hàng",
                "dispatch": "Điều phối",
                "general": "Cài đặt chung",
                "promotion": "Ưu đãi",
                "quest": "Nhiệm vụ",
                "rate": "Giá cước",
                "car": "Xe",
                "city": "Thành phố",
                "company": "Công ty",
                "drivers": "Tài xế",
                "driverSettlement": "Thanh toán tài xế",
                "login": "Đăng nhập",
                "logout": "Đăng xuất",
                "mDispatcher": "Đối tác",
                "mDispatcherType": "Loại đối tác",
                "operation": "Điều hành",
                "partners": "Đối tác",
                "permission": "Quyền truy cập",
                "queuingArea": "Hàng đợi",
                "report": "Báo cáo",
                "shift": "Ca làm việc",
                "user": "Người dùng",
                "voiceSms": "Cuộc gọi & tin nhắn SMS",
                "intercityZone": "Khu vực (liên tỉnh)",
                "Payout": "Thanh toán",
                "code#": "Mã số #",
                "ApiManagement": "Quản lý API"
            },
            "serviceTypeItem": {
                "all": "Tất cả",
                "oneWay": "Một chiều",
                "fromAirport": "Từ sân bay",
                "toAirport": "Đến sân bay",
                "hourly": "Theo giờ/ngày",
                "roundTrip": "Khứ hồi",
                "fromAirportHourlyDaily": "Từ sân bay - theo giờ/ngày",
                "fromAirportRoundTrip": "Từ sân bay - khứ hồi",
                "toAirportHourlyDaily": "Đến sân bay - theo giờ/ngày",
                "toAirportRoundTrip": "Đến sân bay - khứ hồi"
            },
            "merchantTransactionTypeItem": {
                "all": "Tất cả",
                "editBalance": "Chỉnh sửa số dư",
                "payout": "Thanh toán",
                "earning": "Thu nhập",
                "itemValue": "Giá trị mặt hàng",
                "orderDeduction": "Khấu trừ đơn hàng"
            },
            "withdrawalTransactionType": {
                "WingBank": "Chuyển vào tài khoản Wingbank",
                "bankAccount": "Chuyển vào tài khoản ngân hàng",
                "cashWallet": "Chuyển vào ví tiền mặt",
                "creditWallet": "Chuyển vào ví tín dụng"
            },
            "payoutDriver": {
                "driversHaveBankAccount": "Tài xế có tài khoản ngân hàng",
                "driversDontHaveBankAccount": "Tài xế không có tài khoản ngân hàng",
                "payoutEndTime": "Thời gian kết thúc thanh toán",
                "driverHaveInvalidBankAccount": "Tài xế có tài khoản ngân hàng không hợp lệ"
            },
            "payoutMerchant": {
                "HaveBankAccount": "Cửa hàng có tài khoản ngân hàng",
                "DontHaveBankAccount": "Cửa hàng không có tài khoản ngân hàng",
                "HaveInvalidBankAccount": "Cửa hàng có tài khoản ngân hàng không hợp lệ",
                "payoutEndTime": "Thời gian kết thúc thanh toán"
            }
        },
        "error": {
            "23005": "Để đảm bảo hiệu suất hệ thống, bạn chỉ có thể xem báo cáo trong khoảng %{interval} %{unitLabel}, vui lòng điều chỉnh phạm vi ngày của bạn."
        },
        "result": {
            "idPermitType": "Loại ID",
            "noResultFound": "Không tìm thấy kết quả",
            "page": "Trang",
            "itemsPerPage": "Mục mỗi trang",
            "showPages": "Hiển thị %{from} - %{to} trên tổng số %{total}",
            "exportToExcel": "Xuất ra Excel",
            "exportToCSV": "Xuất ra CSV",
            "exportToPaymentFile": "Xuất ra tệp thanh toán",
            "pay": "Thanh toán",
            "paySelected": "Thanh toán mục đã chọn",
            "payAll": "Thanh toán tất cả",
            "invalidBankAccount": "Tài khoản ngân hàng không hợp lệ",
            "validBankAccount": "Tài khoản ngân hàng hợp lệ",
            "bookingDetails": {
                "customerAdjustmentsFee": "Điều chỉnh khách hàng",
                "supplierDriverAdjustmentsFee": "Điều chỉnh nhà cung cấp/tài xế",
                "supplierPayout": "Thanh toán cho nhà cung cấp",
                "driverPayout": "Thanh toán cho tài xế",
                "profit": "Lợi nhuận",
                "successSendMessage": "Tin nhắn của bạn đã được gửi",
                "packageName": "Tên gói",
                "transactionId": "Mã giao dịch",
                "proofOfFailure": "Bằng chứng thất bại",
                "recipientsNumber": "Số lượng người nhận",
                "recipientsInfo": "Thông tin người nhận",
                "creditTransactionFee": "Phí thẻ tín dụng",
                "carTypeRequest": "Loại xe được yêu cầu",
                "bookingId": "# Đặt xe",
                "bookingStatus": "Trạng thái chuyến",
                "tripId": "Mã chuyến đi",
                "bookFrom": "Chuyến xe từ",
                "bookingService": "Loại hình phân phối",
                "bookingType": "Loại hình",
                "serviceType": "Loại dịch vụ",
                "operator": "Điều hành viên",
                "customerPhone": "Số điện thoại hành khách",
                "customerName": "Tên hành khách",
                "customerIdNumber": "CMND/CCCD hành khách",
                "corpDivision": "Bộ phận",
                "corpDept": "Phòng ban",
                "chargeCode": "Mã phí",
                "tripDescription": "Mô tả chuyến",
                "rideSharing": "Đi chung",
                "queueName": "Hàng đợi",
                "bookingTime": "Thời gian tạo",
                "pickupTime": "Thời gian đón",
                "expectedPickupTime": "Thời gian đón dự kiến",
                "dispatchTime": "Thời gian điều phối",
                "onBoardTime": "Thời gian lên xe",
                "droppedOffTime": "Thời gian trả khách",
                "onBoardDuration": "Thời gian xe di chuyển",
                "dispatch": "Mã điều phối",
                "completedTime": "Thời gian hoàn thành",
                "driverName": "Tên tài xế",
                "driverIdPermit": "Mã tài xế",
                "driverLicenseNumber": "Số giấy phép lái xe",
                "companyName": "Công ty",
                "carType": "Loại xe",
                "licensePlate": "Biển số",
                "intercityRoute": "Tuyến đường liên tỉnh",
                "pickupLocation": "Điểm đón",
                "geoPickup": "Tọa độ điểm đón",
                "extraDestination": "Điểm đến bổ sung",
                "originDestination": "Điểm đến ban đầu",
                "originEstDistance": "Khoảng cách ước tính ban đầu",
                "destination": "Điểm đến thực tế",
                "geoDestination": "Vĩ độ/kinh độ điểm đến thực tế",
                "pickupFrom": "Điểm đón từ",
                "distanceTour": "Khoảng cách P.O.B",
                "internalNotes": "Ghi chú nội bộ",
                "notes": "Ghi Chú",
                "basicFareCalculator": "Tính giá cước cơ bản",
                "basicFare": "Cước phí",
                "editFare": "Chỉnh sửa cước phí",
                "oldBasicFare": "Cước phí cũ",
                "airportFee": "Phí sân bay",
                "meetDriver": "Gặp tài xế",
                "rushHour": "Phụ phí",
                "surchargeParameter": "Phụ phí động",
                "dynamicFare": "Giá cước động",
                "heavyTraffic": "Kẹt xe",
                "tollFee": "Phí cầu đường",
                "parkingFee": "Phí đỗ xe",
                "gasFee": "Phí nhiên liệu",
                "otherFees": "Các phí khác",
                "subtotal": "Tổng cước",
                "subTotalFF": "Tổng phụ FF",
                "techFee": "Phí công nghệ",
                "serviceFee": "Dịch vụ bổ sung",
                "fleetServiceFee": "Dịch vụ đội xe",
                "bookingFee": "Phí đặt xe",
                "salesTax": "Tax",
                "tipAmt": "Tiền tip",
                "promoCode": "Mã khuyến mãi",
                "promoAmt": "Số tiền ưu đãi",
                "requestedTotalAmount": "OTA Price",
                "total": "Tổng số tiền",
                "totalNotRounded": "Làm tròn (Tổng số tiền)",
                "actualReceived": "Số tiền thực nhận",
                "differenceAmt": "Chênh lệch (số tiền nhận được)",
                "customerDebt": "Nợ khách hàng",
                "markupDifference": "Chênh lệch markup giá",
                "receivedWhenDropOff": "Nhận tiền khi trả khách",
                "refundAmount": "Số tiền hoàn trả",
                "requestedPaymentMethod": "Phương thức thanh toán yêu cầu",
                "paidBy": "Thanh toán bởi",
                "splitPayment": "Thanh toán chia nhỏ",
                "paidByWallet": "Thanh toán bằng ví",
                "paidByOtherMethod": "Thanh toán bằng phương thức khác",
                "cashReceived": "Tiền mặt nhận được",
                "transferredChangeByWallet": "Chuyển tiền lẻ qua ví",
                "returnedChangeByCash": "Trả tiền lẻ bằng tiền mặt",
                "instructions": "Hướng dẫn",
                "additionalServiceName": "Tên",
                "additionalServiceValue": "Giá trị",
                "sendReceiptHeader": "Please provide the text you would like me to translate to Vietnamese.",
                "sendReceipt": "Gửi biên lai",
                "send": "Gửi",
                "cancel": "Hủy",
                "sentReceiptSuccess": "Biên lai đã được gửi thành công",
                "sentReceiptFailed": "Biên lai không thể gửi ngay bây giờ. Vui lòng thử lại.",
                "coRider": "Người đi cùng",
                "coriderName": "Tên",
                "stopAddress": "Điểm đến bổ sung",
                "stopGeo": "Vĩ độ/kinh độ",
                "addonPrice": "KH điều chỉnh giá",
                "oldSubTotal": "Tổng phụ trước điều chỉnh",
                "view_good_receipt": "Biên lai hàng hóa",
                "view_delivery_receipt": "Ảnh giao hàng",
                "view": "Xem",
                "tipAfterCompletedDetails": "Đã chuyển: {0}{1}; Phí giao dịch: {0}{2}",
                "fleetMarkup": "Lợi nhuận",
                "editedDriverEarning": "Đã chỉnh sửa thu nhập tài xế",
                "driverEarning": "Thu nhập tài xế",
                "supplierAmount": "Thu nhập nhà cung cấp",
                "currencyISO": "Tiền tệ",
                "pickUpZoneName": "Khu vực đón",
                "dynamicFactor": "Giá cước động (hệ số)",
                "supplierEarning": "Thu nhập nhà cung cấp",
                "passengerName": "Tên hành khách",
                "totalPayout": "Tổng thanh toán",
                "numberOfTrips": "Số chuyến",
                "psgLocation": "Vị trí hành khách (vĩ độ/kinh độ)",
                "psgIp": "IP hành khách",
                "DeviceImei": "IMEI thiết bị",
                "otaDiscount": 'OTA Discount',
            },
            "financial": {
                "supplierPayout": "Thanh toán cho nhà cung cấp",
                "driverPayout": "Thanh toán cho tài xế",
                "profit": "Lợi nhuận",
                "currencyISO": "Tiền tệ",
                "supplierAmount": "Thu nhập nhà cung cấp",
                "driverEarning": "Thu nhập tài xế",
                "supplierEarning": "Thu nhập nhà cung cấp",
                "passengerName": "Tên hành khách",
                "totalPayout": "Tổng thanh toán",
                "numberOfTrips": "Số chuyến",
                "driverName": "Tên tài xế",
                "driverPhone": "Số điện thoại",
                "driverUserName": "Tên đăng nhập",
                "companyName": "Công ty",
                "bookingList": "Danh sách chuyến",
                "totalFare": "Tổng cước chưa tính ưu đãi",
                "netEarning": "Thu nhập ròng",
                "showBookingList": "Hiển thị",
                "referralEarning": "Thu nhập từ giới thiệu",
                "totalEarningNet": "Tổng thu nhập (ròng)",
                "totalEarningNetTooltip": "Số tiền bạn kiếm được sau khi trả lại tất cả phí cho đội xe. Tổng thu nhập (ròng) = Thu nhập ròng + Tip sau chuyến đi",
                "totalEarningNetTooltipRefferal": "Số tiền bạn kiếm được sau khi trả lại tất cả phí cho đội xe. Tổng thu nhập (ròng) = Thu nhập từ giới thiệu + Thu nhập ròng + Tip sau chuyến đi",
                "totalEarningGross": "Tổng thu nhập (gộp)",
                "totalEarning": "Tổng thu nhập",
                "totalEarningGrossTooltip": "Số tiền bạn kiếm được từ giá cước và tiền tip. Tổng thu nhập (gộp) = Thu nhập gộp + Tip sau chuyến đi",
                "totalEarningGrossTooltipRefferal": "Số tiền bạn kiếm được từ giá cước và tiền tip. Tổng thu nhập (gộp) = Thu nhập từ giới thiệu + Thu nhập gộp + Tip sau chuyến đi",
                "note": "Ghi chú",
                "shortTrip": "Chuyến ngắn",
                "deduction": "Khấu trừ",
                "totalDriverEarning": "Tổng thu nhập tài xế",
                "totalDriverEarningTooltip": "Bao gồm các chuyến với thanh toán trực tuyến và ngoại tuyến",
                "totalDriverPayout": "Tổng thanh toán cho tài xế",
                "totalDriverPayoutTooltip": "Không bao gồm các chuyến thanh toán bằng tiền mặt hoặc ngoại tuyến"
            },
            "financialDriver": {
                "supplierAmount": "Hoa hồng nhà cung cấp",
                "payoutType": "Loại thanh toán",
                "date": "Ngày",
                "driverTipAfterCompleted": "Tip sau chuyến",
                "bookingId": "Mã đặt xe",
                "paidBy": "Thanh toán bởi",
                "bookFrom": "Chuyến xe từ",
                "bookingType": "Loại hình",
                "companyName": "Công ty",
                "driverName": "Tài xế",
                "driverIdPermit": "Mã tài xế",
                "totalFare": "Tổng cước không bao gồm ưu đãi",
                "subtotal": "Tổng cước",
                "airportFee": "Phí sân bay",
                "meetDriver": "Gặp tài xế",
                "tollFee": "Phí cầu đường",
                "parkingFee": "Phí đỗ xe",
                "gasFee": "Phí nhiên liệu",
                "rushHour": "Giờ cao điểm",
                "transactionFee": "Phí giao dịch",
                "techFee": "Phí công nghệ",
                "salesTax": "Thuế",
                "tipAmt": "Tiền tip",
                "bookingFee": "Phí đặt xe",
                "commission": "Hoa hồng",
                "deduction": "Khấu trừ",
                "promoAmt": "Số tiền ưu đãi",
                "ridePayment": "Chi phí chuyến",
                "driverTax": "Thuế tài xế",
                "grossEarning": "Tổng thu nhập",
                "driverDeduction": "Khấu trừ tài xế",
                "netEarning": "Thu nhập ròng",
                "payToDriver": "Thanh toán cho tài xế",
                "payToFleet": "Thanh toán cho đội xe",
                "totalNotRounded": "Làm tròn (Tổng số tiền)",
                "fleetServiceFee": "Phí dịch vụ đội xe",
                "editedDriverEarning": "Đã chỉnh sửa thu nhập tài xế",
                "stripeFee": "Phí Stripe",
                "currencyISO": "Tiền tệ"
            },
            "financialCompany": {
                "companyName": "Company ",
                "homeFleetNetEarning": "Thu nhập ròng của đội xe nội bộ",
                "affiliateNetEarning": "Tổng thu nhập ròng hãng liên kết",
                "totalNetEarning": "Tổng thu nhập ròng",
                "status": "Trạng thái",
                "companyAmount": "Company profit",
                "numberOfTrips": "Số chuyến"
            },
            "companySettlement": {
                "companyName": "Công ty",
                "pendingSettlement": "Chưa quyết toán",
                "viewDetails": "Xem chi tiết",
                "settlementType": "Loại"
            },
            "companySettlementDetails": {
                "bookId": "Mã đặt xe",
                "dateTime": "Ngày giờ",
                "originalPaymentStatus": "Trạng thái thanh toán ban đầu",
                "subTotal": "Tổng phụ",
                "fleetAmount": "Số tiền đội xe",
                "driverAmount": "Số tiền tài xế",
                "companyAmount": "Số tiền công ty",
                "companyOweFleet": "Công ty nợ đội xe",
                "fleetOweCompany": "Đội xe nợ công ty",
                "notes": "Ghi chú"
            },
            "financialProfit": {
                "profit": "Lợi nhuận",
                "bookingId": "# Đặt xe",
                "subTotal": "Tổng cước",
                "subTotalFF": "Tổng phụ FF",
                "fleetCommission": "Hoa hồng đội xe",
                "techFee": "Phí công nghệ",
                "promotion": "Ưu đãi",
                "markupDifference": "Chênh lệch markup",
                "Profit": "Lợi nhuận",
                "currency": "Đơn vị tiền tệ",
                "fleetServiceFee": "Dịch vụ đội xe (phí đội xe thu)",
                "fleetServiceFeeTooltip": "Số tiền đội xe thu hoa hồng từ phí dịch vụ"
            },
            "promotion": {
                "date": "Ngày",
                "promoCode": "Mã khuyến mãi",
                "users": "Người dùng",
                "uses": "Lượt sử dụng",
                "checked": "Đã kiểm tra",
                "applied": "Đã áp dụng",
                "totalPromoAmount": "Tổng số tiền ưu đãi",
                "totalReceipt": "Tổng biên lai",
                "numberOfUsers": "Số lượng người dùng",
                "numberOfPromoCodeAppliance": "Số lượt áp dụng mã ưu đãi",
                "numberOfSuccessfulBookings": "Số lượng chuyến xe thành công",
                "numberOfCompletedBookings": "Số chuyến hoàn tất",
                "numberOfCompletedUsers": "Số lượng người dùng đã hoàn tất",
                "numberOfUsersApplyPromotion": "Số lượng người dùng áp dụng ưu đãi",
                "numberOfUsersApplyPromotionAndCompleteBooking": "Số lượng người dùng áp dụng ưu đãi & hoàn tất chuyến",
                "numberOfPromoCodeApplianceTooltip": "Tổng số lượt áp dụng mã ưu đãi của tất cả người dùng",
                "numberOfSuccessfulBookingsTooltip": "Số lượng chuyến thành công có sử dụng mã ưu đãi",
                "numberOfCompletedBookingsTooltip": "Số lượng chuyến hoàn tất có sử dụng mã ưu đãi"
            },
            "export": {
                "createdDate": "Ngày",
                "sessionName": "Tên phiên",
                "download": "Tải xuống",
                "delete": "Xóa",
                "percent": "Percent",
                "status": "Trạng thái",
                "name": "Tên mô đun"
            },
            "redeemed": {
                "date": "Ngày",
                "code": "Mã",
                "customers": "Khách hàng",
                "phone": "Số điện thoại",
                "value": "Giá trị",
                "currency": "Đơn vị tiền tệ",
                "campaignName": "Chiến dịch"
            },
            "carActivity": {
                "plateNumber": "Biển số",
                "vehicleType": "Loại xe",
                "companyName": "Công ty",
                "day1st": "Ngày 1",
                "day2nd": "Ngày 2",
                "day3rd": "Ngày 3",
                "day4th": "Ngày 4",
                "day5th": "Ngày 5",
                "day6th": "Ngày 6",
                "day7th": "Ngày 7",
                "day8th": "Ngày 8",
                "day9th": "Ngày 9",
                "day10th": "Ngày 10",
                "day11th": "Ngày 11",
                "day12th": "Ngày 12",
                "day13th": "Ngày 13",
                "day14th": "Ngày 14",
                "day15th": "Ngày 15",
                "day16th": "Ngày 16",
                "day17th": "Ngày 17",
                "day18th": "Ngày 18",
                "day19th": "Ngày 19",
                "day20th": "Ngày 20",
                "day21st": "Ngày 21",
                "day22nd": "Ngày 22",
                "day23rd": "Ngày 23",
                "day24th": "Ngày 24",
                "day25th": "Ngày 25",
                "day26th": "Ngày 26",
                "day27th": "Ngày 27",
                "day28th": "Ngày 28",
                "day29th": "Ngày 29",
                "day30th": "Ngày 30",
                "day31st": "Ngày 31",
                "operationDays": "Ngày vận hành",
                "activeCars": "Tổng xe đang hoạt động"
            },
            "carActivityLogsTitle": "Nhật ký",
            "carActivityLogs": {
                "licensePlate": "Biển số",
                "companyName": "Công ty",
                "bookingId": "Mã đặt xe",
                "driverName": "Tên tài xế",
                "driverIDNumber": "Mã tài xế",
                "date": "Thời gian nhận",
                "bookFrom": "Chuyến xe từ"
            },
            "affiliation": {
                "date": "Date",
                "bookingId": "Mã đặt xe",
                "bookingType": "Loại hình",
                "homeFleet": "Đội xe nội bộ",
                "providerFleet": "Độ xe nhà cung cấp",
                "driver": "Tài xế",
                "passenger": "Khách hàng",
                "paidBy": "Được thanh toán bởi",
                "airportFee": "Phí dịch vụ sân bay",
                "meetDriver": "Gặp tài xế",
                "rushHour": "Phụ phí",
                "tollFee": "Phí cầu đường",
                "parkingFee": "Phí đỗ xe",
                "gasFee": "Phí xăng xe",
                "heavyTraffic": "Kẹt xe",
                "otherFees": "Các phí khác",
                "provider": "Nhà cung cấp",
                "basicFareProvider": "Nhà cung cấp giá cước cơ bản",
                "subTotalProvider": "Nhà cung cấp tổng phụ",
                "techFeeProvider": "Nhà cung cấp phí công nghệ",
                "bookingFeeProvider": "Đơn vị thu phí đặt xe",
                "taxValueProvider": "Nhà cung cấp giá trị thuế",
                "tipProvider": "Nhà cung cấp tiền tip",
                "totalFareProvider": "Nhà cung cấp tổng giá cước",
                "basicFare": "Cước phí",
                "subtotal": "Tổng cước",
                "techFee": "Phí công nghệ",
                "bookingFee": "Phí đặt xe",
                "tax": "Thuế",
                "tip": "Tiền Tip",
                "totalFare": "Tổng giá cước",
                "payoutInLocalCurrency": "Thu nhập chuyến theo đơn vị tiền tệ địa phương",
                "payoutInUSD": "Thu nhập chuyến theo USD",
                "fleetCommInUSD": "Hoa hồng đội xe theo USD",
                "bookingFeeInUSD": "Phí đặt xe (USD)",
                "totalPayoutInUSD": "Tổng thanh toán theo USD",
                "subTotal": "Tổng cước",
                "bookingStatus": "Trạng thái chuyến",
                "vehicle": "Xe",
                "customerPhone": "Số điện thoại khách hàng",
                "driverPhone": "Số điện thoại tài xế",
                "total": "Tổng cộng",
                "totalInUSD": "Tổng các chi phí (USD)",
                "supplierPayout": "Thanh toán cho nhà cung cấp",
                "supplierPayoutInUSD": "Thanh toán cho nhà cung cấp (USD)",
                "buyerPayout": "Hoa hồng người mua",
                "buyerPayoutInUSD": "Hoa hồng (USD)",
                "buyerCommission": "Hoa hồng",
                "buyerCommissionInUSD": "Hoa hồng (USD)",
                "receivableInUSD": "Thu (USD)",
                "payableInUSD": "Thanh toán (USD)",
                "fleetMarkupInUSD": "Lợi nhuận (USD)",
                "paymentMethod": "Phương thức thanh toán",
                "paymentStatus": "Trạng thái thanh toán"
            },
            "prepaidTopUp": {
                "date": "Ngày giờ",
                "topUpId": "Mã nạp tiền",
                "transactionId": "Mã giao dịch",
                "name": "Tên",
                "company": "Công ty",
                "paidBy": "Thanh toán bởi",
                "amount": "Số tiền",
                "newAmount": "Số dư mới",
                "transactionType": "Loại giao dịch"
            },
            "operatorLogs": {
                "date": "Ngày",
                "operator": "Người vận hành",
                "username": "Tên đăng nhập",
                "module": "Mô đun",
                "description": "Mô tả"
            },
            "corporate": {
                "date": "Ngày",
                "bookingId": "Mã đặt xe",
                "operatorName": "Đơn vị vận hành doanh nghiệp",
                "corporateName": "Công ty",
                "corpTraveler": "Người dùng doanh nghiệp",
                "travelerSignature": "Chữ kí hành khách",
                "corpId": "Mã doanh nghiệp",
                "corpDivision": "Bộ phận",
                "costCentre": "Trung tâm chi phí",
                "corpPO": "Corp PO",
                "managerName": "Tên quản lý",
                "managerEmail": "Email quản lý",
                "title": "Chức danh",
                "department": "Phòng/ ban",
                "clientCaseMatter": "Chi tiết khách hàng/ Mô tả chuyến di",
                "chargeCode": "Mã thanh toán/ Mã chuyến xe",
                "driverName": "Tài xế",
                "pickupLocation": "Điểm đón",
                "destination": "Điểm đến",
                "total": "Tổng số tiền",
                "subtotal": "Tổng cước",
                "subTotalFF": "Tổng phụ phí FF",
                "commission": "Hoa hồng",
                "commissionBooking": "Áp dụng hoa hồng cho đặt xe từ ứng dụng/PWA",
                "paidBy": "Được thanh toán bởi",
                "statusDisplay": "Trạng thái",
                "flightNumber": "Số hiệu chuyến bay"
            },
            "bookingLogs": {
                "bookingId": "Mã đặt xe",
                "bookingService": "Loại hình phân phối",
                "bookingType": "Loại hình",
                "driverName": "Tài xế",
                "driverIdPermit": "Mã tài xế",
                "customerName": "Hành khách",
                "pickupTime": "Thời gian đón",
                "onBoardTime": "Thời gian lên xe",
                "droppedOffTime": "Thời gian trả",
                "pickupLocation": "Điêểm đón",
                "destination": "Điểm đến",
                "dispatchHistory": "Lịch sử điều phối",
                "otwDistance": "Quãng đường di chuyển",
                "distanceTour": "Quãng đường chở khách",
                "duration": "Thời gian chở khách",
                "paidBy": "Được thanh toán bởi",
                "bookFrom": "Chuyến xe từ",
                "map": "Bản đồ",
                "showDispatchHistory": "Hiển thị",
                "showMap": "Hiển thị",
                "paymentActivities": "Hoạt động thanh toán"
            },
            "rating": {
                "date": "Ngày",
                "bookingId": "Mã đặt xe",
                "driverName": "Tài xế",
                "driverIdPermit": "Mã tài xế",
                "customerName": "Tên khách hàng",
                "customerPhone": "Số điện thoại khách hàng",
                "like": "Thích",
                "dislike": "Không thích",
                "notes": "Nhận xét",
                "stars": "Đánh giá",
                "vehicleRating": "Đánh giá phương tiện",
                "driverRating": "Đánh giá tài xế",
                "plateNumber": "Biển số xe"
            },
            "mDispatcher": {
                "date": "Ngày",
                "bookingId": "Mã đặt xe",
                "mDispatcherName": "Tên đối tác",
                "mDispatcherType": "Loại đối tác",
                "subtotal": "Tổng cước",
                "commission": "Hoa hồng",
                "paidBy": "Được thanh toán bởi"
            },
            "totalAdjustment": {
                "date": "Ngày",
                "bookingId": "Mã đặt xe",
                "oldAmount": "Tổng cộng",
                "type": "Loại",
                "markupDifference": "Chênh lệch giá",
                "newAmount": "Giá sau điều chỉnh",
                "username": "Người vận hành",
                "reason": "Lý do"
            },
            "incidentCancellation": {
                "date": "Ngày",
                "bookingId": "Mã đặt xe",
                "customerName": "Tên khách hàng",
                "customerPhone": "Số điện thoại khách hàng",
                "bookFrom": "Chuyến xe từ",
                "canceledBy": "Bị hủy bởi",
                "type": "Loại",
                "reason": "Lý do hủy",
                "reasonCode": {
                    "0": "Tôi đã tìm được phương thức di chuyển khác",
                    "1": "Tài xế ở quá xa",
                    "2": "Tôi nhập sai điểm đón",
                    "3": "Tôi đã chờ quá lâu",
                    "4": "Tài xế yêu cầu hủy chuyến",
                    "5": "Tôi đã thay đổi kế hoạch",
                    "6": "Tôi muốn đổi điểm đến",
                    "101": "Hầu hết hoặc tất cả các mặt hàng không có sẵn",
                    "102": "Hiện tải chúng tôi quá tải",
                    "103": "Hiện tại chúng tôi đã đóng cửa",
                    "104": "Chúng tôi sắp đóng cửa"
                },
                "canceller": "Người hủy chuyến",
                "incidentStatus": "Tình trạng sự cố"
            },
            "acceptanceCancellationRate": {
                "companyId": "Mã công ty",
                "driverId": "Mã tài xế",
                "driverName": "Tên tài xế",
                "phoneNumber": "Số điện thoại",
                "company": "Công ty",
                "acceptanceRate": "Tỉ lệ chấp nhận",
                "cancellationRate": "Tỉ lệ hủy chuyến",
                "rating": "Đánh giá"
            },
            "revenueFleet": {
                "date": "Ngày",
                "fareRevenue": "Doanh thu từ giá cước",
                "trip": "Chuyến",
                "avgFareTrip": "Giá cước trung bình/chuyến",
                "drivers": "# Tài xế",
                "avgTripPerDriver": "Số chuyến trung bình mỗi tài xế",
                "dispatcher": "# Điều phối viên"
            },
            "revenueDriver": {
                "date": "Ngày",
                "driverName": "Tài xế",
                "fareRevenue": "Doanh thu từ giá cước",
                "trip": "# Chuyến",
                "avgFareTrip": "Giá cước trung bình/chuyến"
            },
            "revenueMonthly": {
                "month": "Tháng",
                "trip": "Số chuyến hoàn tất",
                "subtotal": "Tổng cước",
                "tipAmt": "Tiền Tip",
                "techFee": "Phí công nghệ",
                "salesTax": "Thuế",
                "partnerCommission": "Hoa hồng từ đối tác/ODD",
                "totalFare": "Tổng giá cước chưa áp dụng ưu đãi",
                "netEarning": "Thu nhập ròng",
                "fleetServiceFee": "Phí dịch vụ đội xe"
            },
            "dailyDriver": {
                "driverName": "Tài xế",
                "driverIDPermit": "Mã tài xế",
                "driverPhone": "Điện thoại",
                "companyName": "Công ty",
                "workingHoursOnline": "Trực tuyến (giờ)",
                "workingHoursAvailable": "Sẵn sàng (giờ)",
                "driverWorkingHours": "Giờ làm việc của tài xế",
                "distance": "Tổng quãng đường tài xế đã đi",
                "CC_activity": "Hoạt động của Trung tâm Chỉ huy",
                "fare_summary": "Hoạt động của Trung tâm Chỉ huy",
                "workingHoursNotAvailable": "Không hoạt động (giờ)",
                "workingHoursPob": "Thời gian chở khách (giờ)",
                "workingHoursPobToolTip": "Tổng thời gian chở khách",
                "workingHoursAccepted": "Đã chấp nhận",
                "workingHoursReject": "Từ chối",
                "workingHoursIgnore": "Bỏ qua",
                "workingHoursCancel": "Hủy",
                "completedTripsTotal": "Tổng cộng",
                "completedTripsCc": "Từ Trung tâm điều hành",
                "completedTripsCarHailing": "Từ khách vãng lai",
                "completedTripsStreetSharing": "Từ KH ghép chuyến",
                "completedTripsPaxApp": "Từ app khách hàng",
                "completedTripsWebBooking": "Từ web đặt xe",
                "completedTripsMDispatcher": "Từ đối tác",
                "completedTripsKiosk": "Từ Kiosk",
                "completedTripsApi": "Từ API",
                "ccActivityDispatchedTrips": "Các chuyến đã điều phối",
                "ccActivityAccepted": "Đã chấp nhận",
                "ccActivityReject": "Từ chối",
                "ccActivityIgnore": "Bỏ qua",
                "ccActivityCancelByPassenger": "Đã hủy bởi khách hàng ",
                "ccActivityCancelByDriver": "Bị hủy bởi tài xế",
                "ccActivityCancelByCc": "Đã hủy bởi tổng đài",
                "ccActivityCancelByAPI": "Bị hủy bởi API",
                "ccActivityNoShow": "Không thấy khách",
                "fareSummaryTotalCash": "Tiền mặt",
                "fareSummaryTotalCreditCard": "Thẻ tín dụng",
                "fareSummaryTotalExternalCard": "Thẻ ngoài",
                "fareSummaryTotalPaxWallet": "Ví điện tử",
                "fareSummaryTotalDirectBilling": "Hóa đơn trực tiếp",
                "fareSummaryTotalQrCode": "Mã QR",
                "fareSummaryTotalPrePaid": "Doanh nghiệp trả trước",
                "fareSummaryTotalApplePay": "Apple Pay",
                "fareSummaryTotalTngeWallet": "Ví TNG",
                "fareSummaryTotalVippseWallet": "Vipps",
                "fareSummaryTotal": "Tổng cộng",
                "ratingNotes": "Số lượng ghi chú",
                "ratingDislike": "Số lượt không thích",
                "ratingLike": "Số lượt thích",
                "fareDetailsBasicFare": "Cước phí",
                "fareDetailsAirportFee": "Phí sân bay",
                "fareDetailsRushHour": "Phụ phí",
                "fareDetailsHeavyTraffic": "Kẹt xe",
                "fareDetailsOtherFees": "Các phí khác",
                "fareDetailsSubTotal": "Tổng cước",
                "fareDetailsSubTotalFF": "Tổng phụ phí FF",
                "fareDetailsTechFee": "Phí công nghệ",
                "fareDetailsBookingFee": "Phí đặt xe",
                "fareDetailsSalesTax": "Thuế bán hàng",
                "fareDetailsTip": "Số tiền tip",
                "fareDetailsPromoAmount": "Số tiền ưu đãi",
                "fareDetailsTotalAmt": "Tổng số tiền",
                "availableDistance": "Sẵn sàng",
                "otwDistance": "Đang trên đường đi",
                "otwDistanceToolTip": "Khoảng cách di chuyển",
                "pobDistance": "Đang đi",
                "pobDistanceToolTip": "Khoảng cách hành khách trên xe",
                "ratingStars1": "Lượt đánh giá 1 sao",
                "ratingStars2": "Lượt đánh giá 2 sao",
                "ratingStars3": "Lượt đánh giá 3 sao",
                "ratingStars4": "Lượt đánh giá 4 sao",
                "ratingStars5": "Lượt đánh giá 5 sao",
                "ratingAvg": "Trung bình",
                "ssnNumber": "#Số an sinh xã hội ",
                "driverEmail": "Địa chỉ email",
                "driverAddress": "Địa chỉ nhà",
                "fareDetailsAddonPrice": "Khách hàng điều chỉnh giá",
                "fareDetailsOldSubTotal": "Tổng phụ phí trước điều chỉnh giá"
            },
            "dailyCar": {
                "carInfo": "Thông tin xe",
                "fareDetails": "Chi tiết giá cước",
                "completedTrips": "Hoàn thành chuyến",
                "carInfoCompanyName": "Công ty",
                "carInfoPermission": "Quyền truy cập",
                "carInfoVehiclePlateNumber": "Biển số",
                "carInfoVhcId": "Xe #",
                "carInfoCarType": "Loại xe",
                "completedTripsTotal": "Tổng cộng",
                "completedTripsCc": "Từ Trung tâm điều hành",
                "completedTripsCarHailing": "Từ khách vãng lai",
                "completedTripsStreetSharing": "Từ KH ghép chuyến",
                "completedTripsPaxApp": "Từ app khách hàng",
                "completedTripsWebBooking": "Từ đặt xe trên web",
                "completedTripsMDispatcher": "Từ đối tác",
                "completedTripsKiosk": "Từ ki ốt",
                "completedTripsAPI": "Từ API",
                "fareDetailsBasicFare": "Cước phí",
                "fareDetailsAirportFee": "Phí sân bay",
                "fareDetailsMeetDriver": "Gặp tài xế",
                "fareDetailsRushHour": "Phụ phí",
                "fareDetailsHeavyTraffic": "Kẹt xe",
                "fareDetailsTollFee": "Phí cầu đường",
                "fareDetailsParkingFee": "Phí đậu xe",
                "fareDetailsGasFee": "Phí nhiên liệu",
                "fareDetailsOtherFees": "Các phí khác",
                "fareDetailsSubTotal": "Tổng phụ phí",
                "fareDetailsSubTotalFF": "Tổng phụ phí FF",
                "fareDetailsTechFee": "Phí công nghệ",
                "fareDetailsBookingFee": "Phí đặt xe",
                "fareDetailsSalesTax": "Thuế bán hàng",
                "fareDetailsTip": "Tiền Tip",
                "fareDetailsPromoAmount": "Khoảng ưu đãi",
                "fareDetailsTotalAmt": "Tổng số tiền",
                "fareDetailsAddonPrice": "Khách hàng điều chỉnh giá",
                "fareDetailsOldSubTotal": "Tổng phụ phí trước điều chỉnh giá"
            },
            "dailyDriverCar": {
                "driverInfo": "Thông tin tài xế",
                "driverName": "Tên tài xế",
                "driverIDPermit": "Mã tài xế",
                "driverPhone": "Số điện thoại",
                "companyName": "Công ty",
                "actionInfo": "Thao tác",
                "date": "Ngày",
                "action": "Thao tác",
                "bookingId": "Mã đặt xe",
                "carInfo": "Thông tin xe",
                "permission": "Quyền truy cập",
                "licensePlate": "Biển số",
                "carId": "Xe #",
                "carType": "Loại xe"
            },
            "driverLoginStatus": {
                "driver": "Tài xế",
                "driverIdPermit": "Mã tài xế",
                "phone": "Số điện thoại",
                "username": "Tên đăng nhập",
                "company": "Công ty",
                "carType": "Loại xe",
                "licensePlate": "Biển số",
                "status": "Trạng thái"
            },
            "bookingSummary": {
                "date": "Ngày",
                "operator": "Nhà điều hành",
                "username": "Tên đăng nhập",
                "action": "Thao tác",
                "bookingId": "Mã đặt xe"
            },
            "cashWallet": {
                "bankAccount": "Chuyển vào tài khoản ngân hàng",
                "creditWallet": "Chuyển vào ví tín dụng",
                "tipAfterCompleted": "Tiền thưởng sau khi hoàn thành",
                "netEarning": "Thu nhập ròng",
                "referralEarning": "Thu nhập từ giới thiệu",
                "receiverAccount": "Tài khoản nhận",
                "dateAndTime": "Ngày và giờ",
                "driverName": "Tên tài xế",
                "phoneNumber": "Số điện thoại",
                "userName": "Tên đăng nhập",
                "company": "Công ty",
                "type": "Loại",
                "bookingId": "# Đặt xe",
                "operator": "Nhà điều hành",
                "reason": "Lí do",
                "amount": "Số tiền",
                "newAmount": "Số dư mới",
                "currency": "Đơn vị tiền tệ",
                "topUpGCashReason": "Nạp tiền qua Gcash",
                "topUpReason": "Nạp tiền bằng thẻ tín dụng *{0}",
                "cashWalletReason": "Nạp tiền bằng tiền mặt",
                "topUpMOLPayReason": "Thanh toán qua Razer Pay [ {0} ]",
                "chargedAmount": "Khoảng phụ phí",
                "differentPercent": "Chiết khấu/ Phí bổ sung (%)",
                "operatorName": "Nhà điều hành",
                "sendPayout": "Thao tác",
                "sendPayoutTitle": "Gửi lại email thanh toán",
                "payoutReason": "{0} (Thanh toán {1} {2})"
            },
            "creditWallet": {
                "receiverType": "Loại người nhận",
                "receiverName": "Tên người nhận",
                "receiverPhone": "Số điện thoại người nhận",
                "senderPhone": "Số điện thoại người gửi",
                "senderName": "Tên người gửi",
                "sentToCustomer": "Gửi đến khách hàng",
                "sentToDriver": "Gửi đến tài xế",
                "dateAndTime": "Ngày và giờ",
                "driverName": "Tên tài xế",
                "phoneNumber": "Số điện thoại",
                "userName": "Tên đăng nhập",
                "company": "Công ty",
                "type": "Loại",
                "bookingId": "# Đặt xe",
                "operator": "Nhà điều hành",
                "reason": "Lí do",
                "amount": "Số tiền",
                "newAmount": "Số dư mới",
                "currency": "Đơn vị tiền tệ",
                "transactionId": "Mã giao dịch",
                "topUpGCashReason": "Nạp tiền qua Gcash",
                "topUpReason": "Nạp tiền bằng thẻ tín dụng *{0}",
                "cashWalletReason": "Nạp tiền bằng tiền mặt",
                "topUpMOLPayReason": "Thanh toán qua Razer Pay [ {0} ]",
                "topUpWalletReason": "{0} [ {1} ]",
                "chargedAmount": "Khoảng phụ phí",
                "differentPercent": "Chiết khấu/ Phí bổ sung (%)",
                "cashExcessReason": "Khách hàng phải trả {0}; Tiền mặt nhận được {1}",
                "referralEarningReason": "Khách hàng {0} {1} đã hoàn thành chuyến đầu tiền {2}",
                "referralEarningReason_2": "Khách hàng {0} {1} đã hoàn thành chuyến {2}",
                "insurance": "Bảo hiểm tài xế"
            },
            "passengerWallet": {
                "dateTime": "Ngày và giờ",
                "customerName": "Tên khách hàng",
                "phoneNumber": "Số điện thoại",
                "type": "Loại",
                "bookingId": "# Đặt xe",
                "changedAmount": "Số tiền đã thay đổi",
                "amount": "Số tiền đã thay đổi",
                "newBalance": "Số dư mới",
                "currency": "Đơn vị tiền tệ",
                "transactionId": "Mã giao dịch",
                "Note": "Ghi chú",
                "credit": "Nạp tiền bằng thẻ tín dụng *{0}",
                "TnG": "Nạp tiền bằng Tng #{0}",
                "MOLPay": "Nạp tiền qua [RazerPay - #{0}]",
                "gatewayName": "Nạp tiền qua [{0} - #{1}]",
                "cashExcess": "Khách hàng phải trả {0}; Tiền mặt nhận được {1}",
                "editBalance": "Chỉnh sửa số dư",
                "ride": "Chuyến xe",
                "topUp": "Nạp tiền",
                "topUpReferee": "Phần thưởng giới thiệu ({0})",
                "topUpReferrer": "Người được giới thiệu mới (#{0}): {1} ({2})"
            },
            "recipientsInfo": {
                "order": "Số",
                "orderId": "Mã đơn hàng #",
                "name": "Tên người nhận",
                "phone": "Số điện thoại",
                "address": "Địa chỉ người nhận",
                "deliveryFee": "Phí giao hàng",
                "ItemValue": "Giá trị hàng hóa (Thanh toán khi nhận hàng)",
                "status": "Trạng thái",
                "Performer": "Người thực hiện",
                "Reason": "Lí do",
                "proofOfFailure": "Bằng chứng sự cố",
                "referenceNumber": "Mã tham chiếu"
            },
            "dispatchHistory": {
                "performer": "Người thực hiện",
                "name": "Tên",
                "action": "Thao tác",
                "date": "Ngày",
                "location": "Vị trí tài xế",
                "estimate": "Thời gian xe đến điểm đón dự kiến",
                "passenger": "Khách hàng",
                "detachVehicle": "Hủy gán xe",
                "assignVehicle": "Gán xe"
            },
            "payToDriver": {
                "driverName": "Tài xế",
                "totalUnsettledTransactions": "Tổng giao dịch chưa thanh toán",
                "totalUnsettledAmount": "Tổng số tiền chưa thanh toán",
                "actions": "Thao tác",
                "pay": "Thanh toán",
                "remove": "Hủy",
                "clearSuccess": "Thu nhập của tài xế được chọn đã được thanh toán thành công.",
                "clearFailed": "Không thể xóa dữ liệu doanh thu của tài xế. Vui lòng thử lại",
                "selectDriver": {
                    "title": "Please provide the text you would like me to translate to Vietnamese.",
                    "body": "Vui lòng chọn tài xế để thanh toán.",
                    "buttonTitle": "Đồng ý"
                },
                "confirmClear": {
                    "title": "Please provide the text you would like to have translated into Vietnamese.",
                    "body": "Bạn muốn xóa dữ liệu thu nhập của tài xế này? Hành động này không thể hoàn tác.",
                    "buttonTitle": "Đồng ý",
                    "closeButtonText": "Từ chối"
                },
                "confirmPay": {
                    "body": "Bạn chắc chắn muốn thanh toán cho tài xế được chọn?",
                    "buttonTitle": "Đồng ý",
                    "closeButtonText": "Từ chối"
                },
                "paymentSuccessfully": "Đã thanh toán thành công cho tài xế.",
                "ProcessPayout": "Xử lý thanh toán"
            },
            "customerQuest": {
                "name": "Tên",
                "phoneNumber": "Số điện thoại",
                "supportId": "Mã hỗ trợ",
                "ranking": "Xếp hạng",
                "points": "Điểm",
                "numberOfReservation": "Số lượt đặt xe",
                "driver": "Tài xế",
                "customer": "Khách hàng",
                "firstWillWin": "Đầu tiên sẽ thắng",
                "firstWillWinLuckyDraw": "Đầu tiên sẽ thắng (quay may mắn)",
                "largestWillWin": "Dẫn đầu sẽ thắng (bảng xếp hạng)",
                "qualified": "Đủ điều kiện",
                "notQualified": "Không đủ điều kiện",
                "userName": "Người dùng",
                "completedDate": "Ngày hoàn thành",
                "isQualified": "Trạng thái",
                "ticket": "Vé",
                "numOfComplete": "Số lượng chuyến hoàn thành",
                "bookingDistance": "Quãng đường chở khách",
                "numberOfIntercity": "Số chuyến liên tỉnh",
                "numberOfDelivery": "số chuyến giao hàng",
                "pleaseSelectEventName": "Vui lòng chọn tên sự kiện",
                "numberOfQualifiedSetting": "Đủ điều kiện (cài đặt):",
                "numberOfActualQualified": "Số lượng thực tế đủ điều kiện",
                "driverRating": "Đánh giá tài xế",
                "acceptanceRating": "Tỷ lệ nhận chuyến",
                "cancellationRating": "Tỷ lệ hủy chuyến",
                "period": "Kỳ hạn: "
            },
            "payoutToDriver": {
                "IFSCCode": "Mã IFSC",
                "payoutID": "Mã thanh toán",
                "driverName": "Tài xế",
                "driverPhone": "Số điện thoại",
                "companyName": "Công ty",
                "period": "Kỳ hạn",
                "driverId": "Mã tài xế",
                "cashWalletBalance": "Số dư ví tiền mặt",
                "creditBalance": "Số dư tín dụng",
                "holdAmount": "Số tiền tạm giữ",
                "minPayout": "Số tiền thanh toán tối thiểu",
                "enterMinimumPayoutAmount": "Nhập số tiền thanh toán tối thiểu",
                "payoutAmount": "Số tiền thanh toán",
                "payoutDate": "Ngày thanh toán",
                "actions": "Thao tác",
                "pay": "Thanh toán",
                "remove": "Hủy",
                "payoutEndTime": "Thời hạn thanh toán kết thúc",
                "clearSuccess": "Thu nhập của tài xế được chọn đã được xử lý thành công.",
                "clearFailed": "Không thể xóa dữ liệu doanh thu của tài xế. Vui lòng thử lại",
                "amountKeepInDriverCashWallet": "Khoảng tiền giữ lại trong ví của tài xế",
                "selectDriver": {
                    "title": "Please provide the text you would like to have translated into Vietnamese.",
                    "body": "Vui lòng chọn tài xế để thanh toán",
                    "buttonTitle": "Đồng ý"
                },
                "confirmClear": {
                    "title": "Please provide the text you would like me to translate to Vietnamese.",
                    "body": "Bạn muốn xóa dữ liệu thu nhập của tài xế này? Thao tác này không thể hoàn tác.",
                    "buttonTitle": "Đồng ý",
                    "closeButtonText": "Từ chối"
                },
                "confirmPay": {
                    "body": "Bạn muốn thanh toán cho tài xế đã chọn? <br> - Số lượng tài xế: %{drivers}</b> <br> - Số tiền chi trả tối thiểu cho mỗi tài xế: %{currency} %{min}</b> <br> - Số tiền giữ lại: %{currency} %{hold}</b> <br> - Tổng số tiền chi trả: %{currency} %{total}<b>\n",
                    "buttonTitle": "Đồng ý",
                    "closeButtonText": "Từ chối"
                },
                "paymentSuccessfully": "Đã thanh toán thành công cho tài xế.",
                "paymentCompleted": "Quá trình thanh toán hoàn tất: <br> - Thanh toán thành công: %{success} <br> - Thất bại: %{failed} <br> - Tổng số tiền thanh toán thành công: %{currency} %{total}",
                "noteSelectDrivers": "Lưu ý: Vui lòng chọn tài xế đã có tài khoản ngân hàng để thanh toán.",
                "sendPayout": "Gửi thông báo thanh toán thành công đến email",
                "accountNumber": "Số tài khoản",
                "iBanNumber": "Số IBAN",
                "accountHoldName": "Tên chủ tài khoản",
                "bankName": "Tên ngân hàng",
                "selelctedDriverHasBeenPaid": "Tài xế đã thanh toán",
                "selelctedDriverHasBeenFailed": "Thanh toán cho tài xế thất bại",
                "selelctedDriverHasBeenUpdateAsInvalid": "Tài xế được cập nhật là 'Tài khoản ngân hàng không hợp lệ'",
                "selelctedDriverHasBeenUpdateAsValid": "Tài xế được cập nhật là 'Tài khoản ngân hàng hợp lệ'.",
                "isBankAccountOwner": "Người thụ hưởng là tài xế",
                "isBankAccountOwner_true": "Đồng ý",
                "isBankAccountOwner_false": "Từ chối",
                "beneficiaryIDIC": "ID người thụ hưởng / CMND",
                "bankRelationship": "Mối quan hệ",
                "bankRelationship_1": "Vợ/Chồng",
                "bankRelationship_2": "Con gái/ Con trai",
                "bankRelationship_3": "Anh/Chị/Em",
                "bankRelationship_4": "Họ hàng",
                "bankRelationship_5": "Bạn bè",
                "bankRelationship_6": "Khác: {0}",
                "bankStatus": "Tình trạng Ngân hàng",
                "emailStatement": "Thông báo qua Email",
                "viewStatement": "Xem Báo cáo",
                "downloadStatement": "Tải xuống dưới dạng PDF",
                "emailStatementSuccess": "Thông báo email đã được gửi thành công",
                "NumberDriver": "Số lượng Tài xế",
                "NumberSupplier": "Số lượng Nhà cung cấp",
                "sendMailPayout": "Gửi thông báo thanh toán thành công đến địa chỉ email sau:",
                "confirmPayoutTitle": "Bạn có chắc chắn muốn thanh toán cho những người dùng đã chọn không?",
                "phoneOfBank": "Điện thoại Ngân hàng"
            },
            "payoutToMerchant": {
                "payoutId": "Mã thanh toán",
                "merchantName": "Tên cửa hàng",
                "phone": "Số điện thoại",
                "accountNumber": "Số tài khoản",
                "iBanNumber": "Mã IBAN",
                "bankAccountHolder": "Tên chủ tài khoản",
                "bankName": "Tên ngân hàng",
                "pendingAmount": "Số tiên đang chờ xử lý",
                "payoutAmount": "Số tiền thanh toán",
                "payoutDate": "Ngày thanh toán",
                "holdAmount": "Số tiền bị giữ lại",
                "minPayout": "Số tiền thanh toán tối thiểu",
                "selelctedMerchantHasBeenPaid": "Cửa hàng đã được thanh toán",
                "selelctedMerchantHasBeenFailed": "Cửa hàng thanh toán không thanh toán",
                "pay": "Thanh toán",
                "selectMerchant": {
                    "title": "Cảnh báo",
                    "body": "Vui lòng chọn cửa hàng để thanh toán",
                    "buttonTitle": "Đồng ý"
                },
                "confirmPay": {
                    "body": "Bạn muốn thanh toán cho cửa hàng đã chọn? <br> - Số lượng cửa hàng: <br>%{merchants}</b><br> - Thanh toán tối thiểu cho mỗi tài xế: %{currency} <b>%{min}<b> <br> - Số tiền bị giữ lại: <b>%{currency} %{hold}<b> - Tổng số tiền thanh toán: <b>%{currency} %{total}</b>",
                    "buttonTitle": "Đồng ý",
                    "closeButtonText": "Từ chối"
                },
                "sendPayout": "Gửi thông báo thanh toán thành công đến email",
                "HasBeenUpdateAsInvalid": "Cửa hàng được cập nhật là 'Tài khoản ngân hàng không hợp lệ'",
                "HasBeenUpdateAsValid": "Cửa hàng được cập nhật là 'Tài khoản ngân hàng hợp lệ'."
            },
            "payoutSupplier": {
                "selelctedSupplierHasBeenUpdateAsValid": "Các nhà cung cấp được chọn đã được cập nhật là 'Tài khoản ngân hàng hợp lệ'",
                "selelctedSupplierHasBeenUpdateAsInvalid": "Các nhà cung cấp đã chọn đã được cập nhật là 'Tài khoản ngân hàng không hợp lệ'",
                "selelctedSupplierHasBeenFailed": "Các nhà cung cấp được chọn đã thất bại",
                "selelctedSupplierHasBeenPaid": "Nhà cung cấp đã chọn đã được thanh toán",
                "confirmPay": {
                    "body": "Bạn có chắc chắn muốn thanh toán cho nhà cung cấp đã chọn không? <br> - Số lượng nhà cung cấp: <b>%{drivers}</b> <br> - Số tiền tối thiểu cho mỗi nhà cung cấp: %{currency} <b>%{min}</b> <br> - Số tiền giữ lại: %{currency}<b> %{hold}</b> <br> - Tổng số tiền thanh toán: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Vâng",
                    "closeButtonText": "Không"
                },
                "agentName": "Tên đại lý",
                "walletBalance": "Số dư ví",
                "newAmount": "Số tiền mới"
            },
            "settlementHistory": {
                "date": "Ngày",
                "driverName": "Tên tài xế",
                "dateRange": "Khoảng thời gian ",
                "totalTransaction": "Tổng giao dịch đã quyết toán",
                "paidAmount": "Tổng số tiền đã quyết toán"
            },
            "settlement": {
                "driverName": "Tài xế",
                "driverIdPermit": "Mã tài xế",
                "totalBookings": "Tổng số lượt đặt xe",
                "total": "Tổng số tiền",
                "approved": "Được phê duyệt",
                "acct": "TK",
                "gross": "Tổng thu nhập",
                "percent": 0.03,
                "net": "Thu nhập ròng"
            },
            "documentExpiry": {
                "driverName": "Tên tài xế",
                "driverPhone": "Số điện thoại tài xế",
                "company": "Công ty",
                "documentName": "Tên tài liệu",
                "expiredDate": "Ngày hết hạn",
                "status": "Trạng thái",
                "statusStr": {
                    "NA": "Không có sẵn",
                    "expired": "Hết hạn",
                    "active": "Đang hoạt động",
                    "expireSoon": "Sắp hết hạn"
                }
            },
            "referralDetail": {
                "bookingId": "Đặt xe #",
                "completedDate": "Thời gian hoàn thành",
                "paidBy": "Thanh toán bởi",
                "bookFrom": "Chuyến xe từ",
                "driverName": "Tên tài xế",
                "driverIdPermit": "Mã tài xế",
                "companyName": "Công ty",
                "Passenger": "Khách hàng",
                "Customer": "Khách hàng",
                "subtotal": "Tổng cước",
                "subTotalFF": "Tổng phụ phí FF",
                "subtotalWithPromo": "Tổng phụ có ưu đãi",
                "referralEarning": "Thu nhập từ giới thiệu",
                "Amount": "Số tiền",
                "Note": "Ghi chú",
                "Currency": "Đơn vị tiền tệ",
                "PercentOfSubTotal": "{0}% của tổng phụ phí",
                "max": "Tối đa {0}",
                "referrerInfo": "Tài xế giới thiệu khách hàng",
                "phoneReferral": "Số điện thoại tài xế #",
                "driverNumber": "Mã tài xế",
                "referralCode": "Mã giới thiệu bạn bè",
                "reference": "Reference"
            },
            "referralHistory": {
                "driverName": "Tên tài xế",
                "phoneNumber": "Số điện thoại",
                "companyName": "Công ty",
                "referralCode": "Mã giới thiệu bạn bè",
                "commission": "Tổng hoa hồng",
                "expectedReferralEarning": "Dự kiến thu nhập từ giới thiệu",
                "activePaxTooltip": "Khách hàng đã sử dụng mã giới thiệu từ tài xế và hoàn tất ít nhất một chuyến.",
                "referredPaxTooltip": "Khách hàng đã sử dụng mã giới thiệu từ tài xế nhưng chưa đặt chuyến.",
                "activePax": "Tổng số khách hàng đang hoạt động",
                "referredPax": "Tổng số khách hàng được giới thiệu",
                "detailFields": {
                    "passengerId": "Mã khách hàng",
                    "passengerName": "Tên khách hàng",
                    "firstBookingDate": "Ngày hoàn thành chuyến xe đầu tiên",
                    "firstBookingDateGMT": "Ngày hoàn thành chuyến xe đầu tiên (GMT)",
                    "passengerPhone": "Số điện thoại khách hàng",
                    "appliedDate": "Ngày giới thiệu",
                    "referredByDriver": "Được tài xế giới thiệu",
                    "driverPhone": "Số điện thoại tài xế",
                    "referralCode": "Mã giới thiệu bạn bè"
                },
                "showDetail": "Hiển thị",
                "detail": "Chi tiết"
            },
            "paxReferralHistory": {
                "customerName": "Tên khách hàng",
                "phoneNumber": "Số điện thoại",
                "referralCode": "Mã giới thiệu bạn bè",
                "commission": "Tổng hoa hồng",
                "activePaxTooltip": "Khách hàng đã dùng mã giới thiệu và hoàn thành ít nhất một chuyến.",
                "referredPaxTooltip": "Khách hàng đã sử dụng mã giới thiệu từ tài xế nhưng chưa đặt chuyến",
                "activePax": "Tổng số khách hàng đang hoạt động",
                "referredPax": "Tổng số khách hàng được giới thiệu",
                "detailFields": {
                    "passengerId": "Mã hành khách",
                    "passengerName": "Tên khách hàng",
                    "firstBookingDate": "Ngày hoàn thành chuyến xe đầu tiên",
                    "firstBookingDateGMT": "Ngày hoàn thành chuyến xe đầu tiên (GMT)"
                },
                "showDetail": "Hiển thị",
                "detail": "Chi tiết"
            },
            "driverRefersDriver": {
                "companyName": "Công ty",
                "phoneNumber": "Số điện thoại",
                "username": "Tên đăng nhập",
                "referralCode": "Mã giới thiệu bạn bè",
                "referrer": "Người giới thiệu",
                "numberOfReferees": "Số lượng người được giới thiệu",
                "activeReferees": "Người được giới thiệu đang hoạt động",
                "referee": "Người được giới thiệu",
                "refereePhone": "Số điện thoại người được giới thiệu",
                "refereeUsername": "Tên người được giới thiệu",
                "referredDate": "Ngày được giới thiệu",
                "activatedDate": "Ngày kích hoạt",
                "referrerByDriver": "Ngày giới thiệu",
                "referrerPhone": "Số điện thoại người giới thiệu",
                "referralStatus": "Trạng thái giới thiệu ",
                "lifeTimeBookings": "Lượt tích lũy",
                "inReview": "Đang kiểm tra",
                "activated": "Đã kích hoạt"
            },
            "driverWithdrawal": {
                "transferToEWallet": "Đã chuyển về ví điện tử ngoài *{0}",
                "channelCode": "Mã kênh",
                "channelName": "Tên kênh",
                "reversed": "Đảo ngược giao dịch",
                "currentBalanceTooltip": "Số dư ví tiền mặt hiện tại của tài xế trước yêu cầu rút tiền",
                "paymentTime": "Thời gian thanh toán ",
                "requestTime": "Thời gian yêu cầu",
                "referenceId": "Mã tham chiếu #",
                "transactionId": "Mã giao dịch",
                "description": "Mô tả",
                "transferAmount": "Số tiền chuyển khoản",
                "currency": "Đơn vị tiền tệ",
                "approved": "Đã duyệt",
                "rejected": "Từ chối",
                "failed": "Thất bại",
                "reason": "Lý do"
            },
            "penaltyCompensation": {
                "penaltyAmount": "Phí phạt",
                "totalCollect": "Cần thanh toán bằng nội tệ",
                "totalCollectInUSD": "Cần thanh toán bằng USD",
                "compensationAmount": "Bồi thường",
                "compensationAmountInUSD": "Bồi thường (USD)",
                "penaltyReason": "Lý do phạt",
                "estimatedPrice": "Giá ước tính",
                "estimatedPriceInUSD": "Giá ước tính (USD)",
                "penaltyAmountInUSD": "Tiền phạt (USD)",
                "amount": "Số tiền",
                "amountInUSD": "Số tiền (USD)"
            },
            "imcompletePayment": {
                "bookingId": "Mã đặt xe",
                "bookFrom": "Chuyến xe từ",
                "bookingTime": "Ngày/Giờ chuyến xe",
                "completedTime": "Ngày/Giờ hoàn thành chuyến",
                "customerName": "Tên khách hàng",
                "requestedPaymentMethod": "Phương thức thanh toán yêu cầu",
                "originalPaymentStatus": "Trạng thái thanh toán ban đầu",
                "currentPaymentStatus": "Trạng thái thanh toán hiện tại",
                "updatedDateTime": "Ngày/giờ thu tiền",
                "totalAmt": "Tổng số tiền",
                "originalOutstandingAmount": "Số tiền nợ ban đầu",
                "currentOutstandingAmount": "Số tiền nợ hiện tại",
                "outstandingAmountPaidBy": "Số tiền nợ được thu bởi",
                "writeOffDebtMethod": "Số tiền nợ được thu bởi",
                "reason": "Lý do",
                "customerPhone": "Số điện thoại",
                "amountCollected": "Số tiền đã thu",
                "partialPaymentAmount": "Thanh toán một phần khi trả khách"
            },
            "driverDeposit": {
                "dateAndTime": "Ngày và giờ",
                "userName": "Tên đăng nhập",
                "type": "Loại",
                "newAmount": "Số dư mới",
                "topUpGCashReason": "Nạp tiền qua Gcash",
                "topUpReason": "Nạp tiền bằng thẻ tín dụng *{0}",
                "cashWalletReason": "Nạp tiền bằng tiền mặt",
                "topUpMOLPayReason": "Thanh toán qua Razer Pay [ {0} ]"
            },
            "refund": {
                "fullRefund": "Hoàn tiền toàn bộ",
                "partialRefund": "Hoàn tiền một phần",
                "tripId": "Mã chuyến",
                "route": "Lộ trình",
                "refundAmount": "Số tiền hoàn lại",
                "refundTime": "Thời gian hoàn tiền",
                "paymentStatus": "Trạng thái thanh toán"
            },
            "merchant": {
                "store": "Cửa hàng",
                "name": "Tên",
                "phoneNumber": "Số điện thoại",
                "bookingId": "# Đặt xe",
                "totalOrders": "Tổng số đơn hàng",
                "completedOrders": "Đơn đã hoàn thành",
                "canceledOrders": "Đơn đã hủy",
                "incidentOrders": "Sự cố",
                "revenue": "Doanh thu",
                "commission": "Hoa hồng",
                "earning": "Thu nhập",
                "food": "Đồ ăn",
                "mart": "Đi chợ",
                "preferredMerchant": "Cửa hàng ưu tiên",
                "regularMerchant": "Cửa hàng thường",
                "companyName": "Công ty"
            },
            "merchantCashTransactionHistory": {
                "companyName": "Công ty",
                "dateTime": "Ngày và giờ",
                "merchantUserName": "Người dùng cửa hàng",
                "merchantUserPhone": "Số điện thoại",
                "merchantUserEmail": "Email",
                "merchantName": "Cửa hàng",
                "transactionType": "Loại",
                "bookId": "# Đặt xe",
                "transactionId": "Mã giao dịch",
                "operatorName": "Người điều hành",
                "reason": "Lý do",
                "amount": "Số tiền",
                "newBalance": "Số dư mới",
                "currencyISO": "Đơn vị tiền tệ"
            },
            "merchantCreditTransactionHistory": {
                "dateTime": "Ngày và giờ",
                "merchantUserName": "Người dùng cửa hàng",
                "merchantUserPhone": "Số điện thoại",
                "merchantUserEmail": "Email",
                "merchantName": "Cửa hàng",
                "transactionType": "Loại",
                "bookId": "# Đặt xe",
                "transactionId": "Mã giao dịch",
                "operatorName": "Người điều hành",
                "reason": "Lý do",
                "amount": "Số tiền",
                "newBalance": "Số dư mới",
                "currencyISO": "Đơn vị tiền tệ"
            },
            "deleteAccountRequest": {
                "date": "Ngày",
                "phone": "Điện thoại",
                "username": "Tên đăng nhập",
                "supportId": "Mã hỗ trợ",
                "requestFrom": "Yêu cầu từ",
                "associatedApps": "App liên kết",
                "reason": "Lý do"
            },
            "affiliationPayoutHistory": {
                "payoutId": "Mã thanh toán",
                "dateTime": "Ngày và giờ",
                "payoutType": "Loại",
                "accountHolderName": "Tên chủ tài khoản",
                "bankName": "Tên ngân hàng",
                "accountNumber": "Số tài khoản",
                "totalPayout": "Tổng số tiền thanh toán (USD)",
                "viewDetails": "Xem chi tiết",
                "notes": "Ghi chú",
                "bookId": "# Đặt xe",
                "transactionType": "Loại giao dịch",
                "transactionId": "Mã giao dịch (chuyển tiền tự động)",
                "settlement": "Quyết toán",
                "paymentMethod": "Loại",
                "networkType": "Loại hình phân phối"
            },
            "thirdPartyBooking": {
                "date": "Ngày",
                "bookingId": "Mã đặt xe",
                "externalId": "ID ngoài",
                "psgPhone": "Số điện thoại khách hàng",
                "psgName": "Tên khách hàng",
                "pickupLocation": "Điểm đón",
                "pickupLocationLatLong": "Vĩ độ/kinh độ vị trí đón",
                "dropoffLocation": "Điểm trả khách",
                "dropoffLocationLatLong": "Vĩ độ/kinh độ vị trí trả",
                "pickupTime": "Thời gian đón",
                "numOfPassenger": "Số hành khách",
                "action": "Thao tác"
            },
            "external": "Nhà cung cấp bên ngoài",
            "inHouse": "Nhà cung cấp nội bộ",
            "negative": "Tiêu cực",
            "positive": "Tích cực",
            "supplierType": "Loại nhà cung cấp",
            "supplierCompany": "Nhà cung cấp/Công ty",
            "invalidOrNoBank": "Không hợp lệ",
            "BankInfo": "Thông tin Ngân hàng",
            "BankStatusConnect": "Trạng thái Cổng",
            "payManually": "Thanh toán thủ công",
            "payViaGateway": "Thanh toán qua %{gateway}",
            "payConfirmModal_manual": "Xác nhận thanh toán thủ công",
            "payConfirmModal_manual_note": "Bạn sắp thực hiện một <b>thanh toán thủ công</b> cho %{type} đã chọn. Điều này sẽ cập nhật số dư ví của mỗi %{type} và tạo ra một báo cáo thanh toán để xử lý ngân hàng.",
            "payConfirmModal_auto": "Xác Nhận Thanh Toán Tự Động",
            "payConfirmModal_auto_note": "Bạn sắp thực hiện <b>thanh toán tự động</b> cho %{type} đã chọn qua <b>%{gateway}</b>. Các khoản thanh toán sẽ được gửi trực tiếp đến tài khoản ngân hàng đã đăng ký của họ.",
            "Eligible": "Đủ điều kiện nhận tiền tự động",
            "EligibleNote": "Chỉ có %{value} nhà cung cấp đủ điều kiện nhận thanh toán tự động. Vui lòng kiểm tra và cập nhật thông tin tài khoản ngân hàng cho các nhà cung cấp còn lại."
        }
    },
    "zoneSetting": {
        "Add": "Thêm",
        "Import": "Nhập dữ liệu",
        "Name": "Tên",
        "Status": "Trạng thái",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "Deactivate": "Ngừng hoạt động",
        "Activate": "Kích hoạt",
        "Delete": "Xóa",
        "Cancel": "Hủy",
        "Input_zone_name": "Nhập khu vực",
        "Save_zone": "Lưu khu vực",
        "Clear_draw": "Xóa bản vẽ",
        "Edit": "Chỉnh sửa",
        "Delete_zone_success": "Khu vực đã được xóa thành công",
        "Delete_zone_fail": "Xảy ra lỗi khi xóa khu vực",
        "Update_zone_fail": "Xảy ra lỗi khi cập nhật khu vực",
        "Update_zone_success": "Cập nhật khu vực thành công",
        "Create_zone_fail": "Xảy ra lỗi khi tạo khu vực",
        "Create_zone_success": "Tạo thành công khu vực mới",
        "Draw_zone": "Vui lòng vẽ khu vực trên bản đồ",
        "Import_zones_successful": "Nhập khu vực thành công",
        "Import_zones_fail": "Xảy ra lỗi khi nhập khu vực",
        "DELETE_ZONE": "Xóa khu vực này",
        "ZONE_CONFIRM": "Bạn muốn xóa khu vực đã chọn?",
        "Name_zone_required": "Bắt buộc nhập Tên và Khu vực",
        "Select_file": "Nhập file",
        "No": "Từ chối",
        "Yes": "Đồng ý",
        "Import_zones_intercity_successful": "[{0}] khu vực đã được nhập thành công, [{1}] thất bại.",
        "Import_zones_intercity_successful_failed": "[{0}] khu vực đã được nhập thành công, [{1}] thất bại.",
        "Flat_zone": "Khu vực cố định",
        "Json_file": "File Json",
        "Import_zones": "Nhập khu vực",
        "timezone": "Múi giờ"
    },
    "companySetting": {
        "DELETE_COMPANY": "Xóa công ty",
        "DELETE_CONFIRM": "Bạn muốn xóa công ty này?",
        "DETAIL_COMPANY": "Detail company",
        "commissionValue": "Phí hoa hồng công ty",
        "connectStatus": "Kết nối Stripe",
        "connectStripe": "Kết nối",
        "stripeConnectId": "Mã tài khoản Stripe",
        "loginStripe": "Bảng điều khiển",
        "disconnectStripe": "Ngắt kết nối",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Cancel": "Hủy",
        "EDIT_COMPANY": "EDIT COMPANY SUPPLIER",
        "ADD_COMPANY": "ADD COMPANY SUPPLIER",
        "Name": "Tên",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Actions": "Thao tác",
        "Edit": "Chỉnh sửa",
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Create_company_success": "Công ty mới được tạo thành công",
        "Create_company_fail": "Xảy ra lỗi khi tạo công ty",
        "Update_company_success": "Cập nhật công ty thành công",
        "Update_company_fail": "Xảy ra lỗi khi cập nhật công ty",
        "Load_company_fail": "Xảy ra lỗi khi tải thông tin công ty",
        "Delete_company_success": "Công ty được xóa thành công",
        "Delete_company_fail": "Xảy ra lỗi khi xóa công ty",
        "hideFare": "Luôn ẩn giá cước",
        "Broadcast_orders": "Phân phối tất cả chuyến",
        "paymentMethodsApply": "Hỗ trợ phương thức thanh toán",
        "emailsNotification": "Thông báo qua email",
        "CopySignUpLink": "Sao chép link đăng ký",
        "operationZone": "Khu vực hoạt động",
        "delayBroadcast": "Hiển thị đơn hàng sau",
        "releaseTime": "Thời gian phát hành",
        "advanceBookingVisibility": "Số ngày xem trước chuyến",
        "advanceBookingVisibilityTooltip": "Thiết lập số ngày mà nhà cung cấp có thể xem chuyến xe trước ngày đón, đảm bảo đặt xe được phân bổ kịp thời theo từng nhà cung cấp."
    },
    "dispatchSetting": {
        "Cut_off_time_range": "Thời gian cắt đặt sau giờ",
        "Cut_off_time_range_tooltip": "Nếu khoảng thời gian cắt là từ 10 giờ tối đến 6 giờ sáng, khách hàng vẫn có thể đặt trước 10 giờ tối cho các lượt đón sau 10 giờ tối. Tuy nhiên, nếu thời gian hiện tại nằm trong khoảng từ 10 giờ tối đến 6 giờ sáng, lượt đón sớm nhất được phép là sau 6 giờ sáng cộng với thời gian chuẩn bị.",
        "GENERAL": "Cài đặt chung",
        "Offer_interval": "Thời gian nhận chuyến (tài xế)",
        "Offer_interval_merchant": "Thời gian nhận đơn (cửa hàng)",
        "Offer_interval_merchant_toolTip": "Thời gian tối đa để cửa hàng nhận đơn",
        "Offer_interval_toolTip": "Thời gian tối đa để tài xế nhận chuyến",
        "soundMarketplace": "Âm thanh",
        "sound": "Âm thanh",
        "Auto_re_dispatch_interval_toolTip": "Thời gian nghỉ giữa 2 vòng điều phối",
        "Maximum_auto_dispatch_duration_toolTip": "Thời gian tối đa điều phối chuyến cho tài xế",
        "Seconds": "Giây",
        "Auto_re_dispatch_interval": "Tự động điều phối lại",
        "Maximum_auto_dispatch_duration": "Thời gian tối đa tự động điều phối ",
        "Time_out": "Quá giờ",
        "mins": "phút",
        "minTimeBeforeReservation": "Không cho phép tài xế bắt đầu chuyến trước giờ đón",
        "IN_ADVANCE": "ĐẶT TRƯỚC",
        "Assign_reservation_to_driver": "Gán chuyến cho tài xế",
        "Dispatcher_confirms_job_for_driver": "Người điều phối xác nhận chuyến cho tài xế",
        "Dispatcher_confirms_job_for_offline_driver": "Người điều phối xác nhận đặt trước cho tài xế ngoại tuyến\n",
        "Broadcast_orders": "Phân phối chuyến cho tất cả công ty",
        "Broadcast_orders_tooltip_1": "Bật cài đặt này nếu bạn muốn phân phối chuyến đến tất cả nhà cung cấp của công ty. Lưu ý: bạn cần kích hoạt chế độ phân phối trong hồ sơ của từng công ty.",
        "Minimum_book_ahead": "Thời gian đặt trước tối thiểu",
        "Maximum_book_ahead": "Thời gian đặt trước tối đa - đơn lẻ",
        "Maximum_period_recurring_oders_fleet": "Thời gian tối đa cho đơn hàng định kỳ (quản lý đội xe)",
        "Maximum_period_recurring_oders_corp": "Thời gian tối đa cho đơn hàng định kỳ (khách doanh nghiệp)",
        "Day": "Ngày",
        "Week": "Tuần",
        "Month": "Tháng",
        "hrs": "giờ",
        "Driver_cancellation_duration": "Thời gian tài xế hủy chuyến",
        "Mins": "phút",
        "Maximum_Day": "Số chuyến tối đa tài xế có thể nhận trong ngày.",
        "Maximum_Accept_Reservation": "Tổng số chuyến tài xế có thể nhận cùng lúc.",
        "jobRTDriver": "Thời gian phát hành công việc cho tài xế (trước khi đón)",
        "jobRTDriverDes": "Đặt thời gian khi công việc trở nên hiển thị cho tài xế được chỉ định trong ứng dụng của họ trước thời gian đón. - ví dụ: 24 giờ trước khi đón.",
        "Local_notification_before": "Thông báo nội bộ trước",
        "Dispatch_mode": "Chế độ điều phối",
        "Manual": "Thủ công",
        "Immediate_auto_dispatch": "Tự động điều phối ngay",
        "Delayed_auto_dispatch": "Tự động điều phối chậm",
        "Auto_dispatch_before_pickup_time": "Tự động điều phối trước giờ đón",
        "Auto_Reassign_Before_Pickup_Time": "Tự động phân công lại trước thời gian lấy hàng",
        "Auto_Reassign_Before_Pickup_Time_Tooltip": "Tự động phân công lại công việc nếu tài xế được giao chưa bắt đầu chuyến đi X phút trước thời gian đón. Lưu ý: Điều này chỉ áp dụng cho tài xế của nhà cung cấp nội bộ.",
        "Required_fields": "Mục bắt buộc",
        "Shuttle": "XE ĐƯA ĐÓN",
        "Shuttle_Dispatch_mode": "Chế độ điều phối",
        "Dispatch_setting_Shuttle_Dispatch_mode_tooltip": "- Manual mode: Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. After clicking on “Update booking” at the booking detail, reservation will be dispatched to your assigned drivers or to all drivers in case of no driver assigning. It will be integrated into driver device calendar and reminder will be available. <br>- Delayed mode:Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. Reservation will be automatically dispatched before “time value at “Process in advance”” from pick up time to the assigned driver or the nearest available one in case of no driver assigning. <br>- Immediate auto-dispatch mode: Reservation will be automatically dispatched to all drivers once reservation is created. It will be integrated into driver device calendar and reminder will be available.",
        "Save": "Lưu",
        "Process_in_advance": "Xử lý trước",
        "Save_dispatch_success": "Điều phối đã được cập nhật thành công",
        "Save_dispatch_fail": "Lỗi khi cập nhật điều phối",
        "Dispatch_setting_general_tooltip": "Áp dụng với đặt xe đi ngay, đặt trước với điều phối tự động có độ trễ",
        "Dispatch_setting_Assign_reservation_to_driver_tooltip": "Đơn đặt trước được tự động chỉ định và chấp nhận cho tài xế khi bật tùy chọn này",
        "Dispatch_setting_Driver_cancellation_duration_tooltip": "Thời gian tính từ lúc đón khách đến khi tài xế hủy chuyến.",
        "Dispatch_setting_Dispatch_mode_tooltip": "- Manual mode: Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. After clicking on “Update booking” at the booking detail, reservation will be dispatched to your assigned drivers or to all drivers in case of no driver assigning. It will be integrated into driver device calendar and reminder will be available. <br>- Delayed mode:Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. Reservation will be automatically dispatched before “time value at “Process in advance”” from pick up time to the assigned driver or the nearest available one in case of no driver assigning. <br>- Immediate auto-dispatch mode: Reservation will be automatically dispatched to all drivers once reservation is created. It will be integrated into driver device calendar and reminder will be available.",
        "Notification_nearby_drivers_before_pickup_time": "Thông báo tài xế gần đó trước giờ đón.",
        "Dispatch_setting_Maximum_Day_tooltip": "Giới hạn số lượng đặt trước mà tài xế có thể nhận trong một ngày. Áp dụng cho Marketplace và các chuyến liên tỉnh.",
        "Maximum_Accept_Reservation_tooltip": "Số chuyến tài xế có thể nhận không được vượt quá số này. Áp dụng cho Marketplace và các chuyến liên tỉnh.",
        "Notification_nearby_drivers_before_pickup_time_tooltip": "Nếu chuyến xe của khách hàng chưa được bất kỳ tài xế nào nhận trong thời gian quy định, hệ thống sẽ thông báo cho các tài xế gần đó kiểm tra Marketplace và nhận chuyến.",
        "marketPlace": "THỊ TRƯỜNG",
        "howFarDriverSeeBookingMarketplace": "Thời gian tối đa mà tài xế có thể thấy các chuyến trên Marketplace",
        "shortNoticeOrder": "Thông báo chuyến xe gấp",
        "shortNoticeOrderTooltip": "Thiết lập khoảng thời gian các chuyến xe gấp và hiển thị ngay cho tất cả các tài xế."
    },
    "voiceSMSSetting": {
        "ACCOUNT_SETTINGS": "Cài đặt tài khoản",
        "Account_SID": "Tài khoản SID",
        "Auth_Token": "Mã xác thực",
        "Application_ID": "Mã app",
        "SMS_number_1": "SĐT SMS 1",
        "SMS_number_2": "SĐT SMS 2",
        "SMS_SETTINGS": "Cài đặt SMS",
        "MASKED_PHONE_SETTINGS": "Cài đặt ẩn số điện thoại",
        "SMS_MARKETING_SETTINGS": "Cài đặt SMS Marketing",
        "Phone_number": "Số điện thoại",
        "Save": "Lưu",
        "voiceSMS": "TWILIO",
        "DRIVER_APP": "App Tài xế",
        "PASSENGER_APP": "App Hành khách",
        "allowDriverToCallCC": "Cho phép Tài xế gọi bộ phận Hỗ trợ qua:",
        "allowDriverToCallHelpdesk": "Cho phép Tài xế gọi bộ phận Hỗ trợ qua:",
        "allowDriverToCallPassenger": "Cho phép Tài xế gọi KH qua:",
        "allowPassengerToCallCC": "Cho phép KH gọi bộ phận Hỗ trợ qua:",
        "allowPassengerToCallHelpdesk": "Cho phép KH gọi bộ phận Hỗ trợ qua:",
        "allowPassengerToCallDriver": "Cho phép KH gọi Tài xế qua:",
        "voip": "VOIP",
        "mobile": "Di động",
        "bookingSMS": "Cuộc gọi Di động",
        "bookingSMSTemplate": {
            "name": "Mẫu tin nhắn",
            "content": "Nội dung",
            "action": "Thao tác",
            "DELETE": "Xóa mẫu tin nhắn",
            "DELETE_CONFIRM": "Bạn muốn xóa mẫu tin nhắn đã chọn?",
            "EDIT": "Chỉnh sửa mẫu tin nhắn",
            "ADD": "Thêm mẫu tin nhắn",
            "DETAIL": "Chi tiết mẫu tin nhắn",
            "Update_success": "Mẫu tin nhắn đã được cập nhật thành công",
            "Create_success": "Mẫu tin nhắn đã được tạo thành công",
            "Delete_success": "Mẫu tin nhắn đã được xóa thành công",
            "Delete_fail": "Lỗi xảy ra khi xóa mẫu tin nhắn",
            "Load_fail": "Lỗi xảy ra khi tải mẫu tin nhắn",
            "Update_fail": "Lỗi xảy ra khi cập nhật mẫu tin nhắn",
            "Create_fail": "Lỗi xảy ra khi tải mẫu tin nhắn"
        },
        "bookingSMSModal": {
            "title": "Thêm mẫu SMS",
            "save": "Lưu",
            "cancel": "Hủy",
            "titleMessage": "Gửi tin nhắn",
            "template": "Mẫu",
            "phoneNumber": "Số điện thoại",
            "content": "Nội dung",
            "messageType": "Loại tin nhắn",
            "inbox": "Hộp thư nhắn",
            "sms": "SMS",
            "sendTo": "Gửi đến ",
            "passenger": "Khách hàng",
            "driver": "Tài xế"
        }
    },
    "regularSetting": {
        "extraWaitTimeTooltip": "Fee to compensate the driver when he has to wait additional time for the customer till they are onboard.",
        "fareWaitTimeLater": "Giá cước mỗi phút (Đặt trước)",
        "fareWaitTimeNow": "Giá cước mỗi phút (Đi ngay)",
        "transport": "Di chuyển",
        "delivery": "Giao hàng",
        "Fer_Stop": "Phí mỗi điểm dừng",
        "First_Stop": "Phí cho điểm dừng đầu tiên",
        "Each_Stop": "Phí thêm điểm đến",
        "Name": "Tên",
        "Pay_to_driver_Cash": "Thanh toán cho nhà cung cấp/tài xế (thanh toán tiền mặt)",
        "Last_Update": "Lần cuối cập nhật",
        "Status": "Trạng thái",
        "Required_fields": "Mục bắt buộc",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Cancel": "Hủy",
        "Save": "Lưu",
        "Actions": "Thao tác",
        "Edit": "Chỉnh sửa",
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "DELETE_CONFIRM": "Bạn có muốn xóa không?",
        "ADD_REGULAR_RATE": "Thêm giá theo km",
        "EDIT_REGULAR_RATE": "Chỉnh sửa giá theo km",
        "DETAIL_REGULAR_RATE": "Chi tiết giá theo km",
        "DELETE_REGULAR_RATE": "Xóa giá theo km",
        "Delete_confirm_regular_rate": "Bạn muốn xóa mục này?",
        "STARTING": "Bắt đầu",
        "Starting_Now": "Bắt đầu (Ngay bây giờ)",
        "Starting_Reservation": "Bắt đầu (Đặt trước)",
        "FIRST_DISTANCE_FEE": "Phí km đầu",
        "First_distance_fee": "km đầu",
        "From": "Từ",
        "To": "Đến",
        "Fee_for_first_distance": "Phí km đầu",
        "SECOND_DISTANCE_FEE": "Phí km thứ hai",
        "Second_distance_fee": "km thứ hai",
        "AFTER_SECOND_DISTANCE": "Sau km thứ hai",
        "Fee_after_second_distance": "Phí sau km thứ hai",
        "PER_MINUTE": "Theo phút",
        "Fee_per_minute": "Giá cước mỗi phút",
        "mi": "dặm",
        "hour": "giờ",
        "MINIMUM": "Giá tối thiểu",
        "Minimum_Now": "Giá tối thiểu (đi ngay)",
        "Minimum_Reservation": "Giá tối thiểu (đặt trước)",
        "PAX_MDISPATCHER_CANCELLATION": "Khách/đối tác hủy chuyến",
        "On_demand": "Khách/đối tác hủy chuyến - Đi ngay",
        "Penalty": "Số tiền phạt",
        "In_advance": "Khách/đối tác hủy chuyến - Đặt trước",
        "PAX_MDISPATCHER_NO_SHOW": "Khách/đối tác không đến",
        "Driver_cancel_demand": "Chính sách tài xế hủy chuyến - Đi ngay",
        "Driver_cancel_advance": "Chính sách tài xế hủy chuyến - Đặt trước",
        "Assign_car_type": "Chỉ định loại xe",
        "Select_car_type": "Chọn loại xe",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "Deactivate": "Ngừng hoạt động",
        "DELETE_FLATE_RATE": "Xóa giá cước cố định",
        "Delete_confirm_flat_rate": "Bạn muốn xóa mục này?",
        "EDIT_FLAT_RATE": "Chỉnh sửa giá cố định",
        "ADD_FLAT_RATE": "Thêm giá cố định",
        "DELETE_FLAT_RATE": "Xóa giá cố định",
        "DELETE_HOURLY_RATE": "Xóa giá theo giờ/ngày",
        "Delete_confirm_hour_rate": "Bạn muốn xóa mục này?",
        "EDIT_HOURLY_RATE": "Chỉnh sửa giá theo giờ/ngày",
        "ADD_HOURLY_RATE": "Thêm giá theo giờ/ngày",
        "DELETE_FLAT_ROUTE": "Xóa giá lộ trình cố định",
        "DELETE_ROUTE_CONFIRM": "Bạn muốn xóa tuyến đường?",
        "EDIT_ROUTE": "Chỉnh sửa lộ trình",
        "ADD_ROUTE": "Thêm lộ trình",
        "Route_name": "Tên lộ trình",
        "Route_type": "Loại lộ trình",
        "Zone_to_zone": "Từ khu vực này đến khu vực khác",
        "Zipcode_to_zipcode": "Từ mã vùng này đến mã vùng khác",
        "First_location": "Điểm xuất phát",
        "Second_location": "Điểm đến",
        "First_location_zip_note": "Lưu ý: Bạn có thể nhập nhiều mã bưu điện cùng lúc bằng cách dùng dấu ',', hoặc dùng '->' cho các mã liên tiếp thay vì nhập từng cái một (ví dụ: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "Second_location_zip_note": "Lưu ý: Bạn có thể nhập nhiều mã bưu điện cùng lúc bằng cách dùng dấu ',', hoặc dùng '->' cho các mã liên tiếp thay vì nhập từng cái một (ví dụ: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "SINGLE_TRIP_SETUP": "Thiết lập chuyến đi một chiều",
        "Route_1": "Tuyến 1 (Điểm xuất phát -> Điểm đến)",
        "Route_2": "Tuyến 2 (Điểm đến -> Điểm xuất phát)",
        "Limitation": "Giới hạn",
        "Unlimited": "Không giới hạn",
        "Limited": "Có giới hạn",
        "Time_coverage": "Thời gian áp dụng",
        "Extra_time": "Thời gian thêm",
        "ROUND_TRIP_SETUP": "Thiết lập cuốc xe khứ hồi",
        "Round_trip": "Khứ hồi",
        "ROUTES": "Tuyến đường",
        "Route_1_Fare": "Giá cước tuyến 1",
        "Route_2_Fare": "Giá cước tuyến 2",
        "Round_Trip_Fare": "Giá cước khứ hồi",
        "Select_a_zone": "Chọn khu vực",
        "minute": "phút",
        "VIEW_REGULAR_RATE": "Xem chi tiết giá theo km",
        "VIEW_FLAT_RATE": "Xem giá cước cố định",
        "VIEW_HOURLY_RATE": "Xem giá cước theo giờ",
        "HOURLY_PACKAGE_RATE": "Giá gói theo giờ",
        "Package_name": "Tên gói dịch vụ",
        "Package_duration": "Thời lượng gói dịch vụ",
        "PackageId": "Mã gói dịch vụ",
        "Base_rate": "Giá cơ bản",
        "Distance_coverage": "Khoảng cách áp dụng",
        "Extra_duration": "Thời gian thêm",
        "Extra_distance": "Khoảng cách thêm",
        "DELETE_HOURLY_PACKAGE": "Xóa gói theo giờ",
        "DELETE_PACKAGE_CONFIRM": "Bạn muốn xóa gói cước này?",
        "EDIT_PACKAGE": "Chỉnh sửa gói dịch vụ",
        "VIEW_PACKAGE": "Xem chi tiết gói dịch vụ",
        "ADD_PACKAGE": "Thêm gói dịch vụ",
        "Fee_per_extra_duration": "Phí cho thời gian thêm",
        "Fee_per_extra_distance": "Phí cho khoảng cách thêm",
        "hours": "giờ",
        "days": "ngày",
        "Update_flat_rate_success": "Giá cố định đã được cập nhật thành công.",
        "Update_flat_rate_fail": "Lỗi xảy ra khi cập nhật giá cố định.",
        "Created_flat_rate_success": "Giá cố định đã được tạo thành công.",
        "Created_flat_rate_fail": "Lỗi xảy ra khi tạo giá cố định",
        "Update_flat_rate_route_success": "Giá cố định đã được cập nhật thành công.",
        "Update_flat_rate_route_fail": "Lỗi xảy ra khi cập nhật giá tuyến đường cố định",
        "Created_flat_rate_route_success": "Tuyến đường giá cố định đã được tạo thành công",
        "Created_flat_rate_route_fail": "Lỗi xảy ra khi tạo giá tuyến đường cố định",
        "Loading_flat_rate_fail": "Lỗi xảy ra khi tải thông tin giá tuyến đường cố định",
        "Delete_flat_rate_route_fail": "Lỗi xảy ra khi xóa thông tin giá tuyến đường cố định",
        "Delete_flat_rate_success": "Giá cước cố định đã được xóa thành công",
        "Delete_flat_rate_fail": "Lỗi xảy ra khi xóa giá cước cố định",
        "Update_intercity_rate_success": "Giá cước liên tỉnh đã được cập nhật thành công.",
        "Update_intercity_rate_fail": "Xảy ra lỗi khi cập nhật giá cước liên tỉnh",
        "Created_intercity_rate_success": "Giá liên tỉnh đã được tạo thành công",
        "Created_intercity_rate_fail": "Xảy ra lỗi khi tạo giá cước liên tỉnh",
        "Update_intercity_rate_route_success": "Tuyến đường giá cước liên tỉnh đã được cập nhật thành công",
        "Update_intercity_rate_route_fail": "Đã xảy ra lỗi khi cập nhật giá liên tỉnh",
        "Created_intercity_rate_route_success": "Giá liên tỉnh đã được tạo thành công",
        "Created_intercity_rate_route_fail": "Xảy ra lỗi khi tạo tuyến đường",
        "Loading_intercity_rate_fail": "Xảy ra lỗi khi tải chi tiết giá xe tuyến",
        "Delete_intercity_rate_route_fail": "Xảy ra lỗi khi xóa tuyến đường",
        "Delete_intercity_rate_success": "Giá xe tuyến được xóa thành công",
        "Delete_intercity_rate_fail": "Xảy ra lỗi khi xóa giá xe tuyến",
        "Update_regular_rate_success": "Giá theo km đã được cập nhật thành công",
        "Update_regular_rate_fail": "Đã xảy ra lỗi khi cập nhật giá theo km",
        "Create_regular_rate_success": "Giá theo km đã được tạo thành công",
        "Create_regular_rate_fail": "Đã xảy ra lỗi khi tạo giá theo km",
        "Update_hourly_rate_success": "Giá theo giờ đã được cập nhật thành công",
        "Update_hourly_rate_fail": "Đã xảy ra lỗi khi cập nhật giá theo giờ",
        "Create_hourly_rate_success": "Giá theo giờ đã được tạo thành công",
        "Create_hourly_rate_fail": "Đã xảy ra lỗi khi tạo giá theo giờ",
        "Update_hourly_rate_package_success": "Gói giá theo giờ đã được cập nhật thành công",
        "Update_hourly_rate_package_fail": "Đã xảy ra lỗi khi cập nhật gói giá theo giờ",
        "Create_hourly_rate_package_success": "Gói giá theo giờ đã được tạo thành công",
        "Create_hourly_rate_package_fail": "Đã xảy ra lỗi khi tạo gói giá theo giờ",
        "Load_hourly_rate_fail": "Đã xảy ra lỗi khi tải chi tiết giá theo giờ",
        "Update_hourly_status": "Đã xảy ra lỗi khi cập nhật trạng thái giá theo giờ",
        "Delete_hourly_fail": "Đã xảy ra lỗi khi xóa giá theo giờ",
        "Delete_hourly_success": "Giá theo giờ đã được xóa thành công",
        "Loading_regular_rate_fail": "Đã xảy ra lỗi khi tải giá theo km",
        "Update_regular_status_fail": "Đã xảy ra lỗi khi cập nhật trạng thái giá theo km",
        "Delete_regular_rate_success": "Giá theo km đã được xóa thành công",
        "Delete_regular_rate_fail": "Đã xảy ra lỗi khi xóa giá theo km",
        "Please_go_to_Car_Type_settings": "Để áp dụng mức giá này cho bất kỳ loại xe nào, vui lòng vào Cài đặt > Xe > Loại xe.",
        "Car_type_filter": "Bộ lọc loại xe",
        "Delete_package_error": "Đã xảy ra lỗi khi xóa gói!",
        "Pax_mDispatcher_cancellation_tooltip": "Chính sách hủy áp dụng cho hành khách",
        "Penalty_tooltip": "Số tiền khách hàng sẽ bị tính phí. Ngoài khoản phạt, bạn có thể thêm thuế hoặc phí công nghệ.",
        "Pax_mDispatcher_no_show_tooltip": "Chính sách không xuất hiện áp dụng cho hành khách. Phí này sẽ được tính nếu tài xế chọn \"Không xuất hiện\" khi không thấy hành khách tại điểm đón.",
        "detail_route": "Chi tiết tuyến",
        "detail_package": "Chi tiết gói",
        "THIRD_DISTANCE_FEE": "Phí khoảng cách thứ ba",
        "AFTER_DISTANCE_FEE": "Sau phí khoảng cách thứ ba",
        "Loading_delivery_rate_fail": "Đã xảy ra lỗi khi tải chi tiết giá giao hàng",
        "Update_delivery_rate_fail": "Đã xảy ra lỗi khi cập nhật giá giao hàng",
        "Update_delivery_rate_success": "Giá giao hàng đã được cập nhật thành công",
        "Created_delivery_rate_success": "Giá giao hàng đã được tạo thành công",
        "Created_delivery_rate_fail": "Đã xảy ra lỗi khi tạo giá giao hàng",
        "Starting_fee": "Giá mở cửa",
        "First_distance": "km đầu",
        "Second_distance": "km thứ hai",
        "Third_distance": "km thứ bai",
        "Fee_for_second_distance": "Phí từ km thứ hai",
        "Fee_for_third_distance": "Phí từ km thứ ba",
        "Fee_after_third_distance": "Phí sau km thứ ba",
        "Assign_rate_to_car_type": "Gán mức giá cho loại xe",
        "car_type": "Loại xe",
        "PRICE_ADJUSTABLE": "Giá có thể điều chỉnh",
        "Amount_Step": "Giá có thể điều chỉnh",
        "Tax": "Thuế",
        "TechFee": "Phí công nghệ",
        "Pay_to_driver": "Thanh toán cho nhà cung cấp/tài xế",
        "Pay_to_driver_tooltip": "Tùy chọn bồi thường cho tài xế:\n- Số tiền cố định: Số tiền cố định mà tài xế sẽ nhận được.\n- Hoa hồng: Hoa hồng của tài xế được áp dụng cho số tiền phạt.",
        "Fix_amount": "Số tiền",
        "Commission": "Hoa hồng",
        "fareFlat": "Giá cố định",
        "flatRoute": "Tuyến cố định",
        "Mode": "Chế độ",
        "speedThresholdKM": "Ngưỡng tốc độ (km/h)",
        "speedThresholdMI": "Ngưỡng tốc độ (mi/h)",
        "timeAndMileage": "Thời gian và quãng đường",
        "timeOrMileage": "Thời gian hoặc quãng đường",
        "perDistanceKM": "Theo km",
        "perDistanceMI": "Theo dặm",
        "perTime": "Theo phút",
        "regularRates": "Giá theo km",
        "newRate": "Giá mới",
        "enterName": "Nhập tên giá",
        "actualMode": "Giá thực tế",
        "estimatedMode": "Giá báo trước",
        "feePerStop": "Phí mỗi điểm dừng bổ sung",
        "extraWaitTime": "Phí chờ",
        "startingFee": "Mở cửa",
        "minimumFee": "Tối thiểu",
        "minAppend": "/phút",
        "kmAppend": "/ km",
        "miAppend": "/dặm",
        "kmhrAppend": "km/giờ",
        "mihrAppend": "dặm/giờ",
        "feePerKm": "Theo km",
        "feePerMi": "Theo dặm",
        "feeSpeedThreshold": "Ngưỡng tốc độ",
        "serviceType": "Loại dịch vụ",
        "fareMode": "Công thức",
        "calculationMode": "Chế độ tính toán",
        "timeChangeMode": "Chế độ tính phí theo thời gian",
        "minimum_Percent_Adjust": "% tối thiểu từ giá ước tính",
        "maximum_Percent_Adjust": "% tối đa từ giá ước tính",
        "AllowAdjustPrice": "Cho phép khách hàng điều chỉnh giá",
        "Calculation": "Tính toán",
        "distanceTier": "Cấp độ khoảng cách",
        "perKm": "Phí theo km",
        "perMi": "Phí theo dặm",
        "flatFee": "Phí cố định",
        "defaultRate": "Mức giá mặc định",
        "timeRange": "Khoảng thời gian",
        "bookingType": "Loại hình",
        "rateDetail": "Chi tiết mức giá",
        "subRate": "Giá phụ",
        "specialRates": "Giá đặc biệt",
        "surcharge": "Phụ phí",
        "penalty": "Phí phạt",
        "basedOriginMode": "Dựa trên thời gian đón ban đầu",
        "basedDriverMode": "Dựa trên thời gian đón của tài xế",
        "hourlyRate": "Mức giá theo giờ",
        "flat_Fare": "Giá cố định",
        "flatFeeOption": "Phí cố định",
        "fareModeTooltip": "Thời gian hoặc quãng đường chỉ áp dụng cho giá khách hàng, không áp dụng cho giá thanh toán của nhà cung cấp/tài xế.",
        "cloneRate": "Tỷ lệ sao chép",
        "rateName": "Tên Tỷ Lệ",
        "Infinity": "Vô cực",
        "Fee": "Phí",
        "headerTile": "Nhập tiêu đề tiêu đề",
        "enterFooter": "Nhập tiêu đề chân trang",
        "invoiceNo": "Số hóa đơn",
        "paidOn": "Đã thanh toán",
        "amountPaid": "Số tiền đã thanh toán",
        "isFeePerSeatActive": "Phí mỗi hành khách",
        "minSeat": "Số lượng hành khách tối thiểu",
        "minSeatTooltip": "Đây là số ghế tối thiểu để tính phí cho một đặt chỗ.",
        "dropOffZoneIds": "Khu vực trả khách",
        "applyGeniusDiscount": "Booking.com: Áp dụng Giảm giá Genius (5%)"
    },
    "flatRateSettings": {
        "flatZoneNote": "Khu vực bạn tạo ở đây chỉ được sử dụng để thiết lập giá cố định."
    },
    "deliverySetting": {
        "Name": "Tên",
        "Last_Update": "Cập nhật lần cuối",
        "Status": "Trạng thái",
        "Actions": "Thao tác"
    },
    "sharingSetting": {
        "EDIT_RATE": "Chỉnh sửa giá ghép chuyến",
        "ADD_RATE": "Thêm giá ghép chuyến",
        "VIEW_RATE": "Xem giá ghép chuyến",
        "Name": "Tên",
        "startingFee": "Giá mở cửa",
        "minimumFee": "Giá tối thiểu",
        "Update_streetSharing_rate_fail": "Đã xảy ra lỗi khi cập nhật giá ghép chuyến",
        "Update_streetSharing_rate_success": "Giá ghép chuyến đã cập nhật thành công",
        "Created_streetSharing_rate_success": "Giá ghép chuyến đã tạo thành công",
        "Created_streetSharing_rate_fail": "Đã xảy ra lỗi khi tạo giá ghép chuyến",
        "Loading_streetSharing_rate_fail": "Đã xảy ra lỗi khi tải chi tiết giá ghép chuyển",
        "Delete_streetSharing_rate_success": "Giá ghép chuyến đã được xóa thành công",
        "Delete_streetSharing_rate_fail": "Đã xảy ra lỗi khi xóa giá ghép chuyến",
        "Delete_streetSharing_rate": "Xóa giá ghép chuyến",
        "Assign_Car": "Chỉ định loại xe"
    },
    "carTypeSetting": {
        "ID": "ID loại xe",
        "newService": "Dịch vụ mới",
        "editService": "Chỉnh sửa dịch vụ",
        "serviceInfo": "Thông tin dịch vụ",
        "name": "Tên",
        "namePH": "Tên loại xe",
        "enterNumber": "Nhập một số",
        "appDisplayName": "Tên hiển thị trên app",
        "shortDescription": "Mô tả ngắn",
        "maxPassengers": "Hành khách tối đa",
        "maxLuggage": "Hành lý tối đa",
        "vehiclePhoto": "Ảnh xe",
        "iconShowList": "Icon hiển thị trong danh sách",
        "imageShowWeb": "Ảnh hiển thị trên web",
        "carPinOnMap": "Icon xe trên bản đồ",
        "recommendedSize": "Kích thước khuyến nghị:",
        "serviceSetting": "Cài đặt dịch vụ",
        "serviceType": "Loại dịch vụ",
        "reservation": "Đặt trước",
        "onDemand": "Đi ngay",
        "destinationSetting": "Cài đặt điểm đến",
        "requireDestination": "Yêu cầu điểm đến",
        "extraDestination": "Điểm đến bổ sung",
        "calculatorFareMode": "Chế độ tính giá cước",
        "hideDestinationOnDemand": "Theo yêu cầu",
        "meteredFare": "Giá cước theo đồng hồ",
        "quotedFare": "Giá cước báo trước",
        "availableZones": "Khu vực có sẵn",
        "dispatchAssociation": "Liên kết điều phối",
        "Save": "Lưu",
        "Edit": "Chỉnh sửa",
        "Cancel": "Hủy",
        "validateName": "Vui lòng nhập tên",
        "validateAppDisplayName": "Vui lòng nhập tên hiển thị trên app",
        "validateSelectImage": "Vui lòng chọn hình ảnh",
        "updateSuccess": "Cập nhật thành công",
        "createSuccess": "Tạo thành công",
        "failApi": "Đã xảy ra lỗi!",
        "validateRequire": "Vui lòng xác định số lượng hành khách và kiểm tra lại hành lý."
    },
    "carSetting": {
        "Details": "Chi tiết",
        "vehicleInfo": "Thông tin xe",
        "Documents": "Tài liệu",
        "vehicle": "Xe",
        "addVehicle": "Thêm phương tiện",
        "detailVehicle": "Chi tiết xe",
        "additionalVehicleTitle": "Thông tin bổ sung",
        "Phone_Number_Tooltip": "Nhập số điện thoại xe để khách hàng liên lạc. Nếu không được cung cấp, cuộc gọi sẽ chuyển đến số cá nhân của tài xế. Dành cho các nhà cung cấp trang bị điện thoại liên lạc riêng trên phương tiện.",
        "discardChange": "Hủy bỏ thay đổi",
        "model_name_is_required": "Tên mẫu xe bắt buộc",
        "DELETE_CAR": "Xóa xe",
        "DELETE_CONFIRM": "Bạn muốn xóa xe đã chọn?",
        "Yes": "Đồng ý",
        "Cancel": "Hủy",
        "EDIT_CAR": "Chỉnh sửa xe",
        "CREATE_CAR": "Tạo xe",
        "Plate_Number": "Biển số xe",
        "Car_Type": "Loại xe",
        "Select_car_type": "Chọn loại xe",
        "Make": "Hãng xe",
        "Select_car_make": "Chọn hãng xe",
        "Model": "Dòng xe",
        "Select_a_car_model": "Chọn mẫu xe",
        "Year": "Năm",
        "Select_year": "Chọn năm",
        "Hardware_Meter": "Đồng hồ phần cứng",
        "VIN": "Số nhận dạng phương tiện (VIN)",
        "Company": "Công ty",
        "Select_company": "Chọn công ty",
        "Max_Passengers": "Hành khách tối đa",
        "Max_Luggage": "Hành lý tối đa",
        "Color": "Màu sắc",
        "License_expiry": "Ngày hết hạn giấy phép",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Add": "Thêm",
        "Car_Model": "Mẫu xe",
        "Created_Date": "Ngày Tạo",
        "Status": "Trạng thái",
        "Actions": "Thao tác",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Active": "Đang hoạt động",
        "activeVehicle": "Xe đang hoạt động",
        "Inactive": "Không hoạt động",
        "Edit": "Chỉnh sửa",
        "Deactivate": "Vô hiệu hóa",
        "Activate": "Kích hoạt",
        "Delete": "Xóa",
        "Name": "Tên",
        "MODEL_LIST": "Danh sách mẫu xe",
        "Model_Name": "Tên mẫu xe",
        "Add_Model": "Thêm mẫu xe",
        "DELETE_CAR_MODEL": "Xóa mẫu xe",
        "DELETE_CONFIRM_MODEL": "Bạn có muốn xóa mẫu xe không?",
        "DELETE_CAR_MAKE": "Xóa dòng xe",
        "DELETE_CONFIRM_CAR_MAKE": "Bạn có muốn xóa dòng xe này không?",
        "EDIT_CAR_MAKE": "Chỉnh sửa dòng xe",
        "CREATE_CAR_MAKE": "Thêm dòng xe",
        "Assign_Rate": "Gán mức giá",
        "ASSIGN_RATE": "Gán mức giá",
        "Car_type_ID": "Mã loại xe",
        "App_Display_Name": "Tên hiển thị trên app",
        "Affiliate_car_type": "Loại xe liên kết",
        "Regular_rate": "Giá theo km",
        "Zone": "Khu vực",
        "Rate": "Giá cước",
        "Zone_Rate": "Khu vực - Giá",
        "Flat_Fare": "Giá cố định",
        "Flat_Delivery": "Giá giao hàng cố định",
        "Select_flat_rate": "Chọn giá cố định",
        "Hourly_daily_rate": "Theo giờ/ngày",
        "Dispatch_To": "Điều phối đến",
        "Normal_Fare": "Theo km",
        "Upload_an_image": "Tải lên hình ảnh",
        "DETAIL_CAR": "Chi tiết xe",
        "DELETE_MULTI_CAR": "Xóa các xe đã chọn",
        "DELETE_MULTI_CAR_CONFIRM": "Bạn muốn xóa các xe này? Chỉ có thể xóa những xe ở trạng thái không hoạt động.",
        "DETAIL_CAR_MAKE": "Dòng xe",
        "Car_Make": "Dòng xe",
        "Create_car_success": "Xe mới đã được tạo thành công",
        "Update_car_success": "Xe này đã được cập nhật thành công.",
        "Update_car_fail": "Đã xảy ra lỗi khi cập nhật xe",
        "Create_car_fail": "Đã xảy ra lỗi khi tạo xe",
        "Load_car_fail": "Đã xảy ra lỗi khi tải xe",
        "Delete_car_fail": "Đã xảy ra lỗi khi xóa xe",
        "Delete_car_success": "Xe đã được xóa thành công",
        "Change_cars_status_success": "Đã thay đổi trạng thái tất cả xe thành công.",
        "Change_cars_status_fail": "Lỗi xảy ra khi thay đổi trạng thái xe",
        "Delete_cars_success": "Tất cả xe đã chọn đã được xóa thành công",
        "Delete_cars_fail": "Lỗi xảy ra khi xóa xe",
        "Update_car_type_success": "Loại xe đã được cập nhật thành công",
        "Update_car_type_fail": "Lỗi xảy ra khi cập nhật loại xe",
        "Load_car_type_details_fail": "Không thể tải thông tin chi tiết loại xe",
        "Update_car_make_fail": "Lỗi xảy ra khi cập nhật hãng xe",
        "Update_car_make_success": "Hãng xe đã được cập nhật thành công",
        "Create_car_make_fail": "Lỗi xảy ra khi tạo hãng xe",
        "Create_car_make_success": "Hãng xe mới đã được tạo thành công",
        "Update_car_model_fail": "Lỗi xảy ra khi cập nhật mẫu xe",
        "Update_car_model_success": "Mẫu xe đã được cập nhật thành công",
        "Create_car_model_fail": "Lỗi xảy ra khi tạo mẫu xe mới",
        "Create_car_model_success": "Mẫu xe mới đã được tạo thành công",
        "Loading_car_model_fail": "Lỗi xảy ra khi tải thông tin mẫu xe",
        "Delete_car_make_success": "Hãng xe đã được xóa thành công",
        "Delete_cat_make_fail": "Lỗi xảy ra khi xóa hãng xe",
        "Delete_regular_rate_success": "Xóa giá theo km thành công",
        "Delete_regular_rate_fail": "Lỗi xảy ra khi xóa giá theo km",
        "Update_status_error": "Lỗi xảy ra khi cập nhật trạng thái",
        "Case_number": "Số vụ án",
        "Phone_Number": "Số điện thoại",
        "ERROR_INPUT_VALIDPHONE": "Vui lòng nhập số điện thoại hợp lệ",
        "Car_type_filter": "Bộ lọc loại xe",
        "No": "Từ chối",
        "Intercity_Rate": "Giá cước liên tỉnh",
        "Select_intercity_rate": "Chọn giá cước liên tỉnh",
        "Delivery_Rate": "Giá cước giao hàng",
        "Select_delivery_rate": "Chọn giá cước giao hàng",
        "vehicleOwner": "Tên chủ xe",
        "EDIT_CAR_COLOR": "Chỉnh sửa màu xe",
        "DETAIL_CAR_COLOR": "Chi tiết màu xe",
        "CREATE_CAR_COLOR": "Thêm màu xe",
        "Car_Color": "Màu xe",
        "Update_car_color_fail": "Lỗi xảy ra khi cập nhật màu xe",
        "Update_car_color_success": "Màu xe đã được cập nhật thành công",
        "Create_car_color_fail": "Lỗi xảy ra khi tạo màu xe",
        "Create_car_color_success": "Màu xe mới đã được tạo thành công.",
        "Delete_car_color_success": "Màu xe đã được xóa thành công",
        "Delete_car_color_fail": "Lỗi xảy ra khi xóa màu xe",
        "DELETE_CAR_COLOR": "Xóa màu xe",
        "DELETE_CONFIRM_CAR_COLOR": "Bạn có chắc muốn xóa màu xe này không?",
        "sharing_Rate": "Giá ghép chuyến",
        "bookingAffiliate": "Loại xe liên kết với Booking.com",
        "streetSharing": "Ghép chuyến",
        "colorCode": "Mã màu",
        "selectColorCode": "Chọn mã màu"
    },
    "operationSetting": {
        "Driver": "Tài xế",
        "Search_driver_name": "Tìm tên tài xế",
        "Company": "Công ty",
        "License_plate": "Biển số",
        "Select_license_plate": "Chọn Biển số",
        "Shift": "Ca làm việc",
        "Zone": "Khu vực",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "No": "STT",
        "Car_Type": "Loại xe",
        "Plate_Number": "Biển số xe",
        "Unassign": "Hủy gán",
        "Please_choose_driver": "Vui lòng chọn tài xế",
        "Please_choose_company": "Vui lòng chọn công ty",
        "Please_license_plate": "Vui lòng chọn biển số",
        "Please_choose_shift": "Vui lòng chọn ca làm việc",
        "Please_choose_zone": "Vui lòng chọn khu vực",
        "CONFIRM_UNASSIGN": "Bạn muốn hủy gán tài xế này?",
        "Assign_success": "Đã hủy gán tài xế thành công\n",
        "Unassign_success": "Tài xế đã được hủy gán thành công"
    },
    "paymentMethod": {
        "cash": "Tiền mặt",
        "easyPaisa": "Easy Paisa",
        "jazzCash": "Jazz Cash",
        "cashBySender": "Tiền mặt từ người gửi",
        "cashByRecipient": "Tiền mặt từ người nhận",
        "personalCard": "Thẻ cá nhân",
        "corporateCard": "Thẻ doanh nghiệp",
        "qrCodePayment": "Thanh toán bằng mã QR",
        "directBilling": "Thanh toán trả sau",
        "externalCard": "Thẻ ngoài",
        "mDispatcherCard": "Thẻ đối tác",
        "corporatePrepaid": "Doanh nghiệp trả trước",
        "fleetCard": "Thẻ ngoài",
        "applePay": "Apple Pay",
        "creditExternalCard": "Thẻ tín dụng",
        "googlePay": "Google Pay",
        "wallet": "Ví điện tử",
        "BankOfGeorgia": "Ngân hàng Georgia",
        "tnGeWalletlet": "Ví điện tử TnG",
        "paymentMethod_1": "Tiền mặt",
        "paymentMethod_2": "Thẻ cá nhân",
        "paymentMethod_3": "Thẻ đối tác",
        "paymentMethod_4": "Thẻ doanh nghiệp",
        "paymentMethod_5": "Thanh toán trả sau",
        "paymentMethod_6": "Thẻ ngoài",
        "paymentMethod_7": "Doanh nghiệp trả trước",
        "paymentMethod_8": "Thanh toán bằng mã QR",
        "paymentMethod_9": "Apple Pay",
        "paymentMethod_11": "Airpay",
        "paymentMethod_12": "Thẻ tín dụng",
        "paymentMethod_13": "Ví điện tử",
        "paymentMethod_14": "Ví điện tử TnG",
        "paymentMethod_16": "Tiền mặt từ người gửi",
        "paymentMethod_17": "Tiền mặt từ người nhận",
        "paymentMethod_19": "Ví điện tử Boost",
        "paymentMethod_20": "Vipps",
        "paymentMethod_21": "ZainCash",
        "paymentMethod_23": "Google Pay",
        "paymentMethod_25": "Easy Paisa",
        "paymentMethod_27": "Samsung Pay",
        "paymentMethod_28": "Kakao Pay",
        "paymentMethod_29": "Naver Pay",
        "paymentMethod_30": "WeChat Pay",
        "paymentMethod_31": "Alipay",
        "paymentMethod_32": "PayNow",
        "paymentMethod_33": "GrabPay",
        "paymentMethod_34": "Thanh toán qua Cash App",
        "vippseWallet": "Vipps",
        "paymentMethod_credit": "Thẻ cá nhân",
        "paymentMethod_razerPay": "RazerPay",
        "paymentMethod_gCash": "GCash",
        "paymentMethod_zainCash": "ZainCash",
        "paymentMethod_xenDit": "Xendit",
        "paymentMethod_alipayExternal": "Alipay",
        "paymentMethod_FIB": "FIB",
        "paymentMethod_SantimPay": "SantimPay",
        "paymentMethod_ksher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_fawry": "Fawry",
        "paymentMethod_BankOfGeorgia": "Ngân hàng Georgia",
        "paymentLink": "Link thanh toán",
        "paymentMethod_xendit": "Xendit",
        "paymentMethod_easyPaisa": "Easy Paisa",
        "paymentMethod_jazzCash": "Jazz Cash",
        "paymentMethod_flooz": "Flooz",
        "paymentMethod_tmoney": "Tmoney",
        "paymentMethod_samsung_pay": "Samsung Pay",
        "paymentMethod_kakao_pay": "Kakao Pay",
        "paymentMethod_naver_pay": "Naver Pay",
        "paymentMethod_wechat_pay": "WeChat Pay",
        "paymentMethod_alipay": "Alipay",
        "paymentMethod_paynow": "PayNow",
        "paymentMethod_grabpay": "GrabPay",
        "paymentMethod_cashapp": "Thanh toán qua Cash App"
    },
    "changePassword": {
        "Change_password": "Đổi mật khẩu",
        "Current_password": "Mật khẩu hiện tại",
        "New_password": "Mật khẩu mới",
        "Confirm_password": "Xác nhận mật khẩu",
        "ERROR_INPUT_PASSWORD": "Vui lòng nhập mật khẩu",
        "ERROR_INPUT_VALID_PASSWORD": "Mật khẩu phải có ít nhất 8 ký tự, một chữ số và một ký tự đặc biệt",
        "ERROR_INPUT_MATCH_PASSWORD": "Mật khẩu không khớp. Vui lòng thử lại",
        "Save": "Lưu",
        "Cancel": "Hủy"
    },
    "userProfile": {
        "My_account": "Tài khoản của tôi",
        "Username": "Tên đăng nhập",
        "First_name": "Tên",
        "Last_name": "Tên",
        "Phone_number": "Số điện thoại",
        "Email_address": "Địa chỉ email",
        "Address": "Địa chỉ",
        "Save": "Lưu",
        "Edit_profile": "Chỉnh sửa hồ sơ",
        "Change_password": "Thay đổi mật khẩu",
        "ERROR_INPUT_USERNAME": "Vui lòng nhập tên đăng nhập.",
        "ERROR_INPUT_FIRSTNAME": "Vui lòng nhập tên Họ",
        "ERROR_INPUT_VALID_EMAIL": "Vui lòng nhập email hợp lệ",
        "Required_fields": "Mục bắt buộc"
    },
    "General": {
        "widgetChat": "Support / Chat",
        "searchQueuingDriver": "Tìm kiếm: Tên tài xế, Số điện thoại",
        "search": "Tìm kiếm",
        "User": "Người dùng",
        "My_Account": "Tài khoản của tôi",
        "Product_Discovery": "Khám Phá Sản Phẩm",
        "Sign_out": "Đăng xuất",
        "My_site": "Trang của tôi",
        "Command_center": "Trung tâm điều hành",
        "Notifications": "Thông báo",
        "Show_all": "Hiển thị tất cả",
        "SOS_Notifications": "Thông báo khẩn cấp",
        "You_dont_have_any_message": "Bạn không có tin nhắn nào",
        "Mon": "Thứ Hai",
        "Tue": "Thứ Ba",
        "Wed": "Thứ Tư",
        "Thu": "Thứ Năm",
        "Fri": "Thứ Sáu",
        "Sat": "Thứ Bảy",
        "Sun": "Chủ Nhật",
        "Now": "Đi ngay",
        "NowComplete": "Đi ngay (Thời gian đón thực tế)",
        "hrs": "giờ",
        "patmentMethod_1": "Tiền mặt",
        "patmentMethod_2": "Thẻ cá nhân",
        "patmentMethod_3": "Thẻ đối tác",
        "patmentMethod_4": "Thẻ doanh nghiệp",
        "patmentMethod_5": "Thanh toán trả sau",
        "patmentMethod_6": "Thẻ ngoài",
        "patmentMethod_7": "Doanh nghiệp trả trước",
        "patmentMethod_8": "Mã QR",
        "patmentMethod_9": "Apple Pay",
        "patmentMethod_10": "Apple Pay",
        "patmentMethod_12": "Thẻ tín dụng",
        "patmentMethod_13": "Ví",
        "patmentMethod_14": "Ví điện tử TnG",
        "patmentMethod_16": "Tiền mặt từ người gửi",
        "patmentMethod_17": "Tiền mặt từ người nhận",
        "patmentMethod_19": "Tăng cường",
        "patmentMethod_20": "Vipps",
        "patmentMethod_23": "Google Pay",
        "patmentMethod_24": "Link thanh toán",
        "patmentMethod_25": "Easy Paisa",
        "patmentMethod_26": "Jazz Cash",
        "patmentMethod_27": "Samsung Pay",
        "patmentMethod_28": "Kakao Pay",
        "patmentMethod_29": "Naver Pay",
        "patmentMethod_30": "WeChat Pay",
        "patmentMethod_31": "Alipay",
        "patmentMethod_32": "PayNow",
        "patmentMethod_33": "GrabPay",
        "patmentMethod_34": "Thanh toán Cash App",
        "patmentMethod_ZainCash": "ZainCash",
        "patmentMethod_Xendit": "Xendit",
        "patmentMethod_FIB": "FIB",
        "patmentMethod_SantimPay": "SantimPay",
        "patmentMethod_GCash": "GCash",
        "patmentMethod_cash": "Tiền mặt",
        "patmentMethod_credit": "Thẻ cá nhân",
        "patmentMethod_mDispatcher": "Partner card",
        "patmentMethod_corpCredit": "Thẻ doanh nghiệp",
        "patmentMethod_directBilling": "Thanh toán trả sau",
        "patmentMethod_fleetCard": "Thẻ ngoài",
        "patmentMethod_prepaid": "Doanh nghiệp trả trước",
        "patmentMethod_QRCode": "Mã QR",
        "patmentMethod_applePay": "Apple Pay",
        "patmentMethod_easyPaisa": "Easy Paisa",
        "patmentMethod_jazzCash": "Jazz Cash",
        "patmentMethod_prePaid": "Trả trước Doanh nghiệp",
        "patmentMethod_GooglePay": "Google Pay",
        "patmentMethod_creditCardExternal": "Thẻ tín dụng",
        "patmentMethod_exXendit": "QRIS",
        "patmentMethod_PaxWallet": "Ví",
        "patmentMethod_TnGeWallet": "Ví điện tử TnG",
        "patmentMethod_boosteWallet": "Tăng cường",
        "patmentMethod_Vipps": "Vipps",
        "patmentMethod_exZainCash": "ZainCash",
        "patmentMethod_exGCash": "GCash",
        "patmentMethod_exPayTM": "PayTM",
        "patmentMethod_exFlooz": "Flooz",
        "patmentMethod_exTmoney": "Tmoney",
        "patmentMethod_exTelebirr": "GCash",
        "paymentMethod_exzainCash": "ZainCash",
        "paymentMethod_exXendit": "Xendit",
        "paymentMethod_exalipay": "Alipay",
        "paymentMethod_exFIB": "FIB",
        "paymentMethod_exSantimPay": "SantimPay",
        "patmentMethod_exKsher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_exfawry": "Fawry",
        "patmentMethod_exBankOfGeorgia": "Ngân hàng Georgia",
        "patmentMethod_exPayDunya": "PayDunya",
        "patmentMethod_21": "ZainCash",
        "patmentMethod_paymentLink": "Link thanh toán",
        "patmentMethod_card": "Thẻ cá nhân",
        "patmentMethod_corporateCard": "Thẻ doanh nghiệp",
        "patmentMethod_paxWallet": "Ví điện tử",
        "patmentMethod_externalWallet": "Ví ngoài",
        "patmentMethod_googlePay": "Google Pay",
        "patmentMethod_manual": "Hướng dẫn",
        "patmentMethod_samsung_pay": "Samsung Pay",
        "patmentMethod_kakao_pay": "Kakao Pay",
        "patmentMethod_naver_pay": "Naver Pay",
        "patmentMethod_wechat_pay": "WeChat Pay",
        "patmentMethod_alipay": "Alipay",
        "patmentMethod_paynow": "PayNow",
        "patmentMethod_grabpay": "GrabPay",
        "patmentMethod_cashapp": "Thanh toán Cash App",
        "patmentMethod_online": "Thanh toán bằng thẻ/Trực tuyến",
        "patmentMethod_check": "Kiểm tra",
        "patmentMethod_wire": "Dây",
        "patmentMethod_digitalWallet": "Ví điện tử",
        "patmentMethod_bankTransfer": "Chuyển khoản ngân hàng",
        "patmentMethod_offlineMethod": "Thanh toán ngoại tuyến",
        "patmentAirlineMethod_5": "Thanh toán trả sau",
        "patmentAirlineMethod_4": "Thẻ hãng hàng không",
        "patmentAirlineMethod_7": "Thẻ trả trước hãng hàng không",
        "Name": "Tên",
        "Delete": "Xóa",
        "App_SOS_dialog_form_message_1": "{0} Khẩn cấp SOS!",
        "App_SOS_dialog_form_message_2": "Tôi cần trợ giúp tại",
        "App_SOS_dialog_form_message_3": "Đặt xe: {0}, Tài xế: {1}, Hành khách: {2}, Biển số: {3} ({4})",
        "mins": "phút",
        "Credit_Card": "Thẻ tín dụng",
        "ALL": "Tất cả",
        "NotFound": "Không tìm thấy trang yêu cầu",
        "ServerError": "Xảy ra lỗi.",
        "AccessDenied": "Bạn không có quyền truy cập vào mô-đun này!",
        "Retry": "Thử lại",
        "Can_not_get_data": "Không lấy được dữ liệu"
    },
    "shiftSettings": {
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "Name": "Tên",
        "Time_Range": "Khoảng thời gian",
        "Actions": "Thao tác",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Edit": "Chỉnh sửa",
        "Delete": "Xóa",
        "EDIT_SHIFT_SETTING": "Chỉnh sửa cài đặt ca làm việc",
        "ADD_SHIFT_SETTING": "Thêm cài đặt ca làm việc",
        "DETAIL_SHIFT_SETTING": "Chi tiết cài đặt ca làm việc",
        "DELETE_SHIFT_SETTING": "Xóa cài đặt ca làm việc",
        "Delete_confirm_shift_setting": "Bạn có muốn xóa mục này không?",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "From": "Từ",
        "To": "Đến",
        "Edit_shift_template": "Chỉnh sửa cài đặt ca làm việc",
        "Add_shift_template": "Thêm cài đặt ca làm việc",
        "Detail_shift_template": "Chi tiết cài đặt ca làm việc",
        "Delete_shift_template": "Xóa cài đặt ca làm việc",
        "Delete_confirm_shift_template": "Bạn muốn xóa mục này?",
        "Working_time": "Thời gian làm việc",
        "Create_shift_settings_success": "Cài đặt ca làm việc mới thành công",
        "Create_shift_settings_fail": "Lỗi khi tạo cài đặt ca làm việc",
        "Update_shift_settings_success": "Cài đặt ca làm việc đã được cập nhật thành công",
        "Update_shift_settings_fail": "Lỗi khi cập nhật cài đặt ca làm việc",
        "Delete_shift_settings_success": "Cài đặt ca làm việc đã được xóa thành công",
        "Delete_shift_settings_fail": "Lỗi khi xóa cài đặt ca làm việc",
        "Create_shift_template_success": "Tạo mẫu ca làm việc mới thành công",
        "Create_shift_template_fail": "Lỗi khi tạo mẫu ca làm việc",
        "Update_shift_template_success": "Mẫu ca làm việc đã được cập nhật thành công",
        "Update_shift_template_fail": "Lỗi xảy ra khi cập nhật mẫu ca làm việc",
        "Delete_shift_template_success": "Mẫu ca làm việc đã được xóa thành công",
        "Delete_shift_template_fail": "Lỗi khi xóa mẫu ca làm việc",
        "Yes": "Đồng ý",
        "No": "Từ chối"
    },
    "promotionSettings": {
        "Detail_campaign": "Chi tiết chiến dịch",
        "Edit_campaign": "Chỉnh sửa chiến dịch",
        "Add_campaign": "Thêm chiến dịch",
        "Delete_campaign": "Xóa chiến dịch",
        "Delete_confirm_campaign": "Bạn muốn xóa chiến dịch đã chọn?",
        "Add": "Thêm",
        "Corporate_list": "Danh sách doanh nghiệp",
        "permittedCorporate": "Danh sách doanh nghiệp được phép",
        "CorporateCustomers": "Khách hàng doanh nghiệp",
        "auto_add_corporate": "Tự động thêm vào danh sách ưu đãi của người dùng doanh nghiệp",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "Name": "Tên",
        "Actions": "Thao tác",
        "Private": "Riêng tư",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Edit": "Chỉnh sửa",
        "Delete": "Xóa",
        "Send_to_inbox": "Gửi vào hộp thư",
        "Save": "Lưu",
        "Duplicate": "Nhân bản",
        "Cancel": "Hủy",
        "Required_fields": "Mục bắt buộc",
        "Promotion_code": "Mã khuyến mãi",
        "Promotion_type": "Loại ưu đãi",
        "Campaign": "Chiến dịch",
        "Type": "Loại",
        "Value": "Giá trị",
        "keepMinFee": "Tổng giá cước sau ưu đãi phải lớn hơn giá tối thiểu",
        "Zone": "Khu vực",
        "paymentMethodsApply": "Phương thức thanh toán",
        "schedules": "Lịch trình",
        "minimumEstFareApply": "Tổng giá cước ước tính tối thiểu để áp dụng mã",
        "quantityLimitPerYear": "Số lượt sử dụng tối đa/người/năm",
        "termAndCondition": "Điều khoản & điều kiện",
        "Valid_from": "Có hiệu lực từ",
        "Valid_to": "Có hiệu lực đến",
        "Total_uses_user": "Tổng số lần sử dụng/người dùng",
        "Released_quantity": "Số lượng đã phát hành",
        "Number_of_sending_inbox": "Số lần gửi vào hộp thư",
        "Status": "Trạng thái",
        "Activate": "Kích hoạt",
        "Deactivate": "Vô hiệu hóa",
        "Add_promotion_code": "Thêm mã ưu đãi",
        "Edit_promotion_code": "Chỉnh sửa mã ưu đãi",
        "Detail_promotion_code": "Chi tiết mã ưu đãi",
        "Delete_promotion_code": "Xóa mã ưu đãi",
        "Delete_confirm_promotion_code": "Bạn muốn xóa mã ưu đãi đã chọn?",
        "New_customer": "Khách hàng mới",
        "Budget_per_user": "Ngân sách/người dùng (cho toàn bộ thời gian ưu đãi)\n",
        "Budget_per_user_day": "Ngân sách/người dùng/ngày",
        "Budget_per_user_month": "Ngân sách/người dùng/tháng",
        "Budget_per_user_year": "Ngân sách/người dùng/năm",
        "Unlimited": "Không giới hạn",
        "Limited": "Giới hạn",
        "Total_uses_per_user": "Số lần sử dụng tối đa/người dùng (cho toàn bộ thời gian ưu đãi)",
        "Send_an_in_box_automatically_to_new_customers": "Tự động gửi tin nhắn đến hộp thư đến của khách hàng mới\n",
        "Notes": "Ghi Chú",
        "Public": "Công khai",
        "Create_campaign_success": "Chiến dịch mới đã được tạo thành công",
        "Create_campaign_fail": "Lỗi xảy ra khi tạo chiến dịch",
        "Update_campaign_success": "Chiến dịch đã được cập nhật thành công.",
        "Update_campaign_fail": "Lỗi xảy ra khi cập nhật chiến dịch",
        "Delete_campaign_success": "Chiến dịch đã được xóa thành công",
        "Delete_campaign_fail": "Lỗi xảy ra khi xóa chiến dịch",
        "Loading_campaign_fail": "Lỗi xảy ra khi tải chiến dịch",
        "Update_campaign_status_success": "Trạng thái chiến dịch đã được cập nhật thành công",
        "Update_campaign_status_fail": "Lỗi xảy ra khi cập nhật trạng thái chiến dịch",
        "Loading_promotion_code_fail": "Lỗi xảy ra khi tải mã ưu đãi",
        "Select_campaign": "Chọn chiến dịch",
        "Create_promotion_code_success": "Mã ưu đãi mới đã được tạo thành công",
        "Create_promotion_code_fail": "Lỗi xảy ra khi tạo mã ưu đãi",
        "Update_promotion_code_status_success": "Trạng thái mã ưu đãi đã được cập nhật thành công.",
        "Update_promotion_code_status_fail": "Lỗi xảy ra khi cập nhật trạng thái mã ưu đãi",
        "Delete_promotion_code_confirmation": "Bạn muốn xóa các mã ưu đãi này?",
        "Just_delete_inactive": "** Chỉ có thể xóa mã ưu đãi ở trạng thái không hoạt động.",
        "Send_inbox_confirmation": "Bạn muốn gửi mã ưu đãi này vào hộp thư đến của khách hàng?",
        "Send_inbox_success": "Mã ưu đãi đã được gửi thành công.",
        "Send_inbox_fail": "Gửi mã ưu đãi thất bại. Vui lòng thử lại!",
        "Confirmation": "Xác nhận",
        "Delete_promotion_codes_success": "Mã ưu đãi đã được xóa thành công",
        "Delete_promotion_codes_fail": "Lỗi xảy ra khi xóa mã ưu đãi",
        "Delete_multiple_promotion_codes_success": "Các mã ưu đãi đã được xóa thành công.",
        "Delete_multiple_promotion_codes_fail": "Lỗi xảy ra khi xóa các mã ưu đãi",
        "Delete_promotion_code_success": "Các mã ưu đãi đã được xóa thành công.",
        "Delete_promotion_code_fail": "Lỗi xảy ra khi xóa các mã ưu đãi",
        "Update_multiple_promotion_code_status_success": "Trạng thái mã ưu đãi đã được cập nhật thành công",
        "Update_multiple_promotion_code_status_fail": "Lỗi khi xóa trạng thái mã ưu đãi",
        "Search_here": "Tìm tại đây",
        "Please_input_campaign_name": "Vui lòng nhập tên chiến dịch",
        "Please_input_promotion_code": "Vui lòng nhập mã ưu đãi",
        "Please_input_promotion_code_at_least_4_characters": "Vui lòng nhập ít nhất 4 ký tự.",
        "Please_select_campaign": "Vui lòng chọn chiến dịch",
        "Please_input_value": "Vui lòng nhập giá trị",
        "Please_select_date": "Vui lòng chọn ngày",
        "Please_add_schedules": "Vui lòng thêm lịch trình",
        "Please_add_corporate": "Vui lòng thêm doanh nghiệp",
        "Please_choose_at_least_one_customer": "Vui lòng chọn ít nhất một khách hàng.",
        "This_campaign_name_has_been_existing_on_the_system_Please_input_another_one": "Tên chiến dịch này đã tồn tại trong hệ thống. Vui lòng nhập tên khác.",
        "This_promotion_code_has_been_existing_on_the_system_Please_input_another_one": "Mã ưu đãi này đã tồn tại trong hệ thống. Vui lòng nhập mã khác.",
        "Invalid_file": "Nội dung tệp không hợp lệ",
        "File_size_larger_than_5Mb": "Kích thước tệp lớn hơn 5Mb",
        "Import_promotions_success": "Tệp đã được nhập thành công",
        "Import_Promotions": "Nhập Tệp",
        "Number_successful_imports": "Mục đã nhập",
        "Number_skipped": "Bỏ qua mục",
        "File": "Tệp",
        "Phone_Numbers": "Số điện thoại",
        "Import_Promotion_code_success": "Mã ưu đãi <b>{0}</b> đã được nhập thành công",
        "Import_Promotion_code_fail": "Mã ưu đãi <b>{0}</b> nhập thất bại. Vui lòng thử lại",
        "Customer_type": "Loại khách hàng",
        "All": "Tất cả",
        "Referred_customers": "Khách hàng được giới thiệu",
        "Common_customers": "Khách hàng thông thường",
        "Operation_zone": "Khu vực hoạt động",
        "totalUsesLimitPerDay": "Số lượt sử dụng tối đa/người/ngày",
        "quantityLimitPerDay": "Số lượng tối đa/ngày",
        "quantityLimitPerMonth": "Số lượng tối đa/người dùng/tháng",
        "applyVerifiedCustomers": "Chỉ áp dụng cho khách hàng Malaysia đã được xác minh",
        "applyWhenBudgetLimit": "Người dùng có thể áp dụng mã cho đến khi hết ngân sách.",
        "applyVerifiedCustomersTooltip": "Ưu đãi này chỉ áp dụng cho công dân Malaysia đã xác minh và tải CMND/Thẻ căn cước lên hệ thống.",
        "valueLimitPerUse": "Giá trị tối đa/lượt sử dụng (Áp dụng cho app v48 trở lên)",
        "Promotion_Services": "Dịch vụ",
        "transport": "Di chuyển",
        "shuttle": "Xe đưa đón",
        "parcel": "Giao hàng",
        "food": "Đồ ăn",
        "mart": "Đi chợ",
        "intercity": "Liên tỉnh",
        "addSchedule": "Thêm lịch trình",
        "editSchedule": "Chỉnh sửa lịch trình",
        "date": "Ngày",
        "Time_range": "Khoảng thời gian",
        "startTime": "Thời gian bắt đầu",
        "endTime": "Thời gian kết thúc",
        "applyForOtherDays": "Áp dụng cho các ngày khác",
        "scheduleTimeOverlap": "Thời gian lịch trình không được trùng nhau",
        "schedule_startDate_greater_than_endDate": "Ngày bắt đầu lớn hơn ngày kết thúc",
        "scheduleTimeDuplicate": "Thời gian lịch trình không được trùng nhau",
        "promoIcon": "Icon ưu đãi",
        "bannerImage": "Hình ảnh banner",
        "Upload_an_image": "Tải ảnh lên",
        "Click_here_to_view": "Nhấp vào đây để xem."
    },
    "quest_event": {
        "name": "Tên",
        "userType": "Loại người dùng",
        "carType": "Loại xe",
        "operationZones": "Khu vực hoạt động",
        "type": "Loại sự kiện",
        "isLuckyDraw": "Vòng quay may mắn",
        "start_date": "Ngày bắt đầu",
        "end_date": "Ngày kết thúc",
        "numOfQualify": "Đủ điều kiện",
        "event_progress": "Tiến trình sự kiện",
        "isActive": "Trạng thái",
        "Actions": "Thao tác",
        "passenger": "Khách hàng",
        "driver": "Tài xế",
        "first_will_win": "Đầu tiên sẽ thắng",
        "largest_will_win": "Dẫn đầu sẽ thắng (bảng xếp hạng)",
        "not_start": "Chưa bắt đầu",
        "active": "Đang hoạt động",
        "closed": "Đã đóng",
        "event_details": "Chi tiết nhiệm vụ",
        "add_event": "Thêm nhiệm vụ",
        "limited": "Giới hạn",
        "unlimited": "Không giới hạn",
        "eventImage": "Hình ảnh sự kiện",
        "sharedImage": "Hình ảnh chia sẻ",
        "qualifiedImage": "Hình ảnh đủ điều kiện",
        "expiredImage": "Hình ảnh hết hạn",
        "luckyDrawImage": "Hình ảnh quay số may mắn",
        "Upload_an_image": "Tải lên hình ảnh",
        "Required_Image": "Định dạng hình ảnh (.jpg, .png, .gif)",
        "ok": "Được",
        "eventId": "ID sự kiện",
        "passengerMetric": {
            "booking_distance": "Khoảng cách chuyến",
            "booking_time": "Thời gian đặt chuyến",
            "booking_amount_spent": "Số tiền đã chi cho chuyến",
            "num_of_ondemand": "Số lượng chuyến đi ngay",
            "num_of_reservation": "Số lượng chuyến đặt trước",
            "num_of_intercity": "Số lượng chuyến liên tỉnh",
            "num_of_delivery": "Số lượng giao hàng",
            "num_of_referral": "Số lượng giới thiệu",
            "num_of_sharing": "Số lượng chia sẻ",
            "topup_wallet_amount": "Số tiền nạp vào ví",
            "num_of_complete_wallet": "Số lượng chuyến hoàn thành (ví)",
            "num_of_complete_booking_by_referee": "Số lượng chuyến hoàn thành (do người giới thiệu)",
            "number_of_complete_booking": "Số lượng chuyến hoàn thành",
            "number_of_food_mart": "Số lượng đơn hàng đồ ăn / đi chợ"
        },
        "driverMetric": {
            "booking_distance": "Khoảng cách công việc",
            "booking_time": "Thời gian công việc",
            "num_of_referral": "Số lượng giới thiệu",
            "num_of_complete": "Số lượng chuyến hoàn thành (khách hàng duy nhất)",
            "num_of_referral_driver": "Số lượng giới thiệu (tài xế)",
            "num_of_accept": "Số lượng chuyến đã nhận",
            "num_of_receive": "Số lượng chuyến được nhận",
            "num_of_cancel": "Số lượng chuyến bị hủy bởi tài xế",
            "sum_of_rating": "Tổng số sao đánh giá",
            "total_rating": "Tổng số lần đánh giá",
            "earnings_amount": "Số tiền thu nhập",
            "num_of_complete_wallet": "Số lượng chuyến hoàn thành (ví)",
            "num_of_complete_booking_by_referee": "Số lượng chuyến hoàn thành (do người giới thiệu)",
            "available_time": "Thời gian trực tuyến"
        },
        "Click_here_to_view": "Nhấp vào đây để xem.",
        "view": "Nhấp vào đây để xem.",
        "metricType": "Loại",
        "task": "Nhiệm vụ",
        "value": "Giá trị",
        "quantity": "Số lượng",
        "quests_list": "Nhiệm vụ",
        "rankImages": "Hình ảnh xếp hạng (điểm)",
        "qualifiedPrizeOrder": "Giải thưởng đủ điều kiện",
        "luckyDrawPrizeOrder": "Giải thưởng quay số may mắn",
        "reward": "Mục",
        "from": "Từ",
        "to": "Đến",
        "image": "Hình ảnh",
        "Add_Prize": "Thêm",
        "bannerText": "Nội dung banner",
        "buttonText": "Nội dung button",
        "bannerLink": "Link biểu ngữ",
        "shortLink": "Link rút gọn",
        "buttonLinkDesktop": "Nút liên kết (Máy tính để bàn)",
        "buttonLinkAndroid": "Nút liên kết (Android)",
        "buttonLinkiOS": "Nút liên kết (iOS)",
        "termsURL": "Link Điều khoản & Điều kiện",
        "metadataTitle": "Tiêu đề Metadata",
        "metadataDescription": "Mô tả Metadata",
        "isDarkMode": "Chế độ tối",
        "isActive_details": "Đang hoạt động",
        "Required_fields": "Mục bắt buộc",
        "change": "Thay đổi",
        "Please_input_name": "Vui lòng nhập tên",
        "Please_select_date": "Vui lòng chọn ngày",
        "endDate_invalid": "Ngày kết thúc không hợp lệ",
        "startDate_greater_than_endDate": "Ngày bắt đầu lớn hơn ngày kết thúc",
        "Please_input_termsURL": "Vui lòng nhập link Điều khoản & Điều kiện",
        "Please_input_metadataTitle": "Vui lòng nhập metadate",
        "Please_input_metadataDescription": "Vui lòng nhập mô tả metadate",
        "Please_input_bannerText": "Vui lòng nhập nội dung banner",
        "Please_input_buttonText": "Vui lòng nhập nội dung button",
        "Please_input_bannerLink": "Vui lòng nhập link banner",
        "Please_input_shortLink": "Vui lòng nhập link rút gọn",
        "Please_input_buttonLinkDesktop": "Vui lòng nhập link button (Desktop)",
        "Please_input_buttonLinkAndroid": "Vui lòng nhập link button (Android)",
        "Please_input_buttonLinkiOS": "Vui lòng nhập link button (iOS)",
        "the_range_1_to_5": "Vui lòng nhập giá trị trong khoảng từ 1 đến 5 cho %{name}!",
        "the_range_1_to_100": "Vui lòng nhập giá trị trong khoảng từ 1 đến 100 cho %{name}!",
        "task_is_empty": "Vui lòng nhập nhiệm vụ cho %{name}!",
        "task_limit_50_characters": "Độ dài tối đa của nhiệm vụ là 50 ký tự cho %{name}!",
        "please_input_points": "Vui lòng nhập điểm cho %{name}!",
        "please_input_value": "Vui lòng nhập giá trị cho %{name}!",
        "value_is_invalid": "%{name}, giá trị phải là một số",
        "please_upload_image": "Vui lòng tải lên hình ảnh cho mục %{name}!",
        "rank_invalid": "Xếp hạng %{name} không hợp lệ!",
        "rank_invalid_to": "Xếp hạng \"Đến\" phải là một số",
        "deepLink": "Deeplink",
        "point_per_task": "Điểm mỗi nhiệm vụ",
        "points": "Điểm",
        "points_per_some_think": "Điểm mỗi %{unit}",
        "criterias": "Tiêu chí (tùy chọn)",
        "criterias_list": "Tiêu chí",
        "criteriaType": "Loại",
        "criteriaValue": "Giá trị",
        "acceptance_rating": "Tỷ lệ nhận chuyến (lớn hơn hoặc bằng)",
        "cancellation_rating": "Tỷ lệ hủy chuyến (nhỏ hơn hoặc bằng)",
        "driver_rating": "Đánh giá tài xế (lớn hơn hoặc bằng)",
        "please_upload_image_rank": "Vui lòng tải lên hình ảnh cho xếp hạng %{name}!",
        "Update_event_success": "Nhiệm vụ đã được cập nhật thành công",
        "Update_event_fail": "Đã xảy ra lỗi khi cập nhật nhiệm vụ",
        "Create_event_success": "Nhiệm vụ mới đã được tạo thành công",
        "Create_event_fail": "Đã xảy ra lỗi khi tạo nhiệm vụ",
        "suspend_list": "Danh sách cấm"
    },
    "voucherSettings": {
        "Search_here": "Tìm tại đây",
        "Voucher_code": "Mã số #",
        "Campaign": "Chiến dịch",
        "Type": "Loại",
        "Value": "Giá trị",
        "Valid_from": "Có hiệu lực từ",
        "Valid_to": "Có hiệu lực đến",
        "isActive": "Trạng thái",
        "Activate": "Kích hoạt",
        "Deactivate": "Vô hiệu hóa",
        "Actions": "Thao tác",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "redeemed": "Đã đổi",
        "expired": "Đã hết hạn",
        "Add_Voucher_code": "Thêm mã",
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "Name": "Tên",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Edit": "Chỉnh sửa",
        "Delete": "Xóa",
        "Save": "Lưu",
        "Duplicate": "Trùng lặp",
        "Cancel": "Hủy",
        "Required_fields": "Mục bắt buộc",
        "Detail_voucher_code": "Chi tiết mã voucher",
        "Delete_voucher_code": "Xóa mã voucher",
        "Confirmation": "Xác nhận",
        "Delete_confirm_voucher_code": "Bạn muốn xóa mã voucher đã chọn?",
        "Delete_voucher_code_confirmation": "Bạn muốn xóa các mã voucher này?",
        "Just_delete_inactive": "** Chỉ có thể xóa những mã voucher ở trạng thái không hoạt động.",
        "Loading_voucher_code_fail": "Đã xảy ra lỗi khi tải mã voucher",
        "Select_campaign": "Chọn chiến dịch",
        "Create_voucher_code_success": "Mã voucher mới đã được tạo thành công",
        "Create_voucher_code_fail": "Đã xảy ra lỗi khi tạo mã voucher",
        "Update_voucher_code_status_success": "Trạng thái mã voucher đã được cập nhật thành công",
        "Update_voucher_code_status_fail": "Đã xảy ra lỗi khi cập nhật trạng thái mã voucher",
        "Delete_voucher_codes_success": "Mã phiếu thưởng đã được xóa thành công",
        "Delete_voucher_codes_fail": "Đã xảy ra lỗi khi xóa mã voucher",
        "Delete_multiple_voucher_codes_success": "Mã voucher đã được xóa thành công",
        "Delete_multiple_voucher_codes_fail": "Đã xảy ra lỗi khi xóa các mã voucher",
        "Delete_voucher_code_success": "Mã voucher đã được xóa thành công",
        "Delete_voucher_code_fail": "Đã xảy ra lỗi khi xóa mã voucher",
        "Update_multiple_voucher_code_status_success": "Trạng thái mã voucher đã được cập nhật thành công",
        "Update_multiple_voucher_code_status_fail": "Đã xảy ra lỗi khi xóa trạng thái mã voucher",
        "Please_input_voucher_code": "Vui lòng nhập mã voucher",
        "Please_input_voucher_code_at_least_4_characters": "Vui lòng nhập ít nhất 4 ký tự.",
        "Please_select_campaign": "Vui lòng chọn chiến dịch",
        "Please_input_value": "Vui lòng nhập giá trị",
        "Please_select_date": "Vui lòng chọn ngày",
        "Invalid_file": "Nội dung tệp không hợp lệ",
        "File_size_larger_than_5Mb": "Kích thước tệp lớn hơn 5Mb",
        "Import_vouchers_success": "Tệp đã được nhập thành công",
        "Import_vouchers": "Nhập tệp",
        "Number_successful_imports": "Các mục đã nhập",
        "Number_skipped": "Bỏ qua mục",
        "File": "Tệp",
        "Phone_Numbers": "Số điện thoại",
        "Import_voucher_code_success": "Mã voucher <b>{0}</b> đã được nhập thành công",
        "Import_voucher_code_fail": "Mã voucher <b>{0}</b> nhập không thành công. Vui lòng thử lại",
        "All": "Tất cả"
    },
    "pointConfig": {
        "point_config": "Thiết lập điểm",
        "Convert_spent_amount_to_points": "Chuyển đổi số tiền đã chi thành điểm",
        "Convert_topup_amount_to_points": "Chuyển đổi số tiền nạp thành điểm",
        "Redeem_points_to_voucher": "Đổi điểm lấy voucher",
        "others": "Khác",
        "Online_Payment": "Thanh toán trực tuyến",
        "transport": "Di chuyển",
        "parcel": "Giao hàng",
        "food": "Đồ ăn",
        "mart": "Đi chợ",
        "delivery": "Giao hàng",
        "intercity": "Liên tỉnh",
        "applyCash": "Áp dụng cho tiền mặt",
        "point": "Điểm",
        "vourcherName": "Tên",
        "pointsToRedeem": "Điểm để đổi thưởng",
        "vourcherValue": "Giá trị voucher",
        "validTime": "Thời gian hiệu lực",
        "month": "Tháng",
        "day": "Ngày",
        "termAndCondition": "Điều khoản & điều kiện",
        "Actions": "Thao tác",
        "add_voucher": "Thêm",
        "instructionURL": "Link hướng dẫn",
        "displayName": "Hiển thị tên trên siêu ứng dụng",
        "isActive": "Đang hoạt động",
        "EDIT_VOUCHER": "Cập nhật voucher",
        "DETAIL_VOUCHER": "Chi tiết voucher",
        "CREATE_VOUCHER": "Thêm voucher",
        "update_successfully": "Thiết lập điểm đã được cập nhật thành công",
        "Create_voucher_successfully": "Voucher mới đã được tạo thành công",
        "Create_voucher_fail": "Đã xảy ra lỗi khi tạo voucher",
        "Update_voucher_successfully": "Voucher đã được cập nhật thành công",
        "Update_voucher_fail": "Đã xảy ra lỗi khi cập nhật voucher",
        "Delete_voucher_successfully": "Voucher đã được xóa thành công",
        "Delete_voucher_fail": "Đã xảy ra lỗi khi xóa voucher",
        "Confirmation": "Xác nhận",
        "Delete_voucher_confirmation": "Bạn muốn xóa voucher này?",
        "Please_enter_value_least_one": "Tỷ lệ chuyển đổi là bắt buộc! Hãy thiết lập số tiền đã chi hoặc số tiền nạp để tiếp tục.",
        "Please_enter_value_is_number_spentAmount": "Vui lòng nhập số tiền hợp lệ tại dịch vụ \"Chuyển đổi số tiền đã chi\" \"{0}\".",
        "Please_enter_value_is_number_topUp": "Vui lòng nhập số tiền hợp lệ tại phương thức \"Chuyển đổi số tiền nạp\" \"{0}\"."
    },
    "resetPassword": {
        "New_Password": "Mật khẩu mới",
        "New_Comfirm_Password": "Xác nhận mật khẩu mới",
        "Save": "Lưu",
        "INFO_SUCCESS": "Link đặt lại mật khẩu đã được gửi đến email của bạn",
        "TOKEN_EXPIRED": "Mã đặt lại mật khẩu của bạn đã hết hạn",
        "Back_To_Login_Page": "Quay lại trang đăng nhập"
    },
    "permission": {
        "editBooking": "Chuyển chuyến",
        "companyOperator": "Điều hành viên công ty",
        "Third_Party_Integration_Booking": "Tích hợp bên thứ ba (Booking.com)",
        "Third_Party_Integration_HolidayTaxis": "Tích hợp bên thứ ba (HolidayTaxis)",
        "supplierPermission": "Quyền nhà cung cấp",
        "Hint_edit_booking": "Cho phép công ty/nhà cung cấp chỉnh sửa các đặt chỗ được chuyển giao bởi chủ đội xe.",
        "View": "Xem",
        "Actions": "Thao tác",
        "EditFare": "Chỉnh sửa giá",
        "EditDriverEarning": "Chỉnh sửa thu nhập tài xế",
        "EditTotal": "Chỉnh sửa tổng số",
        "ImportBookings": "Nhập dữ liệu chuyến xe",
        "ImportDeliveryBookings": "Nhập dữ liệu giao hàng",
        "ShowFare": "Hiển thị giá",
        "delete_permission": "Xóa quyền",
        "DELETE_CONFIRM": "Bạn chắc chắn muốn xóa quyền đã chọn!",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Cancel": "Hủy",
        "DRIVERS": "TÀI XẾ",
        "Driver_list": "Danh sách tài xế",
        "Enter_to_search": "Nhập để tìm kiếm",
        "Permitted_driver_list": "Danh sách tài xế được phép",
        "Save": "Lưu",
        "CAR": "Xe",
        "Car_list": "Danh sách xe",
        "Permitted_car_list": "Danh sách xe được phép",
        "Edit_permission": "Chỉnh sửa quyền",
        "Add_permission": "Thêm quyền",
        "Detail_permission": "Chi tiết quyền",
        "Name": "Tên",
        "Driver_Car": "Tài xế/Xe",
        "All": "Tất cả",
        "Company": "Công ty",
        "By_specific": "Theo từng đối tượng cụ thể",
        "Drivers": "Tài xế",
        "Cars": "Xe",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Delete": "Xóa",
        "Edit": "Chỉnh sửa",
        "Status": "Trạng thái",
        "Action": "Thao tác",
        "Inactive": "Không hoạt động",
        "Active": "Đang hoạt động",
        "Update_status_error": "Lỗi cập nhật trạng thái",
        "All_tooltip": "Tất cả tài xế sẽ được hiển thị ở phần Bản đồ, Hàng đợi, Tài xế, Hoạt động và Báo cáo. Tất cả xe sẽ được hiển thị trên Quản lý xe",
        "Company_tooltip": "Chỉ những tài xế công ty này hiển thị ở phần Bản đồ, Hàng đợi, Tài xế, Hoạt động và Báo cáo. Xe thuộc công ty này sẽ được hiển thị ở phần Quản lý xe",
        "By_specific_tooltip": "Chỉ những tài xế trong danh sách này hiển thị ở phần Tài xế, Hoạt động. Xe nằm trong danh sách này sẽ được hiển thị ở phần Quản lý xe",
        "Full_permissions": "Quyền đầy đủ",
        "Balance": "Thay đổi số dư",
        "ChangeBalance": "Thay đổi số dư tín dụng",
        "ChangeCashBalance": "Thay đổi số dư tiền mặt",
        "TotalBalance": "Tổng số dư",
        "WriteOffDebt": "Xóa nợ",
        "topupPaxWallet": "Thay đổi số dư",
        "SeFleetCommission": "Thiết lập hoa hồng đội xe (tất cả tài xế)",
        "EditFleetCommission": "Chỉnh sửa hoa hồng đội xe",
        "EditBalance": "Chỉnh sửa số dư",
        "ViewHeatMap": "Xem bản đồ nhiệt",
        "Delete_permission_success": "Quyền đã được xóa thành công",
        "Delete_permission_fail": "Đã xảy ra lỗi khi xóa quyền",
        "Create_permission_fail": "Đã xảy ra lỗi khi tạo quyền mới",
        "Create_permission_success": "Quyền mới đã được tạo thành công",
        "Update_permission_fail": "Đã xảy ra lỗi khi cập nhật quyền",
        "Update_permission_success": "Quyền đã được cập nhật thành công",
        "No_action_selected": "Vui lòng chọn ít nhất một thao tác trong danh sách",
        "Required_fields": "Mục bắt buộc",
        "sendSMS": "Gửi tin nhắn (SMS)",
        "sendInbox": "Gửi tin nhắn (Hộp thư đến)",
        "PayToDriver": "Xem 'Thanh toán cho tài xế'",
        "PayoutHistory": "Xem 'Lịch sử thanh toán'",
        "Pay": "Thanh toán cho tài xế",
        "ActivateDriver": "Kích hoạt tài xế",
        "Export": "Xuất dữ liệu",
        "Export_csv": "Xuất tệp .csv",
        "Street-sharing_rate": "Giá ghép chuyến"
    },
    "thirdPartySettings": {
        "category": "Danh mục",
        "Not_over_limit_subs": "Bạn không thể tạo hơn 10 vị trí phụ",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trong tổng số {2}",
        "Delete": "Xóa",
        "Edit": "Chỉnh sửa",
        "Status": "Trạng thái",
        "Actions": "Thao tác",
        "Action": "Thao tác",
        "Inactive": "Không hoạt động",
        "Active": "Đang hoạt động",
        "website": "Trang web",
        "Check_Google_Address": "Kiểm tra địa chỉ Google từ vĩ độ & kinh độ",
        "Delete_Category_success": "Danh mục đã được xóa thành công",
        "Delete_category_fail": "Đã xảy ra lỗi khi xóa danh mục",
        "availableTime": "Thời gian sử dụng",
        "Please_choose_at_least_one_category": "Vui lòng chọn ít nhất một danh mục",
        "Please_input_category_name": "Vui lòng nhập tên danh mục",
        "Create_category_success": "Danh mục đã được tạo thành công",
        "Create_category_fail": "Đã xảy ra lỗi khi tạo danh mục",
        "Update_third_party_success": "Vị trí đã được cập nhật thành công",
        "Update_category_fail": "Đã xảy ra lỗi khi cập nhật danh mục",
        "All_Category": "Tất cả danh mục",
        "Delete_Category": "Chỉnh sửa danh mục",
        "Edit_Category": "Chỉnh sửa danh mục",
        "Add_Category": "Thêm danh mục",
        "Add_Third_Party_location": "Thêm vị trí bên thứ ba",
        "Add": "Thêm",
        "Edit_Third_Party_location": "Chỉnh sửa vị trí bên thứ ba",
        "Location_Not_Found": "Không tìm thấy vị trí",
        "Create_third_party_success": "Vị trí đã được tạo thành công",
        "Create_third_party_fail": "Đã xảy ra lỗi khi tạo vị trí",
        "Update_third_party_fail": "Đã xảy ra lỗi khi cập nhật vị trí",
        "Alias": "Tên gọi khác",
        "Address": "Địa chỉ",
        "Latitude": "Vĩ độ",
        "Longitude": "Kinh độ",
        "Please_input_address": "Vui lòng nhập địa chỉ",
        "Please_input_name": "Vui lòng nhập tên địa điểm",
        "Please_input_latitude": "Vui lòng nhập vĩ độ",
        "Please_input_longitude": "Vui lòng nhập kinh độ",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "Required_fields": "Mục bắt buộc",
        "Last_update": "Cập nhật lần cuối",
        "Username": "Tên đăng nhập",
        "locationType": "Loại địa điểm",
        "single": "Một điểm",
        "multiple": "Nhiều điểm",
        "AddMore": "Thêm",
        "locationList": "Danh sách địa điểm",
        "instructionLink": "Link hướng dẫn",
        "location": "Địa điểm",
        "checkOnMap": "Kiểm tra trên bản đồ",
        "Remove": "Hủy",
        "all": "Tất cả",
        "PU": "Điểm đón",
        "DO": "Trả khách",
        "namePlaceholder": "ví dụ: nhà ga 1",
        "instructionLinkPlaceholder": "Trang HTML với hướng dẫn đầy đủ",
        "instructionLinkTooltip": "Vui lòng nhập link cho trang hướng dẫn. Hành khách có thể theo hướng dẫn trên link này để tìm địa điểm đón.",
        "longitudePlaceholder": 108.1837969,
        "latitudePlaceholder": 16.0393381,
        "Error_message_lat_in_range": "Vĩ độ phải nằm trong khoảng từ -90.0 đến 90.0",
        "Error_message_lng_in_range": "Kinh độ phải nằm trong khoảng từ -180.0 đến 180.0.",
        "Delete_third_party_success": "Địa điểm đã được xóa thành công",
        "Delete_third_party_fail": "Đã xảy ra lỗi khi xóa địa điểm",
        "Delete_location": "Xóa địa điểm",
        "Note_guide": "Lưu ý: khi tìm kiếm trên bản đồ, vị trí của bạn sẽ nhanh chóng được đánh dấu bằng ghim.",
        "PostalCode": "Mã bưu chính",
        "meetZonesTooltip": "Khu vực Họp: Định nghĩa khu vực bao gồm tất cả các điểm họp được chỉ định. Hữu ích cho các địa điểm như sân bay, nơi cần xác định rõ các điểm đón và trả khách cụ thể.",
        "instructions": "Hướng dẫn nhận hàng",
        "pickupMode": "Loại xe tải",
        "tripSegment": "Đoạn đường",
        "buildingLevel": "Cấp độ Tòa nhà",
        "instructionType": "Loại Hướng Dẫn",
        "instructionUrl": "URL hướng dẫn",
        "instructionImage": "Hình ảnh hướng dẫn",
        "imageInstructions": "Hướng dẫn hình ảnh Pickup",
        "addMultipleInstructions": "Thêm nhiều hướng dẫn lấy hàng.",
        "maximum3Images": "Tối đa 3 hình ảnh.",
        "image": "Hình ảnh",
        "uploadImage": "Tải lên một hình ảnh",
        "description": "Mô tả",
        "descriptionPlaceholder": "Tên của điểm gặp gỡ.",
        "altText": "Văn bản thay thế",
        "altTextPlaceholder": "Tên của điểm gặp gỡ.",
        "addImage": "Thêm Hình Ảnh",
        "imageCount": "Số lượng hình ảnh",
        "viewEditImages": "Xem/Sửa Ảnh",
        "addMeetingZone": "Thêm khu vực họp"
    },
    "city": {
        "DELETE_CITY": "Xóa thành phố",
        "DELETE_CONFIRM": "Bạn muốn xóa thành phố đã chọn?",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Cancel": "Hủy",
        "EDIT_CITY": "Chỉnh sửa thành phố",
        "ADD_CITY": "Thêm thành phố",
        "Name": "Tên",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Delete": "Xóa",
        "Edit": "Chỉnh sửa",
        "DETAIL_CITY": "Chi tiết thành phố",
        "Update_city_success": "Thành phố đã được cập nhật thành công",
        "Create_city_success": "Thành phố mới đã được tạo thành công",
        "Delete_city_success": "Thành phố đã được xóa thành công",
        "cityName": "Tên thành phố",
        "Service": "Dịch vụ",
        "serviceTransportation": "Di chuyển",
        "serviceAssistant": "Trợ lý",
        "serviceDelivery": "Giao hàng",
        "isShowDriverSignUp": "Hiển thị khi đăng ký nhà cung cấp",
        "note_isShowDriverSignUp": "Áp dụng cho module đăng ký mới từ phiên bản 4.6.46 trở lên"
    },
    "blockPassenger": {
        "Imei": "IMEI",
        "EditImei": "Chỉnh sửa Block IMEI",
        "AddImei": "Thêm khối IMEI",
        "DetailImei": "Chi tiết khối IMEI",
        "Update_Imei_success": "Khóa IMEI đã được cập nhật thành công",
        "Update_Imei_Fail": "Các lỗi xảy ra trong quá trình cập nhật Block IMEI",
        "Create_Imei_success": "Khối IMEI mới đã được tạo thành công",
        "Create_Imei_Fail": "Các lỗi xảy ra trong quá trình tạo Block IMEI",
        "Delete_Imei_success": "Khóa IMEI đã được xóa thành công",
        "Delete_Imei_fail": "Các lỗi xảy ra trong quá trình xóa Block IMEI",
        "DELETE_IMEI": "Xóa Khối IMEI",
        "DELETE_CONFIRM": "Bạn có chắc chắn muốn xóa Block IMEI đã chọn không?"
    },
    "jobTab": {
        "DELETE_JOBTAB": "Xóa tab công việc",
        "DELETE_CONFIRM": "Bạn muốn xóa tab công việc đã chọn?",
        "Yes": "Có",
        "No": "Không",
        "Cancel": "Hủy",
        "EDIT_JOBTAB": "Chỉnh sửa tab công việc",
        "ADD_JOBTAB": "Thêm tab công việc",
        "Name": "Tên",
        "Required_fields": "Các trường bắt buộc",
        "Save": "Lưu",
        "Add": "Mục mỗi trang",
        "Show_per_page": "Thêm",
        "Page": "Hiển thị {0} - {1} trên tổng số {2}",
        "show_pages": "Trang",
        "Delete": "Xóa",
        "Edit": "Chỉnh sửa",
        "DETAIL_JOBTAB": "Chi tiết tab công việc",
        "Update_JOBTAB_success": "Tab công việc đã được cập nhật thành công",
        "Create_JOBTAB_success": "Tab công việc mới đã được tạo thành công",
        "Delete_JOBTAB_success": "Tab công việc đã được xóa thành công",
        "JOBTABName": "Tên tab công việc",
        "jobsLink": "Liên kết"
    },
    "driverNote": {
        "name": "Ghi chú tài xế",
        "DELETE": "Xóa ghi chú tài xế",
        "DELETE_CONFIRM": "Bạn muốn xóa ghi chú tài xế đã chọn?",
        "EDIT": "Chỉnh sửa ghi chú tài xế",
        "ADD": "Thêm ghi chú tài xế",
        "DETAIL": "Chi tiết ghi chú tài xế",
        "Update_success": "Ghi chú tài xế đã được cập nhật thành công",
        "Create_success": "Ghi chú tài xế mới đã được tạo thành công",
        "Delete_success": "Ghi chú tài xế đã được xóa thành công",
        "Delete_fail": "Đã xảy ra lỗi khi xóa ghi chú tài xế",
        "Load_fail": "Đã xảy ra lỗi khi tải ghi chú tài xế",
        "Update_fail": "Đã xảy ra lỗi khi cập nhật ghi chú tài xế",
        "Create_fail": "Đã xảy ra lỗi khi tạo ghi chú tài xế"
    },
    "flightIntegration": {
        "Username": "Tên đăng nhập",
        "provider": "Cung cấp chuyến bay",
        "Key": "Khóa API",
        "apiKeys": "Khóa API",
        "apiId": "ID API",
        "Save": "Lưu",
        "Update_flight_integration_success": "Tích hợp chuyến bay đã được cập nhật thành công",
        "Update_flight_integration_fail": "Đã xảy ra lỗi khi cập nhật tích hợp chuyến bay"
    },
    "smsIntegration": {
        "provider": "Nhà cung cấp dịch vụ SMS",
        "apiToken": "Token API",
        "subAccountId": "Mã ID Tài Khoản Phụ",
        "senderIdSource": "Mã định danh người gửi (nguồn):",
        "apiKey": "Khóa API",
        "username": "Tên đăng nhập",
        "shortCode": "Mã ngắn",
        "key": "Chìa khóa",
        "webService": "Dịch vụ web",
        "bearerToken": "Token mang",
        "keyId": "ID khóa",
        "email": "Email",
        "appKey": "Khóa ứng dụng",
        "sender": "Người gửi",
        "password": "Mật khẩu",
        "maskedPhone": "Số điện thoại ẩn danh",
        "senderId": "Mã người gửi",
        "webservice": "Dịch vụ web",
        "brandname": "Tên thương hiệu",
        "appSecret": "bí mật ứng dụng",
        "consumerKey": "Khóa người tiêu dùng",
        "requestUrl": "Yêu cầu Url",
        "authId": "Mã xác thực",
        "authToken": "Token xác thực",
        "authKey": "Khóa xác thực",
        "templateId": "ID Mẫu",
        "templateKey": "Key Mẫu",
        "phloId": "ID PHLO",
        "dlcNumber": "Số 10DLC",
        "app_key": "Khóa ứng dụng",
        "api_key": "Khóa API",
        "accountSID": "Tài khoản SID",
        "applicationId": "Mã ứng dụng",
        "phoneNumber": "Số SMS 1",
        "phoneNumber2": "Số SMS 2",
        "SenderID_1": "SenderID 1",
        "SenderID_2": "SenderID 2",
        "smsMarketingNumber": "SMS marketing phone number",
        "updateSMSSuccess": "The sms integration has been updated successfully",
        "Deleted_success": "SMS đã được xóa thành công",
        "receiverCountries": "Quốc gia nhận",
        "error": {
            "ERROR_CREATE": "Đã xảy ra lỗi khi tạo SMS",
            "COUNTRY_EXISTED": "Quốc gia đã tồn tại trong hệ thống",
            "ERROR_DELETE": "Xóa SMS không thành công",
            "ERROR_UPDATE": "Cập nhật SMS không thành công"
        },
        "identifierId": "ID định danh"
    },
    "mDispatcher": {
        "mDispatchers": "Đối tác",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "Deactivate": "Vô hiệu hóa",
        "Activate": "Kích hoạt",
        "Delete": "Xóa",
        "Save": "Lưu",
        "Edit": "Chỉnh sửa",
        "ADD_MDISPATCHER": "Thêm đối tác",
        "EDIT_MDISPATCHER": "Chỉnh sửa đối tác",
        "Phone_number": "Số điện thoại",
        "first_name": "Họ",
        "last_name": "Tên",
        "email": "Email",
        "address": "Địa chỉ",
        "mDispatcher_type": "Loại đối tác",
        "mDispatcher_type_toolTip": "Để thêm loại đối tác, vui lòng vào Cài đặt > Loại đối tác",
        "queuing_area_toolTip": "Để thêm khu vực xếp hàng, vui lòng vào phần Hàng đợi.",
        "mDispatcher": "Đối tác",
        "card_management": "Quản lý thẻ tín dụng",
        "Select_mDispatcher_type": "Chọn loại đối tác",
        "Amount": "Số tiền",
        "Percent": "Percent",
        "Yes": "Đồng ý",
        "Required_fields": "Mục bắt buộc",
        "Cancel": "Hủy",
        "commission_type": "Loại hoa hồng",
        "commission_value": "Giá trị hoa hồng",
        "Name": "Tên",
        "Phone_Number": "Số điện thoại",
        "queuing_area": "Hàng đợi",
        "mdispatcher_type": "Loại đối tác",
        "registered_from": "Đăng ký từ",
        "registration_date": "Ngày đăng ký",
        "status": "Trạng thái",
        "actions": "Thao tác",
        "Select_queue_area": "Chọn khu vực xếp hàng",
        "for_new_mDipatcher_account_password_default_is_password": "Đối với tài khoản đối tác mới, mật khẩu mặc định là \"12345678",
        "Create_mDispatcher_success": "Đối tác mới đã được tạo thành công",
        "Create_mDispatcher_fail": "Đã xảy ra lỗi khi tạo đối tác",
        "Load_mDispatcher_fail": "Đã xảy ra lỗi khi tải đối tác",
        "Update_mDispatcher_success": "Đối tác đã được cập nhật thành công",
        "Update_mDispatcher_fail": "Đã xảy ra lỗi khi cập nhật đối tác",
        "Update_mDispatcher_status_success": "Trạng thái đối tác đã được cập nhật thành công",
        "Update_mDispatcher_status_fail": "Đã xảy ra lỗi khi cập nhật trạng thái đối tác",
        "Update_mDispatcher_statuses_success": "Trạng thái đối tác đã được cập nhật thành công",
        "Update_mDispatcher_statuses_fail": "Đã xảy ra lỗi khi cập nhật trạng thái đối tác",
        "Delete_mDispatcher_success": "Đối tác đã được xóa thành công",
        "Delete_mDispatcher_fail": "Đã xảy ra lỗi khi xóa đối tác",
        "Delete_mDispatchers_success": "Đối tác đã bị xóa thành công",
        "Delete_mDispatchers_fail": "Đã xảy ra lỗi khi xóa đối tác",
        "Do_you_want_to_delete_these_mDipatchers": "Bạn muốn xóa những đối tác này?",
        "Only_mDistcher_in_the_inactive_status_can_be_deleted": "** Chỉ có mDistcher ở trạng thái không hoạt động mới có thể bị xóa",
        "No_card": "Không tìm thấy thẻ",
        "Reset_Password": "Đặt lại mật khẩu",
        "Reset_password_success": "Mật khẩu đối tác đã được đặt lại thành công",
        "Reset_password_fail": "Đã xảy ra lỗi khi đặt lại mật khẩu đối tác",
        "Do_you_want_to_reset_password": "Bạn muốn đặt lại mật khẩu?",
        "ERROR_EXISTED_PHONE": "Số điện thoại này đã tồn tại trong hệ thống. Vui lòng nhập số khác",
        "ERROR_INPUT_VALIDPHONE": "Vui lòng nhập số điện thoại hợp lệ.",
        "Partner_detail": "Chi tiết đối tác",
        "ALERT_SELECT_ACTIVATE": "Vui lòng chọn đối tác để kích hoạt.",
        "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn đối tác để vô hiệu hóa.",
        "CONFIRM_DEACTIVATE_MULTI": "Bạn muốn vô hiệu hóa những đối tác này?",
        "CONFIRM_ACTIVATE_MULTI": "Bạn muốn kích hoạt những đối tác này?",
        "ERROR_COMMISSION_NUMBERS": "Vui lòng nhập số hợp lệ",
        "No_Support": "Thêm thẻ mới hiện không được hỗ trợ trong khu vực này",
        "Add": "Thêm",
        "Default_zone": "Vùng mặc định",
        "required_email_payment": "Email của đối tác là bắt buộc. Vui lòng cập nhật hồ sơ để tiếp tục.",
        "titleGuestQR": "Link QR-Guest",
        "questQRContent": "Link đặt xe của đối tác đã sẵn sàng! Đặt mã QR tại những nơi thuận tiện để khách hàng dễ dàng quét mã và đặt chuyến!",
        "View_Guest_QR": "Xem mã QR Guest"
    },
    "mDispatcherType": {
        "Name": "Tên",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "No": "Từ chối",
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Delete": "Xóa",
        "Edit": "Chỉnh sửa",
        "DELETE_MDISPATCHER_TYPE": "Xóa loại đối tác",
        "DELETE_CONFIRM": "Bạn muốn xóa loại đối tác?",
        "Yes": "Đồng ý",
        "EDIT_MDISPATCHER_TYPE": "Chỉnh sửa loại đối tác",
        "ADD_MDISPATCHER_TYPE": "Thêm loại đối tác",
        "DETAIL_MDISPATCHER_TYPE": "Chi tiết loại đối tác",
        "Actions": "Thao tác",
        "Delete_mDispatcherType_success": "Loại đối tác đã được xóa thành công",
        "Delete_mDispatcherType_fail": "Đã xảy ra lỗi khi xóa loại đối tác",
        "Load_mDispatcherType_fail": "Đã xảy ra lỗi khi tải loại đối tác",
        "Create_mDispatcherType_success": "Loại đối tác mới đã được tạo thành công",
        "Create_mDispatcherType_fail": "Đã xảy ra lỗi khi tạo loại đối tác",
        "Update_mDispatcherType_success": "Loại đối tác đã được cập nhật thành công",
        "Update_mDispatcherType_fail": "Đã xảy ra lỗi khi cập nhật loại đối tác"
    },
    "queuingArea": {
        "queuing_area_info": "Thông tin khu vực xếp hàng",
        "queuingDrivers": "Tài xế đang hoạt động",
        "Name": "Tên",
        "Required_fields": "Mục bắt buộc",
        "Save": "Lưu",
        "Cancel": "Hủy",
        "Yes": "Đồng ý",
        "No": "Từ chối",
        "Add": "Thêm",
        "Show_per_page": "Mục mỗi trang",
        "Enter_to_search": "Nhập để tìm kiếm",
        "Page": "Trang",
        "show_pages": "Hiển thị {0} - {1} trên tổng số {2}",
        "Delete": "Xóa",
        "Edit": "Chỉnh sửa",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "Deactivate": "Vô hiệu hóa",
        "Activate": "Kích hoạt",
        "drivers": {
            "order": "Thứ tự",
            "Driver_name": "Tên tài xế",
            "Phone_Number": "Số điện thoại",
            "driverLicenseNumber": "Biển số",
            "Car_Type": "Loại xe",
            "checkInTime": "Thời gian check-in",
            "duration": "Thời lượng",
            "timestampScore": "Điểm dấu thời gian",
            "changeOrderDriver": "Thay đổi thứ tự",
            "detailOrderDriver": "Thứ tự tài xế",
            "Yes": "Đồng ý",
            "No": "Từ chối",
            "insert": "Chèn",
            "refresh": "Làm mới",
            "insertDriver": "Chèn một tài xế vào hàng đợi",
            "orderDriver": "Số thứ tự",
            "reason": "Lý do",
            "removeDriver": "Xóa tài xế khỏi hàng đợi",
            "removeDriverConfirm": "Bạn muốn xóa tài xế này khỏi hàng đợi?",
            "driverNotStay": "Tài xế này không ở trong khu vực hàng đợi. Vui lòng thử lại sau.",
            "overOrder": "Số thứ tự không thể lớn hơn tổng số tài xế trong hàng đợi.",
            "noDriverFound": "Không tìm thấy tài xế",
            "driverUpdateErrRs": "Tài xế không ở trong khu vực xếp hàng. Vui lòng thử lại sau.",
            "orderUpdateErrRs": "Số thứ tự không thể lớn hơn tổng số tài xế trong hàng đợi.",
            "removeDriverSuccess": "Tài xế đã được xóa khỏi khu vực xếp hàng thành công.",
            "removeDriverFail": "Đã xảy ra lỗi khi xóa tài xế khỏi khu vực xếp hàng.",
            "operationInsertFailRs": "Tài xế không tồn tại hoặc không khả dụng.",
            "versionInsertFailRs": "Để sử dụng tính năng này, tài xế cần nâng cấp app tài xế lên phiên bản mới nhất.",
            "queueInsertFailRs": "Hàng đợi không tồn tại hoặc tài xế không ở trong khu vực xếp hàng. Vui lòng thử lại sau.",
            "vehicleInsertFailRs": "Hàng đợi không hỗ trợ loại xe của tài xế.",
            "orderInsertFailRs": "Thứ tự # không được lớn hơn tổng số tài xế trong hàng đợi.",
            "positionInsertFailRs": "Đã xảy ra lỗi khi chèn tài xế vào khu vực hàng đợi.",
            "insertDriverSuccess": "Tài xế đã được chèn vào khu vực hàng đợi thành công.",
            "changeOrderSuccess": "Vị trí của tài xế đã được thay đổi thành công.",
            "insertDriverFail": "Đã xảy ra lỗi khi chèn tài xế từ khu vực hàng đợi.",
            "changeOrderFail": "Đã xảy ra lỗi khi thay đổi vị trí của tài xế từ khu vực hàng đợi.",
            "selectToInsert": "Tìm kiếm: Tên tài xế, Số điện thoại",
            "updateBy": "Được cập nhật bởi điều hành viên",
            "changeOrder": "Thay đổi thứ tự",
            "remove": "Hủy"
        },
        "keepDriverPlaceCancelNoShow": "Giữ vị trí của tài xế khi chuyến xe bị hủy / không có mặt",
        "keepDriverPlaceUnavailable": "Giữ vị trí của tài xế khi tài xế không khả dụng",
        "range": "Phạm vi hàng đợi",
        "queueRangeTooltip": "Đây là cách tài xế sẽ thấy số thứ tự của họ trong hàng đợi trên app tài xế. Ví dụ:\n\n- Thiết lập phạm vi hàng đợi là 1: Tài xế sẽ thấy vị trí của họ trong hàng đợi dưới dạng một số đơn lẻ: 1, 2, 3, 4, v.v.\n- Thiết lập phạm vi hàng đợi là 5: Tài xế sẽ thấy vị trí của họ trong hàng đợi dưới dạng một khoảng: 1-5, 6-10, 11-15, 16-20, v.v.\n- Thiết lập phạm vi hàng đợi là 10: Tài xế sẽ thấy vị trí của họ trong hàng đợi dưới dạng một khoảng: 1-10, 11-20, 21-30, 31-40, v.v.",
        "queueCanceledTooltip": "- Khi hành khách hủy chuyến hoặc không xuất hiện, tài xế sẽ vẫn giữ vị trí đầu tiên nếu quay lại hàng đợi trong thời gian đã thiết lập.\n- Vị trí của tài xế sẽ được ưu tiên cao nếu tài xế quay lại hàng đợi trong thời gian đã thiết lập sau khi hoàn thành một chuyến đi ngắn.",
        "DELETE_QUEUING_AREA": "Xóa hàng đợi",
        "DELETE_CONFIRM": "Bạn muốn xóa hàng đợi?",
        "EDIT_QUEUING_AREA": "Chỉnh sửa hàng đợi",
        "ADD_QUEUING_AREA": "Thêm hàng đợi",
        "DETAIL_QUEUING_AREA": "Chi tiết hàng đợi",
        "Queuing_area": "Hàng đợi",
        "Address": "Địa chỉ",
        "Enter_a_location": "Nhập vị trí",
        "Entered_Address_is_incorrect": "Hệ thống không thể xác định vị trí của bạn. Vui lòng sử dụng địa chỉ được đề xuất.",
        "Not_supported_zone": "Khu vực xếp hàng này không nằm trong vùng được hỗ trợ.",
        "Active_mDispatcher_list": "Danh sách đối tác đang hoạt động",
        "Queue_list": "Danh sách hàng đợi",
        "Allow_radius": "Bán kính cho phép",
        "Min_drivers_required": "Số lượng tài xế tối thiểu cần thiết",
        "Open_queuing_area": "Mở hàng đợi",
        "Auto_dispatch": "Tự động điều phối cho tài xế trong hàng đợi (không cần sử dụng app đối tác)",
        "Active_car_list": "Danh sách xe đang hoạt động",
        "mDispatcher": "Đối tác",
        "Google_Address": "Địa chỉ Google",
        "Status": "Trạng thái",
        "Update_status_error": "Lỗi cập nhật trạng thái",
        "driver_checkin_area": "Khu vực check-in tài xế",
        "EDIT_POLYGONS": "Chỉnh sửa vùng chọn",
        "pax_pickup_area": "Khu vực đón khách",
        "pickup_area": "Pick-up area",
        "your_chosen_polygon": "Vùng chọn của bạn",
        "other_queues": "Các hàng đợi khác",
        "operation_zones": "Khu vực hoạt động",
        "delete_pickup_area_confirm": "Bạn muốn xóa khu vực đón khách này?",
        "delete_pickup_area": "Xóa khu vực đón khách",
        "please_choose_driver_check_in_area": "Vui lòng chọn khu vực check-in tài xế.",
        "please_choose_pick_up_area": "Vui lòng chọn khu vực đón khách.",
        "Load_queuing_area_fail": "Đã xảy ra lỗi khi tải hàng đợi.",
        "Create_queuingArea_success": "Hàng đợi đã được tạo thành công.",
        "Update_queuingArea_success": "Hàng đợi đã được cập nhật thành công.",
        "Delete_queuingArea_success": "Hàng đợi đã được xóa thành công.",
        "Delete_queuingArea_fail": "Đã xảy ra lỗi khi xóa hàng đợi.",
        "Create_queuingArea_fail": "Đã xảy ra lỗi khi tạo hàng đợi.",
        "Load_queuingArea_fail": "Đã xảy ra lỗi khi tải hàng đợi.",
        "Update_queuingArea_fail": "Đã xảy ra lỗi khi cập nhật hàng đợi."
    },
    "appBanner": {
        "Save": "Lưu",
        "Pax_app": "App hành khách",
        "Apply_to": "Áp dụng cho",
        "Please_select_view": "Vui lòng chọn chế độ xem",
        "Select_Type": "Vui lòng chọn loại banner",
        "Home_view": "Chế độ xem trang chủ",
        "Other_view": "Chế độ xem khác",
        "Banner_1": "Biểu ngữ #1",
        "Upload_an_image": "Chưa chọn hình ảnh",
        "Action": "Thao tác",
        "NA": "N/a",
        "Link_to_website": "Link đến website",
        "Make_a_call": "Gọi điện thoại",
        "Send_an_email": "Gửi email",
        "Banner_2": "Biểu ngữ #2",
        "Banner_3": "Biểu ngữ #3",
        "Driver_app": "App tài xế",
        "pax": "App hành khách",
        "driver": "App tài xế",
        "merchant": "App merchant",
        "Name": "Tên",
        "viewType": "Loại",
        "status": "Trạng thái",
        "image": "Hình ảnh",
        "html": "HTML",
        "Delete_Banner": "Xóa banner",
        "Delete_confirm_banner": "Bạn muốn xóa banner đã chọn?",
        "Delete_banner_success": "Banner đã được xóa thành công",
        "Delete_banner_fail": "Đã xảy ra lỗi khi xóa banner",
        "edit_banner": "Chỉnh sửa banner",
        "detail_banner": "Chi tiết banner",
        "create_banner": "Thêm banner",
        "note_1": "* Phần mở rộng tệp phải là .jpg, .jpeg, .png, .gif và có kích thước nhỏ hơn %{limit}MB.",
        "note_2": "* Hình ảnh cần định dạng theo tỷ lệ 16:9",
        "note_3": "* Các chế độ xem khác bao gồm Hộp thư, Giới thiệu bạn bè, Biên lai, Chuyến xe của tôi, Mã ưu đãi, Thêm thẻ tín dụng/Phương thức thanh toán, Hồ sơ, Đang chờ xử lý/Xác nhận đặt xe, Chế độ xem đã hoàn thành.",
        "Update_app_banner_success": "Banner app đã được cập nhật thành công",
        "Update_app_banner_fail": "Cập nhật banner app không thành công!",
        "Create_app_banner_success": "Banner app đã được tạo thành công",
        "Create_app_banner_fail": "Tạo banner app không thành công!",
        "Note": "Vui lòng sử dụng tệp định dạng .png (nền trong suốt, kích thước 400x200px) để tối ưu ứng dụng",
        "Limit_size_upload": "Kích thước tệp phải nhỏ hơn 8MB.",
        "display_duration": "Thời gian hiển thị",
        "playback_settings": "Cài đặt phát lại",
        "display_banner_again_after": "Hiển thị lại banner sau",
        "stop_display_banner_after": "Dừng hiển thị banner sau",
        "enable_playback": "Bật phát lại",
        "Update_playback_success": "Cài đặt phát lại đã được cập nhật thành công",
        "Update_playback_fail": "Cập nhật cài đặt phát lại không thành công!",
        "language": "Ngôn ngữ",
        "single": "Một ngôn ngữ",
        "multi": "Đa ngôn ngữ",
        "es-ES": "Tiếng Tây Ban Nha",
        "en-US": "Tiếng Anh",
        "fr-FR": "Tiếng Pháp",
        "id-ID": "Bahasa Indonesia",
        "vi-VN": "Tiếng Việt",
        "ur-PK": "Urdu",
        "ms-MY": "Malaysia",
        "ar-AR": "Tiếng Ả Rập",
        "nb-NO": "Na Uy",
        "en-GB": "Tiếng Anh (Vương quốc Anh)",
        "am-ET": "Amharic",
        "ro-RO": "Tiếng Romania",
        "version": "Phiên bản app",
        "comparisonVersionApp": {
            "is": "Là",
            "is_not": "Không phải là",
            "is_one_of": "Là một trong số",
            "is_not_one_of": "Không phải là một trong số",
            "greater_or_equal": "Lớn hơn hoặc bằng",
            "less_or_equal": "Nhỏ hơn hoặc bằng"
        },
        "platform": "Nền tảng",
        "platformItem": {
            "all": "Tất cả",
            "iOS": "iOS",
            "android": "Android"
        },
        "userStatus": "Trạng thái người dùng",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "in_review_completed": "Đang xem xét (hồ sơ đã hoàn tất)",
        "in_review_incomplete": "Đang xem xét (hồ sơ chưa hoàn tất)",
        "in_review_inProgress": "Đang xem xét (hồ sơ đang xử lý)",
        "zones": "Khu vực"
    },
    "reservation": {
        "name": "Đặt trước",
        "company": "Công ty",
        "carType": "Loại xe",
        "licensePlate": "Biển số: %{name}",
        "driver": "Tài xế: %{name}",
        "showAllDrivers": "Hiển thị tất cả tài xế",
        "available": "Sẵn sàng",
        "reserved": "Đã đặt trước",
        "search_holder": "Công ty, Tên tài xế, Loại xe, Biển số",
        "all": "Tất cả",
        "today": "Hôm nay",
        "thisWeek": "Tuần này",
        "day": "Hàng ngày",
        "week": "Hàng tuần",
        "bookingID": "ID đặt xe",
        "tripId": "ID chuyến đi",
        "pickupTime": "Thời gian đón",
        "pickupLocation": "Điểm đón",
        "monday": "Thứ Hai",
        "tuesday": "Thứ Ba",
        "wednesday": "Thứ Tư",
        "thursday": "Thứ Năm",
        "friday": "Thứ Sáu",
        "saturday": "Thứ Bảy",
        "sunday": "Chủ Nhật",
        "overlapped": "Bị trùng",
        "noData": "Không tìm thấy dữ liệu.",
        "bookingDetails": "Chi tiết chuyến xe",
        "reservedHint": "Chuyến xe đã được xác nhận",
        "availableHint": "Không có chuyến xe nào được xác nhận",
        "overlappedHint": "Có chuyến bị trùng lặp"
    },
    "dashboard": {
        "API": "API",
        "cc": "CC",
        "dmc": "Bảng đặt xe",
        "streetSharing": "Ghép chuyến",
        "kiosk": "Kiosk",
        "mDispatcher": "Đối tác",
        "paxApp": "App hành khách",
        "webBooking": "Đặt xe qua web",
        "carHailing": "Khách vãng lai",
        "acceptance": "Chấp nhận",
        "booking_com": "Booking.com",
        "completed": "Đã hoàn thành",
        "noShow": "Không xuất hiện",
        "driverNoShow": "Người lái không xuất hiện",
        "canceled": "Đã hủy",
        "incident": "Sự cố",
        "rate1": "1 Sao",
        "rate2": "2 Sao",
        "rate3": "3 Sao",
        "rate4": "4 Sao",
        "rate5": "5 Sao",
        "Export_to_Excel": "Xuất sang Excel",
        "Profit": "Lợi nhuận",
        "day_change": "Thay đổi hàng ngày",
        "week_change": "Thay đổi hàng tuần",
        "month_change": "Thay đổi hàng tháng",
        "Booking_requests": "Yêu cầu đặt xe",
        "Complete_bookings": "Chuyến hoàn tất",
        "New_customers": "Khách hàng mới",
        "Booking_dashboard": "Bảng đặt xe",
        "others": "Khác",
        "Revenue_booking": "Lợi nhuận & chuyến đã hoàn thành",
        "Profit_finish_booking": "Lợi nhuận & chuyến đã hoàn thành",
        "Booking_request": "Yêu cầu đặt xe",
        "Finished_booking": "Chuyến đã hoàn thành",
        "failed": "Thất bại",
        "partialCompleted": "Hoàn thành một phần",
        "Finished_booking_char_header": "Chuyến đã hoàn thành ({0})",
        "Bookings": "Chuyến xe ({0})",
        "Ratings": "Đánh giá ({0})",
        "Daily": "Hàng ngày",
        "Weekly": "Hàng tuần",
        "Monthly": "Hàng tháng",
        "Total_customer": "Tổng số khách hàng {0}",
        "ProfitToolTips": "Số tiền đội xe kiếm được sau khi trừ tất cả chi phí",
        "RevenueToolTips": "Số tiền đội xe thực nhận trong khoảng thời gian đã chọn, bao gồm ưu đãi, khấu trừ cho tài xế, thuế, v.v.",
        "ProfitChangeToolTips": "Tỷ lệ thay đổi lợi nhuận của đội xe so với kỳ trước",
        "BookingRequestsToolTips": "Tổng số lượt chuyến xe đi ngay và đặt trước được tạo trong khoảng thời gian đã chọn",
        "PercentageOfAcceptanceToolTips": "Tỷ lệ chuyến xe đã nhận trong khoảng thời gian đã chọn",
        "BookingChangeHint": "Tỷ lệ thay đổi số chuyến xe được tạo so với kỳ trước",
        "CompletedBookingHint": "Tổng số lượt chuyến xe đi ngay và đặt trước đã hoàn thành trong khoảng thời gian đã chọn",
        "PercentageOfSatisfactionHint": "Mức độ hài lòng của KH trong khoảng thời gian đã chọn",
        "CompleteBookingDailyChangeHint": "Tỷ lệ thay đổi số chuyến xe đã hoàn thành so với kỳ trước",
        "NewCustomersHint": "Tổng số khách hàng mới đăng ký trong khoảng thời gian đã chọn",
        "CustomerChangeHint": "Số lượng và tỷ lệ thay đổi của khách hàng so với kỳ trước",
        "TotalCustomer": "Tổng số khách hàng trong hệ thống",
        "ProfitAndFinishedBookingHint": "Lợi nhuận & số chuyến xe đã hoàn thành của đội xe trong khoảng thời gian đã chọn",
        "BookingRequestHint": "Tổng số lượt chuyến xe đi ngay và đặt trước được tạo trong khoảng thời gian đã chọn",
        "FinishedBookingChartsHint": "Tổng số lượt chuyến xe đi ngay và đặt trước đã được đóng trong khoảng thời gian đã chọn, bao gồm hủy, không có mặt, sự cố và hoàn thành",
        "Customer_count": "Số lượng khách hàng {0}",
        "Revenue": "Doanh thu"
    },
    "referral": {
        "first_package": "Gói đầu tiên (tức là chuyến xe đầu tiên đã hoàn thành của KH)",
        "driver_refers_to_pax": "Tài xế giới thiệu khách hàng",
        "driver_will_get": "Tài xế sẽ nhận được",
        "money": "Tiền",
        "amount": "Số tiền",
        "percent": "Phần trăm",
        "settlement": "Hoa hồng (% tổng phụ của mỗi lượt đặt chỗ đã hoàn thành)",
        "pax_will_get": "KH sẽ nhận được",
        "promotion_code": "Mã ưu đãi",
        "select_a_promotion": "Chọn một mã ưu đãi",
        "maximum": "Tối đa",
        "second_package": "Gói thứ hai",
        "from": "Từ",
        "to": "Đến",
        "After_2nd_package": "Sau gói thứ hai",
        "from_end_value_of_above_package": "Từ giá trị của gói cuối cùng ở trên + 1",
        "Expiration_date": "Ngày hết hạn",
        "Never": "Không bao giờ",
        "Customized_date": "Ngày tùy chỉnh",
        "limited": "Giới hạn",
        "unlimited": "Không giới hạn",
        "Valid_from": "Có hiệu lực từ",
        "Valid_to": "Có hiệu lực đến",
        "Invitation_limit": "Giới hạn người được giới thiệu/tài xế",
        "Status": "Trạng thái",
        "Active": "Đang hoạt động",
        "Inactive": "Không hoạt động",
        "note": "* Lưu ý rằng khi chiến dịch đã hoạt động, mọi cập nhật về giá trị phần thưởng chỉ ảnh hưởng đến KH mới.",
        "Required_fields": "Mục bắt buộc",
        "refferal_update_successfully": "Cài đặt giới thiệu đã được cập nhật thành công",
        "distributeIncentiveToDriver": "Phân phối phần thưởng cho tài xế",
        "Immediate": "Ngay lập tức",
        "Periodic": "Định kỳ (Thủ công)",
        "Period": "Chu kỳ",
        "startDate": "Ngày bắt đầu",
        "nextDistributionDate": "Ngày phân phối tiếp theo",
        "oneMonth": "1 tháng",
        "threeMonth": "3 tháng",
        "sixMonth": "6 tháng",
        "passenger_refers_to_pax": "Khách hàng giới thiệu KH",
        "referer_will_get": "Người giới thiệu sẽ nhận được",
        "referee_will_get": "Người được giới thiệu sẽ nhận được",
        "promo": "Ưu đãi",
        "Pax_invitation_limit": "Giới hạn lời mời/người dùng",
        "promoPaidBy": "Ưu đãi được thanh toán bởi",
        "fleet": "Đội xe",
        "driver": "Tài xế",
        "promoCode": "Mã ưu đãi",
        "isSendInbox": "Gửi vào hộp thư",
        "isDefaultCode": "Tự động áp dụng trên app",
        "autoApplyOnWeb": "Tự động áp dụng trên web",
        "isDefaultCode_hint": "Thêm mã ưu đãi vào danh sách khách hàng và tự động áp dụng khi KH tạo chuyến",
        "Actions": "Thao tác",
        "add_promoCode": "Thêm",
        "Send_an_in_box_automatically_to_new_customers": "Gửi vào hộp thư của KH",
        "set_default_promo_code": "Tự động áp dụng trên app",
        "EDIT_PROMO_CODE": "Chỉnh sửa mã ưu đãi",
        "DETAIL_PROMO_CODE": "Chi tiết mã ưu đãi",
        "CREATE_PROMO_CODE": "Tạo mã ưu đãi",
        "DELETE_PROMO_CODE": "Xóa mã ưu đãi",
        "DELETE_CONFIRM_PROMO_CODE": "Bạn có muốn xóa mã ưu đãi này không?",
        "ERROR_INPUT_SOURCE": "Vui lòng chọn ít nhất một."
    },
    "upload_document": {
        "NO_FILE_CHOSEN": "Chưa chọn tệp nào",
        "Limit_size_upload": "Kích thước tệp vượt quá giới hạn cho phép {0}MB."
    },
    "payment_info": {
        "member_since": "Thành viên từ",
        "package_name": "Tên gói",
        "last_payment": "Thanh toán cuối cùng",
        "credit_card": "Thẻ tín dụng",
        "last_digits": "4 chữ số cuối",
        "default": "Mặc định",
        "add_new_card": "Thêm card mới",
        "history": "Lịch sử",
        "transaction_date": "Ngày giao dịch",
        "transaction_id": "ID giao dịch",
        "billing_cycle": "Chu kỳ thanh toán",
        "amount": "Số tiền",
        "payment_history": "Lịch sử thanh toán",
        "card_information": "Thông tin thẻ",
        "card_holder": "Chủ thẻ",
        "card_number": "Số thẻ",
        "expiration_date": "Ngày hết hạn",
        "cvv": "Mã CVV"
    },
    "search_by": {
        "group_id": "ID nhóm",
        "booking_id": "# Đặt xe",
        "recurring_id": "# Định kỳ",
        "ExternalID": "# Bên ngoài",
        "tripId": "# Chuyến",
        "driver_name": "Tên tài xế",
        "driver_phone_number": "Số điện thoại tài xế",
        "license_plate": "Biển số",
        "vehicle": "Xe",
        "operator": "Điều hành viên",
        "passenger_email": "Email hành khách",
        "passenger_name": "Tên hành khách",
        "passenger_phone_number": "Số điện thoại hành khách",
        "destination": "Điểm đến",
        "pick_up": "Điểm đón",
        "flight_number": "# chuyến bay",
        "book_from": "Chuyến xe từ",
        "note": "Ghi chú",
        "email": "Email",
        "phone": "Điện thoại"
    },
    "withdrawal": {
        "transferToEWallet": "*Đã chuyển vào ví điện tử bên ngoài {0}",
        "channelCode": "Mã kênh",
        "channelName": "Tên kênh",
        "reversed": "Đã hoàn lại",
        "requestTime": "Thời gian yêu cầu",
        "referenceId": "# tham chiếu",
        "driverName": "Tên tài xế",
        "phoneNumber": "Số điện thoại",
        "company": "Công ty",
        "description": "Mô tả",
        "requestAmount": "Số tiền yêu cầu",
        "transferAmount": "Số tiền chuyển",
        "currentBalance": "Số dư hiện tại",
        "currency": "Đơn vị tiền tệ",
        "action": "Thao tác",
        "approve": "Phê duyệt",
        "reject": "Từ chối",
        "transferToBankAccount": "*Đã chuyển vào tài khoản ngân hàng {0}",
        "transferToWingBank": "*Đã chuyển vào tài khoản ngân hàng Wing {0}",
        "transferToCreditWallet": "Đã chuyển vào ví tín dụng",
        "reason": "Lý do",
        "search": "Tên tài xế, số điện thoại, công ty, ID giao dịch, # tham chiếu",
        "message": {
            "approve": "Bạn muốn thanh toán cho tài xế này số tiền {0}?",
            "approveMulti": "Bạn muốn thanh toán cho tài xế đã chọn?",
            "approveSuccess": "Yêu cầu đã chọn đã được thanh toán",
            "approveFail": "Yêu cầu đã chọn không thành công. Vui lòng thử lại.",
            "approveMultiSuccess": "{0} trong số {1} yêu cầu đã chọn đã được thanh toán.",
            "approveMultiFail": "{0} trong số {1} yêu cầu đã chọn không thành công. Vui lòng thử lại.",
            "buttonConfirmTitle": "Đồng ý",
            "closeButtonText": "Từ chối",
            "pleaseInputReason": "Vui lòng nhập lý do",
            "rejectSuccess": "Yêu cầu của tài xế đã bị từ chối",
            "rejectFail": "Không thể từ chối yêu cầu đã chọn"
        },
        "getDataFailure": "Không thể lấy dữ liệu",
        "rejectRequest": "Từ chối yêu cầu"
    },
    "dynamicSurcharge": {
        "operationZone": "Khu vực hoạt động",
        "activeSurcharge": "Phụ phí đang hoạt động",
        "surcharge": "Phụ phí",
        "surchargeName": "Tên phụ phí",
        "parameter": "Tham số (ví dụ: 1.x)",
        "pickupPoint": "Khu vực đón khách",
        "dropOffPoint": "Khu vực trả khách",
        "delete_surcharge_success": "Phụ phí đã được xóa thành công",
        "delete_surcharge_fail": "Đã xảy ra lỗi khi xóa phụ phí",
        "update_surcharge_fail": "Đã xảy ra lỗi khi cập nhật phụ phí",
        "update_surcharge_success": "Phụ phí đã được cập nhật thành công",
        "create_surcharge_fail": "Đã xảy ra lỗi khi tạo phụ phí",
        "create_surcharge_success": "Phụ phí đã được tạo thành công",
        "active_surcharge_fail": "Đã xảy ra lỗi khi kích hoạt phụ phí",
        "active_surcharge_success": "Phụ phí đã được kích hoạt thành công",
        "deactive_surcharge_fail": "Đã xảy ra lỗi khi hủy kích hoạt phụ phí",
        "deactive_surcharge_success": "Phụ phí đã được hủy kích hoạt thành công",
        "delete_surcharge": "Xóa phụ phí",
        "delete_confirm_message": "Bạn muốn xóa phụ phí đã chọn?",
        "note": "Lưu ý: Đây là hệ số nhân với giá cước cơ bản. Ví dụ: giá cước $20 sẽ thành $30 khi tham số là 1.5x"
    },
    "dynamicFare": {
        "operationZone": "Khu vực hoạt động",
        "activeFare": "Giá đang hoạt động",
        "fare": "Cước phí",
        "fareName": "Tên giá",
        "factor": "Nhân với hệ số",
        "fix_amount": "Số tiền",
        "parameter": "Tham số (ví dụ: 1.x)",
        "delete_fare_success": "Giá đã được xóa thành công",
        "delete_fare_fail": "Đã xảy ra lỗi khi xóa giá",
        "update_fare_fail": "Đã xảy ra lỗi khi cập nhật giá",
        "update_fare_success": "Giá đã được cập nhật thành công",
        "create_fare_fail": "Đã xảy ra lỗi khi tạo giá",
        "create_fare_success": "Giá đã được tạo thành công",
        "active_fare_fail": "Đã xảy ra lỗi khi kích hoạt giá",
        "active_fare_success": "Giá đã được kích hoạt thành công",
        "deactive_fare_fail": "Đã xảy ra lỗi khi hủy kích hoạt giá",
        "deactive_fare_success": "Giá đã được hủy kích hoạt thành công",
        "delete_fare": "Xóa giá",
        "delete_confirm_message": "Bạn muốn xóa giá đã chọn?",
        "note": "* Lưu ý: Đây là hệ số nhân với giá cơ bản. Ví dụ: giá cước $20 sẽ thành $30 khi tham số là 1.5x",
        "note_amount": "* Lưu ý: Đây là số tiền được cộng vào giá cơ bản. Ví dụ: giá cước $20 sẽ thành $25 khi số tiền được đặt là $5"
    },
    "notifications": {
        "search": "Tìm kiếm ID đặt chỗ, ID ngoài",
        "searchProviderName": "Tìm kiếm tên nhà cung cấp",
        "statusItem": {
            "all": "Tất cả thông báo",
            "canceledByDriver": "Di chuyển - Bị hủy bởi tài xế",
            "canceledByPartner": "Đối tác liên kết - Bị hủy bởi đối tác",
            "reservationReminder": "Nhắc nhở chuyến",
            "localPending": "Địa phương - Đang chờ xử lý",
            "reservationIsNotStarted": "Chuyến chưa bắt đầu",
            "partnerRequestsCars": "Đối tác yêu cầu xe",
            "timeout": "Quá giờ",
            "noShow": "Đối tác liên kết - Không có mặt",
            "driverNoShow": "Người lái không xuất hiện",
            "affiliatePending": "Đối tác liên kết - Đang chờ xử lý",
            "affiliatePaymentFailed": "Thanh toán đối tác liên kết thất bại",
            "affiliateTimeout": "Đối tác liên kết quá giờ",
            "flightApi": "API chuyến bay",
            "DebtWriteOff": "Xóa nợ",
            "driverCancelTrip": "Liên tỉnh - Bị hủy bởi tài xế",
            "minimumSeatRequired": "Số ghế tối thiểu cần thiết",
            "newFarmInJobFrom3rd": "Booking.com  - Chuyến xe mới",
            "canceledJobBy3rd": "Booking.com  - Đã hủy",
            "updatedJobBy3rd": "Booking.com  - Đã cập nhật",
            "incidentJobBy3rd": "Booking.com - Sự cố",
            "newFarmInJobFromHolidayTaxis": "HolidayTaxis - Chuyến xe mới",
            "canceledJobByHolidayTaxis": "HolidayTaxis - Đã hủy",
            "updatedJobByHolidayTaxis": "HolidayTaxis - Đã cập nhật",
            "newFarmInJobFromKarhoo": "Karhoo - Chuyến xe mới",
            "canceledJobByKarhoo": "Karhoo - Đã hủy",
            "updatedJobByKarhoo": "Karhoo - Đã cập nhật",
            "newFarmInJobFromHoppa": "Hoppa - Đặt chỗ mới",
            "canceledJobByHoppa": "Hoppa - Đã hủy",
            "updatedJobByHoppa": "Hoppa - Cập nhật",
            "newFarmInJobFromKlook": "Klook - Đặt chỗ mới",
            "canceledJobByKlook": "Klook - Đã hủy",
            "updatedJobByKlook": "Klook - Cập nhật",
            "newFarmInJobFromTransferZ": "TransferZ - Đặt chỗ mới",
            "canceledJobByTransferZ": "TransferZ - Đã hủy",
            "updatedJobByTransferZ": "TransferZ - Cập nhật",
            "incidentReport": "Sự cố",
            "incidentAutoReport": "Cần xem xét"
        },
        "sos": {
            "sosSearch": "Tìm kiếm ID đặt xe, tên hành khách, tên tài xế",
            "statusItem": {
                "all": "Tất cả",
                "driver": "Tài xế",
                "passenger": "Khách hàng",
                "crew": "Đội ngũ"
            }
        }
    },
    "smartData": {
        "No": "Không.",
        "driverName": "Tên",
        "phone": "Điện thoại",
        "rating": "Đánh giá",
        "completed": "Hoàn thành",
        "noShow": "Không có mặt",
        "driverNoShow": "Người lái không xuất hiện",
        "incident": "Sự cố",
        "canceled": "Bị hủy bởi tài xế",
        "accepted": "Đã chấp nhận",
        "reject": "Từ chối",
        "ignore": "Bỏ qua",
        "earning": "Thu nhập",
        "query": {
            "top20": "Top 20",
            "top50": "Top 50",
            "top100": "Top 100",
            "bottom20": "Dưới cùng 20",
            "bottom50": "Dưới cùng 50",
            "bottom100": "Dưới cùng 100"
        },
        "status": {
            "canceled": "Bị hủy bởi tài xế",
            "noShow": "Không có mặt",
            "driverNoShow": "Người lái không xuất hiện",
            "incident": "Sự cố",
            "completed": "Hoàn thành",
            "earning": "Thu nhập",
            "reject": "Từ chối",
            "ignore": "Bỏ qua",
            "accepted": "Đã chấp nhận"
        }
    },
    "Reject": "Không thấy khách",
    "Do not allow Driver to start reservat": "Liên kết",
    "intercityRate": {
        "Delete_intercity_rate": "Xóa giá cước liên tỉnh",
        "edit_intercity_rate": "Chỉnh sửa giá cước liên tỉnh",
        "view_intercity_rate": "Xem giá cước liên tỉnh",
        "add_intercity_rate": "Thêm giá cước liên tỉnh",
        "Delete_confirm_intercity_rate": "Bạn muốn xóa mục này?",
        "Update_intercity_rate_success": "Giá cước liên tỉnh đã được cập nhật thành công",
        "Update_intercity_rate_fail": "Đã xảy ra lỗi khi cập nhật giá cước liên tỉnh",
        "Created_intercity_rate_success": "Giá cước liên tỉnh đã được tạo thành công",
        "Created_intercity_rate_fail": "Đã xảy ra lỗi khi tạo giá cước liên tỉnh",
        "Update_intercity_rate_route_success": "Tuyến giá cước liên tỉnh đã được cập nhật thành công",
        "Update_intercity_rate_route_fail": "Đã xảy ra lỗi khi cập nhật tuyến giá cước liên tỉnh",
        "Created_intercity_rate_route_success": "Tuyến giá cước liên tỉnh đã được tạo thành công",
        "Created_intercity_rate_route_fail": "Đã xảy ra lỗi khi tạo tuyến giá cước liên tỉnh",
        "Loading_intercity_rate_fail": "Xảy ra lỗi khi tải chi tiết giá xe tuyến",
        "Delete_intercity_rate_route_fail": "Xảy ra lỗi khi xóa tuyến đường",
        "Delete_intercity_rate_success": "Giá xe tuyến được xóa thành công",
        "Delete_intercity_rate_fail": "Xảy ra lỗi khi xóa giá xe tuyến"
    },
    "intercityRoute": {
        "alias": "Tên gọi khác",
        "routeNameHint": "Để thay đổi tên tuyến đường, vui lòng vào Cài đặt > Khu vực > Liên tỉnh và thay đổi tên của các khu vực thành phố tương ứng.",
        "pricePerSeat": "Giá mỗi ghế (không bao gồm thuế)",
        "distance": "Khoảng cách",
        "duration": "Thời lượng",
        "cancellationPenalty": "Số tiền phạt mỗi ghế",
        "noShow": "Hành khách/đối tác không có mặt",
        "penalty": "Số tiền phạt mỗi ghế",
        "no_show_tooltip": "Số tiền khách hàng sẽ bị tính phí cho mỗi ghế. Ngoài tiền phạt, khách hàng sẽ phải trả thuế hoặc phí công nghệ nếu có áp dụng",
        "firstLocation": "Địa điểm đầu tiên",
        "secondLocation": "Địa điểm thứ hai",
        "routeOneSetup": "Thiết lập tuyến đường 1",
        "routetwoSetup": "Thiết lập tuyến đường 2",
        "schedules": "Lịch trình",
        "date": "Ngày",
        "time": "Thời gian",
        "editSchedule": "Chỉnh sửa lịch trình",
        "addSchedule": "Thêm lịch trình",
        "requestTimeEnable": "Cho phép khách hàng đặt thời gian yêu cầu",
        "extraFee": "Phí bổ sung",
        "hideRouteEnable": "Ẩn tuyến đường này",
        "timeRange": "Khoảng thời gian",
        "workingTime": "Thời gian làm việc",
        "applyForOtherDays": "Áp dụng cho các ngày khác",
        "limitSeatLuggage": "Giới hạn số ghế / hành lý",
        "warningMinimumSeats": "Số ghế tối thiểu cần thiết",
        "warningMinimumSeatsHint": "Số ghế tối thiểu cần thiết để chuyến đi diễn ra",
        "allowStartLessMinRequiredSeats": "Tài xế có thể bắt đầu chuyến đi bất kể yêu cầu số ghế tối thiểu",
        "allowStartLessMinRequiredSeatsHint": "Cho phép tài xế bắt đầu chuyến đi ngay cả khi số ghế yêu cầu ít hơn số ghế tối thiểu",
        "freeLuggagePerSeat": "Hành lý miễn phí mỗi ghế",
        "freeLuggagePerSeatHint": "Số lượng hành lý miễn phí đi kèm mỗi ghế",
        "allowToAddExtraLuggage": "Thêm hành lý bổ sung",
        "allowToAddExtraLuggageHint": "Cho phép hành khách thêm hành lý bổ sung",
        "feePerExtraLuggage": "Phí cho mỗi hành lý bổ sung",
        "Delete_intercity_route": "Xóa tuyến đường liên tỉnh",
        "Delete_confirm_intercity_route": "Bạn muốn xóa tuyến đường này?",
        "Update_intercity_route_fail": "Đã xảy ra lỗi khi cập nhật tuyến đường liên tỉnh",
        "Update_intercity_route_success": "Tuyến đường liên tỉnh đã được cập nhật thành công",
        "created_intercity_route_success": "Tuyến đường liên tỉnh đã được tạo thành công",
        "created_intercity_route_fail": "Đã xảy ra lỗi khi tạo tuyến đường liên tỉnh",
        "Delete_intercity_route_success": "Tuyến đường liên tỉnh đã được xóa thành công",
        "Delete_intercity_route_fail": "Đã xảy ra lỗi khi xóa tuyến đường liên tỉnh",
        "penalty_less_than_or_equal_to_price": "Vui lòng nhập giá trị nhỏ hơn hoặc bằng giá mỗi ghế.",
        "scheduleTimeOverlap": "Thời gian lịch trình không được trùng nhau.",
        "allows_adding_extra": "Cho phép thêm phụ phí khi khách hàng yêu cầu thời gian không có trong lịch trình của đội xe.",
        "this_is_to_limit_users": "Điều này nhằm hạn chế người dùng (khách hàng, tài xế, điều hành viên) tạo đặt xe hoặc chuyến đi mới trên tuyến đường này. Các đặt xe hoặc chuyến đi hiện có vẫn được giữ nguyên."
    },
    "dayOfWeek": {
        "0": "Chủ nhật",
        "1": "Thứ hai",
        "2": "Thứ ba",
        "3": "Thứ tư",
        "4": "Thứ năm",
        "5": "Thứ sáu",
        "6": "Thứ bảy"
    },
    "intercityBooking": {
        "route": "Lộ trình",
        "departureDate": "Ngày khởi hành",
        "departureTime": "Thời gian khởi hành",
        "Departure": "Khởi hành",
        "Arrival": "Đến nơi",
        "RefundFare": "Giá hoàn",
        "intercityZoneNote": "Khu vực tạo ở đây chỉ được sử dụng để thiết lập giá cước liên tỉnh.",
        "zoneNameHint": "Vui lòng giữ tên khu vực ngắn gọn và rõ ràng để khách hàng có thể tìm kiếm và chọn dễ dàng.",
        "zoneUploadNote_2": "* Độ phân giải hình ảnh là 1095x360 và kích thước tệp nhỏ hơn 5MB.",
        "Complete_booking": "Chuyến hoàn tất",
        "ConfirmCancel": "Xác nhận hủy"
    },
    "deliveryRate": {
        "Delete_delivery_rate": "Xóa giá cước giao hàng",
        "edit_delivery_rate": "Chỉnh sửa giá cước giao hàng",
        "view_delivery_rate": "Xem giá cước giao hàng",
        "add_delivery_rate": "Thêm giá cước giao hàng",
        "Delete_confirm_delivery_rate": "Bạn có muốn xóa mục này không?",
        "Update_delivery_rate_success": "Giá cước giao hàng đã được cập nhật thành công",
        "Update_delivery_rate_fail": "Đã xảy ra lỗi khi cập nhật giá cước giao hàng",
        "Created_delivery_rate_success": "Giá cước giao hàng đã được tạo thành công",
        "Created_delivery_rate_fail": "Đã xảy ra lỗi khi tạo giá cước giao hàng",
        "Update_delivery_rate_route_success": "Tuyến giá cước giao hàng đã được cập nhật thành công",
        "Update_delivery_rate_route_fail": "Đã xảy ra lỗi khi cập nhật tuyến giá cước giao hàng",
        "Created_delivery_rate_route_success": "Lộ trình giá cước giao hàng đã được tạo thành công",
        "Created_delivery_rate_route_fail": "Đã xảy ra lỗi khi tạo lộ trình giao hàng",
        "Loading_delivery_rate_fail": "Đã xảy ra lỗi khi tải chi tiết giá cước giao hàng",
        "Delete_delivery_rate_route_fail": "Đã xảy ra lỗi khi xóa lộ trình giá cước giao hàng",
        "Delete_delivery_rate_success": "Giá cước giao hàng đã được xóa thành công",
        "Delete_delivery_rate_fail": "Đã xảy ra lỗi khi xóa giá cước giao hàng",
        "distance_km": "Phí mỗi km",
        "distance_mile": "Phí mỗi dặm",
        "flat": "Phí cố định",
        "startingFee": "Giá mở cửa",
        "feeFirstDistance": "Phí km đầu",
        "feeSecondDistance": "Phí km thứ hai",
        "feeThirdDistance": "Phí km thứ ba",
        "feeAfterThirdDistance": "Phí sau km thứ ba",
        "feePerMinute": "Giá cước mỗi phút",
        "feeMinimum": "Phí tối thiểu",
        "feeFirstStop": "Phí điểm dừng đầu tiên",
        "feeExtraStop": "Phí thêm điểm đến"
    },
    "aiAtlasSettings": {
        "title": "Chatbot Atlas AI",
        "titleDes": "Hãy cho Atlas biết về công ty và dịch vụ của bạn",
        "information": "Thông tin Atlas",
        "informationDes": "Ví dụ, thêm thông tin công ty như email, số điện thoại, địa chỉ, v.v.",
        "updateSettingSuccess": "Cập nhật cài đặt AI Atlas thành công",
        "updateSettingFail": "Cập nhật cài đặt AI Atlas thất bại"
    },
    "pwaSettings": {
        "pwa": "PWA",
        "iconName": "Icon & tên",
        "logoBackgroundColor": "Logo, nền & màu sắc",
        "longName": "Tên đầy đủ",
        "shortName": "Tên ngắn",
        "icon192": "Icon trên màn hình chính (192x192)",
        "icon512": "Icon trên màn hình khởi động",
        "logo": "Logo (300x300)",
        "logoMenu": "Logo menu (300x300)",
        "backgroundImage": "Hình nền - Di chuyển (1024x500)",
        "backgroundImageDelivery": "Hình nền - Giao hàng (1024x500)",
        "mainColor": "Màu chính",
        "secondaryColor": "Màu phụ",
        "showMainColor": "Hiển thị màu chính thay vì hình nền",
        "success": "Cài đặt PWA đã được cập nhật thành công",
        "failed": "Cập nhật cài đặt PWA thất bại. Vui lòng thử lại!",
        "errorUploadFileSize": "Kích thước yêu cầu là {0}x{0} px.",
        "hideWBInstallAppBtn": "Ẩn nút cài đặt ứng dụng",
        "enableBookNow": "Đi ngay",
        "enableGuestCheckout": "Checkout không cần tài khoản",
        "enableBookLater": "Đặt trước",
        "enableHideRecipient": "Ẩn thông tin người nhận (Nội dung gói hàng, Hướng dẫn giao hàng)",
        "pwaLink": "PWA cho hành khách",
        "partnerLink": "PWA cho đối tác",
        "pwaDriverLink": "PWA cho tài xế",
        "providerSignUp": "Link đăng ký tài xế",
        "AdsTracking": "Theo dõi quảng cáo",
        "googleId": "ID thẻ Google",
        "placeholdergoogleId": "Nhập Google Tag ID",
        "metaId": "ID Meta Pixel",
        "placeholdermetaId": "Nhập ID Meta Pixel"
    },
    "emailConfig": {
        "emailServer": "Máy chủ email",
        "default": "Mặc định",
        "customized": "Tùy chỉnh",
        "fromName": "Tên người gửi",
        "email": "Email người gửi",
        "replyTo": "Trả lời tới",
        "userAuth": "Tên đăng nhập",
        "password": "Mật khẩu",
        "smtpServer": "Máy chủ SMTP",
        "port": "Cổng SMTP",
        "isAuthenticated": "Đã xác thực",
        "option": "Bật tùy chọn",
        "none": "Không có",
        "tls": "TLS",
        "ssl": "SSL",
        "save": "Lưu",
        "cancel": "Hủy",
        "success": "Cập nhật máy chủ email thành công",
        "fail": "Cập nhật máy chủ email thất bại",
        "loadFail": "Tải chi tiết máy chủ email thất bại"
    },
    "driverFields": {
        "Load_fail": "Please provide the text you would like to have translated into Vietnamese.",
        "Edit": "Chỉnh sửa",
        "View": "Xem",
        "Cancel": "Hủy",
        "show": "Hiển thị",
        "hide": "Ẩn",
        "EDIT_DRIVER_FIELDS": "Chỉnh sửa trường tài xế",
        "DETAIL_DRIVER_FIELDS": "Chi tiết trường tài xế",
        "ADD_DRIVER_FIELDS": "Thêm trường tài xế",
        "fieldKey": "Fields Key",
        "fieldName": "Tên trường",
        "availableCC": "Hiện trên Trung tâm điều hành",
        "availableDrvSignUp": "Hiện khi đăng ký tài xế",
        "availableCompanyCar": "Xe công ty - Di chuyển",
        "deliveryCompany": "Xe công ty - Giao hàng",
        "availableIndividualCar": "Xe cá nhân - Di chuyển",
        "deliveryIndividual": "Xe cá nhân - Giao hàng",
        "required": "Bắt buộc",
        "Update_fail": "Đã xảy ra lỗi khi cập nhật trường tài xế",
        "Update_success": "Trường tài xế đã được cập nhật thành công",
        "FieldKey": "Khóa Trường",
        "FieldName": "Tên trường (Tiếng Anh Mỹ)",
        "CommandCenter": "Hiện trên Trung tâm điều hành",
        "SignUp": "Hiện khi đăng ký tài xế",
        "CompanyTransport": "Xe công ty - Di chuyển",
        "CompanyDelivery": "Xe công ty - Giao hàng",
        "IndividualTransport": "Xe cá nhân - Di chuyển",
        "IndividualDelivery": "Xe cá nhân - Giao hàng",
        "Require": "Bắt buộc",
        "Actions": "Thao tác",
        "fieldType": "Loại trường",
        "default": "Mặc định",
        "customized": "Tùy chỉnh"
    },
    "driverDocument": {
        "Load_fail": "Please provide the text you would like me to translate to Vietnamese.",
        "Edit": "Chỉnh sửa",
        "View": "Xem",
        "Cancel": "Hủy",
        "show": "Hiển thị",
        "hide": "Ẩn",
        "EDIT_DRIVER_DOCUMENT": "Chỉnh sửa tài liệu tài xế",
        "DETAIL_DRIVER_DOCUMENT": "Chi tiết tài liệu tài xế",
        "ADD_DRIVER_DOCUMENT": "Thêm tài liệu tài xế",
        "documentKey": "Key tài liệu",
        "documentName": "Tên tài liệu",
        "documentNameDetail": {
            "zh-HK": "Tiếng Trung truyền thống",
            "it-IT": "Italiano standard",
            "es-ES": "Tây Ban Nha",
            "en-US": "Tiếng Anh Mỹ",
            "fr-FR": "Tiếng Pháp chuẩn",
            "zh-CN": "Tiếng Trung giản thể",
            "id-ID": "Tiếng Indonesia",
            "vi-VN": "Tiếng Việt",
            "ur-PK": "Urdu (Cộng hòa Hồi giáo Pakistan)",
            "ms-MY": "Tiếng Mã Lai (Malaysia)",
            "ar-AR": "Tiếng Ả Rập",
            "en-GB": "Tiếng Anh (Vương quốc Anh)",
            "nb-NO": "Na Uy",
            "am-ET": "Amharic",
            "ro-RO": "Romania",
            "th-TH": "Thái",
            "ta-IN": "Tamil",
            "hi-IN": "Hindi",
            "te-IN": "Telugu",
            "ka-GE": "Georgia",
            "ru-RU": "Tiếng Nga",
            "kn-IN": "Kannada"
        },
        "isIndividual": "Xe công ty - Di chuyển",
        "deliveryCompany": "Xe công ty - Giao hàng",
        "isOwner": "Tài xế cá nhân - Di chuyển",
        "deliveryIndividual": "Tài xế cá nhân - Giao hàng",
        "availableCC": "Hiện trên Trung tâm điều hành",
        "availableDrvSignUp": "Hiện khi đăng ký tài xế",
        "isRequired": "Bắt buộc",
        "isExpiredDate": "Ngày hết hạn - Trung tâm điều hành",
        "expiredDateForDrvSignUp": "Ngày hết hạn - Đăng ký tài xế",
        "requireExpiredDate": "Yêu cầu ngày hết hạn",
        "requireExpiredDateForDrvSignUp": "Yêu cầu ngày hết hạn",
        "requireDocumentId": "Yêu cầu ID tài liệu",
        "documentId": "ID tài liệu - Trung tâm điều hành",
        "documentIdForDrvSignUp": "ID tài liệu - Đăng ký tài xế",
        "Update_fail": "Đã xảy ra lỗi khi cập nhật tài liệu tài xế",
        "Update_success": "Tài liệu tài xế đã được cập nhật thành công",
        "DocumentKey": "Key tài liệu",
        "DocumentName": "Tên tài liệu (Tiếng Anh Mỹ)",
        "CommandCenter": "Hiện trên Trung tâm điều hành",
        "SignUp": "Hiện khi đăng ký tài xế",
        "CompanyTransport": "Xe công ty - Di chuyển",
        "CompanyDelivery": "Xe công ty - Giao hàng",
        "IndividualTransport": "Xe cá nhân - Di chuyển",
        "IndividualDelivery": "Xe cá nhân - Giao hàng",
        "Require": "Bắt buộc",
        "Actions": "Thao tác"
    },
    "holidayTaxis": {
        "title": "Thông tin xác thực API HolidayTaxis",
        "note": "Liên hệ với HolidayTaxis để nhận key API kết nối với hệ thống của họ.",
        "apiKey": "Khóa API",
        "placeHolderApiKey": "Nhập API key"
    },
    "trailNotes": {
        "maxLengthFiles": "Tối đa 3 tệp mỗi bình luận",
        "maxSizeFiles": "Tối đa 10MB mỗi tệp",
        "typeFiles": "Các loại tệp được hỗ trợ: pdf, doc, docx, csv, xls, xlsx, jpeg, jpg, png, webp, txt, note",
        "maxComments": "Tối đa 20 bình luận mỗi chuyến",
        "bookingActivity": "Hoạt động & ghi chú",
        "viewAll": "Xem tất cả",
        "operator": "Điều hành viên",
        "driver": "Tài xế",
        "passenger": "Khách hàng",
        "pHInput": "Thêm ghi chú mới. Nhấn Lưu để lưu lại. Bạn cũng có thể kéo và thả nhiều tệp tại đây.",
        "addFiles": "Thêm tệp",
        "save": "Lưu",
        "inputNotes": "Vui lòng nhập nội dung",
        "successDeleteTrailNotes": "Đã xóa ghi chú hành trình thành công.",
        "successCreateTrailNotes": "Đã tạo ghi chú hành trình thành công.",
        "deleteTrailNote": "Xóa ghi chú hành trình",
        "msgDeleteTrailNote": "Bạn muốn xóa mục này?"
    },
    "supplier": {
        "permissionRequired": "Nhà điều hành cần chọn quyền hạn",
        "offerDetail": "Chi tiết đề xuất",
        "orderDetail": "Chi tiết đơn hàng",
        "bookingNumber": "Mã đặt xe",
        "date": "Ngày",
        "pickupLocation": "Điểm đón",
        "dropoffLocation": "Điểm trả khách",
        "passenger": "Hành khách",
        "luggage": "Hành lý",
        "pickupService": "Dịch vụ đón khách",
        "pickupSignage": "Bảng hiệu đón khách",
        "flightNumber": "Số hiệu chuyến bay",
        "departure": "Khởi hành",
        "arrival": "Đến nơi",
        "terminal": "Nhà ga",
        "gate": "Cổng",
        "meetGreet": "Đón tiếp",
        "specialRequests": "Yêu cầu đặc biệt",
        "additionalServices": "Dịch vụ bổ sung",
        "price": "Giá",
        "prices": "Giá",
        "guest": "Khách",
        "serviceClass": "Hạng dịch vụ",
        "distance": "Khoảng cách",
        "duration": "Thời lượng",
        "acceptOffer": "Chấp nhận đề xuất",
        "updateBooking": "Cập nhật chuyến xe",
        "package": "Gói cước",
        "route": "Lộ trình",
        "assignedChauffer": "Tài xế được phân công",
        "assignedVehicle": "Xe được phân công",
        "logs": "Nhật ký",
        "link": "Liên kết",
        "desLink": "Nhấp để sao chép link",
        "trackLink": "Link theo dõi",
        "driverLink": "Link tài xế",
        "close": "Đóng",
        "links": "Liên kết",
        "linksDes": "Nhấp để sao chép link",
        "status": "Trạng thái",
        "rating": "Đánh giá",
        "permissions": "Quyền hạn",
        "permissionsNote": "Phân quyền ở các cấp độ khác nhau cho team của bạn. Có thể chọn xem người điều hành có thể xem các chuyến mở hay chỉ các chuyến đã nhận.",
        "owner": "Chủ sở hữu",
        "ownerNote": "Toàn quyền truy cập",
        "manageUsers": "Quản lý người dùng",
        "manageUsersNote": "Thêm/xóa nhà điều hành mới",
        "manageDrivers": "Quản lý tài xế",
        "manageDriversNote": "Thêm/xóa tài xế",
        "manageVehicles": "Quản lý xe",
        "manageVehiclesNote": "Thêm/xóa xe",
        "mapView": "Bản đồ trực tiếp",
        "mapViewNote": "Theo dõi tài xế và các chuyến đi đang hoạt động trực tiếp trên bản đồ.",
        "calendarView": "Xem lịch trình",
        "calendarViewNote": "Xem lịch trình của tất cả các chuyến đã được phân công.",
        "bookingView": "Xem đơn chuyến xe",
        "bookingViewNote": "Xem và quản lý các chuyến xe hiện tại, chỉ định tài xế và phân bổ xe.",
        "offersView": "Xem đề xuất",
        "offersViewNote": "Chấp nhận các đề xuất công việc mới.",
        "pricing": "Giá cả",
        "pricingNote": "Xem giá chuyến đi",
        "report": "Báo cáo",
        "reportNote": "Xem báo cáo chuyến xe và tài chính",
        "reportExport": "Xuất báo cáo",
        "reportExportNote": "Xuất báo cáo sang .csv",
        "userDetail": "Chi tiết người dùng",
        "addOperator": "Thêm điều hành viên",
        "updateOperator": "Cập nhật điều hành viên",
        "supplier": "Nhà cung cấp",
        "zone": "Khu vực",
        "emails": "Email",
        "email": "Email",
        "phoneNumber": "Số điện thoại",
        "Deactivate": "Vô hiệu hóa",
        "Activate": "Kích hoạt",
        "ALERT_SELECT_DEACTIVATE": "Vui lòng chọn nhà cung cấp để vô hiệu hóa",
        "ALERT_SELECT_ACTIVATE": "Vui lòng chọn nhà cung cấp để kích hoạt",
        "CONFIRM_DEACTIVATE_MULTI": "Bạn muốn vô hiệu hóa các nhà cung cấp này?",
        "CONFIRM_ACTIVATE_MULTI": "Bạn muốn kích hoạt các nhà cung cấp này?",
        "Update_supplier_user_status_success": "Trạng thái nhà cung cấp đã được cập nhật thành công",
        "Update_supplier_user_status_fail": "Đã xảy ra lỗi khi cập nhật trạng thái nhà cung cấp",
        "agent": "Công ty",
        "Supplier": "Nhà cung cấp",
        "addSupplier": "Thêm nhà cung cấp",
        "detailSupplier": "Chi tiết nhà cung cấp",
        "addUser": "Thêm người dùng",
        "Add": "Thêm",
        "ContactInfo": "Thông tin liên hệ",
        "policy": "Chính sách",
        "users": "Người dùng",
        "setting": "Cài đặt",
        "zones": "Khu vực",
        "actions": "Thao tác",
        "companyName": "Tên công ty",
        "corporationType": "Loại hình công ty",
        "country": "Quốc gia",
        "nationality": "Quốc tịch",
        "driverIC": "IC điều khiển",
        "ADMIN_INFORMATION": "Thông tin quản trị viên",
        "firstName": "Tên",
        "lastName": "Họ",
        "commissionValue": "Hoa hồng đội xe",
        "commissionValueDes": "Thiết lập mức hoa hồng mà đội xe nhận được cho mỗi đơn hoàn thành.",
        "SupplierType": "Loại nhà cung cấp",
        "SupplierTypeDes": "Chọn một loại nhà cung cấp.",
        "paymentMethodsApplyDes": "Phương thức thanh toán riêng cho từng chuyến mà nhà cung cấp có thể xử lý:",
        "bookingSettings": "Cài đặt chuyến",
        "bookingSettingsDes": "Cấu hình hiển thị công việc, thời gian phát hành và độ trễ để tối ưu hoạt động của nhà cung cấp.",
        "advanceBookingVisibilityTooltip": "Chỉ định số ngày nhà cung cấp có thể xem trước các đơn hàng.",
        "delayBroadcastToolTip": "Đặt thời gian trễ từ lúc công bố (nếu có) hoặc từ đầu ngày (0:00). Độ trễ được kiểm soát khi các chuyến hiển thị cho nhà cung cấp sau thời gian công bố ban đầu.\n",
        "releaseTimeToolTip": "Đặt thời gian trong ngày khi các chuyến được công bố cho nhà cung cấp, bắt đầu từ ngày đầu tiên họ có thể xem chuyến. Thời gian này cho phép nhà cung cấp đủ thời gian chuẩn bị.\n",
        "otherSettings": "Cài đặt khác",
        "hideFare": "Tài xế - Luôn ẩn giá cước",
        "hideFareDes": "Ẩn giá cước với tất cả tài xế của nhà cung cấp này",
        "supplierJobRequired": "Yêu cầu xác nhận công việc của nhà cung cấp",
        "supplierJobRequiredDes": "Nhà cung cấp phải xác nhận và đồng ý công việc trước khi họ chỉ định tài xế/xe hoặc cho phép tài xế xem công việc trong marketplace.",
        "supplierApproval": "Phê duyệt tài xế/xe của nhà cung cấp",
        "supplierApprovalDes": "Cho phép điều hành viên của nhà cung cấp kích hoạt tài xế và xe trong đội xe của họ",
        "emailsApply": "Email thông báo",
        "emailsApplyDes": "Email để gửi công việc mới, cập nhật chuyến",
        "address": "Địa chỉ",
        "zipCode": "Mã bưu chính",
        "city": "Thành phố",
        "state": "Tỉnh/Thành",
        "tax": "Mã số thuế",
        "businessRegistration": "Số đăng ký kinh doanh",
        "vatNumber": "Mã số thuế ",
        "mobile": "Số điện thoại",
        "editOperator": "Chỉnh sửa nhà điều hành",
        "searchEmail": "Tìm kiếm email",
        "acceptOfferSuccess": "Chấp nhận đề nghị thành công",
        "acceptOfferFail": "Không tìm thấy chuyến xe hoặc nhà cung cấp khác đã nhận",
        "driverPayout": "Thanh toán cho tài xế",
        "payout": "Thanh toán",
        "totalPayout": "Tổng thanh toán",
        "totalPayoutDes": "Tổng thanh toán bao gồm số tiền cơ bản cùng với bất kỳ khoản phí bổ sung nào bạn đã phân bổ cho nhà cung cấp",
        "supplierPayout": "Thanh toán cho nhà cung cấp",
        "driverTip": "Tiền tip của tài xế",
        "cancel": "Hủy",
        "save": "Lưu",
        "activeSupplier": "Nhà cung cấp đang hoạt động",
        "userName": "Tên đăng nhập",
        "bookingCompletedView": "Chuyến hoàn tất",
        "bookingCompletedViewNote": "Xem lịch sử tất cả các chuyến đã hoàn thành",
        "driverEarning": "Thu nhập tài xế",
        "payoutCurrency": "Đơn vị tiền tệ thanh toán",
        "payoutCurrencyDes": "Đơn vị tiền tệ thanh toán cho nhà cung cấp/tài xế",
        "autoCreatePayout": "Tự động tạo thanh toán",
        "autoCreatePayoutDes": "Cài đặt thời gian tự động tạo báo cáo thanh toán cho các đối tác của bạn",
        "startDate": "Ngày bắt đầu",
        "frequency": "Tần số",
        "daily": "Hàng ngày",
        "weekly": "Hàng tuần",
        "biWeekly": "Hai tuần một lần",
        "monthly": "Hàng tháng",
        "commissionSupplier": "Hoa hồng",
        "commissionSupplierDes": "Thiết lập mức hoa hồng mà nhà cung cấp nhận được với mỗi chuyến hoàn thành.",
        "amount": "Số tiền cố định",
        "percent": "Phần trăm",
        "commissionSupplierValue": "Nhập giá trị hoa hồng",
        "payments": "Thanh toán",
        "paymentsDes": "Số dư sẽ được thanh toán cho bạn theo mỗi lịch trình thanh toán",
        "ConnectWithStripe": "Kết nối với Stripe",
        "viewStripeAccount": "Xem tài khoản Stripe",
        "viewBankInfo": "Xem Thông Tin Ngân Hàng",
        "AddBankInfo": "Thêm thông tin ngân hàng",
        "confirmChangeBalane": "Bạn có chắc chắn muốn thay đổi số dư nhà cung cấp không?",
        "changeBalaneSuccess": "Số dư tiền mặt của nhà cung cấp đã được cập nhật thành công",
        "restrictedZoneAccess": "Khu vực truy cập hạn chế",
        "restrictedZoneAccessDes": "Định nghĩa các khu vực an ninh cao hoặc kiểm soát cụ thể—chẳng hạn như căn cứ quân sự hoặc cơ sở không quân—nơi việc đón hoặc trả khách chỉ được phép cho các tài xế được ủy quyền có quyền truy cập hoặc giấy phép đặc biệt.",
        "DrvSignUpLink": "Liên kết Đăng Ký Tài Xế"
    },
    "vehicleLeadTime": {
        "vehicleLeadTime": "Chính sách Thời gian Dẫn xe",
        "customLocationLeadTime": "Thời gian dẫn đầu vị trí tùy chỉnh",
        "leadTime": "Thời gian dẫn",
        "ConfirmDelete": "Bạn có chắc chắn muốn xóa chính sách này không?",
        "Delete_success": "Chính sách đã được xóa thành công",
        "Update_Policy_success": "Chính sách đã được cập nhật thành công",
        "Create_Policy_success": "Chính sách đã được tạo thành công",
        "Update_Policy_fail": "Các lỗi xảy ra trong quá trình cập nhật chính sách",
        "Create_Policy_fail": "Các lỗi xảy ra trong quá trình tạo chính sách",
        "setDefaultSuccess": "Chính sách thời gian dẫn xe mặc định đã được thiết lập thành công",
        "setDefaultFail": "Các lỗi xảy ra khi thiết lập chính sách mặc định",
        "Policies": "Các chính sách",
        "pricingPolicy": "Chính sách giá",
        "customizeLeadTime": "Tùy chỉnh Thời gian Dẫn",
        "SelectVehiclePolicy": "Chọn Chính sách Thời gian Dẫn xe"
    },
    "noResultFound": "Không tìm thấy kết quả",
    "invalidDate": "Ngày không hợp lệ. Vui lòng nhập ngày theo định dạng mm/dd/yyyy",
    "billingUsage": {
        "GSNTitle": "Ví GSN",
        "GSNNote": "Đội xe nạp tiền để gửi hoặc nhận chuyến từ mạng lưới.",
        "GSNPlatform": "Nền tảng",
        "GSNPlatformNote": "Theo dõi đăng ký và mức sử dụng đặt chỗ. Xuất hóa đơn cuối kỳ thanh toán. Phần này tách biệt với Ví GSN của bạn.",
        "GSNPlatformLimit": "Thanh toán nền tảng",
        "GSNPlatformLimitNote": "Theo dõi đăng ký và mức sử dụng. Xuất hóa đơn cuối kỳ thanh toán. Đây là phần tách biệt với Ví GSN của bạn.",
        "usageBalanceNote": "Theo dõi đăng ký và mức sử dụng. Xuất hóa đơn cuối kỳ thanh toán. Đây là phần tách biệt với Ví GSN của bạn.",
        "usageBalanceNoteDate": "Đăng ký và sử dụng còn nợ",
        "usageBalanceNoteDateValue": "đến hạn %{date}.",
        "usageBalance": "Số dư sử dụng",
        "platformUsage": "Sử dụng nền tảng",
        "payoutBalance": "Số dư thanh toán",
        "invoicePayoutBalanceTooltip": "Thu nhập từ các chuyến xe mạng đã hoàn thành, có thể rút. Nếu số dư tín dụng không đủ, số dư này có thể được dùng để chi trả giao dịch trên mạng.",
        "autoPayoutBalanceTooltip": "Số dư này phản ánh thu nhập của bạn từ mạng lưới và bạn có thể rút tiền. Khi số dư tín dụng thấp, phí có thể được tự động trừ từ đây.",
        "creditBalance": "Số dư tín dụng",
        "gsnCreditBalance": "Số dư tín dụng GSN",
        "totalBalance": "Tổng số dư",
        "paid": "Hoàn thành",
        "failed": "Thất bại",
        "processing": "Đang xử lý",
        "pending": "Đang chờ",
        "bookingDeduct": "GSN Farm-Out",
        "cancellationPenalty": "GSN hủy muộn",
        "noShowPenalty": "GSN không đến",
        "withdraw": "Rút tiền",
        "bookingEarning": "GSN Farm-In",
        "booking": "Phí nền tảng",
        "subscriptionFee": "Subscription Fee",
        "waived": "Waived*",
        "learnMore": "Tìm hiểu thêm",
        "viewUsage": "View Usage",
        "productDiscovery": "Khám Phá Sản Phẩm",
        "productDiscoveryDescription": "Khám phá mọi thứ bạn có thể khởi động với GoodJourney. Tìm hiểu các ứng dụng cho tài xế, công cụ đặt chỗ trực tuyến và các sản phẩm khác để nâng cao hoạt động của bạn.",
        "overview": "Tổng quan",
        "paymentMethods": "Các phương thức thanh toán",
        "billingHistory": "Lịch sử thanh toán",
        "creditGrants": "Cấp tín dụng",
        "transactionHistory": "Lịch sử giao dịch",
        "getStartedDescription": "Hướng dẫn toàn diện của bạn về nền tảng. Khám phá các hướng dẫn từng bước, câu hỏi thường gặp và các phương pháp tốt nhất để thành thạo việc đặt chỗ, điều phối, thanh toán và nhiều hơn nữa.",
        "getStartedButton": "Bắt đầu",
        "walletOverview": "Tổng quan Ví",
        "calculateTotal": "Tổng = Tín dụng + Tiền mặt",
        "autoRechargeOn": "Khi số dư tín dụng của bạn đạt $0, bạn sẽ chuyển xuống cấp miễn phí. Bật tính năng nạp tiền tự động để tự động duy trì số dư tín dụng của bạn.",
        "autoRechargeOff": "Mẹo: Bật tính năng Tự động Nạp tiền để giữ cho số dư của bạn luôn đầy. Khi tín dụng của bạn giảm xuống $0, các đặt chỗ mới sẽ bị tạm dừng cho đến khi bạn nạp thêm tiền.",
        "updateSettingsOn": "Cập nhật Cài đặt",
        "updateSettingsOff": "Kích hoạt nạp tiền tự động",
        "autoChargeTitle": "Cài đặt tự động nạp tiền",
        "autoChargeTitleQuestion": "Bạn có muốn thiết lập nạp tiền tự động không?",
        "autoChargeCbx": "Vâng, tự động nạp tiền vào thẻ của tôi khi số dư tín dụng của tôi giảm xuống dưới một ngưỡng.",
        "crdBelow": "Khi số dư tín dụng giảm xuống dưới",
        "crdBelowNote": "Enter an amount between $5 and $100",
        "backupTo": "Đưa số dư tín dụng trở lại",
        "backupToNote": "Enter an amount between $10 and $100",
        "greaterThan": "Giá trị phải lớn hơn {0}",
        "lessThan": "Giá trị phải nhỏ hơn {0}",
        "AddBalance": "Thêm vào số dư tín dụng",
        "toAdd": "Số tiền cần thêm",
        "confirm": "Xác nhận thanh toán",
        "usageCredit": "Tiền tín dụng sử dụng hành trình tốt",
        "estTotal": "Tổng ước tính",
        "topUpSuccess": "Nạp tiền thành công",
        "topUpFailMessage": "Các lỗi xảy ra trong quá trình nạp tiền",
        "autoRechargeSuccess": "Cài đặt tự động nạp tiền đã được cập nhật thành công",
        "autoRechargeFailMessage": "Các lỗi đã xảy ra trong quá trình cập nhật cài đặt tự động nạp tiền",
        "creditBalanceTooltip": "Số dư trả trước của bạn dùng để trả phí nền tảng và mức sử dụng. Hãy duy trì nạp đủ để dịch vụ vận hành trôi chảy, không bị gián đoạn.",
        "gsnCreditBalanceTooltip": "Tín dụng trả trước dùng để gửi và nhận chuyến qua mạng Good Journey. Duy trì số dư đủ để giao dịch không bị gián đoạn.",
        "creditLineTitle": "Hạn mức tín dụng",
        "creditLineTooltip": "Hạn mức tín dụng cho hoạt động Good Journey Network. Phần đã dùng được tính vào hạn mức; phần khả dụng là dư định trước khi cần thanh toán.",
        "creditLineLimit": "Hạn mức",
        "creditLineUsed": "Đã dùng",
        "creditLineAvailable": "Khả dụng",
        "creditLineNextPaymentLead": "Lần thanh toán tự động tiếp theo %{date}",
        "creditLineNextPaymentTail": "hoặc khi số dư của bạn đạt mức %{limitAmount}",
        "creditLineNextPaymentTailOnly": "Thanh toán đến hạn khi số dư của bạn đạt mức %{limitAmount}",
        "creditLineMakePayment": "Thanh toán",
        "cashBalanceTooltip": "Đây là thu nhập của bạn từ các công việc đã hoàn thành trên mạng. Số tiền này có sẵn để rút. Nếu số dư tín dụng của bạn thấp, phí cũng có thể được trừ từ đây.",
        "systemTopUp": "Nạp tiền hệ thống",
        "gsnManualTopUp": "Nạp tiền thủ công",
        "gsnSystemTopUp": "Nạp tiền hệ thống",
        "autoTopUp": "Nạp tiền tự động",
        "manualTopUp": "Nạp tiền thủ công",
        "subscription": "Đăng ký",
        "subscriptionOneTime": "Đăng ký Một lần",
        "subscriptionAddOn": "Thêm gói đăng ký",
        "subscriptionAddOnOneTime": "Thêm gói đăng ký một lần",
        "booking": "Phí Đặt Chỗ",
        "addOn": "Bổ sung",
        "subscriptionEnded": "Đăng ký của bạn đã hết hạn. Chọn một gói mới để tiếp tục.",
        "continue": "Tiếp tục",
        "openGuide": "Mở hướng dẫn",
        "amountMustBeGreaterThan": "Số tiền phải lớn hơn {0}",
        "amountMustBeLessThan": "Số tiền phải nhỏ hơn {0}",
        "billingAndUsage": "Hóa đơn & Sử dụng",
        "manageSubscription": "Quản lý Đăng ký",
        "failedToOpenBillingUrl": "Không thể mở URL thanh toán",
        "autoChargeAmountMustBeGreaterThanThreshold": "Khi tính năng tự động nạp tiền được bật, số tiền phải lớn hơn ngưỡng nạp lại (5)",
        "rechargeWillHappenImmediately": "Sạc lại sẽ xảy ra ngay lập tức",
        "rechargeWillHappenImmediatelyDescription": "Số dư tín dụng của bạn thấp hơn ngưỡng nạp tiền mà bạn đã đặt, vì vậy việc nạp tiền sẽ xảy ra ngay sau khi bạn lưu các cài đặt này.",
        "amountIsRequired": "Số tiền là bắt buộc",
        "selectPaymentMethod": "Chọn phương thức thanh toán",
        "byContinuingYouAgree": "Bằng cách tiếp tục, bạn đồng ý với",
        "serviceCreditTerms": "điều khoản tín dụng dịch vụ",
        "paidCreditsNonRefundable": "Tiền tín dụng đã thanh toán là không hoàn lại và hết hạn sau một năm kể từ ngày mua.",
        "back": "Quay lại",
        "cancel": "Hủy",
        "topUp": "Nạp tiền",
        "autoRechargeIs": "Tự động nạp tiền là",
        "on": "trên",
        "off": "tắt",
        "viewTransactions": "Xem giao dịch",
        "bankInfo": "Thông tin ngân hàng",
        "setupPayment": "Cài đặt thanh toán",
        "bookingUsage": "Booking Usage",
        "overages": "Overages",
        "included": "included",
        "of": "of",
        "extra": "extra",
        "received": "Đã nhận",
        "state": "Tiểu bang",
        "active": "Hoạt động",
        "expired": "Hết hạn",
        "balance": "Cân bằng",
        "expires": "Hết hạn",
        "last7Days": "7 Ngày Qua",
        "viewHistory": "Xem Lịch sử",
        "creditsListedHereWillBeRemoved": "Các tín dụng được liệt kê ở đây sẽ bị xóa khỏi số dư vào ngày hết hạn của chúng.",
        "recentTransactions": "Giao dịch gần đây",
        "onlyPreviewShown": "Chỉ hiển thị một bản xem trước. Xem giao dịch để xem sổ cái đầy đủ.",
        "showingTransactionsPast12Months": "Hiển thị giao dịch trong 12 tháng qua",
        "filter": "Bộ lọc",
        "export": "Xuất khẩu",
        "all": "Tất cả",
        "date": "Ngày",
        "amount": "Số lượng",
        "addOns": "Các phần bổ sung",
        "edit": "Chỉnh sửa",
        "usage": "Sử dụng",
        "usageThisCycle": "Sử dụng chu kỳ này",
        "requests": "yêu cầu",
        "base": "Cơ sở",
        "overage": "Vượt mức",
        "per": "mỗi",
        "endOfSubscription": "Kết thúc Đăng ký",
        "fleetPlan": "Kế hoạch đội tàu",
        "currentPlan": "Kế hoạch hiện tại",
        "billing": "Hóa đơn",
        "startDate": "Ngày bắt đầu",
        "nextBillingDate": "Ngày kết thúc đăng ký",
        "change": "Thay đổi",
        "getStarted": "Bắt đầu",
        "oneTimeSetup": "Cài đặt một lần:",
        "fee": "Phí:",
        "overagePerRequest": "Chi phí vượt mức",
        "overagePerRequestText": "theo yêu cầu",
        "upToRequestsIncluded": "Tối đa",
        "requestsIncluded": "các yêu cầu đã bao gồm",
        "subscribed": "Đã đăng ký",
        "contactUs": "Liên hệ với chúng tôi",
        "enableOnlyWhatYouNeed": "Bật chỉ những gì bạn cần. Giá sẽ điều chỉnh theo chu kỳ thanh toán. Các tiện ích dựa trên mức sử dụng cho bất kỳ khoản vượt mức nào sẽ được trừ từ ví đội tàu của bạn.",
        "subscriptionSummary": "Tóm tắt Đăng ký",
        "reviewAndUpdate": "Xem xét và cập nhật đăng ký của bạn.",
        "plan": "Kế hoạch",
        "ongoingTotal": "Tổng cộng đang diễn ra",
        "nextBillingCycle": "Kỳ Thanh Toán Tiếp Theo",
        "cancelSubscription": "Hủy đăng ký",
        "areYouSureCancelSubscription": "Bạn có chắc chắn muốn hủy đăng ký của mình không? Bạn sẽ tiếp tục có quyền truy cập vào dịch vụ.",
        "until": "cho đến",
        "resumeSubscription": "Tiếp tục Đăng ký",
        "no": "Không",
        "yes": "Vâng",
        "updateSubscription": "Cập nhật Đăng ký",
        "upgrade": "Cập nhật",
        "from": "Từ:",
        "totalDueToday": "Tổng số tiền phải trả hôm nay",
        "howProrationWorks": "Cách thức phân bổ hoạt động",
        "prorationDescription": "Bất kỳ thời gian chưa sử dụng nào từ kế hoạch hiện tại hoặc các gói bổ sung sẽ được ghi có vào kế hoạch mới. Các gói bổ sung được thêm vào giữa chu kỳ chỉ bị tính phí cho những ngày còn lại trong kỳ thanh toán hiện tại.",
        "pleaseSelectPaymentMethod": "Vui lòng chọn phương thức thanh toán.",
        "paymentConfirmedSuccessfully": "Thanh toán đã được xác nhận thành công",
        "failedToConfirmPayment": "Xác nhận thanh toán thất bại",
        "confirmPayment": "Confirm Payment",
        "failedToGetBillingPlan": "Không thể lấy kế hoạch thanh toán theo mã quốc gia",
        "failedToGetPreview": "Không thể lấy kế hoạch thanh toán xem trước",
        "failedToPreviewAddOns": "Không thể xem trước các tiện ích mở rộng",
        "subscriptionCancelledSuccessfully": "Đã hủy đăng ký thành công",
        "failedToCancelSubscription": "Không thể hủy đăng ký",
        "addOnChangedSuccessfully": "Tiện ích đã được thay đổi thành công",
        "failedToChangedAddOn": "Không thể thay đổi tiện ích mở rộng",
        "failedToGetUsage": "Không thể lấy thông tin sử dụng",
        "annual": "Hàng năm",
        "monthly": "Hàng tháng",
        "currentPlanButton": "Kế hoạch hiện tại",
        "upgradeButton": "Cập nhật",
        "save": "Lưu",
        "expiresText": "Hết hạn",
        "noExpiry": "Không hết hạn",
        "managePayment": "Quản lý Thanh Toán",
        "changePlan": "Change Plan",
        "addOns": "Các phần bổ sung",
        "viewUsage": "Xem mức sử dụng",
        "requestWithdrawal": "Yêu cầu rút tiền",
        "withdraw": "Rút tiền",
        "withdrawalGsn": {
            "requestWithdrawal": "Yêu cầu rút tiền",
            "reviewWithdrawal": "Xem lại yêu cầu rút",
            "payTo": "Thanh toán cho",
            "availableBalance": "Số dư khả dụng ({currency})",
            "payoutBalance": "Số dư thanh toán ({currency})",
            "payoutBalanceLabel": "Số dư thanh toán",
            "amountOwedToPlatform": "Số tiền nợ nền tảng",
            "availableToWithdraw": "Có thể rút",
            "amountToWithdraw": "Số tiền rút ({currency})",
            "minimumWithdrawal": "Rút tối thiểu: {amount} {currency}",
            "minimumTransferAmount": "Số tiền chuyển tối thiểu: {amount} {currency}",
            "noPayoutMethods": "Không có phương thức thanh toán",
            "review": "Xem lại",
            "payoutSpeed": "Tốc độ thanh toán",
            "normalPayout": "Thanh toán thường",
            "instantPayout": "Thanh toán tức thì",
            "recommended": "Đề xuất",
            "transferFeePercent": "Phí chuyển {percent}%",
            "transferFee": "Phí chuyển",
            "withdrawalAmount": "Số tiền rút",
            "amountDeducted": "Số tiền khấu trừ",
            "youWillReceive": "Bạn sẽ nhận",
            "totalToReceive": "Tổng nhận",
            "confirmWithdrawal": "Xác nhận rút",
            "disclaimer": "Khoản rút được gửi bằng USD",
            "disclaimer1": "Ngân hàng nhận có thể quy đổi sang tiền địa phương và áp dụng phí và tỷ giá riêng",
            "disclaimer2": "Số tiền thực nhận có thể khác số tiền gửi.",
            "requestSuccess": "Đã gửi yêu cầu rút thành công."
        },
        "addNewPaymentMethod": "Thêm phương thức thanh toán mới",
        "warningCurrentBalance": "Số tiền bạn nợ nền tảng vượt quá số dư thanh toán hiện tại. Bạn không thể yêu cầu rút tiền lúc này."
    },
    "signup": {
        "limitation": {
            "driver": "Driver",
            "vehicle": "Vehicle",
            "operator": "Operator",
            "drivers": "Drivers",
            "vehicles": "Vehicles",
            "operators": "Operators"
        },
        "language": "Ngôn ngữ",
        "contactHeader": "Vui lòng liên hệ nếu có vấn đề hoặc câu hỏi",
        "stepAccountTitle": "Tạo tài khoản",
        "stepAccountDesc": "Vui lòng cung cấp tên đăng nhập và mật khẩu của bạn",
        "stepCompanyTitle": "Thông tin công ty",
        "stepCompanyDesc": "Thêm logo, chủ đề màu sắc và thông tin công ty của bạn.",
        "stepZoneTitle": "Khu vực hoạt động",
        "stepZoneDesc": "Chọn thành phố hoạt động của bạn.",
        "stepPlanTitle": "Chọn gói dịch vụ",
        "stepPlanDesc": "Chọn gói thanh toán phù hợp với bạn.",
        "stepPlanCustom": "Gói Tùy Chỉnh Của Bạn",
        "stepPlanTitleCustom": "Xem Lại Gói Tùy Chỉnh Của Bạn",
        "stepPlanDescCustom": "Một gói được tạo riêng cho đội xe của bạn.",
        "accountStepTitle": "Tạo tài khoản",
        "accountStepUsername": "Tên đăng nhập",
        "accountStepEmail": "Email",
        "accountStepChoosePassword": "Chọn mật khẩu",
        "accountStepConfirmPassword": "Xác nhận mật khẩu",
        "accountStepPasswordHint": "Mật khẩu phải có ít nhất 8 ký tự, 1 chữ cái in hoa và 1 ký tự đặc biệt",
        "accountStepCreateAccount": "Tạo tài khoản",
        "accountStepAlreadyHaveAccount": "Đã có tài khoản?",
        "accountStepCaptchaError": "Vui lòng xác minh captcha",
        "accountStepGenericError": "Đã xảy ra lỗi khi tạo tài khoản",
        "accountStepSuccess": "Tài khoản đã được tạo thành công",
        "usernameRequired": "Tên đăng nhập là bắt buộc",
        "usernameMinLength": "Tên đăng nhập phải có ít nhất 3 ký tự",
        "usernameMaxLength": "Tên đăng nhập phải ít hơn 20 ký tự",
        "usernamePattern": "Tên đăng nhập phải bắt đầu bằng chữ cái thường và chỉ có thể chứa chữ cái thường và số",
        "emailRequired": "Email là bắt buộc",
        "emailInvalid": "Email không hợp lệ",
        "passwordRequired": "Mật khẩu là bắt buộc",
        "passwordMinLength": "Mật khẩu phải có ít nhất 8 ký tự",
        "passwordPattern": "Mật khẩu phải chứa ít nhất 1 chữ cái in hoa và 1 ký tự đặc biệt",
        "confirmPasswordMismatch": "Mật khẩu không khớp",
        "companyStepTitle": "Thông tin công ty",
        "companyStepAddLogo": "Thêm logo",
        "companyStepColorTheme": "Chủ đề màu sắc",
        "companyStepSelectThemeColor": "Chọn màu chủ đề",
        "companyStepFirstName": "Tên",
        "companyStepLastName": "Họ",
        "companyStepPhone": "Số điện thoại",
        "companyStepEmail": "Email",
        "companyStepCompanyName": "Tên công ty",
        "companyStepFleetId": "Mã đội xe",
        "companyStepCompanyAddress": "Địa chỉ công ty",
        "companyStepCompanyWebsite": "Website công ty",
        "companyStepDriversNumber": "Có bao nhiêu tài xế trong đội xe của bạn?",
        "companyStepVehiclesNumber": "Có bao nhiêu phương tiện trong đội xe của bạn?",
        "companyStepContinue": "Tiếp tục",
        "companyStepGenericError": "Đã xảy ra lỗi khi lưu thông tin công ty",
        "companyStepSuccess": "Thông tin công ty đã được lưu thành công",
        "companyStepPhoneInvalid": "Vui lòng nhập số điện thoại hợp lệ",
        "companyNameRequired": "Tên công ty là bắt buộc",
        "fleetIdRequired": "Mã đội xe là bắt buộc",
        "fleetIdPattern": "Phải có 4-30 ký tự, phải bắt đầu bằng chữ cái thường và chỉ có thể chứa chữ cái thường và số",
        "zoneStepTitle": "Thiết lập khu vực hoạt động",
        "zoneStepDescription": "Đây là khu vực hoạt động ban đầu của bạn. Để mở rộng trong tương lai, hãy liên hệ với chúng tôi.",
        "zoneStepSearchAddress": "Tìm kiếm địa chỉ",
        "zoneStepLatitude": "Vĩ độ",
        "zoneStepLongitude": "Kinh độ",
        "zoneStepRadius": "Bạn sẽ đi xa đến mức nào ngoài khu vực trung tâm?",
        "zoneStepRadiusDescription": "Khoảng cách xa nhất từ điểm trung tâm.",
        "zoneStepContinue": "Tiếp tục",
        "zoneStepGenericError": "Đã xảy ra lỗi khi lưu khu vực",
        "zoneStepSuccess": "Khu vực đã được lưu thành công",
        "zoneStepInvalidCoordinates": "Vĩ độ và kinh độ không hợp lệ",
        "latitudeRequired": "Vĩ độ là bắt buộc",
        "latitudeDecimalPlaces": "Vĩ độ có thể có tối đa 10 chữ số thập phân",
        "latitudeRange": "Vĩ độ phải nằm trong khoảng -90 đến 90 độ",
        "longitudeRequired": "Kinh độ là bắt buộc",
        "longitudeDecimalPlaces": "Kinh độ có thể có tối đa 10 chữ số thập phân",
        "longitudeRange": "Kinh độ phải nằm trong khoảng -180 đến 180 độ",
        "radiusRequired": "Bán kính là bắt buộc",
        "radiusMinError": "Bán kính phải ít nhất {0} km",
        "radiusMaxError": "Bán kính không được vượt quá {0} km",
        "contactUs": "liên hệ với chúng tôi",
        "planTitle": "Chọn Gói",
        "planDescription": "Chọn một gói dịch vụ phù hợp với nhu cầu của bạn. Nâng cấp hoặc hủy bất cứ lúc nào. Không có phí ẩn, mãi mãi.",
        "planDescriptionCustom": "Một gói dịch vụ được xây dựng riêng cho đội xe của bạn.",
        "billingMonthly": "Hàng tháng",
        "billingAnnual": "Hàng năm",
        "saveBadge": "Tiết kiệm 20%",
        "popularBadge": "PHỔ BIẾN NHẤT",
        "customPricing": "Tùy chỉnh",
        "periodAnnual": "Hàng năm",
        "periodMonthly": "Hàng tháng",
        "bonusCredits": "Thưởng {0} Tín dụng Một lần",
        "savePercentage": "Tiết kiệm {0}%",
        "oneTimeSetupFee": "Phí Thiết lập Một lần",
        "waived": "Waived*",
        "planFeatures": {
            "feePerBooking39": "3,9% mỗi lần đặt",
            "feePerBooking29": "2,9% mỗi lần đặt",
            "feePerBooking": "{0} mỗi lần đặt bổ sung",
            "freeBookingPerMonth": "{0} đặt chỗ MIỄN PHÍ mỗi tháng",
            "unlimitedUsers": "Người dùng không giới hạn",
            "commandCenterAdminDashboard": "Bảng điều khiển Quản trị Trung tâm Lệnh",
            "nativeDriverApp": "Ứng dụng Lái xe Gốc",
            "webDriverApp": "Ứng dụng Web Driver",
            "customerBookingLink": "Liên kết Đặt Chỗ Khách Hàng",
            "plusEverythingInStartup": "Cộng với mọi thứ trong Startup",
            "corporateManagement": "Quản lý Doanh nghiệp",
            "invoicingManagement": "Quản lý Hóa đơn",
            "driverPayoutManagement": "Quản lý thanh toán cho tài xế",
            "promotionManagement": "Quản lý Khuyến mãi",
            "plusEverythingInPro": "Cộng với mọi thứ trong Pro",
            "tierDiscountPricing": "Giá cả chiết khấu theo cấp độ",
            "customFeatureDevelopment": "Phát triển Tính năng Tùy chỉnh",
            "unlimitedOperators": "Người vận hành không giới hạn",
            "unlimitedDrivers": "Tài xế không giới hạn",
            "unlimitedVehicles": "Xe không giới hạn"
        },
        "planDescriptions": {
            "enterprise": "Enterprise bao gồm thanh toán tùy chỉnh, onboarding chuyên dụng, Giá Giảm Theo Cấp và Phát Triển Tính Năng Tùy Chỉnh để phù hợp hoàn hảo với quy trình làm việc cụ thể của bạn."
        },
        "limitedNotes": "(*) Khuyến mãi độc quyền có thời hạn",
        "unlimitedText": "Không giới hạn",
        "volumeDiscount": "Giảm giá theo khối lượng",
        "letsTalkButton": "Hãy nói chuyện nào!",
        "buildingStepTitle": "Đang xây dựng đội xe của bạn...",
        "congratulationsTitle": "Chúc mừng! Tài khoản của bạn đã sẵn sàng",
        "congratulationsDescription": "Đăng nhập vào bảng điều khiển quản trị tại đây.",
        "congratulationsViewDashboard": "Xem bảng điều khiển",
        "congratulationsContact": "Có câu hỏi? Liên hệ với chúng tôi tại",
        "fleetIdDescription": "Chọn một mã ngắn, đơn giản cho đội tàu của bạn — dễ chia sẻ và nhớ.",
        "fleetIdPlaceholder": "ví dụ: goodjourney",
        "firstNameRequired": "Họ tên là bắt buộc",
        "logIn": "Đăng Nhập",
        "instead": ".",
        "submittingData": "Đang gửi dữ liệu...",
        "upload": "Tải lên",
        "phoneNumberPlaceholder": "Số điện thoại +1",
        "km": "KM",
        "selectPlan": "Chọn Gói",
        "upgrade": "Cập nhật",
        "goodJourney": "Chuyến đi tốt đẹp",
        "loading": "Đang tải...",
        "lastNameRequired": "Họ là bắt buộc",
        "agreeToTerms": "Bằng cách tiếp tục, bạn xác nhận rằng bạn đã đọc và đồng ý với",
        "termsOfService": "Điều khoản dịch vụ",
        "privacyPolicy": "Chính sách bảo mật",
        "and": "và",
        "refresh": "Làm mới",
        "takingTooLong": "Mất quá nhiều thời gian?"
    },
    "addonTemplate": {
        "Addon_Template": "Add-On Template",
        "Add_On_Template": "Add-On Template",
        "Create_addon_template_success": "Add-on template has been created successfully",
        "Create_addon_template_fail": "The errors occurred while creating add-on template",
        "Update_addon_template_success": "Add-on template has been updated successfully",
        "Update_addon_template_fail": "The errors occurred while updating add-on template",
        "Update_template_success": "Template has been updated successfully",
        "Update_template_fail": "The errors occurred while updating template",
        "Edit_Template": "Edit Template",
        "New_Template": "New Template",
        "Enter_Add_On_Template_Name": "Enter Add-On Template Name*",
        "Confirm_Delete": "Confirm Delete",
        "Confirm_Delete_Message": "Are you sure you want to delete this template? Deleting this template will unlink from all the partners/corp it links to",
        "Delete_success": "Template has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting template",
        "Set_Default": "Set as Default",
        "Confirm_Set_Default_Message": "Are you sure you want to set this Add-On as default?",
        "Set_Default_Success": "Add-on template has been set as default successfully",
        "Set_Default_Fail": "The errors occurred while setting add-on template as default",
        "Clone_addon_template": "Clone Add-On Template"
    },
    "addonService": {
        "Additional_Service": "Additional Service",
        "Service_Name": "Service Name",
        "Description": "Description",
        "desPlaceholder": "Brief description of the service",
        "namePlaceholder": "e.g. Meet & Greet, Local-E Sim, GST Tax",
        "Who_pays_for_this_add_on": "Who pays for this add-on?",
        "customer": "Customer",
        "driver": "Driver",
        "fleet": "Fleet",
        "Required": "Required",
        "Apply_Tax": "Apply Tax",
        "Itemize": "Itemize",
        "Attribute": "Attribute",
        "Fee_Type": "Fee Type",
        "feeType.amount": "Amount",
        "feeType.percentageSubtotal": "Percentage of Subtotal",
        "feeType.percentageTotal": "Percentage of Total",
        "feeType.custom": "Custom (Driver Input)",
        "Unit_Settings": "Unit Settings",
        "unit.none": "None",
        "unit.perDay": "per day",
        "unit.eachTime": "each time",
        "unit.perPerson": "per person",
        "Maximum_Quantity": "Maximum Quantity",
        "Maximum_Quantity_Value": "Maximum Quantity Value",
        "How_much_will_the_fleet_make": "How much will the fleet make for this add-on?",
        "Fleet_Commission": "Fleet Commission",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "Currency": "Currency",
        "Unlimited": "Unlimited",
        "Limited": "Limited",
        "Vehicle_Type": "Vehicle Type",
        "Service_Type": "Service Type",
        "Meeting_Zone": "Meeting Zone",
        "Trip_Context": "Trip Context",
        "Trip_Context_Value": {
            "departure": "Departure",
            "arrival": "Arrival"
        },
        "Operation_Zone": "Operation Zone",
        "Restricted_Zone": "Restricted Zone",
        "User_Type": "User Type",
        "Price_Unit": "Price Unit",
        "Info": "Info",
        "Rules": "Rules",
        "Basic_Information": "Basic Information",
        "Delete": "Delete",
        "Delete_addon_service": "Are you sure you want to delete this add-on service?",
        "Delete_success": "Add-on service has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting add-on service",
        "Create_addon_service_success": "Add-on service has been created successfully",
        "Create_addon_service_fail": "The errors occurred while creating add-on service",
        "Update_addon_service_success": "Add-on service has been updated successfully",
        "Update_addon_service_fail": "The errors occurred while updating add-on service",
        "Please_save_template_first": "Please save the template first before adding services",
        "Attribute_Tooltip": "Travel Attribute: Used to map this add-on to its corresponding standardized service key across connected OTAs (e.g., CHILD_SEAT, MEET_GREET).",
        "feeType": {
            "amount": "Amount",
            "percentageSubtotal": "Percentage of Subtotal",
            "percentageTotal": "Percentage of Total",
            "custom": "Custom (Driver Input)"
        },
        "unit": {
            "none": "None",
            "perDay": "Per day (Charge per day)",
            "eachTime": "Each time (Charge per ride)",
            "perPerson": "Per person (Charge per person)",
            "each": "Each (Charge per quantity)"
        },
        "none": "None",
        "perDay": "Per day",
        "eachTime": "Each time",
        "perPerson": "Per person",
        "each": "Each",
        "Unit_Settings_Title": "Unit Settings",
        "Itemize_Tooltip": "Itemize: This will list the add-on as a separate line item in the fare breakdown. If this is disabled, it will be under additional services.",
        "Booking_Channel": "Booking Channel",
        "pointToPoint": "Point To Point",
        "fromAirport": "From Airport",
        "toAirport": "To Airport",
        "hourly": "Hourly",
        "roundTrip": "Round Trip",
        "ADD_ON_BOOKING_CHANNEL_VALUE": {
            "PWA": "Web App",
            "passenger": "Customer App",
            "API": "API",
            "CC": "Command Center",
            "partner": "Partner App",
            "CarHailing": "Street Hailing",
            "streetSharing": "Street Sharing"
        },
        "Select_Attribute": "Select Attribute",
        "allowNoteInput": "Driver Input: Notes or Receipts",
        "allowNoteInputTooltip": "Allows drivers to submit notes and upload supporting photos or receipts for this service at the end of the trip (e.g. parking fees, tolls, additional charges).",
        "isDriverCapability": "Driver Capability",
        "Driver_Capability_Tooltip": "Exposes this service as a selectable capability in the driver profile. Used for driver profiling and booking-to-driver matching.",
        "isVehicleAttribute": "Vehicle Attribute",
        "Vehicle_Attribute_Tooltip": "Exposes this service as a selectable attribute in the vehicle profile. Used for vehicle profiling and booking matching.",
        "linkAtr": "Link attributes to a specific driver.",
        "addOnServicePolicy": "Add-On Policy",
        "selectAddonTemplate": "Select Add-on Template"
    }
};
